import "./Users.d37eb542.js";
import "./Users.28795f8b.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5b49"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5b49"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("yjxvR", function(module, exports) {
module.exports = Promise.all([
    import("cvbgP"),
    import("6YE9E"),
    import("kCOeB"),
    import("h7KvV"),
    import("gG0Dp")
]).then(()=>parcelRequire('fMZlT'));

});

parcelRegister("akIEM", function(module, exports) {
module.exports = Promise.all([
    import("cvbgP"),
    import("6YE9E"),
    import("h7KvV"),
    import("1lYqD")
]).then(()=>parcelRequire('ixlCi'));

});

parcelRegister("leE2r", function(module, exports) {
module.exports = Promise.all([
    import("6YE9E"),
    import("kCOeB"),
    import("h7KvV"),
    import("dveuW")
]).then(()=>parcelRequire('8ayRW'));

});

parcelRegister("6cXKj", function(module, exports) {
module.exports = Promise.all([
    import("cvbgP"),
    import("6YE9E"),
    import("kCOeB"),
    import("h7KvV"),
    import("i70DA")
]).then(()=>parcelRequire('gTPoJ'));

});

parcelRegister("9wX5b", function(module, exports) {
module.exports = Promise.all([
    import("6YE9E"),
    import("kCOeB"),
    import("h7KvV"),
    import("guWc4")
]).then(()=>parcelRequire('gonO9'));

});

parcelRegister("7C1fz", function(module, exports) {
module.exports = Promise.all([
    import("cvbgP"),
    import("6YE9E"),
    import("kCOeB"),
    import("h7KvV"),
    import("8NUxO")
]).then(()=>parcelRequire('gonEE'));

});

parcelRegister("dnKQI", function(module, exports) {
module.exports = Promise.all([
    import("cvbgP"),
    import("6YE9E"),
    import("kCOeB"),
    import("h7KvV"),
    import("dXCQK")
]).then(()=>parcelRequire('3wvRp'));

});

parcelRegister("geDru", function(module, exports) {
module.exports = Promise.all([
    import("cvbgP"),
    import("6YE9E"),
    import("kCOeB"),
    import("h7KvV"),
    import("l1ctg")
]).then(()=>parcelRequire('dciPn'));

});

parcelRegister("96Jpt", function(module, exports) {
module.exports = Promise.all([
    import("cvbgP"),
    import("6YE9E"),
    import("h7KvV"),
    import("euOYE")
]).then(()=>parcelRequire('7MwnB'));

});


var $1jJwX = parcelRequire("1jJwX");
/**
 * @license MIT
 * Copyright (c) 2025–2026 matraic
 * See LICENSE file in the project root for full license text.
 */ 
var $gkQP3 = parcelRequire("gkQP3");
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $fbf856437f99196f$var$t = globalThis, $fbf856437f99196f$export$b4d10f6001c083c2 = $fbf856437f99196f$var$t.ShadowRoot && (void 0 === $fbf856437f99196f$var$t.ShadyCSS || $fbf856437f99196f$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $fbf856437f99196f$var$s = Symbol(), $fbf856437f99196f$var$o = new WeakMap;
class $fbf856437f99196f$export$505d1e8739bad805 {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== $fbf856437f99196f$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($fbf856437f99196f$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $fbf856437f99196f$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $fbf856437f99196f$var$o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $fbf856437f99196f$export$8d80f9cac07cdb3 = (t)=>new $fbf856437f99196f$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $fbf856437f99196f$var$s), $fbf856437f99196f$export$dbf350e5966cf602 = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new $fbf856437f99196f$export$505d1e8739bad805(o, t, $fbf856437f99196f$var$s);
}, $fbf856437f99196f$export$2ca4a66ec4cecb90 = (s, o)=>{
    if ($fbf856437f99196f$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = $fbf856437f99196f$var$t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, $fbf856437f99196f$export$ee69dfd951e24778 = $fbf856437f99196f$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $fbf856437f99196f$export$8d80f9cac07cdb3(e);
    })(t) : t;


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: $660ec1ab4f3f3163$var$i, defineProperty: $660ec1ab4f3f3163$var$e, getOwnPropertyDescriptor: $660ec1ab4f3f3163$var$h, getOwnPropertyNames: $660ec1ab4f3f3163$var$r, getOwnPropertySymbols: $660ec1ab4f3f3163$var$o, getPrototypeOf: $660ec1ab4f3f3163$var$n } = Object, $660ec1ab4f3f3163$var$a = globalThis, $660ec1ab4f3f3163$var$c = $660ec1ab4f3f3163$var$a.trustedTypes, $660ec1ab4f3f3163$var$l = $660ec1ab4f3f3163$var$c ? $660ec1ab4f3f3163$var$c.emptyScript : "", $660ec1ab4f3f3163$var$p = $660ec1ab4f3f3163$var$a.reactiveElementPolyfillSupport, $660ec1ab4f3f3163$var$d = (t, s)=>t, $660ec1ab4f3f3163$export$7312b35fbf521afb = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? $660ec1ab4f3f3163$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $660ec1ab4f3f3163$export$53a6892c50694894 = (t, s)=>!$660ec1ab4f3f3163$var$i(t, s), $660ec1ab4f3f3163$var$b = {
    attribute: !0,
    type: String,
    converter: $660ec1ab4f3f3163$export$7312b35fbf521afb,
    reflect: !1,
    useDefault: !1,
    hasChanged: $660ec1ab4f3f3163$export$53a6892c50694894
};
Symbol.metadata ??= Symbol("metadata"), $660ec1ab4f3f3163$var$a.litPropertyMetadata ??= new WeakMap;
class $660ec1ab4f3f3163$export$c7c07a37856565d extends HTMLElement {
    static addInitializer(t) {
        this._$Ei(), (this.l ??= []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = $660ec1ab4f3f3163$var$b) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.prototype.hasOwnProperty(t) && ((s = Object.create(s)).wrapped = !0), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), h = this.getPropertyDescriptor(t, i, s);
            void 0 !== h && $660ec1ab4f3f3163$var$e(this.prototype, t, h);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        const { get: e, set: r } = $660ec1ab4f3f3163$var$h(this.prototype, t) ?? {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get: e,
            set (s) {
                const h = e?.call(this);
                r?.call(this, s), this.requestUpdate(t, h, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? $660ec1ab4f3f3163$var$b;
    }
    static _$Ei() {
        if (this.hasOwnProperty($660ec1ab4f3f3163$var$d("elementProperties"))) return;
        const t = $660ec1ab4f3f3163$var$n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($660ec1ab4f3f3163$var$d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($660ec1ab4f3f3163$var$d("properties"))) {
            const t = this.properties, s = [
                ...$660ec1ab4f3f3163$var$r(t),
                ...$660ec1ab4f3f3163$var$o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, $fbf856437f99196f$export$ee69dfd951e24778)(s));
        } else void 0 !== s && i.push((0, $fbf856437f99196f$export$ee69dfd951e24778)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$ES = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
    }
    addController(t) {
        (this._$EO ??= new Set).add(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
    }
    removeController(t) {
        this._$EO?.delete(t);
    }
    _$E_() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $fbf856437f99196f$export$2ca4a66ec4cecb90)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((t)=>t.hostConnected?.());
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        this._$EO?.forEach((t)=>t.hostDisconnected?.());
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$ET(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            const h = (void 0 !== i.converter?.toAttribute ? i.converter : $660ec1ab4f3f3163$export$7312b35fbf521afb).toAttribute(s, i.type);
            this._$Em = t, null == h ? this.removeAttribute(e) : this.setAttribute(e, h), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            const t = i.getPropertyOptions(e), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== t.converter?.fromAttribute ? t.converter : $660ec1ab4f3f3163$export$7312b35fbf521afb;
            this._$Em = e;
            const r = h.fromAttribute(s, t.type);
            this[e] = r ?? this._$Ej?.get(e) ?? r, this._$Em = null;
        }
    }
    requestUpdate(t, s, i, e = !1, h) {
        if (void 0 !== t) {
            const r = this.constructor;
            if (!1 === e && (h = this[t]), i ??= r.getPropertyOptions(t), !((i.hasChanged ?? $660ec1ab4f3f3163$export$53a6892c50694894)(h, s) || i.useDefault && i.reflect && h === this._$Ej?.get(t) && !this.hasAttribute(r._$Eu(t, i)))) return;
            this.C(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$ES = this._$EP());
    }
    C(t, s, { useDefault: i, reflect: e, wrapped: h }, r) {
        i && !(this._$Ej ??= new Map).has(t) && (this._$Ej.set(t, r ?? s ?? this[t]), !0 !== h || void 0 !== r) || (this._$AL.has(t) || (this.hasUpdated || i || (s = void 0), this._$AL.set(t, s)), !0 === e && this._$Em !== t && (this._$Eq ??= new Set).add(t));
    }
    async _$EP() {
        this.isUpdatePending = !0;
        try {
            await this._$ES;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t){
                const { wrapped: t } = i, e = this[s];
                !0 !== t || this._$AL.has(s) || void 0 === e || this.C(s, void 0, i, e);
            }
        }
        let t = !1;
        const s = this._$AL;
        try {
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$EO?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$EM();
        } catch (s) {
            throw t = !1, this._$EM(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        this._$EO?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$EM() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$ES;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$Eq &&= this._$Eq.forEach((t)=>this._$ET(t, this[t])), this._$EM();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$660ec1ab4f3f3163$export$c7c07a37856565d.elementStyles = [], $660ec1ab4f3f3163$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $660ec1ab4f3f3163$export$c7c07a37856565d[$660ec1ab4f3f3163$var$d("elementProperties")] = new Map, $660ec1ab4f3f3163$export$c7c07a37856565d[$660ec1ab4f3f3163$var$d("finalized")] = new Map, $660ec1ab4f3f3163$var$p?.({
    ReactiveElement: $660ec1ab4f3f3163$export$c7c07a37856565d
}), ($660ec1ab4f3f3163$var$a.reactiveElementVersions ??= []).push("2.1.2");


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $00a10a29322bb2a1$var$t = globalThis, $00a10a29322bb2a1$var$i = (t)=>t, $00a10a29322bb2a1$var$s = $00a10a29322bb2a1$var$t.trustedTypes, $00a10a29322bb2a1$var$e = $00a10a29322bb2a1$var$s ? $00a10a29322bb2a1$var$s.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $00a10a29322bb2a1$var$h = "$lit$", $00a10a29322bb2a1$var$o = `lit$${Math.random().toFixed(9).slice(2)}$`, $00a10a29322bb2a1$var$n = "?" + $00a10a29322bb2a1$var$o, $00a10a29322bb2a1$var$r = `<${$00a10a29322bb2a1$var$n}>`, $00a10a29322bb2a1$var$l = document, $00a10a29322bb2a1$var$c = ()=>$00a10a29322bb2a1$var$l.createComment(""), $00a10a29322bb2a1$var$a = (t)=>null === t || "object" != typeof t && "function" != typeof t, $00a10a29322bb2a1$var$u = Array.isArray, $00a10a29322bb2a1$var$d = (t)=>$00a10a29322bb2a1$var$u(t) || "function" == typeof t?.[Symbol.iterator], $00a10a29322bb2a1$var$f = "[ \t\n\f\r]", $00a10a29322bb2a1$var$v = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $00a10a29322bb2a1$var$_ = /-->/g, $00a10a29322bb2a1$var$m = />/g, $00a10a29322bb2a1$var$p = RegExp(`>|${$00a10a29322bb2a1$var$f}(?:([^\\s"'>=/]+)(${$00a10a29322bb2a1$var$f}*=${$00a10a29322bb2a1$var$f}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $00a10a29322bb2a1$var$g = /'/g, $00a10a29322bb2a1$var$$ = /"/g, $00a10a29322bb2a1$var$y = /^(?:script|style|textarea|title)$/i, $00a10a29322bb2a1$var$x = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $00a10a29322bb2a1$export$c0bb0b647f701bb5 = $00a10a29322bb2a1$var$x(1), $00a10a29322bb2a1$export$7ed1367e7fa1ad68 = $00a10a29322bb2a1$var$x(2), $00a10a29322bb2a1$export$47d5b44d225be5b4 = $00a10a29322bb2a1$var$x(3), $00a10a29322bb2a1$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $00a10a29322bb2a1$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $00a10a29322bb2a1$var$C = new WeakMap, $00a10a29322bb2a1$var$P = $00a10a29322bb2a1$var$l.createTreeWalker($00a10a29322bb2a1$var$l, 129);
function $00a10a29322bb2a1$var$V(t, i) {
    if (!$00a10a29322bb2a1$var$u(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $00a10a29322bb2a1$var$e ? $00a10a29322bb2a1$var$e.createHTML(i) : i;
}
const $00a10a29322bb2a1$var$N = (t, i)=>{
    const s = t.length - 1, e = [];
    let n, l = 2 === i ? "<svg>" : 3 === i ? "<math>" : "", c = $00a10a29322bb2a1$var$v;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let a, u, d = -1, f = 0;
        for(; f < s.length && (c.lastIndex = f, u = c.exec(s), null !== u);)f = c.lastIndex, c === $00a10a29322bb2a1$var$v ? "!--" === u[1] ? c = $00a10a29322bb2a1$var$_ : void 0 !== u[1] ? c = $00a10a29322bb2a1$var$m : void 0 !== u[2] ? ($00a10a29322bb2a1$var$y.test(u[2]) && (n = RegExp("</" + u[2], "g")), c = $00a10a29322bb2a1$var$p) : void 0 !== u[3] && (c = $00a10a29322bb2a1$var$p) : c === $00a10a29322bb2a1$var$p ? ">" === u[0] ? (c = n ?? $00a10a29322bb2a1$var$v, d = -1) : void 0 === u[1] ? d = -2 : (d = c.lastIndex - u[2].length, a = u[1], c = void 0 === u[3] ? $00a10a29322bb2a1$var$p : '"' === u[3] ? $00a10a29322bb2a1$var$$ : $00a10a29322bb2a1$var$g) : c === $00a10a29322bb2a1$var$$ || c === $00a10a29322bb2a1$var$g ? c = $00a10a29322bb2a1$var$p : c === $00a10a29322bb2a1$var$_ || c === $00a10a29322bb2a1$var$m ? c = $00a10a29322bb2a1$var$v : (c = $00a10a29322bb2a1$var$p, n = void 0);
        const x = c === $00a10a29322bb2a1$var$p && t[i + 1].startsWith("/>") ? " " : "";
        l += c === $00a10a29322bb2a1$var$v ? s + $00a10a29322bb2a1$var$r : d >= 0 ? (e.push(a), s.slice(0, d) + $00a10a29322bb2a1$var$h + s.slice(d) + $00a10a29322bb2a1$var$o + x) : s + $00a10a29322bb2a1$var$o + (-2 === d ? i : x);
    }
    return [
        $00a10a29322bb2a1$var$V(t, l + (t[s] || "<?>") + (2 === i ? "</svg>" : 3 === i ? "</math>" : "")),
        e
    ];
};
class $00a10a29322bb2a1$var$S {
    constructor({ strings: t, _$litType$: i }, e){
        let r;
        this.parts = [];
        let l = 0, a = 0;
        const u = t.length - 1, d = this.parts, [f, v] = $00a10a29322bb2a1$var$N(t, i);
        if (this.el = $00a10a29322bb2a1$var$S.createElement(f, e), $00a10a29322bb2a1$var$P.currentNode = this.el.content, 2 === i || 3 === i) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (r = $00a10a29322bb2a1$var$P.nextNode()) && d.length < u;){
            if (1 === r.nodeType) {
                if (r.hasAttributes()) for (const t of r.getAttributeNames())if (t.endsWith($00a10a29322bb2a1$var$h)) {
                    const i = v[a++], s = r.getAttribute(t).split($00a10a29322bb2a1$var$o), e = /([.?@])?(.*)/.exec(i);
                    d.push({
                        type: 1,
                        index: l,
                        name: e[2],
                        strings: s,
                        ctor: "." === e[1] ? $00a10a29322bb2a1$var$I : "?" === e[1] ? $00a10a29322bb2a1$var$L : "@" === e[1] ? $00a10a29322bb2a1$var$z : $00a10a29322bb2a1$var$H
                    }), r.removeAttribute(t);
                } else t.startsWith($00a10a29322bb2a1$var$o) && (d.push({
                    type: 6,
                    index: l
                }), r.removeAttribute(t));
                if ($00a10a29322bb2a1$var$y.test(r.tagName)) {
                    const t = r.textContent.split($00a10a29322bb2a1$var$o), i = t.length - 1;
                    if (i > 0) {
                        r.textContent = $00a10a29322bb2a1$var$s ? $00a10a29322bb2a1$var$s.emptyScript : "";
                        for(let s = 0; s < i; s++)r.append(t[s], $00a10a29322bb2a1$var$c()), $00a10a29322bb2a1$var$P.nextNode(), d.push({
                            type: 2,
                            index: ++l
                        });
                        r.append(t[i], $00a10a29322bb2a1$var$c());
                    }
                }
            } else if (8 === r.nodeType) {
                if (r.data === $00a10a29322bb2a1$var$n) d.push({
                    type: 2,
                    index: l
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = r.data.indexOf($00a10a29322bb2a1$var$o, t + 1));)d.push({
                        type: 7,
                        index: l
                    }), t += $00a10a29322bb2a1$var$o.length - 1;
                }
            }
            l++;
        }
    }
    static createElement(t, i) {
        const s = $00a10a29322bb2a1$var$l.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $00a10a29322bb2a1$var$M(t, i, s = t, e) {
    if (i === $00a10a29322bb2a1$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s._$Co?.[e] : s._$Cl;
    const o = $00a10a29322bb2a1$var$a(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s._$Co ??= [])[e] = h : s._$Cl = h), void 0 !== h && (i = $00a10a29322bb2a1$var$M(t, h._$AS(t, i.values), h, e)), i;
}
class $00a10a29322bb2a1$var$R {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $00a10a29322bb2a1$var$l).importNode(i, !0);
        $00a10a29322bb2a1$var$P.currentNode = e;
        let h = $00a10a29322bb2a1$var$P.nextNode(), o = 0, n = 0, r = s[0];
        for(; void 0 !== r;){
            if (o === r.index) {
                let i;
                2 === r.type ? i = new $00a10a29322bb2a1$var$k(h, h.nextSibling, this, t) : 1 === r.type ? i = new r.ctor(h, r.name, r.strings, this, t) : 6 === r.type && (i = new $00a10a29322bb2a1$var$Z(h, this, t)), this._$AV.push(i), r = s[++n];
            }
            o !== r?.index && (h = $00a10a29322bb2a1$var$P.nextNode(), o++);
        }
        return $00a10a29322bb2a1$var$P.currentNode = $00a10a29322bb2a1$var$l, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $00a10a29322bb2a1$var$k {
    get _$AU() {
        return this._$AM?._$AU ?? this._$Cv;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $00a10a29322bb2a1$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cv = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $00a10a29322bb2a1$var$M(this, t, i), $00a10a29322bb2a1$var$a(t) ? t === $00a10a29322bb2a1$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $00a10a29322bb2a1$export$45b790e32b2810ee && this._$AR(), this._$AH = $00a10a29322bb2a1$export$45b790e32b2810ee) : t !== this._$AH && t !== $00a10a29322bb2a1$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $00a10a29322bb2a1$var$d(t) ? this.k(t) : this._(t);
    }
    O(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
    }
    _(t) {
        this._$AH !== $00a10a29322bb2a1$export$45b790e32b2810ee && $00a10a29322bb2a1$var$a(this._$AH) ? this._$AA.nextSibling.data = t : this.T($00a10a29322bb2a1$var$l.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $00a10a29322bb2a1$var$S.createElement($00a10a29322bb2a1$var$V(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $00a10a29322bb2a1$var$R(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $00a10a29322bb2a1$var$C.get(t.strings);
        return void 0 === i && $00a10a29322bb2a1$var$C.set(t.strings, i = new $00a10a29322bb2a1$var$S(t)), i;
    }
    k(t) {
        $00a10a29322bb2a1$var$u(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $00a10a29322bb2a1$var$k(this.O($00a10a29322bb2a1$var$c()), this.O($00a10a29322bb2a1$var$c()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, s) {
        for(this._$AP?.(!1, !0, s); t !== this._$AB;){
            const s = $00a10a29322bb2a1$var$i(t).nextSibling;
            $00a10a29322bb2a1$var$i(t).remove(), t = s;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this._$Cv = t, this._$AP?.(t));
    }
}
class $00a10a29322bb2a1$var$H {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $00a10a29322bb2a1$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $00a10a29322bb2a1$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $00a10a29322bb2a1$var$M(this, t, i, 0), o = !$00a10a29322bb2a1$var$a(t) || t !== this._$AH && t !== $00a10a29322bb2a1$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $00a10a29322bb2a1$var$M(this, e[s + n], i, n), r === $00a10a29322bb2a1$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$00a10a29322bb2a1$var$a(r) || r !== this._$AH[n], r === $00a10a29322bb2a1$export$45b790e32b2810ee ? t = $00a10a29322bb2a1$export$45b790e32b2810ee : t !== $00a10a29322bb2a1$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $00a10a29322bb2a1$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $00a10a29322bb2a1$var$I extends $00a10a29322bb2a1$var$H {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $00a10a29322bb2a1$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $00a10a29322bb2a1$var$L extends $00a10a29322bb2a1$var$H {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $00a10a29322bb2a1$export$45b790e32b2810ee);
    }
}
class $00a10a29322bb2a1$var$z extends $00a10a29322bb2a1$var$H {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $00a10a29322bb2a1$var$M(this, t, i, 0) ?? $00a10a29322bb2a1$export$45b790e32b2810ee) === $00a10a29322bb2a1$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $00a10a29322bb2a1$export$45b790e32b2810ee && s !== $00a10a29322bb2a1$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $00a10a29322bb2a1$export$45b790e32b2810ee && (s === $00a10a29322bb2a1$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $00a10a29322bb2a1$var$Z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $00a10a29322bb2a1$var$M(this, t);
    }
}
const $00a10a29322bb2a1$export$8613d1ca9052b22e = {
    M: $00a10a29322bb2a1$var$h,
    P: $00a10a29322bb2a1$var$o,
    A: $00a10a29322bb2a1$var$n,
    C: 1,
    L: $00a10a29322bb2a1$var$N,
    R: $00a10a29322bb2a1$var$R,
    D: $00a10a29322bb2a1$var$d,
    V: $00a10a29322bb2a1$var$M,
    I: $00a10a29322bb2a1$var$k,
    H: $00a10a29322bb2a1$var$H,
    N: $00a10a29322bb2a1$var$L,
    U: $00a10a29322bb2a1$var$z,
    B: $00a10a29322bb2a1$var$I,
    F: $00a10a29322bb2a1$var$Z
}, $00a10a29322bb2a1$var$B = $00a10a29322bb2a1$var$t.litHtmlPolyfillSupport;
$00a10a29322bb2a1$var$B?.($00a10a29322bb2a1$var$S, $00a10a29322bb2a1$var$k), ($00a10a29322bb2a1$var$t.litHtmlVersions ??= []).push("3.3.2");
const $00a10a29322bb2a1$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $00a10a29322bb2a1$var$k(i.insertBefore($00a10a29322bb2a1$var$c(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $fa29e5b5c67837a0$var$s = globalThis;
class $fa29e5b5c67837a0$export$3f2f9f5909897157 extends (0, $660ec1ab4f3f3163$export$c7c07a37856565d) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        const t = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= t.firstChild, t;
    }
    update(t) {
        const r = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $00a10a29322bb2a1$export$b3890eb0ae9dca99)(r, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this._$Do?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this._$Do?.setConnected(!1);
    }
    render() {
        return 0, $00a10a29322bb2a1$export$9c068ae9cc5db4e8;
    }
}
$fa29e5b5c67837a0$export$3f2f9f5909897157._$litElement$ = !0, $fa29e5b5c67837a0$export$3f2f9f5909897157["finalized"] = !0, $fa29e5b5c67837a0$var$s.litElementHydrateSupport?.({
    LitElement: $fa29e5b5c67837a0$export$3f2f9f5909897157
});
const $fa29e5b5c67837a0$var$o = $fa29e5b5c67837a0$var$s.litElementPolyfillSupport;
$fa29e5b5c67837a0$var$o?.({
    LitElement: $fa29e5b5c67837a0$export$3f2f9f5909897157
});
const $fa29e5b5c67837a0$export$f5c524615a7708d6 = {
    _$AK: (t, e, r)=>{
        t._$AK(e, r);
    },
    _$AL: (t)=>t._$AL
};
($fa29e5b5c67837a0$var$s.litElementVersions ??= []).push("4.2.2");


/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $63b56f98105c10d3$export$6acf61af03e62db = !1;




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $82f77e717d6f56f8$export$da64fc29f17f9d0e = (t)=>(e, o)=>{
        void 0 !== o ? o.addInitializer(()=>{
            customElements.define(t, e);
        }) : customElements.define(t, e);
    };



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $21eb6a58ce309899$var$o = {
    attribute: !0,
    type: String,
    converter: (0, $660ec1ab4f3f3163$export$7312b35fbf521afb),
    reflect: !1,
    hasChanged: (0, $660ec1ab4f3f3163$export$53a6892c50694894)
}, $21eb6a58ce309899$export$8d623b1670eb40f4 = (t = $21eb6a58ce309899$var$o, e, r)=>{
    const { kind: n, metadata: i } = r;
    let s = globalThis.litPropertyMetadata.get(i);
    if (void 0 === s && globalThis.litPropertyMetadata.set(i, s = new Map), "setter" === n && ((t = Object.create(t)).wrapped = !0), s.set(r.name, t), "accessor" === n) {
        const { name: o } = r;
        return {
            set (r) {
                const n = e.get.call(this);
                e.set.call(this, r), this.requestUpdate(o, n, t, !0, r);
            },
            init (e) {
                return void 0 !== e && this.C(o, void 0, t, e), e;
            }
        };
    }
    if ("setter" === n) {
        const { name: o } = r;
        return function(r) {
            const n = this[o];
            e.call(this, r), this.requestUpdate(o, n, t, !0, r);
        };
    }
    throw Error("Unsupported decorator location: " + n);
};
function $21eb6a58ce309899$export$d541bacb2bda4494(t) {
    return (e, o)=>"object" == typeof o ? $21eb6a58ce309899$export$8d623b1670eb40f4(t, e, o) : ((t, e, o)=>{
            const r = e.hasOwnProperty(o);
            return e.constructor.createProperty(o, t), r ? Object.getOwnPropertyDescriptor(e, o) : void 0;
        })(t, e, o);
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $c1ea0a8231c7f453$export$ca000e230c0caa3e(r) {
    return (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
        ...r,
        state: !0,
        attribute: !1
    });
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $a1a88c63724d40c4$export$b2b799818fbabcf3(t) {
    return (n, o)=>{
        const c = "function" == typeof n ? n : n[o];
        Object.assign(c, t);
    };
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $034bb2fd6bc640ff$export$51987bb50e1f6752 = (e, t, c)=>(c.configurable = !0, c.enumerable = !0, Reflect.decorate && "object" != typeof t && Object.defineProperty(e, t, c), c);


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $540200038ed52347$export$2fa187e846a241c4(e, r) {
    return (n, s, i)=>{
        const o = (t)=>t.renderRoot?.querySelector(e) ?? null;
        if (r) {
            const { get: e, set: r } = "object" == typeof s ? n : i ?? (()=>{
                const t = Symbol();
                return {
                    get () {
                        return this[t];
                    },
                    set (e) {
                        this[t] = e;
                    }
                };
            })();
            return (0, $034bb2fd6bc640ff$export$51987bb50e1f6752)(n, s, {
                get () {
                    let t = e.call(this);
                    return void 0 === t && (t = o(this), (null !== t || this.hasUpdated) && r.call(this, t)), t;
                }
            });
        }
        return (0, $034bb2fd6bc640ff$export$51987bb50e1f6752)(n, s, {
            get () {
                return o(this);
            }
        });
    };
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ let $65058a48ece6ee50$var$e;
function $65058a48ece6ee50$export$dcd0d083aa86c355(r) {
    return (n, o)=>(0, $034bb2fd6bc640ff$export$51987bb50e1f6752)(n, o, {
            get () {
                return (this.renderRoot ?? ($65058a48ece6ee50$var$e ??= document.createDocumentFragment())).querySelectorAll(r);
            }
        });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $7e869af31291821b$export$163dfc35cc43f240(r) {
    return (n, e)=>(0, $034bb2fd6bc640ff$export$51987bb50e1f6752)(n, e, {
            async get () {
                return await this.updateComplete, this.renderRoot?.querySelector(r) ?? null;
            }
        });
}



/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $41dd0e989e53d188$export$4682af2d9ee91415(o) {
    return (e, n)=>{
        const { slot: r, selector: s } = o ?? {}, c = "slot" + (r ? `[name=${r}]` : ":not([name])");
        return (0, $034bb2fd6bc640ff$export$51987bb50e1f6752)(e, n, {
            get () {
                const t = this.renderRoot?.querySelector(c), e = t?.assignedElements(o) ?? [];
                return void 0 === s ? e : e.filter((t)=>t.matches(s));
            }
        });
    };
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $8ebd1828d350d04d$export$1bdbe53f9df1b8(n) {
    return (o, r)=>{
        const { slot: e } = n ?? {}, s = "slot" + (e ? `[name=${e}]` : ":not([name])");
        return (0, $034bb2fd6bc640ff$export$51987bb50e1f6752)(o, r, {
            get () {
                const t = this.renderRoot?.querySelector(s);
                return t?.assignedNodes(n) ?? [];
            }
        });
    };
}




/**
 * @license MIT
 * Copyright (c) 2025–2026 matraic
 * See LICENSE file in the project root for full license text.
 */ 
var $gkQP3 = parcelRequire("gkQP3");

/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $6b74d27f2843e810$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $6b74d27f2843e810$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $6b74d27f2843e810$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}






/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $bf9413d16f7d3f6d$export$f68dd208b5df064d = (o)=>o ?? (0, $00a10a29322bb2a1$export$45b790e32b2810ee);




var $ca7aa15aa0ba1e7b$var$_AnimationLoopController_frameId, $ca7aa15aa0ba1e7b$var$_AnimationLoopController_lastTime, $ca7aa15aa0ba1e7b$var$_AnimationLoopController_running, $ca7aa15aa0ba1e7b$var$_AnimationLoopController_callback, $ca7aa15aa0ba1e7b$var$_AnimationLoopController_loop;
/** A `ReactiveController` used to execute a function in an animation loop. */ class $ca7aa15aa0ba1e7b$export$643e6927a51c9d90 {
    constructor(host, callback){
        /** @private */ $ca7aa15aa0ba1e7b$var$_AnimationLoopController_frameId.set(this, null);
        /** @private */ $ca7aa15aa0ba1e7b$var$_AnimationLoopController_lastTime.set(this, 0);
        /** @private */ $ca7aa15aa0ba1e7b$var$_AnimationLoopController_running.set(this, false);
        /** @private */ $ca7aa15aa0ba1e7b$var$_AnimationLoopController_callback.set(this, void 0);
        /** @private */ $ca7aa15aa0ba1e7b$var$_AnimationLoopController_loop.set(this, ()=>{
            if (!(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_AnimationLoopController_running, "f")) return;
            const now = performance.now();
            (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_AnimationLoopController_callback, "f").call(this, (now - (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_AnimationLoopController_lastTime, "f")) / 1000, now / 1000);
            (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_AnimationLoopController_lastTime, now, "f");
            (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_AnimationLoopController_frameId, requestAnimationFrame((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_AnimationLoopController_loop, "f")), "f");
        });
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_AnimationLoopController_callback, callback, "f");
        host.addController(this);
    }
    /** @inheritdoc */ hostDisconnected() {
        this.stop();
    }
    /** Starts the animation loop. */ start() {
        if ((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_AnimationLoopController_running, "f")) return;
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_AnimationLoopController_running, true, "f");
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_AnimationLoopController_lastTime, performance.now(), "f");
        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_AnimationLoopController_loop, "f").call(this);
    }
    /** Stops the animation loop. */ stop() {
        if (!(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_AnimationLoopController_running, "f")) return;
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_AnimationLoopController_running, false, "f");
        if ((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_AnimationLoopController_frameId, "f") !== null) {
            cancelAnimationFrame((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_AnimationLoopController_frameId, "f"));
            (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_AnimationLoopController_frameId, null, "f");
        }
    }
}
$ca7aa15aa0ba1e7b$var$_AnimationLoopController_frameId = new WeakMap(), $ca7aa15aa0ba1e7b$var$_AnimationLoopController_lastTime = new WeakMap(), $ca7aa15aa0ba1e7b$var$_AnimationLoopController_running = new WeakMap(), $ca7aa15aa0ba1e7b$var$_AnimationLoopController_callback = new WeakMap(), $ca7aa15aa0ba1e7b$var$_AnimationLoopController_loop = new WeakMap();
var $ca7aa15aa0ba1e7b$var$_MonitorControllerBase_host, $ca7aa15aa0ba1e7b$var$_MonitorControllerBase_target, $ca7aa15aa0ba1e7b$var$_MonitorControllerBase_targets;
/**
 * A base implementation for a `ReactiveController` used to monitor the state of one
 * or more elements. This class must be inherited.
 */ class $ca7aa15aa0ba1e7b$var$MonitorControllerBase {
    /**
   * Initializes the `MonitorControllerBase` base class values when called by a derived class.
   * @param {ReactiveControllerHost & HTMLElement} host The host element to which this controller will be added.
   * @param {MonitorControllerOptions} options Options used to configure this controller.
   */ constructor(host, options){
        /** @private */ $ca7aa15aa0ba1e7b$var$_MonitorControllerBase_host.set(this, void 0);
        /** @private */ $ca7aa15aa0ba1e7b$var$_MonitorControllerBase_target.set(this, void 0);
        /** @private */ $ca7aa15aa0ba1e7b$var$_MonitorControllerBase_targets.set(this, new Set());
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_MonitorControllerBase_host, host, "f");
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_MonitorControllerBase_target, options.target, "f");
        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_MonitorControllerBase_host, "f").addController(this);
    }
    /** The targets being observed. */ get targets() {
        return (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_MonitorControllerBase_targets, "f").values();
    }
    /** @inheritdoc */ hostConnected() {
        // Target defaults to host unless explicitly null.
        if ((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_MonitorControllerBase_target, "f") !== null) this.observe((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_MonitorControllerBase_target, "f") ?? (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_MonitorControllerBase_host, "f"));
    }
    /** @inheritdoc */ hostDisconnected() {
        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_MonitorControllerBase_targets, "f").forEach((x)=>this.unobserve(x));
        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_MonitorControllerBase_targets, "f").clear();
    }
    /**
   * Starts observing the specified element.
   * @param {HTMLElement} target The element to start observing.
   */ observe(target) {
        if ((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_MonitorControllerBase_targets, "f").has(target)) return;
        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_MonitorControllerBase_targets, "f").add(target);
        this._observe(target);
    }
    /**
   * Determines whether the specified element is being observed.
   * @param {HTMLElement} target The element to test.
   * @returns {boolean} Whether `target` is being observed.
   */ isObserving(target) {
        return (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_MonitorControllerBase_targets, "f").has(target);
    }
    /**
   * Stops observing the specified element.
   * @param {HTMLElement} target The element to stop observing.
   */ unobserve(target) {
        if (!(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_MonitorControllerBase_targets, "f").delete(target)) return;
        this._unobserve(target);
    }
}
$ca7aa15aa0ba1e7b$var$_MonitorControllerBase_host = new WeakMap(), $ca7aa15aa0ba1e7b$var$_MonitorControllerBase_target = new WeakMap(), $ca7aa15aa0ba1e7b$var$_MonitorControllerBase_targets = new WeakMap();
/**
 * Computes a CSS size expression (var(), %, rem, calc(), etc.) relative to the given host element.
 * @param {HTMLElement} host - The element whose coordinate system and CSS variables should be used to resolve the expression.
 * @param {string} expression - The CSS expression to evaluate.
 * @returns {number} The resolved pixel value.
 */ function $ca7aa15aa0ba1e7b$export$e7e01037a2b604a4(host, expression) {
    if (!expression) return 0;
    const temp = document.createElement("div");
    temp.style.all = "inherit";
    temp.style.width = expression;
    temp.style.position = "absolute";
    temp.style.visibility = "hidden";
    temp.style.pointerEvents = "none";
    host.appendChild(temp);
    try {
        return parseFloat(getComputedStyle(temp).width);
    } finally{
        temp.remove();
    }
}
/**
 * Determines the number of textual lines presented by an element.
 * @param {HTMLElement} element The element for which to compute the number of lines.
 * @returns {number} The number of lines presented by an element.
 */ function $ca7aa15aa0ba1e7b$export$e35a80688523fffb(element) {
    const lineHeight = parseFloat(getComputedStyle(element).lineHeight);
    return isNaN(lineHeight) || lineHeight <= 0 ? 0 : Math.round(element.scrollHeight / lineHeight);
}
/**
 * Asynchronously attempts to focus an element once it becomes focusable.
 * @param {HTMLElement} element The element to to focus.
 * @param {number} [timeout=200] The maximum amount of time to attempt to focus `el`.
 * @returns {Promise<boolean>} A `Promise` that resolves to whether `el` was focused.
 */ async function $ca7aa15aa0ba1e7b$export$75c2638e65e78d0f(element, timeout = 200) {
    element.focus();
    function isFocused(element) {
        const root = element.getRootNode();
        return root instanceof ShadowRoot ? root.activeElement === element : document.activeElement === element;
    }
    const start = performance.now();
    while(!isFocused(element)){
        if (!element.isConnected || performance.now() - start > timeout) return false;
        await new Promise(requestAnimationFrame);
        element.focus();
    }
    return true;
}
/**
 * Determines whether forced colors are active.
 * @returns {boolean} Whether forced colors are active.
 */ function $ca7aa15aa0ba1e7b$export$23294f3699b537b1() {
    return !(0, $63b56f98105c10d3$export$6acf61af03e62db) && matchMedia("(forced-colors: active)").matches;
}
function $ca7aa15aa0ba1e7b$var$lerp(a, b, t) {
    return a + (b - a) * t;
}
function $ca7aa15aa0ba1e7b$var$quadraticBezier(p0, p1, p2, t) {
    const x = Math.pow(1 - t, 2) * p0.x + 2 * (1 - t) * t * p1.x + Math.pow(t, 2) * p2.x;
    const y = Math.pow(1 - t, 2) * p0.y + 2 * (1 - t) * t * p1.y + Math.pow(t, 2) * p2.y;
    return {
        x: x,
        y: y
    };
}
function $ca7aa15aa0ba1e7b$var$cubicBezier(p0, p1, p2, p3, t) {
    const x = Math.pow(1 - t, 3) * p0.x + 3 * Math.pow(1 - t, 2) * t * p1.x + 3 * (1 - t) * Math.pow(t, 2) * p2.x + Math.pow(t, 3) * p3.x;
    const y = Math.pow(1 - t, 3) * p0.y + 3 * Math.pow(1 - t, 2) * t * p1.y + 3 * (1 - t) * Math.pow(t, 2) * p2.y + Math.pow(t, 3) * p3.y;
    return {
        x: x,
        y: y
    };
}
function $ca7aa15aa0ba1e7b$var$parsePath(pathData) {
    const commands = pathData.match(/[a-zA-Z][^a-zA-Z]*/g) || [];
    return commands.map((cmd)=>{
        const type = cmd[0];
        const nums = cmd.slice(1).trim().split(/[\s,]+/).filter(Boolean).map(Number);
        return {
            type: type,
            nums: nums
        };
    });
}
function $ca7aa15aa0ba1e7b$var$samplePath(pathData, maxPoints) {
    const segments = $ca7aa15aa0ba1e7b$var$parsePath(pathData);
    let current = {
        x: 0,
        y: 0
    };
    let start = {
        x: 0,
        y: 0
    };
    const segs = [];
    for (const seg of segments){
        if (seg.type === "M") {
            current = {
                x: seg.nums[0],
                y: seg.nums[1]
            };
            start = current;
        } else if (seg.type === "L") {
            const next = {
                x: seg.nums[0],
                y: seg.nums[1]
            };
            const dx = next.x - current.x;
            const dy = next.y - current.y;
            segs.push({
                type: "L",
                pts: [
                    current,
                    next
                ],
                length: Math.hypot(dx, dy)
            });
            current = next;
        } else if (seg.type === "H") {
            const next = {
                x: seg.nums[0],
                y: current.y
            };
            const dx = next.x - current.x;
            segs.push({
                type: "L",
                pts: [
                    current,
                    next
                ],
                length: Math.abs(dx)
            });
            current = next;
        } else if (seg.type === "V") {
            const next = {
                x: current.x,
                y: seg.nums[0]
            };
            const dy = next.y - current.y;
            segs.push({
                type: "L",
                pts: [
                    current,
                    next
                ],
                length: Math.abs(dy)
            });
            current = next;
        } else if (seg.type === "Q") {
            const p1 = {
                x: seg.nums[0],
                y: seg.nums[1]
            };
            const p2 = {
                x: seg.nums[2],
                y: seg.nums[3]
            };
            let length = 0;
            let prev = current;
            const steps = 20;
            for(let i = 1; i <= steps; i++){
                const t = i / steps;
                const pt = $ca7aa15aa0ba1e7b$var$quadraticBezier(current, p1, p2, t);
                length += Math.hypot(pt.x - prev.x, pt.y - prev.y);
                prev = pt;
            }
            segs.push({
                type: "Q",
                pts: [
                    current,
                    p1,
                    p2
                ],
                length: length
            });
            current = p2;
        } else if (seg.type === "C") {
            const p1 = {
                x: seg.nums[0],
                y: seg.nums[1]
            };
            const p2 = {
                x: seg.nums[2],
                y: seg.nums[3]
            };
            const p3 = {
                x: seg.nums[4],
                y: seg.nums[5]
            };
            let length = 0;
            let prev = current;
            const steps = 20;
            for(let i = 1; i <= steps; i++){
                const t = i / steps;
                const pt = $ca7aa15aa0ba1e7b$var$cubicBezier(current, p1, p2, p3, t);
                length += Math.hypot(pt.x - prev.x, pt.y - prev.y);
                prev = pt;
            }
            segs.push({
                type: "C",
                pts: [
                    current,
                    p1,
                    p2,
                    p3
                ],
                length: length
            });
            current = p3;
        } else if (seg.type === "Z") {
            const dx = start.x - current.x;
            const dy = start.y - current.y;
            segs.push({
                type: "L",
                pts: [
                    current,
                    start
                ],
                length: Math.hypot(dx, dy)
            });
            current = start;
        }
    }
    const totalLength = segs.reduce((sum, s)=>sum + s.length, 0);
    const step = totalLength / (maxPoints - 1);
    const points = [];
    let distSoFar = 0;
    let segIndex = 0;
    for(let i = 0; i < maxPoints; i++){
        const targetDist = i * step;
        while(segIndex < segs.length && distSoFar + segs[segIndex].length < targetDist){
            distSoFar += segs[segIndex].length;
            segIndex++;
        }
        const seg = segs[segIndex];
        if (!seg) break;
        const localT = (targetDist - distSoFar) / seg.length;
        if (seg.type === "L") {
            const [p0, p1] = seg.pts;
            points.push({
                x: $ca7aa15aa0ba1e7b$var$lerp(p0.x, p1.x, localT),
                y: $ca7aa15aa0ba1e7b$var$lerp(p0.y, p1.y, localT)
            });
        } else if (seg.type === "Q") {
            const [p0, p1, p2] = seg.pts;
            points.push($ca7aa15aa0ba1e7b$var$quadraticBezier(p0, p1, p2, localT));
        } else if (seg.type === "C") {
            const [p0, p1, p2, p3] = seg.pts;
            points.push($ca7aa15aa0ba1e7b$var$cubicBezier(p0, p1, p2, p3, localT));
        }
    }
    return points;
}
function $ca7aa15aa0ba1e7b$var$pointsToPercentClipPath(points) {
    const coords = points.map((p)=>{
        const xPercent = $ca7aa15aa0ba1e7b$var$clamp(p.x * 100, 0, 100);
        const yPercent = $ca7aa15aa0ba1e7b$var$clamp(p.y * 100, 0, 100);
        return `${xPercent.toFixed(2)}% ${yPercent.toFixed(2)}%`;
    });
    return `${coords.join(", ")}`;
}
function $ca7aa15aa0ba1e7b$var$clamp(v, a, b) {
    return Math.max(a, Math.min(b, v));
}
function $ca7aa15aa0ba1e7b$var$bbox(points) {
    let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;
    for (const p of points){
        if (p.x < minX) minX = p.x;
        if (p.x > maxX) maxX = p.x;
        if (p.y < minY) minY = p.y;
        if (p.y > maxY) maxY = p.y;
    }
    return {
        minX: minX,
        minY: minY,
        maxX: maxX,
        maxY: maxY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $ca7aa15aa0ba1e7b$var$rotateArray(arr, offset) {
    const n = arr.length;
    const out = new Array(n);
    for(let i = 0; i < n; i++)out[i] = arr[(i + offset) % n];
    return out;
}
function $ca7aa15aa0ba1e7b$var$bestCircularShift(target, source) {
    const n = Math.min(source.length, target.length);
    let bestK = 0;
    let bestScore = Infinity;
    for(let k = 0; k < n; k++){
        let score = 0;
        for(let i = 0; i < n; i++){
            const s = source[(i + k) % n];
            const t = target[i];
            const dx = s.x - t.x;
            const dy = s.y - t.y;
            score += dx * dx + dy * dy;
            if (score >= bestScore) break; // early exit
        }
        if (score < bestScore) {
            bestScore = score;
            bestK = k;
        }
    }
    return bestK;
}
function $ca7aa15aa0ba1e7b$var$signedArea(points) {
    let area = 0;
    const n = points.length;
    for(let i = 0; i < n; i++){
        const a = points[i];
        const b = points[(i + 1) % n];
        area += a.x * b.y - b.x * a.y;
    }
    return area / 2;
}
function $ca7aa15aa0ba1e7b$var$normalizePointSets(sets) {
    const normalized = sets.map((pts)=>{
        const b = $ca7aa15aa0ba1e7b$var$bbox(pts);
        const translated = pts.map((p)=>({
                x: p.x - b.minX,
                y: p.y - b.minY
            }));
        const scale = Math.max(b.width, b.height) || 1;
        const scaled = translated.map((p)=>({
                x: p.x / scale,
                y: p.y / scale
            }));
        const widthScaled = b.width / scale;
        const heightScaled = b.height / scale;
        const offsetX = (1 - widthScaled) / 2;
        const offsetY = (1 - heightScaled) / 2;
        return scaled.map((p)=>({
                x: p.x + offsetX,
                y: p.y + offsetY
            }));
    });
    const reference = normalized[0];
    const refSign = Math.sign($ca7aa15aa0ba1e7b$var$signedArea(reference));
    for(let i = 1; i < normalized.length; i++){
        let set = normalized[i];
        const sign = Math.sign($ca7aa15aa0ba1e7b$var$signedArea(set));
        if (sign !== 0 && sign !== refSign) set = set.slice().reverse();
        const k = $ca7aa15aa0ba1e7b$var$bestCircularShift(reference, set);
        normalized[i] = $ca7aa15aa0ba1e7b$var$rotateArray(set, k);
    }
    return normalized;
}
/**
 * Generates normalized clip paths from SVG path data.
 * @param {string[]} paths The SVG path data to convert to normalized clip paths.
 * @param {number} maxPoints The maximum number of points to which to normalize paths.
 * @returns {string[]} The normalized clip paths.
 */ function $ca7aa15aa0ba1e7b$export$bd65317e0df81807(paths, maxPoints) {
    return $ca7aa15aa0ba1e7b$var$normalizePointSets(paths.map((x)=>$ca7aa15aa0ba1e7b$var$samplePath(x, maxPoints))).map((x)=>$ca7aa15aa0ba1e7b$var$pointsToPercentClipPath(x));
}
let $ca7aa15aa0ba1e7b$var$_cachedScrollbarWidth = null;
let $ca7aa15aa0ba1e7b$var$_cachedThinScrollbarWidth = null;
/**
 * Computes the width of a scrollbar.
 * @param {boolean} [thin=false] Whether to get the width of a thin scrollbar.
 * @returns {number} The width of a scrollbar.
 */ function $ca7aa15aa0ba1e7b$export$ace028f8da1a6300(thin = false) {
    if (thin) {
        if ($ca7aa15aa0ba1e7b$var$_cachedThinScrollbarWidth !== null) return $ca7aa15aa0ba1e7b$var$_cachedThinScrollbarWidth;
    }
    if ($ca7aa15aa0ba1e7b$var$_cachedScrollbarWidth !== null) return $ca7aa15aa0ba1e7b$var$_cachedScrollbarWidth;
    const outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.overflow = "scroll";
    if (thin) outer.style.scrollbarWidth = "thin";
    outer.style.width = "100px";
    outer.style.position = "absolute";
    outer.style.top = "-9999px";
    document.body.appendChild(outer);
    const inner = document.createElement("div");
    inner.style.width = "100%";
    outer.appendChild(inner);
    let scrollbarWidth;
    if (thin) scrollbarWidth = $ca7aa15aa0ba1e7b$var$_cachedThinScrollbarWidth = outer.offsetWidth - inner.offsetWidth;
    else scrollbarWidth = $ca7aa15aa0ba1e7b$var$_cachedScrollbarWidth = outer.offsetWidth - inner.offsetWidth;
    outer.remove();
    return scrollbarWidth;
}
/**
 * Gets the text content of a given node, including slotted content.
 * @param {Node} node The node for which to get text content.
 * @param {boolean} [trim = false] A value indicating whether to trim content.
 * @returns {string} The text content of `node`.
 */ function $ca7aa15aa0ba1e7b$export$132e79e4118a78e0(node, trim = false) {
    let textContent = "";
    switch(node.nodeType){
        case Node.TEXT_NODE:
            textContent = node.nodeValue ?? "";
            break;
        case Node.ELEMENT_NODE:
            if (node instanceof HTMLSlotElement) for (const assignedNode of node.assignedNodes({
                flatten: true
            }))textContent += $ca7aa15aa0ba1e7b$export$132e79e4118a78e0(assignedNode, trim);
            else for (const child of node.childNodes)textContent += $ca7aa15aa0ba1e7b$export$132e79e4118a78e0(child, trim);
            break;
    }
    if (trim) textContent = textContent.trim();
    return textContent;
}
/**
 * Generates a new globally unique identifier (GUID).
 * @returns {string} A new globally unique identifier.
 */ function $ca7aa15aa0ba1e7b$export$46e8f25c7328f77e() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0;
        const v = c === "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
/**
 * Determines whether a slot has any assigned nodes.
 * @param {HTMLSlotElement} slot The slot to test.
 * @returns {boolean} Whether `slot` has any assigned nodes.
 */ function $ca7aa15aa0ba1e7b$export$e0478d61fdced58c(slot) {
    return slot.assignedNodes({
        flatten: true
    }).length > 0;
}
/**
 * Intercepts property access and mutations on a target object, allowing custom logic
 * to run when the property is read or written to.
 *
 * @template T - The type of the target object.
 * @template K - The key of the property being intercepted (must be a valid key of T).
 * @param target - The object whose property should be intercepted.
 * @param prop - The property key to intercept.
 * @param options - Configuration object for interceptor callbacks.
 * @returns A cleanup function that removes the interceptors and restores the original property descriptor.
 * @throws {Error} If the property does not exist on the target object or its prototype chain.
 */ function $ca7aa15aa0ba1e7b$export$71095dc9b7609b02(target, prop, options) {
    const descriptor = Object.getOwnPropertyDescriptor(target, prop) ?? Object.getOwnPropertyDescriptor(Object.getPrototypeOf(target), prop);
    if (!descriptor) throw new Error(`Property ${String(prop)} not found on target.`);
    const getter = descriptor.get?.bind(target);
    const setter = descriptor.set?.bind(target);
    Object.defineProperty(target, prop, {
        configurable: true,
        enumerable: descriptor.enumerable,
        get () {
            return options.get ? options.get(()=>getter?.()) : getter?.();
        },
        set (v) {
            if (options.set) options.set(v, (val)=>setter?.(val));
            else setter?.(v);
        }
    });
    return ()=>Object.defineProperty(target, prop, descriptor);
}
/**
 * Determines whether reduced motion is preferred.
 * @returns {boolean} Whether reduced motion is preferred.
 */ function $ca7aa15aa0ba1e7b$export$ff7706047246b98b() {
    return (0, $63b56f98105c10d3$export$6acf61af03e62db) || matchMedia("(prefers-reduced-motion)").matches;
}
/**
 * Registers a constructable stylesheet in the document's `adoptedStyleSheets`.
 * @param css - A `CSSResult` (e.g., from `css```) whose text will be injected into a constructable stylesheet.
 */ function $ca7aa15aa0ba1e7b$export$bbc01d91837a4fd(css) {
    if (typeof window === "undefined") return;
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(css.toString());
    document.adoptedStyleSheets = [
        ...document.adoptedStyleSheets,
        sheet
    ];
}
/**
 * Resolves an element by ID, waiting for document readiness if needed.
 * @param {string} id - The element ID to resolve.
 * @param {ParentNode} root - Optional root node to query from (defaults to document).
 * @returns {Promise<T | null>} A promise that resolves with the element or `null` if not found.
 */ function $ca7aa15aa0ba1e7b$export$eaf3894a2d38d832(id, root = document) {
    return new Promise((resolve)=>{
        const element = root.querySelector(`#${id}`);
        if (element) {
            resolve(element);
            return;
        }
        if (document.readyState === "complete" || document.readyState === "interactive") {
            resolve(root.querySelector(`#${id}`));
            return;
        }
        document.addEventListener("DOMContentLoaded", ()=>resolve(root.querySelector(`#${id}`)), {
            once: true
        });
    });
}
/**
 * Resolves a URL fragment reference (`url(path#id)`) based on the current document location.
 *
 * This helper is typically used when constructing fragment-based URLs for SVG
 * references (e.g., masks, clipPaths, filters) where the browser requires a fully
 * qualified `url(...)` value that includes the current path.
 *
 * How it works:
 * - Safely reads `document.location` (guarded for SSR environments).
 * - Extracts the current page's path + query string.
 * - Removes any existing hash fragment from the URL.
 * - Appends `#${id}` to produce a stable fragment reference.
 *
 * Example:
 *   // If the current page is /viewer/page?mode=edit#section2
 *   resolveFragmentUrl("clip") → "url(/viewer/page?mode=edit#clip)"
 *
 * @param id - The fragment identifier to append (e.g., an SVG element's ID).
 * @returns A `url(...)` string pointing to the fragment within the current document.
 */ function $ca7aa15aa0ba1e7b$export$fdcd38275e41d289(id) {
    const location = document?.location ?? null;
    const path = location ? (location.pathname + location.search).split("#")[0] : "";
    return `url(${path}#${id})`;
}
/**
 * If needed, scrolls an element into view within a given scroll container.
 * @param {HTMLElement} element The element to scroll into view.
 * @param {HTMLElement} scrollContainer The scrollable container.
 * @param {ScrollIntoViewOptions} [options=undefined] Options used to scroll into view.
 */ function $ca7aa15aa0ba1e7b$export$9657601bf1e130ee(element, scrollContainer, options) {
    const containerBounds = scrollContainer.getBoundingClientRect();
    const elementBounds = element.getBoundingClientRect();
    if (elementBounds.top < containerBounds.top || elementBounds.bottom > containerBounds.bottom) element.scrollIntoView(options);
}
var $ca7aa15aa0ba1e7b$var$_VelocityTracker_samples, $ca7aa15aa0ba1e7b$var$_VelocityTracker_windowMs;
/** Utility for computing gesture velocity over a rolling time window. */ class $ca7aa15aa0ba1e7b$export$a81cb2a8dbea27f5 {
    /**
   * @param {number} [windowMs = 100] The size of the rolling sampling window in milliseconds.
   */ constructor(windowMs = 100){
        /** @private */ $ca7aa15aa0ba1e7b$var$_VelocityTracker_samples.set(this, []);
        /** @private */ $ca7aa15aa0ba1e7b$var$_VelocityTracker_windowMs.set(this, void 0);
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_VelocityTracker_windowMs, windowMs, "f");
    }
    /**
   * Adds a new sample to the tracker.
   * @param {number} value The value in pixels.
   * @param {number} [timestamp=performance.now()] The timestamp when `value` changed.
   */ add(value, timestamp = performance.now()) {
        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_VelocityTracker_samples, "f").push({
            y: value,
            t: timestamp
        });
        const cutoff = timestamp - (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_VelocityTracker_windowMs, "f");
        while((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_VelocityTracker_samples, "f").length > 1 && (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_VelocityTracker_samples, "f")[0].t < cutoff)(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_VelocityTracker_samples, "f").shift();
    }
    /**
   * Computes the current velocity in px/s.
   * @returns The vertical velocity in pixels per second.
   */ getVelocity() {
        if ((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_VelocityTracker_samples, "f").length < 2) return 0;
        const first = (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_VelocityTracker_samples, "f")[0];
        const last = (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_VelocityTracker_samples, "f")[(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_VelocityTracker_samples, "f").length - 1];
        const dy = last.y - first.y;
        const dt = (last.t - first.t) / 1000;
        return dt > 0 ? dy / dt : 0;
    }
    /** Clears all stored samples. */ reset() {
        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_VelocityTracker_samples, "f").length = 0;
    }
}
$ca7aa15aa0ba1e7b$var$_VelocityTracker_samples = new WeakMap(), $ca7aa15aa0ba1e7b$var$_VelocityTracker_windowMs = new WeakMap();
/**
 * Determines whether an element is a custom element and waits for it to be upgraded.
 * @param {Element} el The element for which to wait for upgrade.
 */ async function $ca7aa15aa0ba1e7b$export$6796da3dcba2f2eb(el) {
    const tag = el.tagName.toLowerCase();
    if (!tag.includes("-")) return;
    if (!customElements.get(tag)) await customElements.whenDefined(tag);
    const ctor = customElements.get(tag);
    if (!ctor || el instanceof ctor) return;
    await Promise.resolve();
    if (el instanceof ctor) return;
    await Promise.resolve();
}
var $ca7aa15aa0ba1e7b$var$_FocusController_instances, $ca7aa15aa0ba1e7b$var$_FocusController_touch, $ca7aa15aa0ba1e7b$var$_FocusController_callback, $ca7aa15aa0ba1e7b$var$_FocusController_keyDownHandler, $ca7aa15aa0ba1e7b$var$_FocusController_focusInHandler, $ca7aa15aa0ba1e7b$var$_FocusController_focusOutHandler, $ca7aa15aa0ba1e7b$var$_FocusController_touchStartHandler, $ca7aa15aa0ba1e7b$var$_FocusController_touchEndHandler, $ca7aa15aa0ba1e7b$var$_FocusController_hadKeydown, $ca7aa15aa0ba1e7b$var$_FocusController_windowKeyDownHandler, $ca7aa15aa0ba1e7b$var$_FocusController_windowPointerDownHandler, $ca7aa15aa0ba1e7b$var$_FocusController_handleKeyDown, $ca7aa15aa0ba1e7b$var$_FocusController_handleFocusIn, $ca7aa15aa0ba1e7b$var$_FocusController_handleFocusOut;
/** A `ReactiveController` used to monitor the focused state of one or more elements. */ class $ca7aa15aa0ba1e7b$export$766c876d58dec02e extends $ca7aa15aa0ba1e7b$var$MonitorControllerBase {
    /**
   * Initializes a new instance of this class.
   * @param {ReactiveControllerHost & HTMLElement} host The host element to which this controller will be added.
   * @param {FocusControllerOptions} options Options used to configure this controller.
   */ constructor(host, options){
        super(host, options);
        $ca7aa15aa0ba1e7b$var$_FocusController_instances.add(this);
        /** @private */ $ca7aa15aa0ba1e7b$var$_FocusController_touch.set(this, false);
        /** @private */ $ca7aa15aa0ba1e7b$var$_FocusController_callback.set(this, void 0);
        /** @private */ $ca7aa15aa0ba1e7b$var$_FocusController_keyDownHandler.set(this, (e)=>(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_FocusController_instances, "m", $ca7aa15aa0ba1e7b$var$_FocusController_handleKeyDown).call(this, e));
        /** @private */ $ca7aa15aa0ba1e7b$var$_FocusController_focusInHandler.set(this, (e)=>(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_FocusController_instances, "m", $ca7aa15aa0ba1e7b$var$_FocusController_handleFocusIn).call(this, e));
        /** @private */ $ca7aa15aa0ba1e7b$var$_FocusController_focusOutHandler.set(this, (e)=>(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_FocusController_instances, "m", $ca7aa15aa0ba1e7b$var$_FocusController_handleFocusOut).call(this, e));
        /** @private */ $ca7aa15aa0ba1e7b$var$_FocusController_touchStartHandler.set(this, ()=>(0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_FocusController_touch, true, "f"));
        /** @private */ $ca7aa15aa0ba1e7b$var$_FocusController_touchEndHandler.set(this, ()=>(0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_FocusController_touch, false, "f"));
        /** @private */ $ca7aa15aa0ba1e7b$var$_FocusController_hadKeydown.set(this, false);
        /** @private */ $ca7aa15aa0ba1e7b$var$_FocusController_windowKeyDownHandler.set(this, ()=>(0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_FocusController_hadKeydown, true, "f"));
        /** @private */ $ca7aa15aa0ba1e7b$var$_FocusController_windowPointerDownHandler.set(this, ()=>(0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_FocusController_hadKeydown, false, "f"));
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_FocusController_callback, options.callback, "f");
    }
    /** @inheritdoc */ hostConnected() {
        super.hostConnected();
        window?.addEventListener("keydown", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_FocusController_windowKeyDownHandler, "f"), {
            capture: true,
            passive: true
        });
        window?.addEventListener("pointerdown", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_FocusController_windowPointerDownHandler, "f"), {
            capture: true
        });
    }
    /** @inheritdoc */ hostDisconnected() {
        super.hostDisconnected();
        window?.removeEventListener("keydown", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_FocusController_windowKeyDownHandler, "f"), {
            capture: true
        });
        window?.removeEventListener("pointerdown", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_FocusController_windowPointerDownHandler, "f"), {
            capture: true
        });
    }
    /**
   * Starts observing the specified element.
   * @param {HTMLElement} target The element to start observing.
   */ _observe(target) {
        target.addEventListener("keydown", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_FocusController_keyDownHandler, "f"));
        target.addEventListener("focusin", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_FocusController_focusInHandler, "f"));
        target.addEventListener("focusout", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_FocusController_focusOutHandler, "f"));
        target.addEventListener("touchstart", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_FocusController_touchStartHandler, "f"));
        target.addEventListener("touchend", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_FocusController_touchEndHandler, "f"));
        target.addEventListener("touchcancel", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_FocusController_touchEndHandler, "f"));
    }
    /**
   * Stops observing the specified element.
   * @param {HTMLElement} target The element to stop observing.
   */ _unobserve(target) {
        target.removeEventListener("keydown", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_FocusController_keyDownHandler, "f"));
        target.removeEventListener("focusin", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_FocusController_focusInHandler, "f"));
        target.removeEventListener("focusout", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_FocusController_focusOutHandler, "f"));
        target.removeEventListener("touchstart", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_FocusController_touchStartHandler, "f"));
        target.removeEventListener("touchend", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_FocusController_touchEndHandler, "f"));
        target.removeEventListener("touchcancel", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_FocusController_touchEndHandler, "f"));
    }
}
$ca7aa15aa0ba1e7b$var$_FocusController_touch = new WeakMap(), $ca7aa15aa0ba1e7b$var$_FocusController_callback = new WeakMap(), $ca7aa15aa0ba1e7b$var$_FocusController_keyDownHandler = new WeakMap(), $ca7aa15aa0ba1e7b$var$_FocusController_focusInHandler = new WeakMap(), $ca7aa15aa0ba1e7b$var$_FocusController_focusOutHandler = new WeakMap(), $ca7aa15aa0ba1e7b$var$_FocusController_touchStartHandler = new WeakMap(), $ca7aa15aa0ba1e7b$var$_FocusController_touchEndHandler = new WeakMap(), $ca7aa15aa0ba1e7b$var$_FocusController_hadKeydown = new WeakMap(), $ca7aa15aa0ba1e7b$var$_FocusController_windowKeyDownHandler = new WeakMap(), $ca7aa15aa0ba1e7b$var$_FocusController_windowPointerDownHandler = new WeakMap(), $ca7aa15aa0ba1e7b$var$_FocusController_instances = new WeakSet(), $ca7aa15aa0ba1e7b$var$_FocusController_handleKeyDown = function _FocusController_handleKeyDown(e) {
    const target = e.currentTarget;
    if (target.matches(":focus-within")) (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_FocusController_instances, "m", $ca7aa15aa0ba1e7b$var$_FocusController_handleFocusIn).call(this, e);
}, $ca7aa15aa0ba1e7b$var$_FocusController_handleFocusIn = function _FocusController_handleFocusIn(e) {
    if ((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_FocusController_touch, "f")) return;
    const target = e.currentTarget;
    (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_FocusController_callback, "f").call(this, true, target.matches(":focus-visible") || (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_FocusController_hadKeydown, "f") || $ca7aa15aa0ba1e7b$export$23294f3699b537b1(), target);
}, $ca7aa15aa0ba1e7b$var$_FocusController_handleFocusOut = function _FocusController_handleFocusOut(e) {
    if ((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_FocusController_touch, "f")) return;
    (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_FocusController_callback, "f").call(this, false, false, e.currentTarget);
};
var $ca7aa15aa0ba1e7b$var$_HoverController_instances, $ca7aa15aa0ba1e7b$var$_HoverController_callback, $ca7aa15aa0ba1e7b$var$_HoverController_startDelays, $ca7aa15aa0ba1e7b$var$_HoverController_endDelays, $ca7aa15aa0ba1e7b$var$_HoverController_pointerInHandler, $ca7aa15aa0ba1e7b$var$_HoverController_pointerLeaveHandler, $ca7aa15aa0ba1e7b$var$_HoverController_clearDelays, $ca7aa15aa0ba1e7b$var$_HoverController_clearStartDelay, $ca7aa15aa0ba1e7b$var$_HoverController_clearEndDelay, $ca7aa15aa0ba1e7b$var$_HoverController_handlePointerEnter, $ca7aa15aa0ba1e7b$var$_HoverController_handlePointerLeave;
/** A `ReactiveController` used to monitor the hover state of one or more elements. */ class $ca7aa15aa0ba1e7b$export$e97521e950437f92 extends $ca7aa15aa0ba1e7b$var$MonitorControllerBase {
    /**
   * Initializes a new instance of this class.
   * @param {ReactiveControllerHost & HTMLElement} host The host element to which this controller will be added.
   * @param {HoverControllerOptions} options Options used to configure this controller.
   */ constructor(host, options){
        super(host, options);
        $ca7aa15aa0ba1e7b$var$_HoverController_instances.add(this);
        /** @private */ $ca7aa15aa0ba1e7b$var$_HoverController_callback.set(this, void 0);
        /** @private */ $ca7aa15aa0ba1e7b$var$_HoverController_startDelays.set(this, new Map());
        /** @private */ $ca7aa15aa0ba1e7b$var$_HoverController_endDelays.set(this, new Map());
        /** @private */ $ca7aa15aa0ba1e7b$var$_HoverController_pointerInHandler.set(this, (e)=>(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_HoverController_instances, "m", $ca7aa15aa0ba1e7b$var$_HoverController_handlePointerEnter).call(this, e));
        /** @private */ $ca7aa15aa0ba1e7b$var$_HoverController_pointerLeaveHandler.set(this, (e)=>(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_HoverController_instances, "m", $ca7aa15aa0ba1e7b$var$_HoverController_handlePointerLeave).call(this, e));
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_HoverController_callback, options.callback, "f");
        this.startDelay = options.startDelay ?? 0;
        this.endDelay = options.endDelay ?? 0;
    }
    /** Clears any hover delays for all targets. */ clearDelays() {
        for (const target of this.targets)(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_HoverController_instances, "m", $ca7aa15aa0ba1e7b$var$_HoverController_clearDelays).call(this, target);
    }
    /**
   * Starts observing the specified element.
   * @param {HTMLElement} target The element to start observing.
   */ _observe(target) {
        target.addEventListener("pointerenter", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_HoverController_pointerInHandler, "f"));
        target.addEventListener("pointerleave", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_HoverController_pointerLeaveHandler, "f"));
        target.addEventListener("touchend", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_HoverController_pointerLeaveHandler, "f"));
    }
    /**
   * Stops observing the specified element.
   * @param {HTMLElement} target The element to stop observing.
   */ _unobserve(target) {
        target.removeEventListener("pointerenter", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_HoverController_pointerInHandler, "f"));
        target.removeEventListener("pointerleave", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_HoverController_pointerLeaveHandler, "f"));
        target.removeEventListener("touchend", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_HoverController_pointerLeaveHandler, "f"));
    }
}
$ca7aa15aa0ba1e7b$var$_HoverController_callback = new WeakMap(), $ca7aa15aa0ba1e7b$var$_HoverController_startDelays = new WeakMap(), $ca7aa15aa0ba1e7b$var$_HoverController_endDelays = new WeakMap(), $ca7aa15aa0ba1e7b$var$_HoverController_pointerInHandler = new WeakMap(), $ca7aa15aa0ba1e7b$var$_HoverController_pointerLeaveHandler = new WeakMap(), $ca7aa15aa0ba1e7b$var$_HoverController_instances = new WeakSet(), $ca7aa15aa0ba1e7b$var$_HoverController_clearDelays = function _HoverController_clearDelays(target) {
    (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_HoverController_instances, "m", $ca7aa15aa0ba1e7b$var$_HoverController_clearStartDelay).call(this, target);
    (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_HoverController_instances, "m", $ca7aa15aa0ba1e7b$var$_HoverController_clearEndDelay).call(this, target);
}, $ca7aa15aa0ba1e7b$var$_HoverController_clearStartDelay = function _HoverController_clearStartDelay(target) {
    if ((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_HoverController_startDelays, "f").has(target)) {
        clearTimeout((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_HoverController_startDelays, "f").get(target));
        return (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_HoverController_startDelays, "f").delete(target);
    }
    return false;
}, $ca7aa15aa0ba1e7b$var$_HoverController_clearEndDelay = function _HoverController_clearEndDelay(target) {
    if ((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_HoverController_endDelays, "f").has(target)) {
        clearTimeout((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_HoverController_endDelays, "f").get(target));
        return (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_HoverController_endDelays, "f").delete(target);
    }
    return false;
}, $ca7aa15aa0ba1e7b$var$_HoverController_handlePointerEnter = function _HoverController_handlePointerEnter(e) {
    const target = e.target;
    // If there is a pending end delay, cancel it.
    (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_HoverController_instances, "m", $ca7aa15aa0ba1e7b$var$_HoverController_clearEndDelay).call(this, target);
    // Otherwise, if there is a pending start delay, cancel it and start a new one.
    if (this.startDelay > 0) {
        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_HoverController_instances, "m", $ca7aa15aa0ba1e7b$var$_HoverController_clearStartDelay).call(this, target);
        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_HoverController_startDelays, "f").set(target, setTimeout(()=>{
            (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_HoverController_startDelays, "f").delete(target);
            (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_HoverController_callback, "f").call(this, true, target);
        }, this.startDelay));
    } else // Otherwise, report the start.
    (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_HoverController_callback, "f").call(this, true, target);
}, $ca7aa15aa0ba1e7b$var$_HoverController_handlePointerLeave = function _HoverController_handlePointerLeave(e) {
    const target = e.target;
    // If there is a pending start delay, cancel it and do not report the end.
    if ((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_HoverController_instances, "m", $ca7aa15aa0ba1e7b$var$_HoverController_clearStartDelay).call(this, target)) return;
    // Otherwise, if there is a pending end delay, cancel it and start a new one.
    if (this.endDelay > 0) {
        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_HoverController_instances, "m", $ca7aa15aa0ba1e7b$var$_HoverController_clearEndDelay).call(this, target);
        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_HoverController_endDelays, "f").set(target, setTimeout(()=>{
            (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_HoverController_endDelays, "f").delete(target);
            (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_HoverController_callback, "f").call(this, false, target);
        }, this.endDelay));
    } else // Otherwise, report the end.
    (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_HoverController_callback, "f").call(this, false, target);
};
var $ca7aa15aa0ba1e7b$var$_InertController_host, $ca7aa15aa0ba1e7b$var$_InertController_inerts;
/**
 * A `ReactiveController` that provides safe, predictable inerting of background
 * content for modal UI surfaces (dialogs, date pickers, fullscreen search views).
 */ class $ca7aa15aa0ba1e7b$export$155838d88759dd18 {
    constructor(host){
        /** @private */ $ca7aa15aa0ba1e7b$var$_InertController_host.set(this, void 0);
        /** @private */ $ca7aa15aa0ba1e7b$var$_InertController_inerts.set(this, new Array());
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_InertController_host, host, "f");
        host.addController(this);
    }
    /**
   * Locks background content by applying inertness to all non‑modal elements,
   * isolating the active surface from pointer and keyboard interaction.
   */ lock() {
        this.unlock();
        for(let current = (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_InertController_host, "f"); current.parentNode && current.parentNode !== document.documentElement; current = current.parentNode){
            for (const sibling of current.parentNode.children)if (sibling instanceof HTMLElement && sibling !== current && !sibling.inert) {
                sibling.inert = true;
                (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_InertController_inerts, "f").push(sibling);
            }
        }
    }
    /** Restores background interactivity by removing inertness previously applied during `lock()`. */ unlock() {
        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_InertController_inerts, "f").forEach((x)=>x.inert = false);
        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_InertController_inerts, "f").length = 0;
    }
    /** @inheritdoc */ hostDisconnected() {
        this.unlock();
    }
}
$ca7aa15aa0ba1e7b$var$_InertController_host = new WeakMap(), $ca7aa15aa0ba1e7b$var$_InertController_inerts = new WeakMap();
var $ca7aa15aa0ba1e7b$var$_IntersectionController_callback, $ca7aa15aa0ba1e7b$var$_IntersectionController_skipInitial, $ca7aa15aa0ba1e7b$var$_IntersectionController_observer, $ca7aa15aa0ba1e7b$var$_IntersectionController_unobservedUpdate;
/** A `ReactiveController` used to monitor changes in the intersection of a target element with an ancestor element. */ class $ca7aa15aa0ba1e7b$export$e9284c0dbc55b3ba extends $ca7aa15aa0ba1e7b$var$MonitorControllerBase {
    /**
   * Initializes a new instance of the `IntersectionController` class.
   * @param {ReactiveControllerHost & HTMLElement} host The host element to which this controller will be added.
   * @param {IntersectionControllerOptions} options Options used to configure this controller.
   */ constructor(host, options){
        super(host, options);
        /** @private */ $ca7aa15aa0ba1e7b$var$_IntersectionController_callback.set(this, void 0);
        /** @private */ $ca7aa15aa0ba1e7b$var$_IntersectionController_skipInitial.set(this, false);
        /** @private */ $ca7aa15aa0ba1e7b$var$_IntersectionController_observer.set(this, void 0);
        /** @private */ $ca7aa15aa0ba1e7b$var$_IntersectionController_unobservedUpdate.set(this, true);
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_IntersectionController_callback, options.callback, "f");
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_IntersectionController_skipInitial, options.skipInitial ?? false, "f");
        if (0, $63b56f98105c10d3$export$6acf61af03e62db) return;
        if (!window.IntersectionObserver) {
            console.warn("IntersectionController error: the browser does not support IntersectionObserver.");
            return;
        }
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_IntersectionController_observer, new IntersectionObserver((entries, observer)=>{
            (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_IntersectionController_callback, "f").call(this, entries, observer);
        }, options.init), "f");
    }
    /** @inheritdoc */ async hostUpdated() {
        if ((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_IntersectionController_observer, "f") && !(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_IntersectionController_skipInitial, "f") && (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_IntersectionController_unobservedUpdate, "f")) (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_IntersectionController_callback, "f").call(this, [], (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_IntersectionController_observer, "f"));
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_IntersectionController_unobservedUpdate, false, "f");
    }
    /**
   * Starts observing the specified element.
   * @param {HTMLElement} target The element to start observing.
   */ _observe(target) {
        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_IntersectionController_observer, "f")?.observe(target);
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_IntersectionController_unobservedUpdate, true, "f");
    }
    /**
   * Stops observing the specified element.
   * @param {HTMLElement} target The element to stop observing.
   */ _unobserve(target) {
        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_IntersectionController_observer, "f")?.unobserve(target);
    }
}
$ca7aa15aa0ba1e7b$var$_IntersectionController_callback = new WeakMap(), $ca7aa15aa0ba1e7b$var$_IntersectionController_skipInitial = new WeakMap(), $ca7aa15aa0ba1e7b$var$_IntersectionController_observer = new WeakMap(), $ca7aa15aa0ba1e7b$var$_IntersectionController_unobservedUpdate = new WeakMap();
var $ca7aa15aa0ba1e7b$var$_LongPressController_instances, $ca7aa15aa0ba1e7b$var$_LongPressController_callback, $ca7aa15aa0ba1e7b$var$_LongPressController_threshold, $ca7aa15aa0ba1e7b$var$_LongPressController_pressedTargets, $ca7aa15aa0ba1e7b$var$_LongPressController_pressedTimeouts, $ca7aa15aa0ba1e7b$var$_LongPressController_touchStartHandler, $ca7aa15aa0ba1e7b$var$_LongPressController_touchEndOrCancelHandler, $ca7aa15aa0ba1e7b$var$_LongPressController_handleTouchStart, $ca7aa15aa0ba1e7b$var$_LongPressController_handleTouchEndOrCancel;
/** A `ReactiveController` used to detect a long press gesture. */ class $ca7aa15aa0ba1e7b$export$e8716f94d74321da extends $ca7aa15aa0ba1e7b$var$MonitorControllerBase {
    /**
   * Initializes a new instance of this class.
   * @param {ReactiveControllerHost & HTMLElement} host The host element to which this controller will be added.
   * @param {LongPressControllerOptions} options Options used to configure this controller.
   */ constructor(host, options){
        super(host, options);
        $ca7aa15aa0ba1e7b$var$_LongPressController_instances.add(this);
        /** @private */ $ca7aa15aa0ba1e7b$var$_LongPressController_callback.set(this, void 0);
        /** @private */ $ca7aa15aa0ba1e7b$var$_LongPressController_threshold.set(this, void 0);
        /** @private */ $ca7aa15aa0ba1e7b$var$_LongPressController_pressedTargets.set(this, new Set());
        /** @private */ $ca7aa15aa0ba1e7b$var$_LongPressController_pressedTimeouts.set(this, new Map());
        /** @private */ $ca7aa15aa0ba1e7b$var$_LongPressController_touchStartHandler.set(this, (e)=>(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_LongPressController_instances, "m", $ca7aa15aa0ba1e7b$var$_LongPressController_handleTouchStart).call(this, e));
        /** @private */ $ca7aa15aa0ba1e7b$var$_LongPressController_touchEndOrCancelHandler.set(this, (e)=>(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_LongPressController_instances, "m", $ca7aa15aa0ba1e7b$var$_LongPressController_handleTouchEndOrCancel).call(this, e));
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_LongPressController_callback, options.callback, "f");
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_LongPressController_threshold, options.threshold ?? 500, "f");
    }
    /**
   * Starts observing the specified element.
   * @param {HTMLElement} target The element to start observing.
   */ _observe(target) {
        target.addEventListener("touchstart", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_LongPressController_touchStartHandler, "f"), {
            passive: true
        });
        target.addEventListener("touchend", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_LongPressController_touchEndOrCancelHandler, "f"));
        target.addEventListener("touchcancel", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_LongPressController_touchEndOrCancelHandler, "f"));
    }
    /**
   * Stops observing the specified element.
   * @param {HTMLElement} target The element to stop observing.
   */ _unobserve(target) {
        target.removeEventListener("touchstart", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_LongPressController_touchStartHandler, "f"));
        target.removeEventListener("touchend", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_LongPressController_touchEndOrCancelHandler, "f"));
        target.removeEventListener("touchcancel", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_LongPressController_touchEndOrCancelHandler, "f"));
    }
}
$ca7aa15aa0ba1e7b$var$_LongPressController_callback = new WeakMap(), $ca7aa15aa0ba1e7b$var$_LongPressController_threshold = new WeakMap(), $ca7aa15aa0ba1e7b$var$_LongPressController_pressedTargets = new WeakMap(), $ca7aa15aa0ba1e7b$var$_LongPressController_pressedTimeouts = new WeakMap(), $ca7aa15aa0ba1e7b$var$_LongPressController_touchStartHandler = new WeakMap(), $ca7aa15aa0ba1e7b$var$_LongPressController_touchEndOrCancelHandler = new WeakMap(), $ca7aa15aa0ba1e7b$var$_LongPressController_instances = new WeakSet(), $ca7aa15aa0ba1e7b$var$_LongPressController_handleTouchStart = function _LongPressController_handleTouchStart(e) {
    if (e.currentTarget instanceof HTMLElement && this.isObserving(e.currentTarget)) {
        const target = e.currentTarget;
        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_LongPressController_pressedTimeouts, "f").set(target, setTimeout(()=>{
            (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_LongPressController_pressedTargets, "f").add(target);
            (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_LongPressController_pressedTimeouts, "f").delete(target);
            (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_LongPressController_callback, "f").call(this, true, target);
        }, (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_LongPressController_threshold, "f")));
    }
}, $ca7aa15aa0ba1e7b$var$_LongPressController_handleTouchEndOrCancel = function _LongPressController_handleTouchEndOrCancel(e) {
    if (e.currentTarget instanceof HTMLElement && this.isObserving(e.currentTarget)) {
        const target = e.currentTarget;
        if ((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_LongPressController_pressedTargets, "f").has(target)) {
            (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_LongPressController_callback, "f").call(this, false, target);
            (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_LongPressController_pressedTargets, "f").delete(target);
        }
        if ((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_LongPressController_pressedTimeouts, "f").has(target)) {
            clearTimeout((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_LongPressController_pressedTimeouts, "f").get(target));
            (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_LongPressController_pressedTimeouts, "f").delete(target);
        }
    }
};
var $ca7aa15aa0ba1e7b$var$_MutationController_callback, $ca7aa15aa0ba1e7b$var$_MutationController_skipInitial, $ca7aa15aa0ba1e7b$var$_MutationController_config, $ca7aa15aa0ba1e7b$var$_MutationController_observer, $ca7aa15aa0ba1e7b$var$_MutationController_unobservedUpdate;
/**
 * A `ReactiveController` that integrates a `MutationObserver` with an element's reactive update lifecycle
 * to detect arbitrary changes to DOM, including nodes being added or removed and attributes changing.
 */ class $ca7aa15aa0ba1e7b$export$745e8cbe4cbbf3f7 extends $ca7aa15aa0ba1e7b$var$MonitorControllerBase {
    /**
   * Initializes a new instance of the `MutationController` class.
   * @param {ReactiveControllerHost & HTMLElement} host The host element to which this controller will be added.
   * @param {MutationControllerOptions} options Options used to configure this controller.
   */ constructor(host, options){
        super(host, options);
        /** @private */ $ca7aa15aa0ba1e7b$var$_MutationController_callback.set(this, void 0);
        /** @private */ $ca7aa15aa0ba1e7b$var$_MutationController_skipInitial.set(this, false);
        /** @private */ $ca7aa15aa0ba1e7b$var$_MutationController_config.set(this, void 0);
        /** @private */ $ca7aa15aa0ba1e7b$var$_MutationController_observer.set(this, void 0);
        /** @private */ $ca7aa15aa0ba1e7b$var$_MutationController_unobservedUpdate.set(this, true);
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_MutationController_callback, options.callback, "f");
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_MutationController_skipInitial, options.skipInitial ?? false, "f");
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_MutationController_config, options.config, "f");
        if (0, $63b56f98105c10d3$export$6acf61af03e62db) return;
        if (!window.MutationObserver) {
            console.warn("MutationController error: the browser does not support MutationObserver.");
            return;
        }
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_MutationController_observer, new MutationObserver((records, observer)=>(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_MutationController_callback, "f").call(this, records, observer)), "f");
    }
    /** @inheritdoc */ async hostUpdated() {
        if ((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_MutationController_observer, "f") && !(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_MutationController_skipInitial, "f") && (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_MutationController_unobservedUpdate, "f")) {
            const records = (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_MutationController_observer, "f").takeRecords();
            if (records.length > 0) (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_MutationController_callback, "f").call(this, records, (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_MutationController_observer, "f"));
        }
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_MutationController_unobservedUpdate, false, "f");
    }
    /** @inheritdoc */ hostDisconnected() {
        super.hostDisconnected();
        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_MutationController_observer, "f")?.disconnect();
    }
    /** @inheritdoc */ _observe(target) {
        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_MutationController_observer, "f")?.observe(target, (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_MutationController_config, "f"));
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_MutationController_unobservedUpdate, true, "f");
    }
    /** @inheritdoc */ _unobserve() {
        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_MutationController_observer, "f")?.disconnect();
        for (const target of this.targets)(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_MutationController_observer, "f")?.observe(target, (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_MutationController_config, "f"));
    }
}
$ca7aa15aa0ba1e7b$var$_MutationController_callback = new WeakMap(), $ca7aa15aa0ba1e7b$var$_MutationController_skipInitial = new WeakMap(), $ca7aa15aa0ba1e7b$var$_MutationController_config = new WeakMap(), $ca7aa15aa0ba1e7b$var$_MutationController_observer = new WeakMap(), $ca7aa15aa0ba1e7b$var$_MutationController_unobservedUpdate = new WeakMap();
var $ca7aa15aa0ba1e7b$var$_PressedController_instances, $ca7aa15aa0ba1e7b$var$_PressedController_capture, $ca7aa15aa0ba1e7b$var$_PressedController_callback, $ca7aa15aa0ba1e7b$var$_PressedController_isPressedKey, $ca7aa15aa0ba1e7b$var$_PressedController_pressedTargets, $ca7aa15aa0ba1e7b$var$_PressedController_minPressedDuration, $ca7aa15aa0ba1e7b$var$_PressedController_pointerDownHandler, $ca7aa15aa0ba1e7b$var$_PressedController_pointerUpHandler, $ca7aa15aa0ba1e7b$var$_PressedController_touchEndHandler, $ca7aa15aa0ba1e7b$var$_PressedController_keyDownHandler, $ca7aa15aa0ba1e7b$var$_PressedController_keyUpHandler, $ca7aa15aa0ba1e7b$var$_PressedController_handlePointerDown, $ca7aa15aa0ba1e7b$var$_PressedController_handlePointerUp, $ca7aa15aa0ba1e7b$var$_PressedController_handleTouchEnd, $ca7aa15aa0ba1e7b$var$_PressedController_handleKeyDown, $ca7aa15aa0ba1e7b$var$_PressedController_handleKeyUp, $ca7aa15aa0ba1e7b$var$_PressedController_clearPressedTargets;
/** A `ReactiveController` used to monitor the pressed state of one or more elements. */ class $ca7aa15aa0ba1e7b$export$1351ab2eef382c23 extends $ca7aa15aa0ba1e7b$var$MonitorControllerBase {
    /**
   * Initializes a new instance of this class.
   * @param {ReactiveControllerHost & HTMLElement} host The host element to which this controller will be added.
   * @param {PressedControllerOptions} options Options used to configure this controller.
   */ constructor(host, options){
        super(host, options);
        $ca7aa15aa0ba1e7b$var$_PressedController_instances.add(this);
        /** @private */ $ca7aa15aa0ba1e7b$var$_PressedController_capture.set(this, void 0);
        /** @private */ $ca7aa15aa0ba1e7b$var$_PressedController_callback.set(this, void 0);
        /** @private */ $ca7aa15aa0ba1e7b$var$_PressedController_isPressedKey.set(this, void 0);
        /** @private */ $ca7aa15aa0ba1e7b$var$_PressedController_pressedTargets.set(this, new Map());
        /** @private */ $ca7aa15aa0ba1e7b$var$_PressedController_minPressedDuration.set(this, void 0);
        /** @private */ $ca7aa15aa0ba1e7b$var$_PressedController_pointerDownHandler.set(this, (e)=>(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_instances, "m", $ca7aa15aa0ba1e7b$var$_PressedController_handlePointerDown).call(this, e));
        /** @private */ $ca7aa15aa0ba1e7b$var$_PressedController_pointerUpHandler.set(this, (e)=>(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_instances, "m", $ca7aa15aa0ba1e7b$var$_PressedController_handlePointerUp).call(this, e));
        /** @private */ $ca7aa15aa0ba1e7b$var$_PressedController_touchEndHandler.set(this, (e)=>(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_instances, "m", $ca7aa15aa0ba1e7b$var$_PressedController_handleTouchEnd).call(this, e));
        /** @private */ $ca7aa15aa0ba1e7b$var$_PressedController_keyDownHandler.set(this, (e)=>(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_instances, "m", $ca7aa15aa0ba1e7b$var$_PressedController_handleKeyDown).call(this, e));
        /** @private */ $ca7aa15aa0ba1e7b$var$_PressedController_keyUpHandler.set(this, (e)=>(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_instances, "m", $ca7aa15aa0ba1e7b$var$_PressedController_handleKeyUp).call(this, e));
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_capture, options.capture, "f");
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_callback, options.callback, "f");
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_isPressedKey, options.isPressedKey, "f");
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_minPressedDuration, options.minPressedDuration ?? 0, "f");
    }
    /** @inheritdoc */ hostConnected() {
        document.addEventListener("pointerup", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_pointerUpHandler, "f"), {
            capture: (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_capture, "f")
        });
        document.addEventListener("touchend", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_touchEndHandler, "f"), {
            capture: (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_capture, "f")
        });
        document.addEventListener("touchcancel", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_touchEndHandler, "f"), {
            capture: (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_capture, "f")
        });
        super.hostConnected();
    }
    /** @inheritdoc */ hostDisconnected() {
        document.removeEventListener("pointerup", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_pointerUpHandler, "f"), {
            capture: (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_capture, "f")
        });
        document.removeEventListener("touchend", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_touchEndHandler, "f"), {
            capture: (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_capture, "f")
        });
        document.removeEventListener("touchcancel", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_touchEndHandler, "f"), {
            capture: (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_capture, "f")
        });
        super.hostDisconnected();
        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_pressedTargets, "f").clear();
    }
    /**
   * Starts observing the specified element.
   * @param {HTMLElement} target The element to start observing.
   */ _observe(target) {
        target.addEventListener("pointerdown", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_pointerDownHandler, "f"), {
            capture: (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_capture, "f")
        });
        if ((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_isPressedKey, "f")) {
            target.addEventListener("keydown", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_keyDownHandler, "f"), {
                capture: (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_capture, "f")
            });
            target.addEventListener("keyup", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_keyUpHandler, "f"), {
                capture: (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_capture, "f")
            });
        }
    }
    /**
   * Stops observing the specified element.
   * @param {HTMLElement} target The element to stop observing.
   */ _unobserve(target) {
        target.removeEventListener("pointerdown", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_pointerDownHandler, "f"), {
            capture: (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_capture, "f")
        });
        if ((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_isPressedKey, "f")) {
            target.removeEventListener("keydown", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_keyDownHandler, "f"), {
                capture: (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_capture, "f")
            });
            target.removeEventListener("keyup", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_keyUpHandler, "f"), {
                capture: (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_capture, "f")
            });
        }
    }
}
$ca7aa15aa0ba1e7b$var$_PressedController_capture = new WeakMap(), $ca7aa15aa0ba1e7b$var$_PressedController_callback = new WeakMap(), $ca7aa15aa0ba1e7b$var$_PressedController_isPressedKey = new WeakMap(), $ca7aa15aa0ba1e7b$var$_PressedController_pressedTargets = new WeakMap(), $ca7aa15aa0ba1e7b$var$_PressedController_minPressedDuration = new WeakMap(), $ca7aa15aa0ba1e7b$var$_PressedController_pointerDownHandler = new WeakMap(), $ca7aa15aa0ba1e7b$var$_PressedController_pointerUpHandler = new WeakMap(), $ca7aa15aa0ba1e7b$var$_PressedController_touchEndHandler = new WeakMap(), $ca7aa15aa0ba1e7b$var$_PressedController_keyDownHandler = new WeakMap(), $ca7aa15aa0ba1e7b$var$_PressedController_keyUpHandler = new WeakMap(), $ca7aa15aa0ba1e7b$var$_PressedController_instances = new WeakSet(), $ca7aa15aa0ba1e7b$var$_PressedController_handlePointerDown = function _PressedController_handlePointerDown(e) {
    if (e.pointerType === "mouse" && e.button > 1) return;
    for (const target of e.composedPath())if (target instanceof HTMLElement && this.isObserving(target)) {
        if (!(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_pressedTargets, "f").has(target)) {
            (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_pressedTargets, "f").set(target, performance.now());
            (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_callback, "f").call(this, true, {
                x: e.x,
                y: e.y
            }, target);
        }
        break;
    }
}, $ca7aa15aa0ba1e7b$var$_PressedController_handlePointerUp = function _PressedController_handlePointerUp(e) {
    if (e.pointerType === "mouse" && e.button > 1) return;
    (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_instances, "m", $ca7aa15aa0ba1e7b$var$_PressedController_clearPressedTargets).call(this, e.x, e.y);
}, $ca7aa15aa0ba1e7b$var$_PressedController_handleTouchEnd = function _PressedController_handleTouchEnd(e) {
    (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_instances, "m", $ca7aa15aa0ba1e7b$var$_PressedController_clearPressedTargets).call(this, e.changedTouches[0]?.clientX ?? 0, e.changedTouches[0]?.clientY ?? 0);
}, $ca7aa15aa0ba1e7b$var$_PressedController_handleKeyDown = function _PressedController_handleKeyDown(e) {
    if (e.target !== e.currentTarget) return;
    const target = e.currentTarget;
    if ((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_isPressedKey, "f")?.call(this, e.key)) {
        if (e.key === " ") e.preventDefault();
        if (!(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_pressedTargets, "f").has(target)) {
            (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_pressedTargets, "f").set(target, performance.now());
            const bounds = target.getBoundingClientRect();
            (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_callback, "f").call(this, true, {
                x: bounds.x + bounds.width / 2,
                y: bounds.y + bounds.height / 2
            }, target);
        }
    }
}, $ca7aa15aa0ba1e7b$var$_PressedController_handleKeyUp = function _PressedController_handleKeyUp(e) {
    const target = e.target;
    if ((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_pressedTargets, "f").has(target) && (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_isPressedKey, "f")?.call(this, e.key)) {
        const remainingTime = (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_minPressedDuration, "f") - (performance.now() - (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_pressedTargets, "f").get(target));
        const bounds = target.getBoundingClientRect();
        if (remainingTime > 0) setTimeout(()=>{
            (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_pressedTargets, "f").delete(target);
            (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_callback, "f").call(this, false, {
                x: bounds.x + bounds.width / 2,
                y: bounds.y + bounds.height / 2
            }, target);
        }, remainingTime);
        else {
            (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_pressedTargets, "f").delete(target);
            (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_callback, "f").call(this, false, {
                x: bounds.x + bounds.width / 2,
                y: bounds.y + bounds.height / 2
            }, target);
        }
    }
}, $ca7aa15aa0ba1e7b$var$_PressedController_clearPressedTargets = function _PressedController_clearPressedTargets(x, y) {
    for (const target of (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_pressedTargets, "f")){
        const remainingTime = (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_minPressedDuration, "f") - (performance.now() - target[1]);
        if (remainingTime > 0) setTimeout(()=>{
            (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_pressedTargets, "f").delete(target[0]);
            (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_callback, "f").call(this, false, {
                x: x,
                y: y
            }, target[0]);
        }, remainingTime);
        else {
            (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_pressedTargets, "f").delete(target[0]);
            (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_PressedController_callback, "f").call(this, false, {
                x: x,
                y: y
            }, target[0]);
        }
    }
};
var $ca7aa15aa0ba1e7b$var$_ResizeController_callback, $ca7aa15aa0ba1e7b$var$_ResizeController_skipInitial, $ca7aa15aa0ba1e7b$var$_ResizeController_config, $ca7aa15aa0ba1e7b$var$_ResizeController_observer, $ca7aa15aa0ba1e7b$var$_ResizeController_unobservedUpdate;
/** A `ReactiveController` used to monitor when an element is resized. */ class $ca7aa15aa0ba1e7b$export$8ba29cfbcbd8efc8 extends $ca7aa15aa0ba1e7b$var$MonitorControllerBase {
    /**
   * Initializes a new instance of the `ResizeController` class.
   * @param {ReactiveControllerHost & HTMLElement} host The host element to which this controller will be added.
   * @param {ResizeControllerOptions} options Options used to configure this controller.
   */ constructor(host, options){
        super(host, options);
        /** @private */ $ca7aa15aa0ba1e7b$var$_ResizeController_callback.set(this, void 0);
        /** @private */ $ca7aa15aa0ba1e7b$var$_ResizeController_skipInitial.set(this, void 0);
        /** @private */ $ca7aa15aa0ba1e7b$var$_ResizeController_config.set(this, void 0);
        /** @private */ $ca7aa15aa0ba1e7b$var$_ResizeController_observer.set(this, void 0);
        /** @private */ $ca7aa15aa0ba1e7b$var$_ResizeController_unobservedUpdate.set(this, true);
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_ResizeController_callback, options.callback, "f");
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_ResizeController_skipInitial, options.skipInitial ?? false, "f");
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_ResizeController_config, options.config, "f");
        if (0, $63b56f98105c10d3$export$6acf61af03e62db) return;
        if (!window.ResizeObserver) {
            console.warn("ResizeController error: the browser does not support ResizeObserver.");
            return;
        }
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_ResizeController_observer, new ResizeObserver((entries, observer)=>(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_ResizeController_callback, "f").call(this, entries, observer)), "f");
    }
    /** @inheritdoc */ async hostUpdated() {
        if ((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_ResizeController_observer, "f") && !(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_ResizeController_skipInitial, "f") && (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_ResizeController_unobservedUpdate, "f")) (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_ResizeController_callback, "f").call(this, [], (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_ResizeController_observer, "f"));
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_ResizeController_unobservedUpdate, false, "f");
    }
    /**
   * Starts observing the specified element.
   * @param {HTMLElement} target The element to start observing.
   */ _observe(target) {
        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_ResizeController_observer, "f")?.observe(target, (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_ResizeController_config, "f"));
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_ResizeController_unobservedUpdate, true, "f");
    }
    /**
   * Stops observing the specified element.
   * @param {HTMLElement} target The element to stop observing.
   */ _unobserve(target) {
        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_ResizeController_observer, "f")?.unobserve(target);
    }
}
$ca7aa15aa0ba1e7b$var$_ResizeController_callback = new WeakMap(), $ca7aa15aa0ba1e7b$var$_ResizeController_skipInitial = new WeakMap(), $ca7aa15aa0ba1e7b$var$_ResizeController_config = new WeakMap(), $ca7aa15aa0ba1e7b$var$_ResizeController_observer = new WeakMap(), $ca7aa15aa0ba1e7b$var$_ResizeController_unobservedUpdate = new WeakMap();
/**
 * Class decorator factory that defines the decorated class as a custom element.
 *
 * ```js
 * @customElement('my-element')
 * class MyElement extends LitElement {
 *   render() {
 *     return html``;
 *   }
 * }
 * ```
 * @param {string} tagName The tag name of the custom element to define.
 */ const $ca7aa15aa0ba1e7b$export$da64fc29f17f9d0e = (tagName)=>(classOrTarget, context)=>{
        const define = ()=>{
            if (typeof window !== "undefined" && !customElements.get(tagName)) customElements.define(tagName, classOrTarget);
        };
        if (context) context.addInitializer(define);
        else define();
    };
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * A decorator that runs a function once after a given "cooldown" period.
 * @param {number} timeout The timeout, in milliseconds, after which the function is invoked.
 * @returns {MethodDecorator} The decorator that runs a function once after a given "cooldown" period.
 */ function $ca7aa15aa0ba1e7b$export$61fc7d43ac8f84b0(timeout) {
    const _id = Symbol("_id");
    return (_, __, descriptor)=>{
        const orig = descriptor.value;
        descriptor.value = function(...args) {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const self = this;
            clearTimeout(self[_id]);
            self[_id] = setTimeout(()=>orig.apply(this, args), timeout);
        };
        return descriptor;
    };
}
var $ca7aa15aa0ba1e7b$var$_ScrollController_instances, $ca7aa15aa0ba1e7b$var$_ScrollController_debounce, $ca7aa15aa0ba1e7b$var$_ScrollController_callback, $ca7aa15aa0ba1e7b$var$_ScrollController_scrollHandler, $ca7aa15aa0ba1e7b$var$_ScrollController_scrollContainers, $ca7aa15aa0ba1e7b$var$_ScrollController_getScrollContainers, $ca7aa15aa0ba1e7b$var$_ScrollController_handleScroll;
/** A `ReactiveController` used to monitor when a scroll event is emitted from a scrollable ancestor. */ class $ca7aa15aa0ba1e7b$export$fe3286d8cd36b08 extends $ca7aa15aa0ba1e7b$var$MonitorControllerBase {
    /**
   * Initializes a new instance of the `ScrollController` class.
   * @param {ReactiveControllerHost & HTMLElement} host The host element to which this controller will be added.
   * @param {ScrollControllerOptions} options Options used to configure this controller.
   */ constructor(host, options){
        super(host, options);
        $ca7aa15aa0ba1e7b$var$_ScrollController_instances.add(this);
        /** @private */ $ca7aa15aa0ba1e7b$var$_ScrollController_debounce.set(this, void 0);
        /** @private */ $ca7aa15aa0ba1e7b$var$_ScrollController_callback.set(this, void 0);
        /** @private */ $ca7aa15aa0ba1e7b$var$_ScrollController_scrollHandler.set(this, (e)=>(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_ScrollController_instances, "m", $ca7aa15aa0ba1e7b$var$_ScrollController_handleScroll).call(this, e));
        /** @private */ $ca7aa15aa0ba1e7b$var$_ScrollController_scrollContainers.set(this, new Map());
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_ScrollController_debounce, options.debounce === true, "f");
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_ScrollController_callback, options.callback, "f");
    }
    /**
   * Returns the scrollable ancestors for a target element currently being observed by this controller.
   * @param target The element whose scroll containers are currently being observed.
   * @returns {Element[] | undefined} The scrollable ancestors, or `undefined` if `target` is not being observed.
   */ getScrollContainers(target) {
        return (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_ScrollController_scrollContainers, "f").get(target);
    }
    /** @inheritdoc */ _observe(target) {
        const scrollableAncestors = (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_ScrollController_instances, "m", $ca7aa15aa0ba1e7b$var$_ScrollController_getScrollContainers).call(this, target);
        if (scrollableAncestors.length > 0) {
            (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_ScrollController_scrollContainers, "f").set(target, scrollableAncestors);
            for (const ancestor of scrollableAncestors)(ancestor === document.documentElement ? document : ancestor).addEventListener("scroll", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_ScrollController_scrollHandler, "f"), {
                passive: true
            });
        }
    }
    /** @inheritdoc */ _unobserve(target) {
        if ((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_ScrollController_scrollContainers, "f").has(target)) {
            for (const ancestor of (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_ScrollController_scrollContainers, "f").get(target))(ancestor === document.documentElement ? document : ancestor).removeEventListener("scroll", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_ScrollController_scrollHandler, "f"));
            (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_ScrollController_scrollContainers, "f").delete(target);
        }
    }
    /** @private */ _debounceCallback(target) {
        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_ScrollController_callback, "f").call(this, target);
    }
}
$ca7aa15aa0ba1e7b$var$_ScrollController_debounce = new WeakMap(), $ca7aa15aa0ba1e7b$var$_ScrollController_callback = new WeakMap(), $ca7aa15aa0ba1e7b$var$_ScrollController_scrollHandler = new WeakMap(), $ca7aa15aa0ba1e7b$var$_ScrollController_scrollContainers = new WeakMap(), $ca7aa15aa0ba1e7b$var$_ScrollController_instances = new WeakSet(), $ca7aa15aa0ba1e7b$var$_ScrollController_getScrollContainers = function _ScrollController_getScrollContainers(element) {
    const ancestors = new Array();
    let ancestor = element;
    while(ancestor){
        const style = getComputedStyle(ancestor);
        if (/(auto|scroll)/.test(style.overflow + style.overflowY + style.overflowX)) ancestors.push(ancestor);
        ancestor = ancestor.parentElement;
    }
    return ancestors;
}, $ca7aa15aa0ba1e7b$var$_ScrollController_handleScroll = function _ScrollController_handleScroll(e) {
    const target = e.target === document ? document.documentElement : e.target;
    if ((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_ScrollController_debounce, "f")) this._debounceCallback(target);
    else (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_ScrollController_callback, "f").call(this, target);
};
(0, $gkQP3.__decorate)([
    $ca7aa15aa0ba1e7b$export$61fc7d43ac8f84b0(40)
], $ca7aa15aa0ba1e7b$export$fe3286d8cd36b08.prototype, "_debounceCallback", null);
var $ca7aa15aa0ba1e7b$var$_ScrollLockController_instances, $ca7aa15aa0ba1e7b$var$_ScrollLockController_locked, $ca7aa15aa0ba1e7b$var$_ScrollLockController_scrollTop, $ca7aa15aa0ba1e7b$var$_ScrollLockController_scrollLeft, $ca7aa15aa0ba1e7b$var$_ScrollLockController_previousOverflow, $ca7aa15aa0ba1e7b$var$_ScrollLockController_previousScrollbarGutter, $ca7aa15aa0ba1e7b$var$_ScrollLockController_isVerticallyScrollable;
/**
 * A `ReactiveController` that provides safe, predictable scroll locking for modal UI
 * surfaces (dialogs, bottom sheets, overlays).
 */ class $ca7aa15aa0ba1e7b$export$a136769acdb0ad4e {
    constructor(host){
        $ca7aa15aa0ba1e7b$var$_ScrollLockController_instances.add(this);
        /** @private */ $ca7aa15aa0ba1e7b$var$_ScrollLockController_locked.set(this, false);
        /** @private */ $ca7aa15aa0ba1e7b$var$_ScrollLockController_scrollTop.set(this, 0);
        /** @private */ $ca7aa15aa0ba1e7b$var$_ScrollLockController_scrollLeft.set(this, 0);
        /** @private */ $ca7aa15aa0ba1e7b$var$_ScrollLockController_previousOverflow.set(this, "");
        /** @private */ $ca7aa15aa0ba1e7b$var$_ScrollLockController_previousScrollbarGutter.set(this, "");
        host.addController(this);
    }
    /** Locks document scrolling only if scroll actually exists. */ lock() {
        if ((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_ScrollLockController_locked, "f")) return;
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_ScrollLockController_locked, true, "f");
        // Save scroll position
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_ScrollLockController_scrollTop, window.scrollY, "f");
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_ScrollLockController_scrollLeft, window.scrollX, "f");
        // Save existing inline styles
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_ScrollLockController_previousOverflow, document.documentElement.style.overflow, "f");
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_ScrollLockController_previousScrollbarGutter, document.documentElement.style.scrollbarGutter, "f");
        // Only apply gutter if vertical scroll exists
        if ((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_ScrollLockController_instances, "m", $ca7aa15aa0ba1e7b$var$_ScrollLockController_isVerticallyScrollable).call(this)) document.documentElement.style.scrollbarGutter = "stable";
        // Lock scroll
        document.documentElement.style.overflow = "hidden";
        // Freeze scroll position
        window.scrollTo((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_ScrollLockController_scrollLeft, "f"), (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_ScrollLockController_scrollTop, "f"));
    }
    /** Unlocks document scrolling and restores the previous state. */ unlock() {
        if (!(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_ScrollLockController_locked, "f")) return;
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_ScrollLockController_locked, false, "f");
        // Restore previous inline styles
        document.documentElement.style.overflow = (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_ScrollLockController_previousOverflow, "f");
        document.documentElement.style.scrollbarGutter = (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_ScrollLockController_previousScrollbarGutter, "f");
        // Restore scroll position
        window.scrollTo((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_ScrollLockController_scrollLeft, "f"), (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_ScrollLockController_scrollTop, "f"));
    }
    /** @inheritdoc */ hostDisconnected() {
        this.unlock();
    }
}
$ca7aa15aa0ba1e7b$var$_ScrollLockController_locked = new WeakMap(), $ca7aa15aa0ba1e7b$var$_ScrollLockController_scrollTop = new WeakMap(), $ca7aa15aa0ba1e7b$var$_ScrollLockController_scrollLeft = new WeakMap(), $ca7aa15aa0ba1e7b$var$_ScrollLockController_previousOverflow = new WeakMap(), $ca7aa15aa0ba1e7b$var$_ScrollLockController_previousScrollbarGutter = new WeakMap(), $ca7aa15aa0ba1e7b$var$_ScrollLockController_instances = new WeakSet(), $ca7aa15aa0ba1e7b$var$_ScrollLockController_isVerticallyScrollable = function _ScrollLockController_isVerticallyScrollable() {
    return document.documentElement.scrollHeight > document.documentElement.clientHeight;
};
/** Converts an ISO‑8601 date to and from a `Date` object. */ const $ca7aa15aa0ba1e7b$export$a904344ff111c3cc = {
    fromAttribute (value) {
        if (!value) return null;
        // Matches all four formats:
        // yyyy-MM-dd
        // yyyy-MM-ddTHH:mm:ss
        // yyyy-MM-ddTHH:mm:ssZ
        // yyyy-MM-ddTHH:mm:ss±HH:mm
        const isoRegex = /^(\d{4})-(\d{2})-(\d{2})(?:T(\d{2}):(\d{2}):(\d{2})(?:\.(\d{3}))?)?(Z|[+-]\d{2}:\d{2})?$/;
        const m = value.match(isoRegex);
        if (!m) return null;
        const year = Number(m[1]);
        const month = Number(m[2]) - 1; // JS months are 0-based
        const day = Number(m[3]);
        const hasTime = m[4] !== undefined;
        const hours = hasTime ? Number(m[4]) : 0;
        const minutes = hasTime ? Number(m[5]) : 0;
        const seconds = hasTime ? Number(m[6]) : 0;
        const ms = hasTime && m[7] ? Number(m[7]) : 0;
        const tz = m[8];
        // CASE 1: yyyy-MM-dd → local date (no timezone math)
        if (!hasTime && !tz) return new Date(year, month, day);
        // CASE 2: yyyy-MM-ddTHH:mm:ss (no timezone) → local datetime
        if (hasTime && !tz) return new Date(year, month, day, hours, minutes, seconds, ms);
        // CASE 3: yyyy-MM-ddTHH:mm:ssZ → UTC
        if (tz === "Z") return new Date(Date.UTC(year, month, day, hours, minutes, seconds, ms));
        // CASE 4: yyyy-MM-ddTHH:mm:ss±HH:mm → offset
        if (tz && /^[+-]\d{2}:\d{2}$/.test(tz)) {
            const sign = tz.startsWith("-") ? -1 : 1;
            const [tzH, tzM] = tz.slice(1).split(":").map(Number);
            const offsetMinutes = sign * (tzH * 60 + tzM);
            // Convert offset datetime → UTC → local
            const utc = Date.UTC(year, month, day, hours, minutes, seconds, ms);
            return new Date(utc - offsetMinutes * 60000);
        }
        return null;
    },
    toAttribute (value) {
        return value?.toISOString() ?? null;
    }
};
/** Converts a space-separated attribute in to an array of strings. */ const $ca7aa15aa0ba1e7b$export$79e726fbede78644 = {
    fromAttribute (value) {
        if (!value) return [];
        return value.split(/\s+/).map((d)=>d.trim()).filter(Boolean);
    },
    toAttribute (value) {
        return value.join(" ");
    }
};
const $ca7aa15aa0ba1e7b$var$important = "important";
// The leading space is important
const $ca7aa15aa0ba1e7b$var$importantFlag = " !" + $ca7aa15aa0ba1e7b$var$important;
// How many characters to remove from a value, as a negative number
const $ca7aa15aa0ba1e7b$var$flagTrim = 0 - $ca7aa15aa0ba1e7b$var$importantFlag.length;
class $ca7aa15aa0ba1e7b$var$SafeStyleMapDirective extends (0, $6b74d27f2843e810$export$befdefbdce210f91) {
    constructor(partInfo){
        super(partInfo);
        if (partInfo.type !== (0, $6b74d27f2843e810$export$9ba3b3f20a85bfa).ATTRIBUTE || partInfo.name !== "style" || partInfo.strings?.length > 2) throw new Error("The `styleMap` directive must be used in the `style` attribute and must be the only part in the attribute.");
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    render(_) {
        return 0, $00a10a29322bb2a1$export$45b790e32b2810ee;
    }
    update(part, [styleInfo]) {
        const { style: style } = part.element;
        if (this._previousStyleProperties === undefined) this._previousStyleProperties = new Set(Object.keys(styleInfo));
        // Remove old properties that no longer exist in styleInfo
        for (const name of this._previousStyleProperties)// If the name isn't in styleInfo or it's null/undefined
        if (styleInfo[name] == null) {
            this._previousStyleProperties.delete(name);
            if (name.includes("-")) style.removeProperty(name);
            else // eslint-disable-next-line @typescript-eslint/no-explicit-any
            style[name] = null;
        }
        // Add or update properties
        for(const name in styleInfo){
            const value = styleInfo[name];
            if (value != null) {
                this._previousStyleProperties.add(name);
                const isImportant = typeof value === "string" && value.endsWith($ca7aa15aa0ba1e7b$var$importantFlag);
                if (name.includes("-") || isImportant) style.setProperty(name, isImportant ? value.slice(0, $ca7aa15aa0ba1e7b$var$flagTrim) : value, isImportant ? $ca7aa15aa0ba1e7b$var$important : "");
                else // eslint-disable-next-line @typescript-eslint/no-explicit-any
                style[name] = value;
            }
        }
        return 0, $00a10a29322bb2a1$export$9c068ae9cc5db4e8;
    }
}
/**
 * A directive that applies CSS properties to an element.
 *
 * `safeStyleMap` can only be used in the `style` attribute and must be the only
 * expression in the attribute. It takes the property names in the
 * {@link StyleInfo styleInfo} object and adds the properties to the inline
 * style of the element.
 *
 * Property names with dashes (`-`) are assumed to be valid CSS
 * property names and set on the element's style object using `setProperty()`.
 * Names without dashes are assumed to be camelCased JavaScript property names
 * and set on the element's style object using property assignment, allowing the
 * style object to translate JavaScript-style names to CSS property names.
 *
 * For example `safeStyleMap({backgroundColor: 'red', 'border-top': '5px', '--size':
 * '0'})` sets the `background-color`, `border-top` and `--size` properties.
 *
 * @param styleInfo
 * @see {@link https://lit.dev/docs/templates/directives/#stylemap styleMap code samples on Lit.dev}
 */ const $ca7aa15aa0ba1e7b$export$1a8e83982275c05e = (0, $6b74d27f2843e810$export$99b43ad1ed32e735)($ca7aa15aa0ba1e7b$var$SafeStyleMapDirective);
/**
 * Determines whether an object has keys for a given type.
 * @template T The type to test.
 * @param {unknown} value The value to test.
 * @param {...keys: Array<keyof T>} keys The keys of `T` to test.
 * @returns {boolean} Whether `value` has all `keys`.
 */ function $ca7aa15aa0ba1e7b$export$b3cfaccc1b88e6cb(value, ...keys) {
    return typeof value === "object" && value !== null && keys.every((x)=>x in value);
}
/** A symbol through which to access the `ElementInternals` attached to an element. */ const $ca7aa15aa0ba1e7b$export$e368aba7747330f2 = Symbol("internals");
/**
 * Determines whether a value is an `AttachInternalsMixin`.
 * @param {unknown} value The value to test.
 * @returns Whether `value` is an `AttachInternalsMixin`.
 */ function $ca7aa15aa0ba1e7b$export$6a3f3fc42130ef44(value) {
    return $ca7aa15aa0ba1e7b$export$b3cfaccc1b88e6cb(value, $ca7aa15aa0ba1e7b$export$e368aba7747330f2);
}
const $ca7aa15aa0ba1e7b$var$_internals = Symbol("_internals");
// Since flushing custom state doesn't flush in Safari (affecting all iOS browsers),
// a copy of custom state is retained locally so components can correctly read after write.
const $ca7aa15aa0ba1e7b$var$_customState = Symbol("_customState");
/**
 * Mixin to augment an element with behavior that attaches to `ElementInternals`.
 * @template T The type of the base class.
 * @param {T} base The base class.
 * @param {boolean | undefined} formAssociated Whether the element is "Form Associated".
 * @returns {Constructor<AttachInternalsMixin> & T} A constructor that implements `AttachInternalsMixin`.
 */ function $ca7aa15aa0ba1e7b$export$282c9fa792fbac93(base, formAssociated) {
    var _a;
    class _AttachInternals extends base {
        constructor(){
            super(...arguments);
            // Since flushing custom state doesn't flush in Safari (affecting all iOS browsers),
            // a copy of custom state is retained locally so components can correctly read after write.
            /** @private */ this[_a] = new Set();
        }
        /** @internal */ get [(_a = $ca7aa15aa0ba1e7b$var$_customState, $ca7aa15aa0ba1e7b$export$e368aba7747330f2)]() {
            return this[$ca7aa15aa0ba1e7b$var$_internals] ?? (this[$ca7aa15aa0ba1e7b$var$_internals] = this.attachInternals());
        }
    }
    /** Indicates that this custom element participates in form submission, validation, and form state restoration. */ _AttachInternals.formAssociated = formAssociated;
    return _AttachInternals;
}
/**
 * Convenience function used to test whether an element has a given custom state.
 * @param {AttachInternalsMixin} element The element to test.
 * @param {string} state The custom state to test.
 * @returns {boolean} Whether `element` has `state`.
 */ function $ca7aa15aa0ba1e7b$export$6bae5520ca265d22(element, state) {
    // Since flushing custom state doesn't flush in Safari (affecting all iOS browsers),
    // a copy of custom state is retained locally so components can correctly read after write.
    if ($ca7aa15aa0ba1e7b$var$_customState in element) return element[$ca7aa15aa0ba1e7b$var$_customState].has(state);
    // This should never get called due to needing a local copy of custom state
    // since reading after write to flush doesn't work in Safari (affecting all iOS browsers).
    return element[$ca7aa15aa0ba1e7b$export$e368aba7747330f2].states.has(state);
}
/**
 * Convenience function used to add custom state to an element.
 * @param {AttachInternalsMixin} element The element to which to add custom state.
 * @param {string} state The custom state to add.
 */ function $ca7aa15aa0ba1e7b$export$ddd0a0ac12dd84d8(element, state) {
    // Since flushing custom state doesn't flush in Safari (affecting all iOS browsers),
    // a copy of custom state is retained locally so components can correctly read after write.
    if ($ca7aa15aa0ba1e7b$var$_customState in element) element[$ca7aa15aa0ba1e7b$var$_customState].add(state);
    element[$ca7aa15aa0ba1e7b$export$e368aba7747330f2]?.states.add(state);
    element[$ca7aa15aa0ba1e7b$export$e368aba7747330f2]?.states.has(state); // flush (even though this doesn't work in Safari)
}
/**
 * Convenience function used to delete custom state from an element.
 * @param {AttachInternalsMixin} element The element from which to delete custom state.
 * @param {string} state The custom state to delete.
 * @returns {boolean} Whether `state` was removed from `element`.
 */ function $ca7aa15aa0ba1e7b$export$eda34dc61103d62e(element, state) {
    // Since flushing custom state doesn't flush in Safari (affecting all iOS browsers),
    // a copy of custom state is retained locally so components can correctly read after write.
    if ($ca7aa15aa0ba1e7b$var$_customState in element) element[$ca7aa15aa0ba1e7b$var$_customState].delete(state);
    if (element[$ca7aa15aa0ba1e7b$export$e368aba7747330f2]?.states.delete(state)) {
        element[$ca7aa15aa0ba1e7b$export$e368aba7747330f2]?.states.has(state); // flush (even though this doesn't work in Safari)
        return true;
    }
    return false;
}
/**
 * Convenience function used to add or delete custom state for an element.
 * @param {AttachInternalsMixin} element The element for which to add or delete custom state.
 * @param {string} state The custom state to add or delete.
 * @param {boolean} value Whether to add or delete `state` from `element`.
 */ function $ca7aa15aa0ba1e7b$export$a6b7fbc1acf03e5b(element, state, value) {
    if (value) $ca7aa15aa0ba1e7b$export$ddd0a0ac12dd84d8(element, state);
    else $ca7aa15aa0ba1e7b$export$eda34dc61103d62e(element, state);
}
/**
 * Determines whether a value is a `CheckedMixin`.
 * @param {unknown} value The value to test.
 * @returns Whether `value` is a `CheckedMixin`.
 */ function $ca7aa15aa0ba1e7b$export$be0c43499cc6393e(value) {
    return $ca7aa15aa0ba1e7b$export$b3cfaccc1b88e6cb(value, "checked");
}
/**
 * Mixin to augment an element with behavior that supports a checked state.
 * @template T The type of the base class.
 * @param {T} base The base class.
 * @returns {Constructor<CheckedMixin> & T} A constructor that implements `CheckedMixin`.
 */ function $ca7aa15aa0ba1e7b$export$8c8ee9238b7b0c2a(base) {
    class _CheckedMixin extends base {
        constructor(){
            super(...arguments);
            /**
       * Whether the element is checked.
       * @default false
       */ this.checked = false;
        }
        /** @inheritdoc */ update(changedProperties) {
            super.update(changedProperties);
            if (changedProperties.has("checked")) {
                if (this.role === "button") {
                    this.ariaPressed = `${this.checked}`;
                    this.ariaChecked = null;
                } else if (this.role && this.role !== "none" && this.role !== "presentation") {
                    this.ariaChecked = `${this.checked}`;
                    this.ariaPressed = null;
                }
            }
        }
    }
    (0, $gkQP3.__decorate)([
        (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
            type: Boolean,
            reflect: true
        })
    ], _CheckedMixin.prototype, "checked", void 0);
    return _CheckedMixin;
}
/**
 * Determines whether a value is a `CheckedIndeterminateMixin`.
 * @param {unknown} value The value to test.
 * @returns Whether `value` is a `CheckedIndeterminateMixin`.
 */ function $ca7aa15aa0ba1e7b$export$f52b304a5bb4eafa(value) {
    return $ca7aa15aa0ba1e7b$export$b3cfaccc1b88e6cb(value, "indeterminate") && $ca7aa15aa0ba1e7b$export$be0c43499cc6393e(value);
}
/**
 * Mixin to augment an element with behavior that supports a mixed checked state.
 * @template T The type of the base class.
 * @param {T} base The base class.
 * @returns {Constructor<CheckedIndeterminateMixin> & T} A constructor that implements `CheckedIndeterminateMixin`.
 */ function $ca7aa15aa0ba1e7b$export$13a11691eea54028(base) {
    class _CheckedIndeterminateMixin extends $ca7aa15aa0ba1e7b$export$8c8ee9238b7b0c2a(base) {
        constructor(){
            super(...arguments);
            /**
       * Whether the element's checked state is indeterminate.
       * @default false
       */ this.indeterminate = false;
        }
        /** @inheritdoc */ update(changedProperties) {
            super.update(changedProperties);
            if (changedProperties.has("indeterminate") && this.role && this.role !== "none" && this.role !== "presentation") this.ariaChecked = !this.checked && this.indeterminate ? "mixed" : `${this.checked}`;
        }
    }
    (0, $gkQP3.__decorate)([
        (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
            type: Boolean,
            reflect: true
        })
    ], _CheckedIndeterminateMixin.prototype, "indeterminate", void 0);
    return _CheckedIndeterminateMixin;
}
/**
 * Determines whether a value is a `SelectedMixin`.
 * @param {unknown} value The value to test.
 * @returns Whether `value` is a `SelectedMixin`.
 */ function $ca7aa15aa0ba1e7b$export$d8fb0462b931b26b(value) {
    return $ca7aa15aa0ba1e7b$export$b3cfaccc1b88e6cb(value, "selected");
}
/**
 * Mixin to augment an element with behavior that supports a selected state.
 * @template T The type of the base class.
 * @param {T} base The base class.
 * @returns {Constructor<SelectedMixin> & T} A constructor that implements `SelectedMixin`.
 */ function $ca7aa15aa0ba1e7b$export$168cec28b141e51c(base) {
    class _SelectedMixin extends base {
        constructor(){
            super(...arguments);
            /**
       * Whether the element is selected.
       * @default false
       */ this.selected = false;
        }
        /** @inheritdoc */ update(changedProperties) {
            super.update(changedProperties);
            if (changedProperties.has("selected")) {
                if (this.role === "button") {
                    this.ariaPressed = `${this.selected}`;
                    this.ariaSelected = null;
                    this.ariaChecked = null;
                } else if (this.role === "radio") {
                    this.ariaChecked = `${this.selected}`;
                    this.ariaSelected = null;
                    this.ariaPressed = null;
                } else if (this.role && this.role !== "none" && this.role !== "presentation") {
                    this.ariaSelected = `${this.selected}`;
                    this.ariaPressed = null;
                    this.ariaChecked = null;
                }
            }
        }
    }
    (0, $gkQP3.__decorate)([
        (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
            type: Boolean,
            reflect: true
        })
    ], _SelectedMixin.prototype, "selected", void 0);
    return _SelectedMixin;
}
/**
 * Determines whether a value is a `CheckedOrSelectedMixin`.
 * @param {unknown} value The value to test.
 * @returns Whether `value` is a `CheckedOrSelectedMixin`.
 */ function $ca7aa15aa0ba1e7b$export$d33dd76c0e70dfe6(value) {
    return $ca7aa15aa0ba1e7b$export$be0c43499cc6393e(value) || $ca7aa15aa0ba1e7b$export$d8fb0462b931b26b(value);
}
/**
 * Determines whether the state of an element is checked or selected.
 * @param {CheckedOrSelectedMixin} element The element to test.
 * @return {boolean} Whether `element` is checked or selected.
 */ function $ca7aa15aa0ba1e7b$export$eba8465f59663c68(element) {
    return $ca7aa15aa0ba1e7b$export$be0c43499cc6393e(element) && element.checked || $ca7aa15aa0ba1e7b$export$d8fb0462b931b26b(element) && element.selected;
}
/**
 * Sets the checked or selected state of an element.
 * @param {CheckedOrSelectedMixin} element The element for which to set the checked or selected state.
 * @param {boolean} checkedOrSelected The checked or selected state.
 */ function $ca7aa15aa0ba1e7b$export$3f5b0d3ac94b21cf(element, checkedOrSelected) {
    if ($ca7aa15aa0ba1e7b$export$be0c43499cc6393e(element)) element.checked = checkedOrSelected;
    else element.selected = checkedOrSelected;
}
/**
 * Determines whether a value is a `DirtyMixin`.
 * @param {unknown} value The value to test.
 * @returns A value indicating whether `value` is a `DirtyMixin`.
 */ function $ca7aa15aa0ba1e7b$export$4aa7c2a4145afbb9(value) {
    return $ca7aa15aa0ba1e7b$export$b3cfaccc1b88e6cb(value, "dirty", "pristine", "markAsDirty", "markAsPristine");
}
const $ca7aa15aa0ba1e7b$var$_eventHandler$2 = Symbol("_eventHandler");
/**
 * Mixin to augment an element with functionality used to mark it as dirty.
 * @template T The type of the base class.
 * @param {T} base The base class.
 * @returns {Constructor<DirtyMixin> & T} A constructor that implements `DirtyMixin`.
 */ function $ca7aa15aa0ba1e7b$export$904c9fbc057090b4(base) {
    var _a;
    class _Dirty extends base {
        constructor(){
            super(...arguments);
            /** @private */ this[_a] = ()=>this.markAsDirty();
        }
        /** Whether the user has modified the value of the element. */ get dirty() {
            return $ca7aa15aa0ba1e7b$export$6bae5520ca265d22(this, "-dirty");
        }
        /** Whether the user has not modified the value of the element. */ get pristine() {
            return !this.dirty;
        }
        /** @inheritdoc */ connectedCallback() {
            this.markAsPristine();
            super.connectedCallback();
            this.addEventListener("change", this[$ca7aa15aa0ba1e7b$var$_eventHandler$2]);
        }
        /** @inheritdoc */ disconnectedCallback() {
            super.disconnectedCallback();
            this.removeEventListener("change", this[$ca7aa15aa0ba1e7b$var$_eventHandler$2]);
        }
        /** Marks the element as pristine. */ markAsPristine() {
            $ca7aa15aa0ba1e7b$export$eda34dc61103d62e(this, "-dirty");
        }
        /** Marks the element as dirty. */ markAsDirty() {
            $ca7aa15aa0ba1e7b$export$ddd0a0ac12dd84d8(this, "-dirty");
        }
    }
    _a = $ca7aa15aa0ba1e7b$var$_eventHandler$2;
    return _Dirty;
}
/**
 * Determines whether a value is a `TouchedMixin`.
 * @param {unknown} value The value to test.
 * @returns A value indicating whether `value` is a `TouchedMixin`.
 */ function $ca7aa15aa0ba1e7b$export$d3eb229ee36277a6(value) {
    return $ca7aa15aa0ba1e7b$export$b3cfaccc1b88e6cb(value, "touched", "untouched", "markAsTouched", "markAsUntouched");
}
const $ca7aa15aa0ba1e7b$var$_eventHandler$1 = Symbol("_eventHandler");
/**
 * Mixin to augment an element with functionality used to mark it as touched.
 * @template T The type of the base class.
 * @param {T} base The base class.
 * @returns {Constructor<TouchedMixin> & T} A constructor that implements `TouchedMixin`.
 */ function $ca7aa15aa0ba1e7b$export$f5f83eb3ab54ce3(base) {
    var _a;
    class _Touched extends base {
        constructor(){
            super(...arguments);
            /** @private */ this[_a] = ()=>this.markAsTouched();
        }
        /** Whether the user has interacted when the element. */ get touched() {
            return $ca7aa15aa0ba1e7b$export$6bae5520ca265d22(this, "-touched");
        }
        /** Whether the user has not interacted when the element. */ get untouched() {
            return !this.touched;
        }
        /** @inheritdoc */ connectedCallback() {
            this.markAsUntouched();
            super.connectedCallback();
            this.addEventListener("focusout", this[$ca7aa15aa0ba1e7b$var$_eventHandler$1], {
                capture: true
            });
        }
        /** @inheritdoc */ disconnectedCallback() {
            super.disconnectedCallback();
            this.removeEventListener("focusout", this[$ca7aa15aa0ba1e7b$var$_eventHandler$1], {
                capture: true
            });
        }
        /** Marks the element as touched. */ markAsTouched() {
            $ca7aa15aa0ba1e7b$export$ddd0a0ac12dd84d8(this, "-touched");
        }
        /** Marks the element as untouched. */ markAsUntouched() {
            $ca7aa15aa0ba1e7b$export$eda34dc61103d62e(this, "-touched");
        }
    }
    _a = $ca7aa15aa0ba1e7b$var$_eventHandler$1;
    return _Touched;
}
/** Design tokens that control color. */ const $ca7aa15aa0ba1e7b$var$ColorToken = {
    /** High-emphasis fills, texts, and icons against surface. */ primary: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-primary, #6750A4)"),
    /** Text and icons against primary. */ onPrimary: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-on-primary, #FFFFFF)"),
    /** Standout fill color against surface, for key components. */ primaryContainer: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-primary-container, #EADDFF)"),
    /** Text and icons against primary container. */ onPrimaryContainer: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-on-primary-container, #4F378B)"),
    /** High-emphasis fills, texts, and icons that maintain the same tone in light and dark themes. */ primaryFixed: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-primary-fixed, #EADDFF)"),
    /** High-emphasis fills, texts, and icons that maintain the same stronger tone in light and dark themes. */ primaryFixedDim: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-primary-fixed-dim, #D0BCFF)"),
    /** Text and icons against fixed primary. */ onPrimaryFixed: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-on-primary-fixed, #21005D)"),
    /** Lower-emphasis text and icons against fixed primary. */ onPrimaryFixedVariant: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-on-primary-fixed-variant, #4F378B)"),
    /** Less prominent fills, text, and icons against surface. */ secondary: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-secondary, #625B71)"),
    /** Text and icons against secondary. */ onSecondary: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-on-secondary, #FFFFFF)"),
    /** Less prominent fill color against surface, for recessive components. */ secondaryContainer: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-secondary-container, #E8DEF8)"),
    /** Text and icons against secondary container. */ onSecondaryContainer: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-on-secondary-container, #4A4458)"),
    /** Less prominent fills, texts, and icons that maintain the same tone in light and dark themes. */ secondaryFixed: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-secondary-fixed, #E8DEF8)"),
    /** Less prominent fills, texts, and icons that maintain the same stronger tone in light and dark themes. */ secondaryFixedDim: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-secondary-fixed-dim, #CCC2DC)"),
    /** Text and icons against fixed secondary. */ onSecondaryFixed: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-on-secondary-fixed, #1D192B)"),
    /** Lower-emphasis text and icons against fixed secondary. */ onSecondaryFixedVariant: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-on-secondary-fixed-variant, #4A4458)"),
    /** Complementary fills, text, and icons against surface. */ tertiary: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-tertiary, #7D5260)"),
    /** Text and icons against tertiary. */ onTertiary: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-on-tertiary, #FFFFFF)"),
    /** Complementary container color against surface. */ tertiaryContainer: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-tertiary-container, #FFD8E4)"),
    /** Text and icons against tertiary container. */ onTertiaryContainer: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-on-tertiary-container, #633B48)"),
    /** Complementary fills, texts, and icons that maintain the same tone in light and dark themes. */ tertiaryFixed: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-tertiary-fixed, #FFD8E4)"),
    /** Complementary fills, texts, and icons that maintain the same stronger tone in light and dark themes. */ tertiaryFixedDim: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-tertiary-fixed-dim, #EFB8C8)"),
    /** Text and icons against fixed tertiary. */ onTertiaryFixed: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-on-tertiary-fixed, #31111D)"),
    /** Lower-emphasis text and icons against fixed tertiary. */ onTertiaryFixedVariant: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-on-tertiary-fixed-variant, #633B48)"),
    /** Attention-grabbing color against surface for fills, icons, and text, indicating urgency. */ error: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-error, #B3261E)"),
    /** Text and icons against error. */ onError: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-on-error, #FFFFFF)"),
    /** Attention-grabbing fill color against surface. */ errorContainer: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-error-container, #F9DEDC)"),
    /** Text and icons against error container. */ onErrorContainer: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-on-error-container, #8C1D18)"),
    /** Default color for backgrounds. */ surface: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-surface, #FEF7FF)"),
    /** Text and icons against any surface color. */ onSurface: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-on-surface, #1D1B20)"),
    /** Lower-emphasis color for text and icons against any surface color. */ onSurfaceVariant: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-on-surface-variant, #49454F)"),
    /** Lowest-emphasis container color. */ surfaceContainerLowest: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-surface-container-lowest, #FFFFFF)"),
    /** Low-emphasis container color. */ surfaceContainerLow: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-surface-container-low, #F7F2FA)"),
    /** Default container color. */ surfaceContainer: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-surface-container, #F3EDF7)"),
    /** High-emphasis container color. */ surfaceContainerHigh: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-surface-container-high, #ECE6F0)"),
    /** Highest-emphasis container color. */ surfaceContainerHighest: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-surface-container-highest, #E6E0E9)"),
    /** Dimmest surface color in light and dark themes. */ surfaceDim: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-surface-dim, #DED8E1)"),
    /** Brightest surface color in light and dark themes. */ surfaceBright: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-surface-bright, #FEF7FF)"),
    /** Alternate surface color, can be used for active states. */ surfaceVariant: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-surface-variant, #E7E0EC)"),
    /** Background fills for elements which contrast against surface. */ inverseSurface: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-inverse-surface, #322F35)"),
    /** Text and icons against inverse surface. */ inverseOnSurface: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-inverse-on-surface, #F5EFF7)"),
    /** Primary text and icons against inverse surface. */ inversePrimary: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-inverse-primary, #D0BCFF)"),
    /** Important boundaries, such as a text field outline. */ outline: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-outline, #79747E)"),
    /** Decorative elements, such as dividers. */ outlineVariant: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-outline-variant, #CAC4D0)"),
    /** Elevation shadow color. */ shadow: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-shadow, #000000)"),
    /** Backdrop which obscures underlying content. */ scrim: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-color-scrim, #000000)")
};
const $ca7aa15aa0ba1e7b$var$_DensityToken = {
    /** Base density multiplier. */ scale: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-density-scale, 0)"),
    /** Spatial unit used to scale component dimensions based on density. */ size: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-density-size, 0.25rem)")
};
/** Design tokens that control density. */ const $ca7aa15aa0ba1e7b$var$DensityToken = {
    ...$ca7aa15aa0ba1e7b$var$_DensityToken,
    /**
   * Creates a CSS `calc` that calculates a dimension based on density.
   * @param {number} minScale The minimum supported scale.
   * @returns {CSSResult} A CSS `calc` used to calculate a dimension based on density.
   */ calc (minScale) {
        return (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`calc(max(${minScale}, ${$ca7aa15aa0ba1e7b$var$_DensityToken.scale}) * ${$ca7aa15aa0ba1e7b$var$_DensityToken.size})`);
    }
};
const $ca7aa15aa0ba1e7b$var$UMBRA_COLOR = `color-mix(in srgb, var(--m3e-elevation-color, ${$ca7aa15aa0ba1e7b$var$ColorToken.shadow}) 20%, transparent)`;
const $ca7aa15aa0ba1e7b$var$UMBRA = [
    "0px 0px 0px 0px",
    "0px 2px 1px -1px",
    "0px 3px 1px -2px",
    "0px 3px 3px -2px",
    "0px 2px 4px -1px",
    "0px 3px 5px -1px",
    "0px 3px 5px -1px",
    "0px 4px 5px -2px",
    "0px 5px 5px -3px",
    "0px 5px 6px -3px",
    "0px 6px 6px -3px",
    "0px 6px 7px -4px",
    "0px 7px 8px -4px",
    "0px 7px 8px -4px",
    "0px 7px 9px -4px",
    "0px 8px 9px -5px",
    "0px 8px 10px -5px",
    "0px 8px 11px -5px",
    "0px 9px 11px -5px",
    "0px 9px 12px -6px",
    "0px 10px 13px -6px",
    "0px 10px 13px -6px",
    "0px 10px 14px -6px",
    "0px 11px 14px -7px",
    "0px 11px 15px -7px"
];
const $ca7aa15aa0ba1e7b$var$PENUMBRA_COLOR = `color-mix(in srgb, var(--m3e-elevation-color, ${$ca7aa15aa0ba1e7b$var$ColorToken.shadow}) 14%, transparent)`;
const $ca7aa15aa0ba1e7b$var$PENUMBRA = [
    "0px 0px 0px 0px",
    "0px 1px 1px 0px",
    "0px 2px 2px 0px",
    "0px 3px 4px 0px",
    "0px 4px 5px 0px",
    "0px 5px 8px 0px",
    "0px 6px 10px 0px",
    "0px 7px 10px 1px",
    "0px 8px 10px 1px",
    "0px 9px 12px 1px",
    "0px 10px 14px 1px",
    "0px 11px 15px 1px",
    "0px 12px 17px 2px",
    "0px 13px 19px 2px",
    "0px 14px 21px 2px",
    "0px 15px 22px 2px",
    "0px 16px 24px 2px",
    "0px 17px 26px 2px",
    "0px 18px 28px 2px",
    "0px 19px 29px 2px",
    "0px 20px 31px 3px",
    "0px 21px 33px 3px",
    "0px 22px 35px 3px",
    "0px 23px 36px 3px",
    "0px 24px 38px 3px"
];
const $ca7aa15aa0ba1e7b$var$AMBIENT_COLOR = `color-mix(in srgb, var(--m3e-elevation-color, ${$ca7aa15aa0ba1e7b$var$ColorToken.shadow}) 12%, transparent)`;
const $ca7aa15aa0ba1e7b$var$AMBIENT = [
    "0px 0px 0px 0px",
    "0px 1px 3px 0px",
    "0px 1px 5px 0px",
    "0px 1px 8px 0px",
    "0px 1px 10px 0px",
    "0px 1px 14px 0px",
    "0px 1px 18px 0px",
    "0px 2px 16px 1px",
    "0px 3px 14px 2px",
    "0px 3px 16px 2px",
    "0px 4px 18px 3px",
    "0px 4px 20px 3px",
    "0px 5px 22px 4px",
    "0px 5px 24px 4px",
    "0px 5px 26px 4px",
    "0px 6px 28px 5px",
    "0px 6px 30px 5px",
    "0px 6px 32px 5px",
    "0px 7px 34px 6px",
    "0px 7px 36px 6px",
    "0px 8px 38px 7px",
    "0px 8px 40px 7px",
    "0px 8px 42px 7px",
    "0px 9px 44px 8px",
    "0px 9px 46px 8px"
];
function $ca7aa15aa0ba1e7b$var$elevation(z) {
    return `${$ca7aa15aa0ba1e7b$var$UMBRA_COLOR} ${$ca7aa15aa0ba1e7b$var$UMBRA[z]},${$ca7aa15aa0ba1e7b$var$PENUMBRA_COLOR} ${$ca7aa15aa0ba1e7b$var$PENUMBRA[z]},${$ca7aa15aa0ba1e7b$var$AMBIENT_COLOR} ${$ca7aa15aa0ba1e7b$var$AMBIENT[z]}`;
}
/** Design tokens that control elevation. */ const $ca7aa15aa0ba1e7b$var$ElevationToken$1 = {
    /** Level 0 elevation. */ level0: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--md-sys-elevation-level0, ${$ca7aa15aa0ba1e7b$var$elevation(0)})`),
    /** Level 1 elevation. */ level1: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--md-sys-elevation-level1, ${$ca7aa15aa0ba1e7b$var$elevation(1)})`),
    /** Level 2 elevation. */ level2: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--md-sys-elevation-level2, ${$ca7aa15aa0ba1e7b$var$elevation(3)})`),
    /** Level 3 elevation. */ level3: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--md-sys-elevation-level3, ${$ca7aa15aa0ba1e7b$var$elevation(6)})`),
    /** Level 4 elevation. */ level4: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--md-sys-elevation-level4, ${$ca7aa15aa0ba1e7b$var$elevation(8)})`),
    /** Level 5 elevation. */ level5: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--md-sys-elevation-level5, ${$ca7aa15aa0ba1e7b$var$elevation(12)})`)
};
const $ca7aa15aa0ba1e7b$var$EasingToken = {
    /** Emphasized transition. */ emphasized: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-motion-easing-emphasized, cubic-bezier(0.2, 0.0, 0, 1.0))"),
    /** Decelerated emphasized transition. */ emphasizedDecelerate: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-motion-easing-emphasized-decelerate, cubic-bezier(0.05, 0.7, 0.1, 1.0))"),
    /** Accelerated emphasized transition. */ emphasizedAccelerate: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-motion-easing-emphasized-accelerate, cubic-bezier(0.3, 0.0, 0.8, 0.15))"),
    /** Simple, small, or utility-focused transition. */ standard: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-motion-easing-standard, cubic-bezier(0.2, 0.0, 0, 1.0))"),
    /** Decelerated standard transition. */ standardDecelerate: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-motion-easing-standard-decelerate, cubic-bezier(0, 0, 0, 1))"),
    /** Accelerated standard transition. */ standardAccelerate: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-motion-easing-standard-accelerate, cubic-bezier(0.3, 0, 1, 1))")
};
const $ca7aa15aa0ba1e7b$var$SpringToken = {
    /** Fast spatial spring. */ fastSpatial: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-motion-spring-fast-spatial, 350ms cubic-bezier(0.27, 1.06, 0.18, 1.00))"),
    /** Default spatial spring. */ defaultSpatial: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-motion-spring-default-spatial, 500ms cubic-bezier(0.27, 1.06, 0.18, 1.00))"),
    /** Slow spatial spring. */ slowSpatial: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-motion-spring-slow-spatial, 750ms cubic-bezier(0.27, 1.06, 0.18, 1.00))"),
    /** Fast effects spring. */ fastEffects: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-motion-spring-fast-effects, 150ms cubic-bezier(0.31, 0.94, 0.34, 1.00))"),
    /** Default effects spring. */ defaultEffects: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-motion-spring-default-effects, 200ms cubic-bezier(0.34, 0.80, 0.34, 1.00))"),
    /** Slow effects spring. */ slowEffects: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-motion-spring-slow-effects, 200ms cubic-bezier(0.34, 0.88, 0.34, 1.00))")
};
const $ca7aa15aa0ba1e7b$var$DurationToken = {
    /** Small utility-focused transition duration. */ short1: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-motion-duration-short-1, 50ms)"),
    /** Small utility-focused transition duration. */ short2: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-motion-duration-short-2, 100ms)"),
    /** Small utility-focused transition duration. */ short3: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-motion-duration-short-3, 150ms)"),
    /** Small utility-focused transition duration. */ short4: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-motion-duration-short-4, 200ms)"),
    /**  Duration for transitions that traverse a medium area of the screen. */ medium1: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-motion-duration-medium-1, 250ms)"),
    /**  Duration for transitions that traverse a medium area of the screen. */ medium2: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-motion-duration-medium-2, 300ms)"),
    /**  Duration for transitions that traverse a medium area of the screen. */ medium3: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-motion-duration-medium-3, 350ms)"),
    /**  Duration for transitions that traverse a medium area of the screen. */ medium4: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-motion-duration-medium-4, 400ms)"),
    /**  Duration for large expressive transitions. */ long1: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-motion-duration-long-1, 450ms)"),
    /**  Duration for large expressive transitions. */ long2: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-motion-duration-long-2, 500ms)"),
    /**  Duration for large expressive transitions. */ long3: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-motion-duration-long-3, 550ms)"),
    /**  Duration for large expressive transitions. */ long4: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-motion-duration-long-4, 600ms)"),
    /**  Extra long duration for ambient transitions. */ extraLong1: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-motion-duration-extra-long-1, 700ms)"),
    /**  Extra long duration for ambient transitions. */ extraLong2: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-motion-duration-extra-long-2, 800ms)"),
    /**  Extra long duration for ambient transitions. */ extraLong3: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-motion-duration-extra-long-3, 900ms)"),
    /**  Extra long duration for ambient transitions. */ extraLong4: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-motion-duration-extra-long-4, 1000ms)")
};
/** Design tokens that control motion. */ const $ca7aa15aa0ba1e7b$var$MotionToken = {
    /** Design tokens that control transition effects. */ easing: $ca7aa15aa0ba1e7b$var$EasingToken,
    /** Design tokens that control transition duration. */ duration: $ca7aa15aa0ba1e7b$var$DurationToken,
    /** Design tokens that control spring effects. */ spring: $ca7aa15aa0ba1e7b$var$SpringToken
};
/** Design tokens that control scrollbars. */ const $ca7aa15aa0ba1e7b$var$ScrollbarToken = {
    /** Width of a standard scrollbar. */ width: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-scrollbar-width, auto)`),
    /** Width of a thin scrollbar. */ thinWidth: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-scrollbar-thin-width, thin)`),
    /** Color of a scrollbar. */ color: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-scrollbar-thumb-color, #938f94) var(--m3e-scrollbar-track-color, transparent)`)
};
const $ca7aa15aa0ba1e7b$var$CornerValue = {
    /** No rounding. */ none: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-shape-corner-value-none, 0)"),
    /** Extra small rounded corner. */ extraSmall: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-shape-corner-value-extra-small, 0.25rem)"),
    /** Small rounded corner. */ small: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-shape-corner-value-small, 0.5rem)"),
    /** Medium rounded corner. */ medium: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-shape-corner-value-medium, 0.75rem)"),
    /** Large rounded corner. */ large: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-shape-corner-value-large, 1rem)"),
    /** Increased large rounded corner. */ largeIncreased: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-shape-corner-value-large-increased, 1.25rem)"),
    /** Extra large rounded corner. */ extraLarge: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-shape-corner-value-extra-large, 1.75rem)"),
    /** Increased extra large rounded corner. */ extraLargeIncreased: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-shape-corner-value-extra-large-increased, 2rem)"),
    /** Extra extra large rounded corner. */ extraExtraLarge: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-shape-corner-value-extra-extra-large, 3rem)")
};
/** Design tokens that control shape. */ const $ca7aa15aa0ba1e7b$var$ShapeToken = {
    corner: {
        /** Fully rounded symmetric shape. */ full: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-shape-corner-full, 624.9375rem)"),
        /** Extra large rounded asymmetric shape directed towards the top. */ extraLargeTop: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--md-sys-shape-corner-extra-large-top, ${$ca7aa15aa0ba1e7b$var$CornerValue.extraLarge} ${$ca7aa15aa0ba1e7b$var$CornerValue.extraLarge} ${$ca7aa15aa0ba1e7b$var$CornerValue.none} ${$ca7aa15aa0ba1e7b$var$CornerValue.none})`),
        /** Extra large rounded symmetric shape. */ extraLarge: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--md-sys-shape-corner-extra-large, ${$ca7aa15aa0ba1e7b$var$CornerValue.extraLarge})`),
        /** Extra large rounded asymmetric shape directed towards the end. */ extraLargeEnd: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`${$ca7aa15aa0ba1e7b$var$CornerValue.none} ${$ca7aa15aa0ba1e7b$var$CornerValue.extraLarge} ${$ca7aa15aa0ba1e7b$var$CornerValue.extraLarge} ${$ca7aa15aa0ba1e7b$var$CornerValue.none}`),
        /** Extra large rounded asymmetric shape directed towards the start. */ extraLargeStart: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`${$ca7aa15aa0ba1e7b$var$CornerValue.extraLarge} ${$ca7aa15aa0ba1e7b$var$CornerValue.none} ${$ca7aa15aa0ba1e7b$var$CornerValue.none} ${$ca7aa15aa0ba1e7b$var$CornerValue.extraLarge}`),
        /** Large rounded asymmetric shape directed towards the top. */ largeTop: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--md-sys-shape-corner-large-top, ${$ca7aa15aa0ba1e7b$var$CornerValue.large} ${$ca7aa15aa0ba1e7b$var$CornerValue.large} ${$ca7aa15aa0ba1e7b$var$CornerValue.none} ${$ca7aa15aa0ba1e7b$var$CornerValue.none})`),
        /** Large rounded asymmetric shape directed towards the end. */ largeEnd: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--md-sys-shape-corner-large-end, ${$ca7aa15aa0ba1e7b$var$CornerValue.none} ${$ca7aa15aa0ba1e7b$var$CornerValue.large} ${$ca7aa15aa0ba1e7b$var$CornerValue.large} ${$ca7aa15aa0ba1e7b$var$CornerValue.none})`),
        /** Large rounded asymmetric shape directed towards the start. */ largeStart: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--md-sys-shape-corner-large-end, ${$ca7aa15aa0ba1e7b$var$CornerValue.large} ${$ca7aa15aa0ba1e7b$var$CornerValue.none} ${$ca7aa15aa0ba1e7b$var$CornerValue.none} ${$ca7aa15aa0ba1e7b$var$CornerValue.large})`),
        /** Large rounded symmetric shape. */ large: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--md-sys-shape-corner-large, ${$ca7aa15aa0ba1e7b$var$CornerValue.large})`),
        /** Medium rounded symmetric shape. */ medium: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--md-sys-shape-corner-medium, ${$ca7aa15aa0ba1e7b$var$CornerValue.medium})`),
        /** Medium rounded asymmetric shape directed towards the top. */ mediumTop: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`${$ca7aa15aa0ba1e7b$var$CornerValue.medium} ${$ca7aa15aa0ba1e7b$var$CornerValue.medium} ${$ca7aa15aa0ba1e7b$var$CornerValue.none} ${$ca7aa15aa0ba1e7b$var$CornerValue.none}`),
        /** Medium rounded asymmetric shape directed towards the end. */ mediumEnd: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`${$ca7aa15aa0ba1e7b$var$CornerValue.none} ${$ca7aa15aa0ba1e7b$var$CornerValue.medium} ${$ca7aa15aa0ba1e7b$var$CornerValue.medium} ${$ca7aa15aa0ba1e7b$var$CornerValue.none}`),
        /** Medium rounded asymmetric shape directed towards the start. */ mediumStart: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`${$ca7aa15aa0ba1e7b$var$CornerValue.medium} ${$ca7aa15aa0ba1e7b$var$CornerValue.none} ${$ca7aa15aa0ba1e7b$var$CornerValue.none} ${$ca7aa15aa0ba1e7b$var$CornerValue.medium}`),
        /** Small rounded symmetric shape. */ small: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--md-sys-shape-corner-small, ${$ca7aa15aa0ba1e7b$var$CornerValue.small})`),
        /** Small rounded asymmetric shape directed towards the top. */ smallTop: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`${$ca7aa15aa0ba1e7b$var$CornerValue.small} ${$ca7aa15aa0ba1e7b$var$CornerValue.small} ${$ca7aa15aa0ba1e7b$var$CornerValue.none} ${$ca7aa15aa0ba1e7b$var$CornerValue.none}`),
        /** Small rounded asymmetric shape directed towards the end. */ smallEnd: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`${$ca7aa15aa0ba1e7b$var$CornerValue.none} ${$ca7aa15aa0ba1e7b$var$CornerValue.small} ${$ca7aa15aa0ba1e7b$var$CornerValue.small} ${$ca7aa15aa0ba1e7b$var$CornerValue.none}`),
        /** Small rounded asymmetric shape directed towards the start. */ smallStart: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`${$ca7aa15aa0ba1e7b$var$CornerValue.small} ${$ca7aa15aa0ba1e7b$var$CornerValue.none} ${$ca7aa15aa0ba1e7b$var$CornerValue.none} ${$ca7aa15aa0ba1e7b$var$CornerValue.small}`),
        /** Extra small rounded asymmetric shape directed towards the top. */ extraSmallTop: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--md-sys-shape-corner-extra-small-top, ${$ca7aa15aa0ba1e7b$var$CornerValue.extraSmall} ${$ca7aa15aa0ba1e7b$var$CornerValue.extraSmall} ${$ca7aa15aa0ba1e7b$var$CornerValue.none} ${$ca7aa15aa0ba1e7b$var$CornerValue.none})`),
        /** Extra small rounded symmetric shape. */ extraSmall: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--md-sys-shape-corner-extra-small, ${$ca7aa15aa0ba1e7b$var$CornerValue.extraSmall})`),
        /** Extra small rounded asymmetric shape directed towards the end. */ extraSmallEnd: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`${$ca7aa15aa0ba1e7b$var$CornerValue.none} ${$ca7aa15aa0ba1e7b$var$CornerValue.extraSmall} ${$ca7aa15aa0ba1e7b$var$CornerValue.extraSmall} ${$ca7aa15aa0ba1e7b$var$CornerValue.none}`),
        /** Extra small rounded asymmetric shape directed towards the start. */ extraSmallStart: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`${$ca7aa15aa0ba1e7b$var$CornerValue.extraSmall} ${$ca7aa15aa0ba1e7b$var$CornerValue.none} ${$ca7aa15aa0ba1e7b$var$CornerValue.none} ${$ca7aa15aa0ba1e7b$var$CornerValue.extraSmall}`),
        /** Extra small rounded asymmetric shape directed towards the bottom. */ extraSmallBottom: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`${$ca7aa15aa0ba1e7b$var$CornerValue.none} ${$ca7aa15aa0ba1e7b$var$CornerValue.none} ${$ca7aa15aa0ba1e7b$var$CornerValue.extraSmall} ${$ca7aa15aa0ba1e7b$var$CornerValue.extraSmall}`),
        /** No rounding. */ none: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--md-sys-shape-corner-none, ${$ca7aa15aa0ba1e7b$var$CornerValue.none})`),
        /** Increased large rounded symmetric shape. */ largeIncreased: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--md-sys-shape-corner-large-increased, ${$ca7aa15aa0ba1e7b$var$CornerValue.largeIncreased})`),
        /** Increased extra large rounded symmetric shape. */ extraLargeIncreased: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--md-sys-shape-corner-extra-large-increased, ${$ca7aa15aa0ba1e7b$var$CornerValue.extraLargeIncreased})`),
        /** Extra extra large rounded symmetric shape. */ extraExtraLarge: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--md-sys-shape-corner-extra-extra-large, ${$ca7aa15aa0ba1e7b$var$CornerValue.extraExtraLarge})`),
        /** Design tokens that control specific corners. */ value: $ca7aa15aa0ba1e7b$var$CornerValue
    }
};
/** Design tokens that control state layer. */ const $ca7aa15aa0ba1e7b$var$StateToken = {
    /** Opacity of the state layer on focus. */ focusStateLayerOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-state-focus-state-layer-opacity, 10%)"),
    /** Opacity of the state layer on hover. */ hoverStateLayerOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-state-hover-state-layer-opacity, 8%)"),
    /** Opacity of the state layer on pressed. */ pressedStateLayerOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-state-pressed-state-layer-opacity, 10%)")
};
/** Design tokens that control typescale. */ const $ca7aa15aa0ba1e7b$var$TypescaleToken = {
    /** Standard typescale variant. */ standard: {
        /** Short, important text or numerals. */ display: {
            large: {
                fontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-display-large-font-size, 3.5625rem)"),
                fontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-display-large-font-weight, 400)"),
                lineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-display-large-line-height, 4rem)"),
                tracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-display-large-tracking, 0.015625rem)")
            },
            medium: {
                fontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-display-medium-font-size, 2.8125rem)"),
                fontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-display-medium-font-weight, 400)"),
                lineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-display-medium-line-height, 3.25rem)"),
                tracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-display-medium-tracking, 0)")
            },
            small: {
                fontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-display-small-font-size, 2.25rem)"),
                fontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-display-small-font-weight, 400)"),
                lineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-display-small-line-height, 2.75rem)"),
                tracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-display-small-tracking, 0)")
            }
        },
        /** Short, high-emphasis text on smaller screens. */ headline: {
            large: {
                fontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-headline-large-font-size, 2rem)"),
                fontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-headline-large-font-weight, 400)"),
                lineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-headline-large-line-height, 2.5rem)"),
                tracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-headline-large-tracking, 0)")
            },
            medium: {
                fontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-headline-medium-font-size, 1.75rem)"),
                fontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-headline-medium-font-weight, 400)"),
                lineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-headline-medium-line-height, 2.25rem)"),
                tracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-headline-medium-tracking, 0)")
            },
            small: {
                fontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-headline-small-font-size, 1.5rem)"),
                fontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-headline-small-font-weight, 400)"),
                lineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-headline-small-line-height, 2rem)"),
                tracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-headline-small-tracking, 0)")
            }
        },
        /** Medium-emphasis text that remains relatively short. */ title: {
            large: {
                fontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-title-large-font-size, 1.375rem)"),
                fontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-title-large-font-weight, 400)"),
                lineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-title-large-line-height, 1.75rem)"),
                tracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-title-large-tracking, 0)")
            },
            medium: {
                fontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-title-medium-font-size, 1rem)"),
                fontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-title-medium-font-weight, 500)"),
                lineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-title-medium-line-height, 1.5rem)"),
                tracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-title-medium-tracking, 0.009375rem)")
            },
            small: {
                fontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-title-small-font-size, 0.875rem)"),
                fontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-title-small-font-weight, 500)"),
                lineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-title-small-line-height, 1.25rem)"),
                tracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-title-small-tracking, 0.00625rem)")
            }
        },
        /** Longer passages of text. */ body: {
            large: {
                fontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-body-large-font-size, 1rem)"),
                fontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-body-large-font-weight, 400)"),
                lineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-body-large-line-height, 1.5rem)"),
                tracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-body-large-tracking, 0.03125rem)")
            },
            medium: {
                fontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-body-medium-font-size, 0.875rem)"),
                fontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-body-medium-font-weight, 400)"),
                lineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-body-medium-line-height, 1.25rem)"),
                tracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-body-medium-tracking, 0.015625rem)")
            },
            small: {
                fontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-body-small-font-size, 0.75rem)"),
                fontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-body-small-font-weight, 400)"),
                lineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-body-small-line-height, 1rem)"),
                tracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-body-small-tracking, 0.025rem)")
            }
        },
        /** Smaller, utilitarian text. */ label: {
            large: {
                fontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-label-large-font-size, 0.875rem)"),
                fontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-label-large-font-weight, 500)"),
                lineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-label-large-line-height, 1.25rem)"),
                tracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-label-large-tracking, 0.00625rem)")
            },
            medium: {
                fontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-label-medium-font-size, 0.75rem)"),
                fontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-label-medium-font-weight, 500)"),
                lineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-label-medium-line-height, 1rem)"),
                tracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-label-medium-tracking, 0.03125rem)")
            },
            small: {
                fontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-label-small-font-size, 0.6875rem)"),
                fontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-label-small-font-weight, 500)"),
                lineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-label-small-line-height, 1rem)"),
                tracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-label-small-tracking, 0.03125rem)")
            }
        }
    },
    /** Emphasized typescale variant. */ emphasized: {
        /** Short, important text or numerals. */ display: {
            large: {
                fontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-display-large-font-size, 3.5625rem)"),
                fontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-display-large-font-weight, 500)"),
                lineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-display-large-line-height, 4rem)"),
                tracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-display-large-tracking, 0.015625rem)")
            },
            medium: {
                fontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-display-medium-font-size, 2.8125rem)"),
                fontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-display-medium-font-weight, 500)"),
                lineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-display-medium-line-height, 3.25rem)"),
                tracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-display-medium-tracking, 0)")
            },
            small: {
                fontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-display-small-font-size, 2.25rem)"),
                fontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-display-small-font-weight, 500)"),
                lineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-display-small-line-height, 2.75rem)"),
                tracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-display-small-tracking, 0)")
            }
        },
        /** Short, high-emphasis text on smaller screens. */ headline: {
            large: {
                fontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-headline-large-font-size, 2rem)"),
                fontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-headline-large-font-weight, 500)"),
                lineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-headline-large-line-height, 2.5rem)"),
                tracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-headline-large-tracking, 0)")
            },
            medium: {
                fontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-headline-medium-font-size, 1.75rem)"),
                fontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-headline-medium-font-weight, 500)"),
                lineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-headline-medium-line-height, 2.25rem)"),
                tracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-headline-medium-tracking, 0)")
            },
            small: {
                fontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-headline-small-font-size, 1.5rem)"),
                fontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-headline-small-font-weight, 500)"),
                lineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-headline-small-line-height, 2rem)"),
                tracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-headline-small-tracking, 0)")
            }
        },
        /** Medium-emphasis text that remains relatively short. */ title: {
            large: {
                fontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-title-large-font-size, 1.375rem)"),
                fontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-title-large-font-weight, 500)"),
                lineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-title-large-line-height, 1.75rem)"),
                tracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-title-large-tracking, 0)")
            },
            medium: {
                fontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-title-medium-font-size, 1rem)"),
                fontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-title-medium-font-weight, 700)"),
                lineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-title-medium-line-height, 3.5rem)"),
                tracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-title-medium-tracking, 0.009375rem)")
            },
            small: {
                fontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-title-small-font-size, 0.875rem)"),
                fontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-title-small-font-weight, 700)"),
                lineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-title-small-line-height, 1.25rem)"),
                tracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-title-small-tracking, 0.00625rem)")
            }
        },
        /** Longer passages of text. */ body: {
            large: {
                fontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-body-large-font-size, 1rem)"),
                fontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-body-large-font-weight, 500)"),
                lineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-body-large-line-height, 1.5rem)"),
                tracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-body-large-tracking, 0.03125rem)")
            },
            medium: {
                fontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-body-medium-font-size, 0.875rem)"),
                fontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-body-medium-font-weight, 500)"),
                lineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-body-medium-line-height, 1.25rem)"),
                tracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-body-medium-tracking, 0.015625rem)")
            },
            small: {
                fontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-body-small-font-size, 0.75rem)"),
                fontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-body-small-font-weight, 500)"),
                lineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-body-small-line-height, 1rem)"),
                tracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-body-small-tracking, 0.025rem)")
            }
        },
        /** Smaller, utilitarian text. */ label: {
            large: {
                fontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-label-large-font-size, 0.875rem)"),
                fontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-label-large-font-weight, 700)"),
                lineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-label-large-line-height, 1.25rem)"),
                tracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-label-large-tracking, 0.00625rem)")
            },
            medium: {
                fontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-label-medium-font-size, 0.75rem)"),
                fontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-label-medium-font-weight, 700)"),
                lineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-label-medium-line-height, 1rem)"),
                tracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-label-medium-tracking, 0.03125rem)")
            },
            small: {
                fontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-label-small-font-size, 0.6875rem)"),
                fontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-label-small-font-weight, 700)"),
                lineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-label-small-line-height, 1rem)"),
                tracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--md-sys-typescale-emphasized-label-small-tracking, 0.03125rem)")
            }
        }
    }
};
/** Design tokens used to style components. */ const $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443 = {
    /** Design tokens that control color. */ color: $ca7aa15aa0ba1e7b$var$ColorToken,
    /** Design tokens that control elevation. */ elevation: $ca7aa15aa0ba1e7b$var$ElevationToken$1,
    /** Design tokens that control motion. */ motion: $ca7aa15aa0ba1e7b$var$MotionToken,
    /** Design tokens that control shape. */ shape: $ca7aa15aa0ba1e7b$var$ShapeToken,
    /** Design tokens that control state layer. */ state: $ca7aa15aa0ba1e7b$var$StateToken,
    /** Design tokens that control typescale. */ typescale: $ca7aa15aa0ba1e7b$var$TypescaleToken,
    /** Design tokens that control scrollbars. */ scrollbar: $ca7aa15aa0ba1e7b$var$ScrollbarToken,
    /** Design tokens that control density. */ density: $ca7aa15aa0ba1e7b$var$DensityToken
};
/**
 * Determines whether a value is a `DisabledMixin`.
 * @param {unknown} value The value to test.
 * @returns {value is DisabledMixin} Whether `value` is a `DisabledMixin`.
 */ function $ca7aa15aa0ba1e7b$export$8db646b38f27adce(value) {
    return $ca7aa15aa0ba1e7b$export$b3cfaccc1b88e6cb(value, "disabled");
}
/**
 * Mixin to augment an element with behavior that supports a disabled state.
 * @template T The type of the base class.
 * @param {T} base The base class.
 * @param {boolean} [reflect=true] Whether the disabled property is reflected as an attribute.
 * @returns {Constructor<DisabledMixin> & T} A constructor that implements `DisabledMixin`.
 */ function $ca7aa15aa0ba1e7b$export$9a986b15f53d6d10(base, reflect = true) {
    class _DisabledMixin extends base {
        constructor(){
            super(...arguments);
            /**
       * Whether the element is disabled.
       * @default false
       */ this.disabled = false;
        }
        /** @inheritdoc */ update(changedProperties) {
            super.update(changedProperties);
            if (changedProperties.has("disabled") && this.role && this.role !== "none" && this.role !== "presentation") this.ariaDisabled = this.disabled ? "true" : null;
        }
    }
    (0, $gkQP3.__decorate)([
        (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
            type: Boolean,
            reflect: reflect
        })
    ], _DisabledMixin.prototype, "disabled", void 0);
    return _DisabledMixin;
}
/**
 * Determines whether a value is a `DisabledInteractiveMixin`.
 * @param {unknown} value The value to test.
 * @returns {value is DisabledInteractiveMixin} Whether `value` is a `DisabledInteractiveMixin`.
 */ function $ca7aa15aa0ba1e7b$export$ef6ef51d21411889(value) {
    return $ca7aa15aa0ba1e7b$export$b3cfaccc1b88e6cb(value, "disabledInteractive") && $ca7aa15aa0ba1e7b$export$8db646b38f27adce(value);
}
const $ca7aa15aa0ba1e7b$var$SUPPRESSED_EVENTS = [
    "click",
    "dblclick",
    "auxclick",
    "keydown",
    "keyup"
];
const $ca7aa15aa0ba1e7b$var$INTERACTIVE_KEYS = [
    "Tab",
    "ArrowLeft",
    "ArrowUp",
    "ArrowRight",
    "ArrowDown",
    "Left",
    "Up",
    "Right",
    "Down"
];
const $ca7aa15aa0ba1e7b$var$_suppressedEventHandler = Symbol("_suppressedEventHandler");
/**
 * Mixin to augment an element with behavior that supports an interactive disabled state.
 * @template T The type of the base class.
 * @param {T} base The base class.
 * @returns {Constructor<DisabledInteractiveMixin>} A constructor that implements `DisabledInteractiveMixin`.
 */ function $ca7aa15aa0ba1e7b$export$3d1d3384b4efc6c3(base) {
    var _a;
    class _DisabledInteractiveMixin extends base {
        constructor(){
            super(...arguments);
            /** @private */ this[_a] = (e)=>{
                if (this.disabledInteractive) {
                    // Only allow specific keys when disabled and interactive.
                    if (e instanceof KeyboardEvent && $ca7aa15aa0ba1e7b$var$INTERACTIVE_KEYS.includes(e.key)) return;
                    e.stopImmediatePropagation();
                    e.preventDefault();
                }
            };
            /**
       * Whether the element is disabled and interactive.
       * @default false
       */ this.disabledInteractive = false;
        }
        /** @inheritdoc */ connectedCallback() {
            $ca7aa15aa0ba1e7b$var$SUPPRESSED_EVENTS.forEach((x)=>this.addEventListener(x, this[$ca7aa15aa0ba1e7b$var$_suppressedEventHandler], true));
            super.connectedCallback();
        }
        /** @inheritdoc */ disconnectedCallback() {
            $ca7aa15aa0ba1e7b$var$SUPPRESSED_EVENTS.forEach((x)=>this.removeEventListener(x, this[$ca7aa15aa0ba1e7b$var$_suppressedEventHandler], true));
            super.disconnectedCallback();
        }
        /** @inheritdoc */ update(changedProperties) {
            super.update(changedProperties);
            if ((changedProperties.has("disabled") || changedProperties.has("disabledInteractive")) && this.role && this.role !== "none" && this.role !== "presentation" && this.role !== "none") this.ariaDisabled = this.disabled || this.disabledInteractive ? "true" : null;
        }
    }
    _a = $ca7aa15aa0ba1e7b$var$_suppressedEventHandler;
    (0, $gkQP3.__decorate)([
        (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
            attribute: "disabled-interactive",
            type: Boolean,
            reflect: true
        })
    ], _DisabledInteractiveMixin.prototype, "disabledInteractive", void 0);
    return _DisabledInteractiveMixin;
}
/** A symbol through which to update labels to reflect a control's current state. */ const $ca7aa15aa0ba1e7b$export$f553cf48211bbbff = Symbol("updateLabels");
/**
 * Determines whether a value is a `LabelledMixin`.
 * @param {unknown} value The value to test.
 * @returns A value indicating whether `value` is a `LabelledMixin`.
 */ function $ca7aa15aa0ba1e7b$export$a6465328056f6fec(value) {
    return $ca7aa15aa0ba1e7b$export$b3cfaccc1b88e6cb(value, "labels") && $ca7aa15aa0ba1e7b$export$6a3f3fc42130ef44(value);
}
const $ca7aa15aa0ba1e7b$var$_eventHandler = Symbol("_eventHandler");
/**
 * Mixin to augment an element with support for labelling.
 * @template T The type of the base class.
 * @param {T} base The base class.
 * @returns {Constructor<FormAssociatedMixin> & T} A constructor that implements `FormAssociatedMixin`.
 */ function $ca7aa15aa0ba1e7b$export$5fd2a77a6d4b3217(base) {
    var _a;
    class _Labelled extends base {
        constructor(){
            super(...arguments);
            /** @private */ this[_a] = (e)=>{
                if (!e.defaultPrevented) this[$ca7aa15aa0ba1e7b$export$f553cf48211bbbff]();
            };
        }
        /** The label elements that the element is associated with. */ get labels() {
            return this[$ca7aa15aa0ba1e7b$export$e368aba7747330f2].labels;
        }
        /** @inheritdoc */ connectedCallback() {
            super.connectedCallback();
            this.addEventListener("focusout", this[$ca7aa15aa0ba1e7b$var$_eventHandler]);
            this.addEventListener("change", this[$ca7aa15aa0ba1e7b$var$_eventHandler]);
        }
        /** @inheritdoc */ disconnectedCallback() {
            super.disconnectedCallback();
            this.removeEventListener("focusout", this[$ca7aa15aa0ba1e7b$var$_eventHandler]);
            this.removeEventListener("change", this[$ca7aa15aa0ba1e7b$var$_eventHandler]);
        }
        /** @inheritdoc */ update(changedProperties) {
            super.update(changedProperties);
            this[$ca7aa15aa0ba1e7b$export$f553cf48211bbbff]();
        }
        /** @internal */ [(_a = $ca7aa15aa0ba1e7b$var$_eventHandler, $ca7aa15aa0ba1e7b$export$f553cf48211bbbff)]() {
            const focusable = this.hasAttribute("tabindex");
            const disabled = $ca7aa15aa0ba1e7b$export$8db646b38f27adce(this) && this.disabled || $ca7aa15aa0ba1e7b$export$ef6ef51d21411889(this) && this.disabledInteractive;
            const invalid = $ca7aa15aa0ba1e7b$export$d3eb229ee36277a6(this) && this.touched && (this.ariaInvalid || $ca7aa15aa0ba1e7b$export$6bae5520ca265d22(this, "-invalid"));
            for (const label of this.labels ?? []){
                label.style.userSelect = focusable ? "none" : "";
                label.style.cursor = !disabled && focusable ? "pointer" : "";
                if (!disabled && focusable) label.style.setProperty("-webkit-tap-highlight-color", "rgba(0, 0, 0, 0)");
                else label.style.removeProperty("-webkit-tap-highlight-color");
                label.style.color = disabled ? `color-mix(in srgb, ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.color.onSurface} 38%, transparent)` : invalid ? `${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.color.error}` : "";
            }
        }
    }
    /** Indicates that this custom element participates in form submission, validation, and form state restoration. */ _Labelled.formAssociated = true;
    return _Labelled;
}
/** A symbol through which a "Form Associated" custom element provides a value for a form. */ const $ca7aa15aa0ba1e7b$export$318685b77e3839c0 = Symbol("formValue");
/** A symbol through which a "Form Associated" custom element provides a default value for resetting a form. */ const $ca7aa15aa0ba1e7b$export$1a01ae0705bafd37 = Symbol("defaultValue");
/**
 * Determines whether a value is a `FormAssociatedMixin`.
 * @param {unknown} value The value to test.
 * @returns A value indicating whether `value` is a `FormAssociatedMixin`.
 */ function $ca7aa15aa0ba1e7b$export$28d2767d6d5fa3c4(value) {
    return $ca7aa15aa0ba1e7b$export$b3cfaccc1b88e6cb(value, "disabled", "form", "name") && $ca7aa15aa0ba1e7b$export$a6465328056f6fec(value) && $ca7aa15aa0ba1e7b$export$6a3f3fc42130ef44(value);
}
const $ca7aa15aa0ba1e7b$var$_defaultValue = Symbol("_defaultValue");
const $ca7aa15aa0ba1e7b$var$_defaultIndeterminate = Symbol("_defaultIndeterminate");
const $ca7aa15aa0ba1e7b$var$_formDisabled = Symbol("_formDisabled");
/**
 * Mixin to augment an element with "Form Associated" behavior.
 * @template T The type of the base class.
 * @param {T} base The base class.
 * @returns {Constructor<FormAssociatedMixin> & T} A constructor that implements `FormAssociatedMixin`.
 */ function $ca7aa15aa0ba1e7b$export$ff50bfebacec67f(base) {
    var _a, _b;
    class _FormAssociatedMixin extends base {
        constructor(){
            super(...arguments);
            /** @private */ this[_a] = false;
            /** @private */ this[_b] = false;
        }
        /** The `HTMLFormElement` associated with this element. */ get form() {
            return this[$ca7aa15aa0ba1e7b$export$e368aba7747330f2].form;
        }
        /** @inheritdoc */ get labels() {
            return this[$ca7aa15aa0ba1e7b$export$e368aba7747330f2].labels;
        }
        /** @internal */ get [(_a = $ca7aa15aa0ba1e7b$var$_defaultIndeterminate, _b = $ca7aa15aa0ba1e7b$var$_formDisabled, $ca7aa15aa0ba1e7b$export$318685b77e3839c0)]() {
            return null;
        }
        /** @internal */ get [$ca7aa15aa0ba1e7b$export$1a01ae0705bafd37]() {
            return this[$ca7aa15aa0ba1e7b$var$_defaultValue];
        }
        /** The name that identifies the element when submitting the associated form. */ get name() {
            return this.getAttribute("name") ?? "";
        }
        set name(value) {
            if (value) this.setAttribute("name", value);
            else this.removeAttribute("name");
        }
        // Disabled attributes should not be reflected for form associated elements due to
        // how the formDisabledCallback overrides an element's disabled state.
        // See https://github.com/whatwg/html/issues/8365
        /**
     * Whether the element is disabled.
     * @default false
     */ get disabled() {
            return super.disabled || this[$ca7aa15aa0ba1e7b$var$_formDisabled];
        }
        set disabled(value) {
            super.disabled = value;
        }
        /** @inheritdoc */ connectedCallback() {
            super.connectedCallback();
            if ($ca7aa15aa0ba1e7b$export$be0c43499cc6393e(this)) {
                this[$ca7aa15aa0ba1e7b$var$_defaultValue] = this.checked;
                if ($ca7aa15aa0ba1e7b$export$f52b304a5bb4eafa(this)) this[$ca7aa15aa0ba1e7b$var$_defaultIndeterminate] = this.indeterminate;
            } else if ("value" in this) this[$ca7aa15aa0ba1e7b$var$_defaultValue] = this.value;
        }
        /** @inheritdoc */ requestUpdate(name, oldValue, options) {
            super.requestUpdate(name, oldValue, options);
            this[$ca7aa15aa0ba1e7b$export$e368aba7747330f2].setFormValue(this[$ca7aa15aa0ba1e7b$export$318685b77e3839c0]);
        }
        /** Called when the element is disabled or enabled via its form association. */ formDisabledCallback(disabled) {
            const wasDisabled = this.disabled;
            this[$ca7aa15aa0ba1e7b$var$_formDisabled] = disabled;
            if (this.disabled != wasDisabled) this.requestUpdate("disabled", wasDisabled);
        }
        /** Called when the associated form is reset. */ formResetCallback() {
            if ($ca7aa15aa0ba1e7b$export$be0c43499cc6393e(this)) {
                this.checked = this[$ca7aa15aa0ba1e7b$var$_defaultValue] === true;
                if ($ca7aa15aa0ba1e7b$export$f52b304a5bb4eafa(this)) this.indeterminate = this[$ca7aa15aa0ba1e7b$var$_defaultIndeterminate];
            } else if ("value" in this) this.value = this[$ca7aa15aa0ba1e7b$export$1a01ae0705bafd37];
            if ($ca7aa15aa0ba1e7b$export$4aa7c2a4145afbb9(this)) this.markAsPristine();
            if ($ca7aa15aa0ba1e7b$export$d3eb229ee36277a6(this)) this.markAsUntouched();
        }
    }
    /** Indicates that this custom element participates in form submission, validation, and form state restoration. */ _FormAssociatedMixin.formAssociated = true;
    (0, $gkQP3.__decorate)([
        (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
            noAccessor: true
        })
    ], _FormAssociatedMixin.prototype, "name", null);
    (0, $gkQP3.__decorate)([
        (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
            type: Boolean
        })
    ], _FormAssociatedMixin.prototype, "disabled", null);
    return _FormAssociatedMixin;
}
/** A symbol through which a "Form Associated" custom element validates its current state. */ const $ca7aa15aa0ba1e7b$export$a22775fa5e2eebd9 = Symbol("validate");
/**
 * Determines whether a value is a `ConstraintValidationMixin`.
 * @param {unknown} value The value to test.
 * @returns Whether `value` is a `ConstraintValidationMixin`.
 */ function $ca7aa15aa0ba1e7b$export$f10b21c67db60ec2(value) {
    return $ca7aa15aa0ba1e7b$export$b3cfaccc1b88e6cb(value, "willValidate", "validity", "validationMessage", "reportValidity", "checkValidity", "setCustomValidity") && $ca7aa15aa0ba1e7b$export$28d2767d6d5fa3c4(value);
}
const $ca7aa15aa0ba1e7b$var$_updateValidity = Symbol("_updateValidity");
const $ca7aa15aa0ba1e7b$var$_validityMessage = Symbol("_validityMessage");
/**
 * Mixin to augment an element with "Form Associated" behavior that supports constraint validation.
 * @template T The type of the base class.
 * @param {T} base The base class.
 * @returns {Constructor<ConstraintValidationMixin> & T} A constructor that implements `ConstraintValidationMixin`.
 */ function $ca7aa15aa0ba1e7b$export$c75eeb9200041a45(base) {
    var __ConstraintValidation_instances, __ConstraintValidation_getNativeMessage;
    class _ConstraintValidation extends base {
        constructor(){
            super(...arguments);
            __ConstraintValidation_instances.add(this);
        }
        /** Whether the element is a submittable element that is a candidate for constraint validation. */ get willValidate() {
            return this[$ca7aa15aa0ba1e7b$export$e368aba7747330f2].willValidate;
        }
        /** The validity state of the element. */ get validity() {
            this[$ca7aa15aa0ba1e7b$var$_updateValidity]();
            return this[$ca7aa15aa0ba1e7b$export$e368aba7747330f2].validity;
        }
        /** The error message that would be displayed if the user submits the form, or an empty string if no error message. */ get validationMessage() {
            this[$ca7aa15aa0ba1e7b$var$_updateValidity]();
            return this[$ca7aa15aa0ba1e7b$export$e368aba7747330f2].validationMessage;
        }
        /** @internal */ [(__ConstraintValidation_instances = new WeakSet(), $ca7aa15aa0ba1e7b$export$a22775fa5e2eebd9)]() {
            return this[$ca7aa15aa0ba1e7b$var$_validityMessage] ? {
                customError: true
            } : undefined;
        }
        /**
     * Returns `true` if the element has no validity problems; otherwise, returns `false`, fires
     * an invalid event, and (if the event isn't canceled) reports the problem to the user.
     */ reportValidity() {
            if ($ca7aa15aa0ba1e7b$export$d3eb229ee36277a6(this)) this.markAsTouched();
            this[$ca7aa15aa0ba1e7b$var$_updateValidity]();
            return this[$ca7aa15aa0ba1e7b$export$e368aba7747330f2].reportValidity();
        }
        /**
     * Returns `true` if the element has no validity problems; otherwise,
     * returns `false`, fires an invalid event.
     */ checkValidity() {
            this[$ca7aa15aa0ba1e7b$var$_updateValidity]();
            return this[$ca7aa15aa0ba1e7b$export$e368aba7747330f2].checkValidity();
        }
        /**
     * Sets a custom validity message for the element.
     * @param error The message to use for validity errors.
     */ setCustomValidity(error) {
            if (error) this[$ca7aa15aa0ba1e7b$var$_validityMessage] = error;
            else this[$ca7aa15aa0ba1e7b$var$_validityMessage] = undefined;
            this[$ca7aa15aa0ba1e7b$var$_updateValidity]();
        }
        /** @inheritdoc */ requestUpdate(name, oldValue, options) {
            super.requestUpdate(name, oldValue, options);
            this[$ca7aa15aa0ba1e7b$var$_updateValidity]();
        }
        /** @inheritdoc */ firstUpdated(_changedProperties) {
            super.firstUpdated(_changedProperties);
            this[$ca7aa15aa0ba1e7b$var$_updateValidity]();
        }
        /** @private */ [$ca7aa15aa0ba1e7b$var$_updateValidity]() {
            if ((0, $63b56f98105c10d3$export$6acf61af03e62db) || !this.isConnected) return;
            const validity = this[$ca7aa15aa0ba1e7b$export$a22775fa5e2eebd9]();
            const invalid = validity && Object.keys(validity).some((x)=>validity[x] === true);
            let validityMessage = validity?.customError ? this[$ca7aa15aa0ba1e7b$var$_validityMessage] : "";
            if (validity && !validityMessage) validityMessage = (0, $gkQP3.__classPrivateFieldGet)(this, __ConstraintValidation_instances, "m", __ConstraintValidation_getNativeMessage).call(this, validity);
            this[$ca7aa15aa0ba1e7b$export$e368aba7747330f2].setValidity(validity, validityMessage);
            this.ariaInvalid = invalid ? "true" : null;
            $ca7aa15aa0ba1e7b$export$a6b7fbc1acf03e5b(this, "-invalid", invalid === true);
            if ($ca7aa15aa0ba1e7b$export$a6465328056f6fec(this)) this[$ca7aa15aa0ba1e7b$export$f553cf48211bbbff]?.();
        }
    }
    __ConstraintValidation_getNativeMessage = function __ConstraintValidation_getNativeMessage(flags) {
        const input = document.createElement("input");
        // Default to text input unless overridden
        input.type = "text";
        // Simulate constraints and values based on flags
        if (flags.valueMissing) {
            input.required = true;
            input.value = ""; // triggers valueMissing
        }
        if (flags.typeMismatch) {
            input.type = "email";
            input.value = "not-an-email"; // triggers typeMismatch
        }
        if (flags.patternMismatch) {
            input.pattern = "[0-9]{4}";
            input.value = "abcd"; // triggers patternMismatch
        }
        if (flags.tooShort) {
            input.minLength = 5;
            input.value = "abc"; // triggers tooShort
        }
        if (flags.tooLong) {
            input.maxLength = 2;
            input.value = "abcdef"; // triggers tooLong
        }
        if (flags.rangeUnderflow) {
            input.type = "number";
            input.min = "10";
            input.value = "5"; // triggers rangeUnderflow
        }
        if (flags.rangeOverflow) {
            input.type = "number";
            input.max = "5";
            input.value = "10"; // triggers rangeOverflow
        }
        if (flags.stepMismatch) {
            input.type = "number";
            input.step = "2";
            input.value = "3"; // triggers stepMismatch
        }
        if (flags.badInput) {
            input.type = "number";
            input.value = "abc"; // triggers badInput
        }
        input.setCustomValidity("");
        input.checkValidity();
        return input.validationMessage;
    };
    return _ConstraintValidation;
}
/**
 * Mixin that adds support for custom event attributes.
 * @template T The type of base class from which to inherit.
 * @param {T} base The base class from which to inherit.
 * @param {string[]} types The types of event attributes.
 * @returns {T} A class extending `base` that supports custom event attributes.
 */ function $ca7aa15aa0ba1e7b$export$2e969398e322bb5e(base, ...types) {
    class _EventAttribute extends base {
        /** @internal */ dispatchEvent(event) {
            if (types.includes(event.type)) {
                const eventAttribute = this.getAttribute(`on${event.type}`);
                if (eventAttribute) new Function("e", `${eventAttribute};`).call(this, event);
            }
            return super.dispatchEvent(event);
        }
    }
    return _EventAttribute;
}
const $ca7aa15aa0ba1e7b$var$_tabindex = Symbol("_tabindex");
/**
 * Mixin to augment an element with behavior that supports a focused state.
 * @template T The type of the base class.
 * @param {T} base The base class.
 * @returns {Constructor & T} A constructor that implements focusable behavior.
 */ function $ca7aa15aa0ba1e7b$export$35a3bebf7ef2d934(base) {
    var _a;
    class _FocusableMixin extends base {
        constructor(){
            super(...arguments);
            /** @private */ this[_a] = 0;
        }
        /** @inheritdoc */ connectedCallback() {
            this[$ca7aa15aa0ba1e7b$var$_tabindex] = Number.parseInt(this.getAttribute("tabindex") ?? "0");
            super.connectedCallback();
        }
        /** @inheritdoc */ firstUpdated(_changedProperties) {
            super.firstUpdated(_changedProperties);
            if (!this.hasAttribute("tabindex") && !_changedProperties.has("disabled")) this.setAttribute("tabindex", `${this[$ca7aa15aa0ba1e7b$var$_tabindex]}`);
        }
        /** @inheritdoc */ update(changedProperties) {
            super.update(changedProperties);
            if (changedProperties.has("disabled")) {
                if (!this.disabled && this.role !== "none") {
                    if (!this.hasAttribute("tabindex")) this.setAttribute("tabindex", `${this[$ca7aa15aa0ba1e7b$var$_tabindex]}`);
                } else {
                    const tabIndex = this.getAttribute("tabindex");
                    if (tabIndex) this[$ca7aa15aa0ba1e7b$var$_tabindex] = Number.parseInt(tabIndex);
                    this.removeAttribute("tabindex");
                }
            }
        }
    }
    _a = $ca7aa15aa0ba1e7b$var$_tabindex;
    return _FocusableMixin;
}
/**
 * Determines whether a value is a `FormSubmitterMixin`.
 * @param {unknown} value The value to test.
 * @returns {value is FormSubmitterMixin} Whether `value` is a `FormSubmitterMixin`.
 */ function $ca7aa15aa0ba1e7b$export$e3621352909a5e7d(value) {
    return $ca7aa15aa0ba1e7b$export$b3cfaccc1b88e6cb(value, "name", "type", "value") && $ca7aa15aa0ba1e7b$export$6a3f3fc42130ef44(value);
}
const $ca7aa15aa0ba1e7b$var$_clickHandler$1 = Symbol("_clickHandler");
/**
 * Mixin to augment an element with behavior used to submit a form.
 * @template T The type of the base class.
 * @param {T} base The base class.
 * @returns {Constructor<FormSubmitterMixin>} A constructor that implements `FormSubmitterMixin`.
 */ function $ca7aa15aa0ba1e7b$export$f7d03dabd73ead6b(base) {
    var _a;
    class _FormSubmitterMixin extends base {
        constructor(){
            super(...arguments);
            /**
       * The type of the element.
       * @default "button"
       */ this.type = "button";
            /** @private */ this[_a] = async (e)=>{
                if (e.defaultPrevented || $ca7aa15aa0ba1e7b$export$8db646b38f27adce(this) && this.disabled || $ca7aa15aa0ba1e7b$export$ef6ef51d21411889(this) && this.disabledInteractive) return;
                const form = this[$ca7aa15aa0ba1e7b$export$e368aba7747330f2].form;
                if (!form || this.type === "button") return;
                await new Promise((resolve)=>setTimeout(resolve));
                if (e.defaultPrevented) return;
                switch(this.type){
                    case "reset":
                        form.reset();
                        break;
                    case "submit":
                        form.addEventListener("submit", (e)=>Object.defineProperty(e, "submitter", {
                                configurable: true,
                                enumerable: true,
                                get: ()=>this
                            }), {
                            capture: true,
                            once: true
                        });
                        this[$ca7aa15aa0ba1e7b$export$e368aba7747330f2].setFormValue(this.value);
                        form.requestSubmit();
                        break;
                }
            };
        }
        /**
     * The name of the element, submitted as a pair with the element's `value`
     * as part of form data, when the element is used to submit a form.
     */ get name() {
            return this.getAttribute("name") ?? "";
        }
        set name(value) {
            if (value) this.setAttribute("name", value);
            else this.removeAttribute("name");
        }
        /** The value associated with the element's name when it's submitted with form data. */ get value() {
            return this.getAttribute("value");
        }
        set value(value) {
            if (value !== null && value !== undefined) this.setAttribute("value", value);
            else this.removeAttribute("value");
        }
        /** @inheritdoc */ connectedCallback() {
            super.connectedCallback();
            this.addEventListener("click", this[$ca7aa15aa0ba1e7b$var$_clickHandler$1]);
        }
        /** @inheritdoc */ disconnectedCallback() {
            super.disconnectedCallback();
            this.removeEventListener("click", this[$ca7aa15aa0ba1e7b$var$_clickHandler$1]);
        }
    }
    _a = $ca7aa15aa0ba1e7b$var$_clickHandler$1;
    /** Indicates that this custom element participates in form submission, validation, and form state restoration. */ _FormSubmitterMixin.formAssociated = true;
    (0, $gkQP3.__decorate)([
        (0, $21eb6a58ce309899$export$d541bacb2bda4494)()
    ], _FormSubmitterMixin.prototype, "name", null);
    (0, $gkQP3.__decorate)([
        (0, $21eb6a58ce309899$export$d541bacb2bda4494)()
    ], _FormSubmitterMixin.prototype, "value", null);
    (0, $gkQP3.__decorate)([
        (0, $21eb6a58ce309899$export$d541bacb2bda4494)()
    ], _FormSubmitterMixin.prototype, "type", void 0);
    return _FormSubmitterMixin;
}
/**
 * Determines whether a value is a `HtmlForMixin`.
 * @param {unknown} value The value to test.
 * @returns {value is HtmlForMixin} Whether `value` is a `HtmlForMixin`.
 */ function $ca7aa15aa0ba1e7b$export$aee76d14a5b732d(value) {
    return $ca7aa15aa0ba1e7b$export$b3cfaccc1b88e6cb(value, "htmlFor", "control", "attach", "detach");
}
const $ca7aa15aa0ba1e7b$var$_control = Symbol("_control");
const $ca7aa15aa0ba1e7b$var$_firstUpdated = Symbol("_firstUpdated");
/**
 * Mixin that creates an attached element associated with an interactive control.
 * @template T The type of the base class.
 * @param {T} base The base class.
 * @returns {Constructor<HtmlForMixin> & T} A constructor extends `base` and implements `HtmlForMixin`.
 */ function $ca7aa15aa0ba1e7b$export$ccf21c713b2bbcbb(base) {
    var _a;
    class _HtmlForMixin extends base {
        constructor(){
            super(...arguments);
            /** @private */ this[_a] = false;
            /** The identifier of the interactive control to which this element is attached. */ this.htmlFor = null;
        }
        /** The interactive element to which this element is attached. */ get control() {
            return this[$ca7aa15aa0ba1e7b$var$_control]?.deref() ?? null;
        }
        /** @inheritdoc */ connectedCallback() {
            super.connectedCallback();
            const control = this[$ca7aa15aa0ba1e7b$var$_control]?.deref();
            if (control) this.attach(control);
        }
        /** @inheritdoc */ disconnectedCallback() {
            super.disconnectedCallback();
            const control = this[$ca7aa15aa0ba1e7b$var$_control];
            if (control) {
                this.detach();
                this[$ca7aa15aa0ba1e7b$var$_control] = control;
            }
        }
        /** @inheritdoc */ firstUpdated(_changedProperties) {
            super.firstUpdated(_changedProperties);
            this[$ca7aa15aa0ba1e7b$var$_firstUpdated] = true;
        }
        /** @inheritdoc */ update(changedProperties) {
            super.update(changedProperties);
            if (changedProperties.has("htmlFor")) {
                if (this.htmlFor) {
                    const root = this.getRootNode();
                    if (root) $ca7aa15aa0ba1e7b$export$eaf3894a2d38d832(this.htmlFor, root).then((control)=>{
                        if (control !== this.control) {
                            if (this.control) this.detach();
                            if (control instanceof HTMLElement) this.attach(control);
                        }
                    });
                } else if (this.control && this[$ca7aa15aa0ba1e7b$var$_firstUpdated]) this.detach();
            }
        }
        /**
     * Attaches the element to an interactive control.
     * @param {HTMLElement} control The element that controls the attachable element.
     */ attach(control) {
            this[$ca7aa15aa0ba1e7b$var$_control] = new WeakRef(control);
        }
        /** Detaches the element from its current interactive control. */ detach() {
            this[$ca7aa15aa0ba1e7b$var$_control] = undefined;
        }
    }
    _a = $ca7aa15aa0ba1e7b$var$_firstUpdated;
    (0, $gkQP3.__decorate)([
        (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
            attribute: "for"
        })
    ], _HtmlForMixin.prototype, "htmlFor", void 0);
    return _HtmlForMixin;
}
/**
 * Mixin to augment an element with behavior emits a click event on keyboard events.
 * @template T The type of the base class.
 * @param {T} base The base class.
 * @param {boolean} [allowEnter=true] Whether the `ENTER` key emits a click event.
 * @returns {T} A class that extends `base` with keyboard click behavior.
 */ function $ca7aa15aa0ba1e7b$export$d564d59935f4debe(base, allowEnter = true) {
    var __KeyboardClickMixin_instances, __KeyboardClickMixin_keyPressed, __KeyboardClickMixin_keyDownHandler, __KeyboardClickMixin_keyUpHandler, __KeyboardClickMixin_focusOutHandler, __KeyboardClickMixin_handleKeyDown, __KeyboardClickMixin_handleKeyUp;
    class _KeyboardClickMixin extends base {
        constructor(){
            super(...arguments);
            __KeyboardClickMixin_instances.add(this);
            /** @private */ __KeyboardClickMixin_keyPressed.set(this, false);
            /** @private */ __KeyboardClickMixin_keyDownHandler.set(this, (e)=>(0, $gkQP3.__classPrivateFieldGet)(this, __KeyboardClickMixin_instances, "m", __KeyboardClickMixin_handleKeyDown).call(this, e));
            __KeyboardClickMixin_keyUpHandler.set(this, (e)=>(0, $gkQP3.__classPrivateFieldGet)(this, __KeyboardClickMixin_instances, "m", __KeyboardClickMixin_handleKeyUp).call(this, e));
            __KeyboardClickMixin_focusOutHandler.set(this, ()=>(0, $gkQP3.__classPrivateFieldSet)(this, __KeyboardClickMixin_keyPressed, false, "f"));
        }
        /** @inheritdoc */ connectedCallback() {
            super.connectedCallback();
            this.addEventListener("keydown", (0, $gkQP3.__classPrivateFieldGet)(this, __KeyboardClickMixin_keyDownHandler, "f"));
            this.addEventListener("keyup", (0, $gkQP3.__classPrivateFieldGet)(this, __KeyboardClickMixin_keyUpHandler, "f"));
            this.addEventListener("focusout", (0, $gkQP3.__classPrivateFieldGet)(this, __KeyboardClickMixin_focusOutHandler, "f"));
        }
        /** @inheritdoc */ disconnectedCallback() {
            super.disconnectedCallback();
            this.removeEventListener("keydown", (0, $gkQP3.__classPrivateFieldGet)(this, __KeyboardClickMixin_keyDownHandler, "f"));
            this.removeEventListener("keyup", (0, $gkQP3.__classPrivateFieldGet)(this, __KeyboardClickMixin_keyUpHandler, "f"));
            this.removeEventListener("focusout", (0, $gkQP3.__classPrivateFieldGet)(this, __KeyboardClickMixin_focusOutHandler, "f"));
        }
    }
    __KeyboardClickMixin_keyPressed = new WeakMap(), __KeyboardClickMixin_keyDownHandler = new WeakMap(), __KeyboardClickMixin_keyUpHandler = new WeakMap(), __KeyboardClickMixin_focusOutHandler = new WeakMap(), __KeyboardClickMixin_instances = new WeakSet(), __KeyboardClickMixin_handleKeyDown = function __KeyboardClickMixin_handleKeyDown(e) {
        if (e.target !== e.currentTarget || $ca7aa15aa0ba1e7b$export$8db646b38f27adce(this) && this.disabled || $ca7aa15aa0ba1e7b$export$ef6ef51d21411889(this) && this.disabledInteractive) {
            (0, $gkQP3.__classPrivateFieldSet)(this, __KeyboardClickMixin_keyPressed, false, "f");
            return;
        }
        if (e.key === " " || allowEnter && e.key === "Enter") (0, $gkQP3.__classPrivateFieldSet)(this, __KeyboardClickMixin_keyPressed, true, "f");
    }, __KeyboardClickMixin_handleKeyUp = function __KeyboardClickMixin_handleKeyUp(e) {
        if (e.target !== e.currentTarget || $ca7aa15aa0ba1e7b$export$8db646b38f27adce(this) && this.disabled || $ca7aa15aa0ba1e7b$export$ef6ef51d21411889(this) && this.disabledInteractive || !(0, $gkQP3.__classPrivateFieldGet)(this, __KeyboardClickMixin_keyPressed, "f")) {
            (0, $gkQP3.__classPrivateFieldSet)(this, __KeyboardClickMixin_keyPressed, false, "f");
            return;
        }
        (0, $gkQP3.__classPrivateFieldSet)(this, __KeyboardClickMixin_keyPressed, false, "f");
        // NOTE: the dispatched click event will not be trusted since it is synthetic.
        this.dispatchEvent(new MouseEvent("click", {
            cancelable: true,
            bubbles: true,
            composed: true
        }));
    };
    return _KeyboardClickMixin;
}
/** A symbol through which to access a function used to render a pseudo link. */ const $ca7aa15aa0ba1e7b$export$6118a8e97d251010 = Symbol("renderPseudoLink");
/**
 * Determines whether a value is a `LinkButtonMixin`.
 * @param {unknown} value The value to test.
 * @returns {value is LinkButtonMixin} Whether `value` is a `LinkButtonMixin`.
 */ function $ca7aa15aa0ba1e7b$export$f840425621b07716(value) {
    return $ca7aa15aa0ba1e7b$export$b3cfaccc1b88e6cb(value, "download", "href", "rel", "target");
}
const $ca7aa15aa0ba1e7b$var$_clickHandler = Symbol("_clickHandler");
/**
 * Mixin to augment an element with behavior that supports functioning as a link.
 * @template T The type of the base class.
 * @param {T} base The base class.
 * @param {boolean} [disableClick=false] Whether to disable the default click handler.
 * @returns {Constructor<LinkButtonMixin>} A constructor that implements `LinkButtonMixin`.
 */ function $ca7aa15aa0ba1e7b$export$29d11c0fe2fc51d8(base, disableClick = false) {
    var __LinkButtonMixin_instances, __LinkButtonMixin_handleLinkPointerDown, __LinkButtonMixin_handleLinkFocus, __LinkButtonMixin_handleLinkBlur, _a;
    class _LinkButtonMixin extends base {
        constructor(){
            super(...arguments);
            __LinkButtonMixin_instances.add(this);
            this[_a] = async (e)=>{
                if ($ca7aa15aa0ba1e7b$export$ef6ef51d21411889(this) && this.disabledInteractive) {
                    e.preventDefault();
                    e.stopPropagation();
                }
                await new Promise((resolve)=>resolve());
                if (e.defaultPrevented) return;
                if (this.href) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    const link = document.createElement("a");
                    link.href = this.href;
                    link.rel = this.rel;
                    link.target = this.target;
                    if (this.download != null) link.download = this.download;
                    link.addEventListener("click", async ()=>{
                        await new Promise((resolve)=>resolve());
                        link.remove();
                    });
                    document.body.appendChild(link);
                    link.click();
                }
            };
            /**
       * The URL to which the link button points.
       * @default ""
       */ this.href = "";
            /**
       * The target of the link button.
       * @default ""
       */ this.target = "";
            /**
       * The relationship between the `target` of the link button and the document.
       * @default ""
       */ this.rel = "";
        }
        /**
     * A value indicating whether the `target` of the link button will be downloaded,
     * optionally specifying the new name of the file.
     * @default null
     */ get download() {
            return this.getAttribute("download");
        }
        set download(value) {
            const old = this.download;
            if (old !== value) {
                if (value) this.setAttribute("download", value);
                else this.removeAttribute("download");
                this.requestUpdate("download", old);
            }
        }
        /** @inheritdoc */ connectedCallback() {
            super.connectedCallback();
            if (!disableClick) this.addEventListener("click", this[$ca7aa15aa0ba1e7b$var$_clickHandler]);
            if (this.hasAttribute("href") && this.role === "button") this.role = "link";
        }
        /** @inheritdoc */ disconnectedCallback() {
            super.disconnectedCallback();
            if (!disableClick) this.removeEventListener("click", this[$ca7aa15aa0ba1e7b$var$_clickHandler]);
        }
        /** @internal */ [(__LinkButtonMixin_instances = new WeakSet(), _a = $ca7aa15aa0ba1e7b$var$_clickHandler, $ca7aa15aa0ba1e7b$export$6118a8e97d251010)]() {
            const disabled = $ca7aa15aa0ba1e7b$export$8db646b38f27adce(this) && this.disabled;
            const disabledInteractive = $ca7aa15aa0ba1e7b$export$ef6ef51d21411889(this) && this.disabledInteractive;
            return !disabled && !disabledInteractive && this.href ? (0, $00a10a29322bb2a1$export$c0bb0b647f701bb5)`<a href="${this.href}" target="${(0, $bf9413d16f7d3f6d$export$f68dd208b5df064d)(this.target || undefined)}" rel="${(0, $bf9413d16f7d3f6d$export$f68dd208b5df064d)(this.rel || undefined)}" download="${(0, $bf9413d16f7d3f6d$export$f68dd208b5df064d)(this.download || undefined)}" tabindex="-1" aria-hidden="true" @pointerdown="${(0, $gkQP3.__classPrivateFieldGet)(this, __LinkButtonMixin_instances, "m", __LinkButtonMixin_handleLinkPointerDown)}" @focus="${(0, $gkQP3.__classPrivateFieldGet)(this, __LinkButtonMixin_instances, "m", __LinkButtonMixin_handleLinkFocus)}" @blur="${(0, $gkQP3.__classPrivateFieldGet)(this, __LinkButtonMixin_instances, "m", __LinkButtonMixin_handleLinkBlur)}"></a>` : (0, $00a10a29322bb2a1$export$45b790e32b2810ee);
        }
    }
    __LinkButtonMixin_handleLinkPointerDown = function __LinkButtonMixin_handleLinkPointerDown(e) {
        if (e.button !== 2) {
            e.preventDefault();
            e.stopImmediatePropagation();
            this.dispatchEvent(new MouseEvent("click", {
                bubbles: true,
                cancelable: true,
                view: window
            }));
        } else e.target.removeAttribute("aria-hidden");
    }, __LinkButtonMixin_handleLinkFocus = function __LinkButtonMixin_handleLinkFocus(e) {
        e.target.blur();
        this.focus();
    }, __LinkButtonMixin_handleLinkBlur = function __LinkButtonMixin_handleLinkBlur(e) {
        e.target.setAttribute("aria-hidden", "true");
    };
    (0, $gkQP3.__decorate)([
        (0, $21eb6a58ce309899$export$d541bacb2bda4494)()
    ], _LinkButtonMixin.prototype, "href", void 0);
    (0, $gkQP3.__decorate)([
        (0, $21eb6a58ce309899$export$d541bacb2bda4494)()
    ], _LinkButtonMixin.prototype, "target", void 0);
    (0, $gkQP3.__decorate)([
        (0, $21eb6a58ce309899$export$d541bacb2bda4494)()
    ], _LinkButtonMixin.prototype, "rel", void 0);
    (0, $gkQP3.__decorate)([
        (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
            reflect: false
        })
    ], _LinkButtonMixin.prototype, "download", null);
    return _LinkButtonMixin;
}
/**
 * Determines whether a value is a `ReadOnlyMixin`.
 * @param {unknown} value The value to test.
 * @returns A value indicating whether `value` is a `ReadOnlyMixin`.
 */ function $ca7aa15aa0ba1e7b$export$4204e5f5cae6a57a(value) {
    return $ca7aa15aa0ba1e7b$export$b3cfaccc1b88e6cb(value, "readOnly");
}
/**
 * Mixin to augment an element with behavior that supports a read-only state.
 * @template T The type of the base class.
 * @param {T} base The base class.
 * @param {boolean} reflect A value indicating whether the read-only state is reflected as an attribute. The default value is `true`.
 * @returns {Constructor<ReadOnlyMixin> & T} A constructor that implements `ReadOnlyMixin`.
 */ function $ca7aa15aa0ba1e7b$export$f9d9eb730174736(base, reflect = true) {
    class _ReadOnlyMixin extends base {
        constructor(){
            super(...arguments);
            /**
       * A value indicating whether the element is read-only.
       * @default false
       */ this.readOnly = false;
        }
        /** @inheritdoc */ update(changedProperties) {
            super.update(changedProperties);
            if (changedProperties.has("readOnly")) this.ariaReadOnly = this.readOnly ? "true" : null;
        }
    }
    (0, $gkQP3.__decorate)([
        (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
            attribute: "readonly",
            type: Boolean,
            reflect: reflect
        })
    ], _ReadOnlyMixin.prototype, "readOnly", void 0);
    return _ReadOnlyMixin;
}
const $ca7aa15aa0ba1e7b$var$_wasConnected = Symbol("_wasConnected");
/**
 * Mixin to augment an element with behavior that supports reconnection logic.
 * @template T The type of the base class.
 * @param {T} base The base class.
 * @returns {Constructor<ReconnectedCallbackMixin> & T} A constructor that implements `ReconnectedCallbackMixin`.
 */ function $ca7aa15aa0ba1e7b$export$625d28f11806c030(base) {
    var _a;
    class _ReconnectedCallbackMixin extends base {
        constructor(){
            super(...arguments);
            /** @private */ this[_a] = false;
        }
        /** @inheritdoc */ reconnectedCallback() {}
        /** @inheritdoc */ connectedCallback() {
            super.connectedCallback();
            if (this[$ca7aa15aa0ba1e7b$var$_wasConnected]) this.reconnectedCallback();
        }
        /** @inheritdoc */ disconnectedCallback() {
            super.disconnectedCallback();
            this[$ca7aa15aa0ba1e7b$var$_wasConnected] = true;
        }
    }
    _a = $ca7aa15aa0ba1e7b$var$_wasConnected;
    return _ReconnectedCallbackMixin;
}
/**
 * Determines whether a value is a `RequiredMixin`.
 * @param {unknown} value The value to test.
 * @returns A value indicating whether `value` is a `RequiredMixin`.
 */ function $ca7aa15aa0ba1e7b$export$9cd74388a5907c0e(value) {
    return $ca7aa15aa0ba1e7b$export$b3cfaccc1b88e6cb(value, "required", "optional");
}
/**
 * Mixin to augment an element with behavior that supports a required state.
 * @template T The type of the base class.
 * @param {T} base The base class.
 * @returns {Constructor<RequiredMixin> & T} A constructor that implements `RequiredMixin`.
 */ function $ca7aa15aa0ba1e7b$export$1788c381af06add2(base) {
    class _RequiredMixin extends base {
        constructor(){
            super(...arguments);
            /**
       * Whether a value is required for the element.
       * @default false
       */ this.required = false;
        }
        /** Whether a value is not required for the element. */ get optional() {
            return !this.required;
        }
        /** @inheritdoc */ update(changedProperties) {
            super.update(changedProperties);
            if (changedProperties.has("required")) this.ariaRequired = `${this.required}`;
        }
    }
    (0, $gkQP3.__decorate)([
        (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
            type: Boolean,
            reflect: true
        })
    ], _RequiredMixin.prototype, "required", void 0);
    return _RequiredMixin;
}
/**
 * Determines whether a value is a `RequiredConstraintValidationMixin`.
 * @param {unknown} value The value to test.
 * @returns A value indicating whether `value` is a `RequiredConstraintValidationMixin`.
 */ function $ca7aa15aa0ba1e7b$export$54d36338059db51b(value) {
    return $ca7aa15aa0ba1e7b$export$9cd74388a5907c0e(value) && $ca7aa15aa0ba1e7b$export$f10b21c67db60ec2(value);
}
/**
 * Mixin to augment an element with behavior that supports a required state.
 * @template T The type of the base class.
 * @param {T} base The base class.
 * @returns {Constructor<RequiredConstraintValidationMixin> & T} A constructor that implements `RequiredConstraintValidationMixin`.
 */ function $ca7aa15aa0ba1e7b$export$ee0f44bbbd6c6cc1(base) {
    class _RequiredConstraintValidation extends base {
        /** @internal */ [$ca7aa15aa0ba1e7b$export$a22775fa5e2eebd9]() {
            const validity = super[$ca7aa15aa0ba1e7b$export$a22775fa5e2eebd9]();
            if (!validity && this.required) {
                if ($ca7aa15aa0ba1e7b$export$be0c43499cc6393e(this) && !this.checked) return {
                    valueMissing: true
                };
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if (!this.value) return {
                    valueMissing: true
                };
            }
            return validity;
        }
    }
    return _RequiredConstraintValidation;
}
/**
 * Mixin to augment an element with an ARIA role.
 * @template T The type of the base class.
 * @param {T} base The base class.
 * @param {ARIARole} role The ARIA role.
 * @returns {Constructor & T} A constructor that implements focusable behavior.
 */ function $ca7aa15aa0ba1e7b$export$46919bad18fb2f76(base, role) {
    class _RoleMixin extends base {
        /** @inheritdoc */ connectedCallback() {
            this.role = this.role || role;
            super.connectedCallback();
        }
    }
    return _RoleMixin;
}
/**
 * Mixin to augment an element with behavior that suppresses initial animations.
 * @template T The type of the base class.
 * @param {T} base The base class.
 * @returns {T} A constructor that implements initial animation suppression.
 */ function $ca7aa15aa0ba1e7b$export$7478c9754756300(base) {
    class _SuppressInitialAnimation extends base {
        connectedCallback() {
            super.connectedCallback();
            $ca7aa15aa0ba1e7b$export$ddd0a0ac12dd84d8(this, "-no-animate");
            requestAnimationFrame(()=>$ca7aa15aa0ba1e7b$export$eda34dc61103d62e(this, "-no-animate"));
        }
    }
    return _SuppressInitialAnimation;
}
/**
 * Determines whether a value is a `VerticalMixin`.
 * @param {unknown} value The value to test.
 * @returns A value indicating whether `value` is a `VerticalMixin`.
 */ function $ca7aa15aa0ba1e7b$export$e19221ce99b6a135(value) {
    return $ca7aa15aa0ba1e7b$export$b3cfaccc1b88e6cb(value, "vertical");
}
/**
 * Mixin to augment an element with behavior that supports a vertical orientation.
 * @template T The type of the base class.
 * @param {T} base The base class.
 * @returns {Constructor<VerticalMixin> & T} A constructor that implements `VerticalMixin`.
 */ function $ca7aa15aa0ba1e7b$export$fbd5e94d16e21e4d(base) {
    class _VerticalMixin extends base {
        constructor(){
            super(...arguments);
            /**
       * Whether the element is oriented vertically.
       * @default false
       */ this.vertical = false;
        }
        /** @inheritdoc */ update(changedProperties) {
            super.update(changedProperties);
            if (changedProperties.has("vertical")) this.ariaOrientation = this.vertical ? "vertical" : "horizontal";
        }
    }
    (0, $gkQP3.__decorate)([
        (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
            type: Boolean,
            reflect: true
        })
    ], _VerticalMixin.prototype, "vertical", void 0);
    return _VerticalMixin;
}
var $ca7aa15aa0ba1e7b$var$_ActionElementBase_clickHandler;
/**
 * A base implementation for an element, nested within a clickable element, used to
 * perform an action. This class must be inherited.
 */ class $ca7aa15aa0ba1e7b$export$f87b6e31e5c1d231 extends (0, $fa29e5b5c67837a0$export$3f2f9f5909897157) {
    constructor(){
        super(...arguments);
        /** @private */ $ca7aa15aa0ba1e7b$var$_ActionElementBase_clickHandler.set(this, (e)=>{
            if (!e.defaultPrevented) this._onClick(e);
        });
    }
    /** @inheritdoc */ connectedCallback() {
        super.connectedCallback();
        this.parentElement?.addEventListener("click", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_ActionElementBase_clickHandler, "f"));
    }
    /** @inheritdoc */ disconnectedCallback() {
        super.disconnectedCallback();
        this.parentElement?.removeEventListener("click", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_ActionElementBase_clickHandler, "f"));
    }
    /** @inheritdoc */ render() {
        return (0, $00a10a29322bb2a1$export$c0bb0b647f701bb5)`<slot></slot>`;
    }
}
$ca7aa15aa0ba1e7b$var$_ActionElementBase_clickHandler = new WeakMap();
/** The styles of the element. */ $ca7aa15aa0ba1e7b$export$f87b6e31e5c1d231.styles = (0, $fbf856437f99196f$export$dbf350e5966cf602)`:host { display: contents; } ::slotted(.material-icons) { font-size: inherit !important; }`;
/* eslint-disable @typescript-eslint/no-unsafe-declaration-merging */ var $ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_instances, $ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_slotChanged, $ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_hasOpened, $ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_handleSlotChange, $ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_autoSize, $ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_clearSize, $ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_actualSize;
/**
 * A container used to expand and collapse content.
 *
 * @example
 * ```html
 * <m3e-collapsible>
 *  <!-- Collapsible content -->
 * </m3e-collapsible>
 * ```
 *
 * @tag m3e-collapsible
 *
 * @slot - Renders the collapsible content.
 *
 * @attr open - Whether content is visible.
 *
 * @fires opening - Emitted when the collapsible begins to open.
 * @fires opened - Emitted when the collapsible has opened.
 * @fires closing - Emitted when the collapsible begins to close.
 * @fires closed - Emitted when the collapsible has closed.
 *
 * @cssprop --m3e-collapsible-animation-duration - The duration of the expand / collapse animation.
 */ let $ca7aa15aa0ba1e7b$export$5dbbfb77a67b0a06 = class M3eCollapsibleElement extends $ca7aa15aa0ba1e7b$export$2e969398e322bb5e($ca7aa15aa0ba1e7b$export$282c9fa792fbac93((0, $fa29e5b5c67837a0$export$3f2f9f5909897157)), "opening", "opened", "closing", "closed") {
    constructor(){
        super(...arguments);
        $ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_instances.add(this);
        /** @private */ $ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_slotChanged.set(this, false);
        /** @private */ $ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_hasOpened.set(this, false);
        /**
     * Whether content is visible.
     * @default false
     */ this.open = false;
    }
    /** @inheritdoc */ update(changedProperties) {
        super.update(changedProperties);
        $ca7aa15aa0ba1e7b$export$ddd0a0ac12dd84d8(this, "-no-animate");
        if (!(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_slotChanged, "f")) {
            if (this.open) {
                (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_hasOpened, true, "f");
                (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_instances, "m", $ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_autoSize).call(this);
            }
            (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_slotChanged, true, "f");
            return;
        }
        this.toggleAttribute("inert", !this.open);
        if (this.open) {
            (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_hasOpened, true, "f");
            if (!$ca7aa15aa0ba1e7b$export$ff7706047246b98b()) {
                (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_instances, "m", $ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_autoSize).call(this);
                $ca7aa15aa0ba1e7b$export$a6b7fbc1acf03e5b(this, "-overflows", this.clientHeight < this.scrollHeight);
                (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_instances, "m", $ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_clearSize).call(this);
            }
            $ca7aa15aa0ba1e7b$export$eda34dc61103d62e(this, "-closing");
            $ca7aa15aa0ba1e7b$export$ddd0a0ac12dd84d8(this, "-opening");
            this.dispatchEvent(new Event("opening"));
            (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_instances, "m", $ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_clearSize).call(this);
            $ca7aa15aa0ba1e7b$export$eda34dc61103d62e(this, "-no-animate");
            (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_instances, "m", $ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_actualSize).call(this);
            if ($ca7aa15aa0ba1e7b$export$ff7706047246b98b()) {
                (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_instances, "m", $ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_autoSize).call(this);
                $ca7aa15aa0ba1e7b$export$eda34dc61103d62e(this, "-opening");
                this.dispatchEvent(new Event("opened"));
            } else this.addEventListener("transitionend", ()=>{
                if (this.open) {
                    (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_instances, "m", $ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_autoSize).call(this);
                    $ca7aa15aa0ba1e7b$export$eda34dc61103d62e(this, "-opening");
                    this.dispatchEvent(new Event("opened"));
                }
            }, {
                once: true
            });
        } else {
            $ca7aa15aa0ba1e7b$export$eda34dc61103d62e(this, "-opening");
            $ca7aa15aa0ba1e7b$export$ddd0a0ac12dd84d8(this, "-closing");
            this.dispatchEvent(new Event("closing"));
            (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_instances, "m", $ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_actualSize).call(this);
            if ((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_hasOpened, "f")) $ca7aa15aa0ba1e7b$export$eda34dc61103d62e(this, "-no-animate");
            if ($ca7aa15aa0ba1e7b$export$ff7706047246b98b()) {
                (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_instances, "m", $ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_clearSize).call(this);
                $ca7aa15aa0ba1e7b$export$eda34dc61103d62e(this, "-closing");
                this.dispatchEvent(new Event("closed"));
            } else requestAnimationFrame(()=>{
                (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_instances, "m", $ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_clearSize).call(this);
                this.addEventListener("transitionend", ()=>{
                    if (!this.open) {
                        $ca7aa15aa0ba1e7b$export$eda34dc61103d62e(this, "-closing");
                        this.dispatchEvent(new Event("closed"));
                    }
                }, {
                    once: true
                });
            });
        }
    }
    /** @inheritdoc */ render() {
        return (0, $00a10a29322bb2a1$export$c0bb0b647f701bb5)`<slot @slotchange="${(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_instances, "m", $ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_handleSlotChange)}"></slot>`;
    }
};
$ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_slotChanged = new WeakMap();
$ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_hasOpened = new WeakMap();
$ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_instances = new WeakSet();
$ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_handleSlotChange = function _M3eCollapsibleElement_handleSlotChange() {
    (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_slotChanged, true, "f");
};
$ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_autoSize = function _M3eCollapsibleElement_autoSize() {
    this.style.height = "auto";
};
$ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_clearSize = function _M3eCollapsibleElement_clearSize() {
    this.style.height = "";
};
$ca7aa15aa0ba1e7b$var$_M3eCollapsibleElement_actualSize = function _M3eCollapsibleElement_actualSize() {
    this.style.height = `${this.scrollHeight}px`;
};
/** The styles of the element. */ $ca7aa15aa0ba1e7b$export$5dbbfb77a67b0a06.styles = (0, $fbf856437f99196f$export$dbf350e5966cf602)`:host { display: block; height: 0px; overflow: hidden; transition: ${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`visibility var(--m3e-collapsible-animation-duration, ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.motion.duration.medium1})
          ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.motion.easing.standard},
        height var(--m3e-collapsible-animation-duration, ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.motion.duration.medium1})
          ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.motion.easing.standard},
        padding-top var(--m3e-collapsible-animation-duration, ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.motion.duration.medium1})
          ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.motion.easing.standard},
        padding-bottom var(--m3e-collapsible-animation-duration, ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.motion.duration.medium1})
          ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.motion.easing.standard}`)}; } :host(:not(:state(-closing)):not([open])) { visibility: hidden; } :host(:not([open])) { min-height: unset !important; padding-top: 0px !important; padding-bottom: 0px !important; } :host(:state(-no-animate)) { transition-duration: 0ms; } :host(:state(-opening)), :host(:state(-closing)) { overflow-y: hidden !important; } :host(:state(-overflows)) { scrollbar-gutter: stable; } ::slotted(*) { --m3e-collapsible-animation-duration: initial; } @media (prefers-reduced-motion) { :host { transition: none; } }`;
(0, $gkQP3.__decorate)([
    (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $ca7aa15aa0ba1e7b$export$5dbbfb77a67b0a06.prototype, "open", void 0);
$ca7aa15aa0ba1e7b$export$5dbbfb77a67b0a06 = (0, $gkQP3.__decorate)([
    $ca7aa15aa0ba1e7b$export$da64fc29f17f9d0e("m3e-collapsible")
], $ca7aa15aa0ba1e7b$export$5dbbfb77a67b0a06);
/**
 * Component design tokens that control the `M3eElevationElement`.
 * @internal
 */ const $ca7aa15aa0ba1e7b$var$ElevationToken = {
    liftDuration: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevation-lift-duration, ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.motion.duration.short4})`),
    liftEasing: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevation-lift-easing, ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.motion.easing.standard})`),
    settleDuration: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevation-settle-duration, ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.motion.duration.short3})`),
    settleEasing: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevation-settle-easing, ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.motion.easing.standardAccelerate})`),
    level: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevation-level, ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.elevation.level0})`),
    hoverLevel: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevation-hover-level, ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.elevation.level0})`),
    focusLevel: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevation-focus-level, ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.elevation.level0})`),
    pressedLevel: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevation-pressed-level, ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.elevation.level0})`)
};
var $ca7aa15aa0ba1e7b$var$_M3eElevationElement_instances, $ca7aa15aa0ba1e7b$var$_M3eElevationElement_hoverController, $ca7aa15aa0ba1e7b$var$_M3eElevationElement_focusController, $ca7aa15aa0ba1e7b$var$_M3eElevationElement_pressedController, $ca7aa15aa0ba1e7b$var$_M3eElevationElement_handleHoverChange, $ca7aa15aa0ba1e7b$var$_M3eElevationElement_handleFocusChange, $ca7aa15aa0ba1e7b$var$_M3eElevationElement_handlePressedChange;
/**
 * Visually depicts elevation using a shadow.
 *
 * @description
 * The `m3e-elevation` component is an absolute positioned element used to depict elevation using a shadow.
 * The parenting element must be a relative positioned element and allow for overflow. Use the `level` attribute
 * to specify the elevation level.
 *
 * The component can also be attached to another element using the `for` attribute.  When attached, elevation will
 * be lifted by 1 level on hover. This can be disabled using the `disabled` attribute.
 *
 * Alternatively, use the `attach` and `detach` methods to programmatically attach and detach this element to another.
 *
 * @example
 * The following example illustrates basic markup. Note how the parenting element's position is `relative`. A parenting
 * element's position must be `relative` and overflow must be visible.
 *
 * ```html
 * <div style="position: relative;">
 *  <m3e-elevation level="1"></m3e-elevation>
 * <div>
 * ```
 * @example
 * The following example illustrates attaching elevation to an interactive element. In this example, the parenting div
 * is given an `id` referenced by `m3e-elevation` using the `for` attribute.  Note that `#myDiv` is not used when
 * specifying the attached element's identifier.  The `#` is inferred.
 *
 * ```html
 * <div id="myDiv" style="position: relative;">
 *  <m3e-elevation for="myDiv" level="1"></m3e-elevation>
 * <div>
 * ```
 *
 * @tag m3e-elevation
 *
 * @attr disabled - Whether hover and press events will not trigger changes in elevation, when attached to an interactive element.
 * @attr for - The identifier of the interactive control to which this element is attached.
 * @attr level - The level at which to visually depict elevation.
 *
 * @cssprop --m3e-elevation-color - Color used to depict elevation.
 * @cssprop --m3e-elevation-lift-duration - Duration when lifting.
 * @cssprop --m3e-elevation-lift-easing - Easing curve when lifting.
 * @cssprop --m3e-elevation-settle-duration - Duration when settling.
 * @cssprop --m3e-elevation-settle-easing - Easing curve when settling.
 * @cssprop --m3e-elevation-level - Elevation when resting (box-shadow).
 * @cssprop --m3e-elevation-hover-level - Elevation on hover (box-shadow).
 * @cssprop --m3e-elevation-focus-level - Elevation on focus (box-shadow).
 * @cssprop --m3e-elevation-pressed-level - Elevation on pressed (box-shadow).
 */ let $ca7aa15aa0ba1e7b$export$b8d84cf1103e360e = class M3eElevationElement extends $ca7aa15aa0ba1e7b$export$ccf21c713b2bbcbb($ca7aa15aa0ba1e7b$export$46919bad18fb2f76((0, $fa29e5b5c67837a0$export$3f2f9f5909897157), "none")) {
    constructor(){
        super(...arguments);
        $ca7aa15aa0ba1e7b$var$_M3eElevationElement_instances.add(this);
        /** @private */ $ca7aa15aa0ba1e7b$var$_M3eElevationElement_hoverController.set(this, new $ca7aa15aa0ba1e7b$export$e97521e950437f92(this, {
            target: null,
            callback: (hovering)=>(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eElevationElement_instances, "m", $ca7aa15aa0ba1e7b$var$_M3eElevationElement_handleHoverChange).call(this, hovering)
        }));
        /** @private */ $ca7aa15aa0ba1e7b$var$_M3eElevationElement_focusController.set(this, new $ca7aa15aa0ba1e7b$export$766c876d58dec02e(this, {
            target: null,
            callback: (focused)=>(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eElevationElement_instances, "m", $ca7aa15aa0ba1e7b$var$_M3eElevationElement_handleFocusChange).call(this, focused)
        }));
        /** @private */ $ca7aa15aa0ba1e7b$var$_M3eElevationElement_pressedController.set(this, new $ca7aa15aa0ba1e7b$export$1351ab2eef382c23(this, {
            target: null,
            callback: (pressed)=>(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eElevationElement_instances, "m", $ca7aa15aa0ba1e7b$var$_M3eElevationElement_handlePressedChange).call(this, pressed)
        }));
        /**
     * Whether hover and press events will not trigger changes in elevation, when attached to an interactive element.
     * @default false
     */ this.disabled = false;
        /**
     * The level at which to visually depict elevation.
     * @default null
     */ this.level = null;
    }
    /** @inheritdoc */ attach(control) {
        super.attach(control);
        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eElevationElement_hoverController, "f").observe(control);
        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eElevationElement_focusController, "f").observe(control);
        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eElevationElement_pressedController, "f").observe(control);
    }
    /** @inheritdoc */ detach() {
        if (this.control) {
            (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eElevationElement_hoverController, "f").unobserve(this.control);
            (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eElevationElement_focusController, "f").unobserve(this.control);
            (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eElevationElement_pressedController, "f").unobserve(this.control);
        }
        super.detach();
    }
    /** @inheritdoc */ connectedCallback() {
        this.ariaHidden = "true";
        super.connectedCallback();
    }
    /** @inheritdoc */ disconnectedCallback() {
        super.disconnectedCallback();
        this._shadow?.classList.toggle("hover", false);
        this._shadow?.classList.toggle("focus", false);
        this._shadow?.classList.toggle("pressed", false);
        this._shadow?.classList.toggle("resting", false);
    }
    /** @inheritdoc */ updated(_changedProperties) {
        super.updated(_changedProperties);
        if (_changedProperties.has("disabled") && this.disabled) {
            this._shadow?.classList.toggle("hover", false);
            this._shadow?.classList.toggle("focus", false);
            this._shadow?.classList.toggle("pressed", false);
            this._shadow?.classList.toggle("resting", true);
        }
    }
    /** @inheritdoc */ render() {
        return (0, $00a10a29322bb2a1$export$c0bb0b647f701bb5)`<div class="shadow"></div>`;
    }
};
$ca7aa15aa0ba1e7b$var$_M3eElevationElement_hoverController = new WeakMap();
$ca7aa15aa0ba1e7b$var$_M3eElevationElement_focusController = new WeakMap();
$ca7aa15aa0ba1e7b$var$_M3eElevationElement_pressedController = new WeakMap();
$ca7aa15aa0ba1e7b$var$_M3eElevationElement_instances = new WeakSet();
$ca7aa15aa0ba1e7b$var$_M3eElevationElement_handleHoverChange = function _M3eElevationElement_handleHoverChange(hovering) {
    if (!this.disabled) {
        this._shadow?.classList.toggle("hover", hovering);
        this._shadow?.classList.toggle("resting", !hovering);
    }
};
$ca7aa15aa0ba1e7b$var$_M3eElevationElement_handleFocusChange = function _M3eElevationElement_handleFocusChange(focused) {
    if (!this.disabled) this._shadow?.classList.toggle("focus", focused);
};
$ca7aa15aa0ba1e7b$var$_M3eElevationElement_handlePressedChange = function _M3eElevationElement_handlePressedChange(pressed) {
    if (!this.disabled) this._shadow?.classList.toggle("pressed", pressed);
};
/** The styles of the element. */ $ca7aa15aa0ba1e7b$export$b8d84cf1103e360e.styles = (0, $fbf856437f99196f$export$dbf350e5966cf602)`:host { display: block; } :host, .shadow { position: absolute; left: 0; top: 0; right: 0; bottom: 0; pointer-events: none; border-radius: inherit; } .shadow.resting, .shadow.focus, .shadow.pressed { will-change: box-shadow; transition: ${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`box-shadow ${$ca7aa15aa0ba1e7b$var$ElevationToken.settleDuration} ${$ca7aa15aa0ba1e7b$var$ElevationToken.settleEasing};`)}; } .shadow.hover { will-change: box-shadow; transition: ${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`box-shadow ${$ca7aa15aa0ba1e7b$var$ElevationToken.liftDuration} ${$ca7aa15aa0ba1e7b$var$ElevationToken.liftEasing};`)}; } .shadow { box-shadow: ${$ca7aa15aa0ba1e7b$var$ElevationToken.level}; } .shadow.focus { box-shadow: ${$ca7aa15aa0ba1e7b$var$ElevationToken.focusLevel}; } .shadow.hover { box-shadow: ${$ca7aa15aa0ba1e7b$var$ElevationToken.hoverLevel}; } .shadow.pressed { box-shadow: ${$ca7aa15aa0ba1e7b$var$ElevationToken.pressedLevel}; } :host([level="0"]) .shadow { --m3e-elevation-level: ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.elevation.level0}; --m3e-elevation-hover-level: ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.elevation.level1}; } :host([level="1"]) .shadow { --m3e-elevation-level: ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.elevation.level1}; --m3e-elevation-hover-level: ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.elevation.level2}; } :host([level="2"]) .shadow { --m3e-elevation-level: ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.elevation.level2}; --m3e-elevation-hover-level: ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.elevation.level3}; } :host([level="3"]) .shadow { --m3e-elevation-level: ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.elevation.level3}; --m3e-elevation-hover-level: ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.elevation.level4}; } :host([level="4"]) .shadow { --m3e-elevation-level: ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.elevation.level4}; --m3e-elevation-hover-level: ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.elevation.level5}; } :host([level="5"]) .shadow { --m3e-elevation-level: ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.elevation.level5}; --m3e-elevation-hover-level: ${$ca7aa15aa0ba1e7b$var$ElevationToken.level}; } :host([level]) .shadow { --m3e-elevation-focus-level: ${$ca7aa15aa0ba1e7b$var$ElevationToken.level}; --m3e-elevation-pressed-level: ${$ca7aa15aa0ba1e7b$var$ElevationToken.level}; } @media (prefers-reduced-motion) { .shadow.resting, .shadow.pressed, .shadow.focus, .shadow.hover { transition: none; } } @media (forced-colors: active) { .shadow { display: none; } }`;
(0, $gkQP3.__decorate)([
    (0, $540200038ed52347$export$2fa187e846a241c4)(".shadow")
], $ca7aa15aa0ba1e7b$export$b8d84cf1103e360e.prototype, "_shadow", void 0);
(0, $gkQP3.__decorate)([
    (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $ca7aa15aa0ba1e7b$export$b8d84cf1103e360e.prototype, "disabled", void 0);
(0, $gkQP3.__decorate)([
    (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
        type: Number,
        reflect: true
    })
], $ca7aa15aa0ba1e7b$export$b8d84cf1103e360e.prototype, "level", void 0);
$ca7aa15aa0ba1e7b$export$b8d84cf1103e360e = (0, $gkQP3.__decorate)([
    $ca7aa15aa0ba1e7b$export$da64fc29f17f9d0e("m3e-elevation")
], $ca7aa15aa0ba1e7b$export$b8d84cf1103e360e);
/**
 * Component design tokens that control the `M3eFocusRingElement`.
 * @internal
 */ const $ca7aa15aa0ba1e7b$var$FocusRingToken = {
    /** The color of the focus ring. */ color: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-focus-ring-color, ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.color.secondary})`),
    /** The duration of the focus ring animation. */ duration: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-focus-ring-duration, ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.motion.duration.long2})`),
    /** The thickness of the focus ring. */ thickness: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--m3e-focus-ring-thickness, 3px)"),
    /** Offset of an outward focus ring. */ outwardOffset: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--m3e-focus-ring-outward-offset, 2px)"),
    /** Offset of an inward focus ring. */ inwardOffset: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--m3e-focus-ring-inward-offset, 0px)"),
    /** The visibility of the focus ring. */ visibility: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--m3e-focus-ring-visibility, visible)"),
    /** The factor by which the focus ring grows. */ growthFactor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--m3e-focus-ring-growth-factor, 2)")
};
var $ca7aa15aa0ba1e7b$var$_M3eFocusRingElement_instances, $ca7aa15aa0ba1e7b$var$_M3eFocusRingElement_focusController, $ca7aa15aa0ba1e7b$var$_M3eFocusRingElement_handleFocusChange;
/**
 * A focus ring used to depict a strong focus indicator.
 *
 * @description
 * The `m3e-focus-ring` component is an absolute positioned element used to provide a strong focus indicator.
 * The parenting element must be a relative positioned focusable element and allow for overflow.
 *
 * The component can be attached to an interactive element using the `for` attribute or programmatically using the `attach` method.
 * The focus ring is displayed when the interactive element receives visible focus and hidden when focus is lost.
 * This can be disabled using the `disabled` attribute.
 *
 * Alternatively, you can use the `show` and `hide` methods to programmatically control the focus ring.
 *
 * @example
 * The following example illustrates attaching a focus ring to an interactive element. In this example, the parenting div
 * has relative positioning and is given an `id` referenced by `m3e-focus-ring` using the `for` attribute.  Note that `#myDiv`
 * is not used when specifying the attached element's identifier.  The `#` is inferred.
 *
 * ```html
 * <div id="myDiv" tabindex="0" style="position: relative;">
 *  <m3e-focus-ring for="myDiv"></m3e-focus-ring>
 * <div>
 * ```
 *
 * @tag m3e-focus-ring
 *
 * @attr disabled - Whether the focus events will not trigger the focus ring. Focus rings can be still controlled manually by using the `show` and `hide` methods.
 * @attr inward - Whether the focus ring animates inward instead of outward.
 *
 * @cssprop --m3e-focus-ring-color - The color of the focus ring.
 * @cssprop --m3e-focus-ring-duration - The duration of the focus ring animation.
 * @cssprop --m3e-focus-ring-growth-factor - The factor by which the focus ring grows.
 * @cssprop --m3e-focus-ring-thickness - The thickness of the focus ring.
 * @cssprop --m3e-focus-ring-visibility - The visibility of the focus ring.
 * @cssprop --m3e-focus-ring-outward-offset - Offset of an outward focus ring.
 * @cssprop --m3e-focus-ring-inward-offset - Offset of an inward focus ring.
 */ let $ca7aa15aa0ba1e7b$export$961832a2da773570 = class M3eFocusRingElement extends $ca7aa15aa0ba1e7b$export$ccf21c713b2bbcbb($ca7aa15aa0ba1e7b$export$46919bad18fb2f76((0, $fa29e5b5c67837a0$export$3f2f9f5909897157), "none")) {
    constructor(){
        super(...arguments);
        $ca7aa15aa0ba1e7b$var$_M3eFocusRingElement_instances.add(this);
        /** @private */ $ca7aa15aa0ba1e7b$var$_M3eFocusRingElement_focusController.set(this, new $ca7aa15aa0ba1e7b$export$766c876d58dec02e(this, {
            target: null,
            callback: (_, focusVisible)=>(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eFocusRingElement_instances, "m", $ca7aa15aa0ba1e7b$var$_M3eFocusRingElement_handleFocusChange).call(this, focusVisible)
        }));
        /**
     * Whether the focus ring animates inward instead of outward.
     * @default false
     */ this.inward = false;
        /**
     * Whether the focus events will not trigger the focus ring.
     * Focus rings can be still controlled manually by using the `show` and `hide` methods.
     * @default false
     */ this.disabled = false;
    }
    /** Launches a manual focus ring. */ show() {
        this._outline?.classList.toggle("visible", true);
    }
    /** Hides the focus ring. */ hide() {
        this._outline?.classList.toggle("visible", false);
    }
    /** @inheritdoc */ attach(control) {
        super.attach(control);
        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eFocusRingElement_focusController, "f").observe(control);
    }
    /** @inheritdoc */ detach() {
        if (this.control) (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eFocusRingElement_focusController, "f").unobserve(this.control);
        super.detach();
    }
    /** @inheritdoc */ connectedCallback() {
        this.ariaHidden = "true";
        super.connectedCallback();
    }
    /** @inheritdoc */ disconnectedCallback() {
        super.disconnectedCallback();
        this.hide();
    }
    /** @inheritdoc */ render() {
        return (0, $00a10a29322bb2a1$export$c0bb0b647f701bb5)`<div class="outline"></div>`;
    }
    /** @inheritdoc */ updated(_changedProperties) {
        super.updated(_changedProperties);
        if (_changedProperties.has("disabled") && this.disabled) this.hide();
    }
};
$ca7aa15aa0ba1e7b$var$_M3eFocusRingElement_focusController = new WeakMap();
$ca7aa15aa0ba1e7b$var$_M3eFocusRingElement_instances = new WeakSet();
$ca7aa15aa0ba1e7b$var$_M3eFocusRingElement_handleFocusChange = function _M3eFocusRingElement_handleFocusChange(focusVisible) {
    if (!this.disabled) {
        if (focusVisible) this.show();
        else this.hide();
    }
};
/** The styles of the element. */ $ca7aa15aa0ba1e7b$export$961832a2da773570.styles = (0, $fbf856437f99196f$export$dbf350e5966cf602)`:host { display: block; position: absolute; left: 0; top: 0; right: 0; bottom: 0; pointer-events: none; border-radius: inherit; outline: none; } .outline { position: absolute; left: 0; top: 0; right: 0; bottom: 0; pointer-events: none; border-radius: inherit; z-index: 1; outline-color: ${$ca7aa15aa0ba1e7b$var$FocusRingToken.color}; outline-width: ${$ca7aa15aa0ba1e7b$var$FocusRingToken.thickness}; visibility: ${$ca7aa15aa0ba1e7b$var$FocusRingToken.visibility}; } .outline.visible { outline-style: solid; } :host(:not([inward])) .outline { outline-offset: ${$ca7aa15aa0ba1e7b$var$FocusRingToken.outwardOffset}; } :host([inward]) .outline { outline-offset: calc(${$ca7aa15aa0ba1e7b$var$FocusRingToken.inwardOffset} - ${$ca7aa15aa0ba1e7b$var$FocusRingToken.thickness}); } :host(:not([inward])) .outline.visible { animation: grow-shrink ${$ca7aa15aa0ba1e7b$var$FocusRingToken.duration}; } :host([inward]) .outline.visible { animation: shrink-grow ${$ca7aa15aa0ba1e7b$var$FocusRingToken.duration}; } @keyframes grow-shrink { 50% { outline-width: calc(${$ca7aa15aa0ba1e7b$var$FocusRingToken.thickness} * ${$ca7aa15aa0ba1e7b$var$FocusRingToken.growthFactor}); } } @keyframes shrink-grow { 50% { outline-offset: calc( ${$ca7aa15aa0ba1e7b$var$FocusRingToken.inwardOffset} - calc(${$ca7aa15aa0ba1e7b$var$FocusRingToken.thickness} * ${$ca7aa15aa0ba1e7b$var$FocusRingToken.growthFactor}) ); outline-width: calc(${$ca7aa15aa0ba1e7b$var$FocusRingToken.thickness} * ${$ca7aa15aa0ba1e7b$var$FocusRingToken.growthFactor}); } } @media (prefers-reduced-motion) { :host(:not([inward])) .outline.visible, :host([inward]) .outline.visible { animation: none; } } @media (forced-colors: active) { .outline { outline-color: Highlight; } }`;
(0, $gkQP3.__decorate)([
    (0, $540200038ed52347$export$2fa187e846a241c4)(".outline")
], $ca7aa15aa0ba1e7b$export$961832a2da773570.prototype, "_outline", void 0);
(0, $gkQP3.__decorate)([
    (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $ca7aa15aa0ba1e7b$export$961832a2da773570.prototype, "inward", void 0);
(0, $gkQP3.__decorate)([
    (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $ca7aa15aa0ba1e7b$export$961832a2da773570.prototype, "disabled", void 0);
$ca7aa15aa0ba1e7b$export$961832a2da773570 = (0, $gkQP3.__decorate)([
    $ca7aa15aa0ba1e7b$export$da64fc29f17f9d0e("m3e-focus-ring")
], $ca7aa15aa0ba1e7b$export$961832a2da773570);
/**
 * An element which looks like a checkbox.
 *
 * @description
 * The `m3e-pseudo-checkbox` component is a pseudo-checkbox supporting checked, indeterminate, and disabled
 * states. It is customizable via CSS properties for expressive, accessible UI design.
 *
 * @example
 * The following example illustrates how to render a checked pseudo-checkbox.
 * ```html
 * <m3e-pseudo-checkbox checked></m3e-pseudo-checkbox>
 * ```
 *
 * @tag m3e-pseudo-checkbox
 *
 * @attr checked - A value indicating whether the element is checked.
 * @attr disabled - A value indicating whether the element is disabled.
 * @attr indeterminate - A value indicating whether the element's checked state is indeterminate.
 *
 * @cssprop --m3e-checkbox-icon-size - Size of the checkbox icon.
 * @cssprop --m3e-checkbox-container-shape - Border radius of the checkbox container.
 * @cssprop --m3e-checkbox-unselected-outline-thickness - Outline thickness for unselected state.
 * @cssprop --m3e-checkbox-unselected-outline-color - Outline color for unselected state.
 * @cssprop --m3e-checkbox-selected-container-color - Background color for selected state.
 * @cssprop --m3e-checkbox-selected-icon-color - Icon color for selected state.
 * @cssprop --m3e-checkbox-unselected-disabled-outline-color - Outline color for unselected disabled state.
 * @cssprop --m3e-checkbox-unselected-disabled-outline-opacity - Outline opacity for unselected disabled state.
 * @cssprop --m3e-checkbox-selected-disabled-container-color - Background color for selected disabled state.
 * @cssprop --m3e-checkbox-selected-disabled-container-opacity - Background opacity for selected disabled state.
 * @cssprop --m3e-checkbox-selected-disabled-icon-color - Icon color for selected disabled state.
 * @cssprop --m3e-checkbox-selected-disabled-icon-opacity - Icon opacity for selected disabled state.
 */ let $ca7aa15aa0ba1e7b$export$dc19991764abe2ea = class M3ePseudoCheckboxElement extends $ca7aa15aa0ba1e7b$export$13a11691eea54028($ca7aa15aa0ba1e7b$export$9a986b15f53d6d10($ca7aa15aa0ba1e7b$export$46919bad18fb2f76((0, $fa29e5b5c67837a0$export$3f2f9f5909897157), "none"))) {
    /** @inheritdoc */ connectedCallback() {
        super.connectedCallback();
        this.ariaHidden = "true";
    }
    /** @inheritdoc */ render() {
        if (this.indeterminate) return (0, $00a10a29322bb2a1$export$c0bb0b647f701bb5)`<svg viewBox="0 -960 960 960" fill="currentColor"><path Required d="M240-440v-80h480v80H240Z"/></svg>`;
        if (this.checked) return (0, $00a10a29322bb2a1$export$c0bb0b647f701bb5)`<svg viewBox="0 -960 960 960" fill="currentColor"><path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z"/></svg>`;
        return 0, $00a10a29322bb2a1$export$45b790e32b2810ee;
    }
};
/** The styles of the element. */ $ca7aa15aa0ba1e7b$export$dc19991764abe2ea.styles = (0, $fbf856437f99196f$export$dbf350e5966cf602)`:host { display: inline-block; vertical-align: middle; width: var(--m3e-checkbox-icon-size, 1.125rem); height: var(--m3e-checkbox-icon-size, 1.125rem); border-radius: var(--m3e-checkbox-container-shape, 2px); box-sizing: border-box; flex: none; } :host(:not([checked]):not([indeterminate])) { border-width: var(--m3e-checkbox-unselected-outline-thickness, 2px); border-style: solid; } :host(:not([disabled])[checked]), :host(:not([disabled])[indeterminate]) { background-color: var(--m3e-checkbox-selected-container-color, ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.color.primary}); color: var(--m3e-checkbox-selected-icon-color, ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.color.onPrimary}); } :host(:not([disabled]):not([checked]):not([indeterminate])) { border-color: var(--m3e-checkbox-unselected-outline-color, ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.color.onSurfaceVariant}); } :host([disabled]:not([checked]):not([indeterminate])) { border-color: color-mix( in srgb, var(--m3e-checkbox-unselected-disabled-outline-color, ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.color.onSurface}) var(--m3e-checkbox-unselected-disabled-outline-opacity, 38%), transparent ); } :host([disabled][checked]), :host([disabled][indeterminate]) { background-color: color-mix( in srgb, var(--m3e-checkbox-selected-disabled-container-color, ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.color.onSurface}) var(--m3e-checkbox-selected-disabled-container-opacity, 38%), transparent ); color: color-mix( in srgb, var(--m3e-checkbox-selected-disabled-icon-color, ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.color.surface}) var(--m3e-checkbox-selected-disabled-icon-opacity, 100%), transparent ); } svg { pointer-events: none; } @media (forced-colors: active) { :host(:not([disabled])[checked]), :host(:not([disabled])[indeterminate]) { border-color: Highlight; background-color: Highlight; color: HighlightText; } :host(:not([disabled]):not([checked]):not([indeterminate])) { border-color: CanvasText; background: Canvas; } :host([disabled]:not([checked]):not([indeterminate])) { border-color: GrayText; background-color: Canvas; } :host([disabled][checked]), :host([disabled][indeterminate]) { background-color: GrayText; color: Canvas; } }`;
$ca7aa15aa0ba1e7b$export$dc19991764abe2ea = (0, $gkQP3.__decorate)([
    $ca7aa15aa0ba1e7b$export$da64fc29f17f9d0e("m3e-pseudo-checkbox")
], $ca7aa15aa0ba1e7b$export$dc19991764abe2ea);
/**
 * An element which looks like a radio button.
 *
 * @description
 * The `m3e-pseudo-radio` component is a pseudo-radio supporting checked and disabled
 * states. It is customizable via CSS properties for expressive, accessible UI design.
 *
 * @example
 * The following example illustrates how to render a checked pseudo-radio.
 * ```html
 * <m3e-pseudo-radio checked></m3e-pseudo-radio>
 * ```
 *
 * @tag m3e-pseudo-radio
 *
 * @attr checked - A value indicating whether the element is checked.
 * @attr disabled - A value indicating whether the element is disabled.
 *
 * @cssprop --m3e-radio-icon-size - Size of the radio icon.
 * @cssprop --m3e-radio-unselected-icon-color - Color of the unselected radio icon.
 * @cssprop --m3e-radio-selected-icon-color - Color of the selected radio icon.
 * @cssprop --m3e-radio-disabled-icon-color - Color of the disabled radio icon.
 */ let $ca7aa15aa0ba1e7b$export$75c468e60a2d8343 = class M3ePseudoRadioElement extends $ca7aa15aa0ba1e7b$export$8c8ee9238b7b0c2a($ca7aa15aa0ba1e7b$export$9a986b15f53d6d10($ca7aa15aa0ba1e7b$export$46919bad18fb2f76((0, $fa29e5b5c67837a0$export$3f2f9f5909897157), "none"))) {
    /** @inheritdoc */ connectedCallback() {
        super.connectedCallback();
        this.ariaHidden = "true";
    }
    /** @inheritdoc */ render() {
        return (0, $00a10a29322bb2a1$export$c0bb0b647f701bb5)`<svg class="icon" viewBox="0 0 20 20"><mask id="cutout2"><rect width="100%" height="100%" fill="white"></rect><circle cx="10" cy="10" r="8" fill="black"></circle></mask><circle class="outer circle" cx="10" cy="10" r="10" mask="url(#cutout2)"></circle><circle class="inner circle" cx="10" cy="10" r="5"></circle></svg>`;
    }
};
/** The styles of the element. */ $ca7aa15aa0ba1e7b$export$75c468e60a2d8343.styles = (0, $fbf856437f99196f$export$dbf350e5966cf602)`:host { display: inline-block; vertical-align: middle; box-sizing: border-box; width: var(--m3e-radio-icon-size, 1.25rem); height: var(--m3e-radio-icon-size, 1.25rem); flex: none; } .circle { fill: currentColor; } :host(:not([checked])) .circle.inner { opacity: 0; } :host(:not([checked])) { color: var(--m3e-radio-unselected-icon-color, ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.color.onSurfaceVariant}); } :host([checked]) { color: var(--m3e-radio-selected-icon-color, ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.color.primary}); } :host([disabled]) { color: color-mix(in srgb, var(--m3e-radio-disabled-icon-color, ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.color.onSurface}) 38%, transparent); } @media (forced-colors: active) { :host { border-radius: 50%; } :host(:not([checked])) { color: CanvasText; background-color: Canvas; } :host([checked]) { color: HighlightText; background-color: Highlight; } :host([disabled]) { color: GrayText; background-color: Canvas; } }`;
$ca7aa15aa0ba1e7b$export$75c468e60a2d8343 = (0, $gkQP3.__decorate)([
    $ca7aa15aa0ba1e7b$export$da64fc29f17f9d0e("m3e-pseudo-radio")
], $ca7aa15aa0ba1e7b$export$75c468e60a2d8343);
/**
 * Component design tokens that control the `M3eRippleElement`.
 * @internal
 */ const $ca7aa15aa0ba1e7b$var$RippleToken = {
    color: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-ripple-color, ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.color.onSurface})`),
    opacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-ripple-opacity, ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.state.pressedStateLayerOpacity})`),
    enterDuration: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-ripple-enter-duration, ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.motion.duration.long4})`),
    exitDuration: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-ripple-exit-duration, ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.motion.duration.short2})`),
    scaleFactor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-ripple-scale-factor, 2.5)`)
};
var $ca7aa15aa0ba1e7b$var$_M3eRippleElement_instances, $ca7aa15aa0ba1e7b$var$_M3eRippleElement_ripple, $ca7aa15aa0ba1e7b$var$_M3eRippleElement_pressedController, $ca7aa15aa0ba1e7b$var$_M3eRippleElement_destroyRipple, $ca7aa15aa0ba1e7b$var$_M3eRippleElement_handleAnimationEnd, $ca7aa15aa0ba1e7b$var$_M3eRippleElement_handlePressedChange;
/**
 * Connects user input to screen reactions using ripples.
 *
 * @description
 * The `m3e-ripple` component is an absolute positioned element used to depict a ripple.
 * The parenting element must be a relative positioned element.
 *
 * The component can be attached to an interactive element using the `for` attribute or programmatically using the `attach` method.
 * The ripple is displayed when the interactive element is pressed and hidden when released.  This can be disabled using the `disabled` attribute.
 *
 * The pressed state actives either using both pointer and keyboard events. For keyboard events, `SPACE` activate a ripple.
 *
 * Alternatively, you can use the `show` and `hide` methods to programmatically control the ripple.
 *
 * @example
 * The following example illustrates attaching a ripple to an interactive element. In this example, the parenting div
 * has relative positioning and is given an `id` referenced by `m3e-ripple` using the `for` attribute.  Note that `#myDiv`
 * is not used when specifying the attached element's identifier.  The `#` is inferred.
 *
 * ```html
 * <div id="myDiv" tabindex="0" style="position: relative;">
 *  <m3e-ripple for="myDiv"></m3e-ripple>
 * <div>
 * ```
 *
 * @tag m3e-ripple
 *
 * @attr centered - Whether the ripple always originates from the center of the element's bounds, rather than originating from the location of the click event.
 * @attr disabled - Whether click events will not trigger the ripple.  Ripples can be still controlled manually by using the `show` and 'hide' methods.
 * @attr for - The identifier of the interactive control to which this element is attached.
 * @attr radius - The radius, in pixels, of the ripple.
 * @attr unbounded - Whether the ripple is visible outside the element's bounds.
 *
 * @cssprop --m3e-ripple-color - The color of the ripple.
 * @cssprop --m3e-ripple-enter-duration - The duration for the enter animation (expansion from point of contact).
 * @cssprop --m3e-ripple-exit-duration - The duration for the exit animation (fade-out).
 * @cssprop --m3e-ripple-opacity - The opacity of the ripple.
 * @cssprop --m3e-ripple-scale-factor - The factor by which to scale the ripple.
 * @cssprop --m3e-ripple-shape - The shape of the ripple.
 */ let $ca7aa15aa0ba1e7b$export$4ab7a510e6d61011 = class M3eRippleElement extends $ca7aa15aa0ba1e7b$export$ccf21c713b2bbcbb($ca7aa15aa0ba1e7b$export$46919bad18fb2f76((0, $fa29e5b5c67837a0$export$3f2f9f5909897157), "none")) {
    constructor(){
        super(...arguments);
        $ca7aa15aa0ba1e7b$var$_M3eRippleElement_instances.add(this);
        /** @private */ $ca7aa15aa0ba1e7b$var$_M3eRippleElement_ripple.set(this, null);
        /** @private */ $ca7aa15aa0ba1e7b$var$_M3eRippleElement_pressedController.set(this, new $ca7aa15aa0ba1e7b$export$1351ab2eef382c23(this, {
            target: null,
            minPressedDuration: 150,
            isPressedKey: (key)=>key === " ",
            callback: (pressed, { x: x, y: y })=>(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eRippleElement_instances, "m", $ca7aa15aa0ba1e7b$var$_M3eRippleElement_handlePressedChange).call(this, pressed, x, y)
        }));
        /**
     * Whether click events will not trigger the ripple.
     * Ripples can be still controlled manually by using the `show` and 'hide' methods.
     * @default false
     */ this.disabled = false;
        /**
     * Whether the ripple always originates from the center of the element's bounds, rather
     * than originating from the location of the click event.
     * @default false
     */ this.centered = false;
        /**
     * Whether the ripple is visible outside the element's bounds.
     * @default false
     */ this.unbounded = false;
        /**
     * The radius, in pixels, of the ripple.
     * @default null
     */ this.radius = null;
    }
    /** Whether the ripple is currently visible to the user. */ get visible() {
        return (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eRippleElement_ripple, "f") !== null;
    }
    /**
   * Launches a manual ripple.
   * @param {number} x The x-coordinate, relative to the viewport, at which to present the ripple.
   * @param {number} y The y-coordinate, relative to the viewport, at which to present the ripple.
   * @param {boolean} [persistent=false] Whether the ripple will persist until hidden.
   */ show(x, y, persistent = false) {
        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eRippleElement_instances, "m", $ca7aa15aa0ba1e7b$var$_M3eRippleElement_destroyRipple).call(this);
        const bounds = this.getBoundingClientRect();
        if (this.centered) {
            x = bounds.left + bounds.width / 2;
            y = bounds.top + bounds.height / 2;
        }
        let radius = this.radius;
        if (!radius || isNaN(radius)) {
            const distX = Math.max(Math.abs(x - bounds.left), Math.abs(x - bounds.right));
            const distY = Math.max(Math.abs(y - bounds.top), Math.abs(y - bounds.bottom));
            radius = Math.sqrt(distX * distX + distY * distY);
        }
        const offsetX = x - bounds.left;
        const offsetY = y - bounds.top;
        (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_M3eRippleElement_ripple, document.createElement("div"), "f");
        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eRippleElement_ripple, "f").classList.add("ripple");
        if (persistent) (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eRippleElement_ripple, "f").classList.add("persistent");
        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eRippleElement_ripple, "f").style.left = `${offsetX - radius}px`;
        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eRippleElement_ripple, "f").style.top = `${offsetY - radius}px`;
        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eRippleElement_ripple, "f").style.width = `${radius * 2}px`;
        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eRippleElement_ripple, "f").style.height = `${radius * 2}px`;
        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eRippleElement_ripple, "f").addEventListener("animationend", ()=>(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eRippleElement_instances, "m", $ca7aa15aa0ba1e7b$var$_M3eRippleElement_handleAnimationEnd).call(this, persistent), {
            once: true
        });
        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eRippleElement_ripple, "f").addEventListener("transitionend", ()=>(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eRippleElement_instances, "m", $ca7aa15aa0ba1e7b$var$_M3eRippleElement_destroyRipple).call(this), {
            once: true
        });
        this.shadowRoot?.appendChild((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eRippleElement_ripple, "f"));
    }
    /** Manually hides the ripple. */ hide() {
        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eRippleElement_ripple, "f")?.classList.add("exit");
    }
    /** @inheritdoc */ attach(control) {
        super.attach(control);
        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eRippleElement_pressedController, "f").observe(control);
    }
    /** @inheritdoc */ detach() {
        if (this.control) (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eRippleElement_pressedController, "f").unobserve(this.control);
        super.detach();
    }
    /** @inheritdoc */ connectedCallback() {
        this.ariaHidden = "true";
        super.connectedCallback();
    }
    /** @inheritdoc */ disconnectedCallback() {
        super.disconnectedCallback();
        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eRippleElement_instances, "m", $ca7aa15aa0ba1e7b$var$_M3eRippleElement_destroyRipple).call(this);
    }
    /** @inheritdoc */ updated(_changedProperties) {
        super.updated(_changedProperties);
        if (_changedProperties.has("disabled") && this.disabled) this.hide();
    }
};
$ca7aa15aa0ba1e7b$var$_M3eRippleElement_ripple = new WeakMap();
$ca7aa15aa0ba1e7b$var$_M3eRippleElement_pressedController = new WeakMap();
$ca7aa15aa0ba1e7b$var$_M3eRippleElement_instances = new WeakSet();
$ca7aa15aa0ba1e7b$var$_M3eRippleElement_destroyRipple = function _M3eRippleElement_destroyRipple() {
    (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eRippleElement_ripple, "f")?.remove();
    (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_M3eRippleElement_ripple, null, "f");
};
$ca7aa15aa0ba1e7b$var$_M3eRippleElement_handleAnimationEnd = function _M3eRippleElement_handleAnimationEnd(persistent) {
    if (persistent) (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eRippleElement_ripple, "f")?.classList.add("pressed");
    else this.hide();
};
$ca7aa15aa0ba1e7b$var$_M3eRippleElement_handlePressedChange = function _M3eRippleElement_handlePressedChange(pressed, x, y) {
    if (!this.disabled) {
        if (pressed) this.show(x, y, true);
        else this.hide();
    }
};
/** The styles of the element. */ $ca7aa15aa0ba1e7b$export$4ab7a510e6d61011.styles = (0, $fbf856437f99196f$export$dbf350e5966cf602)`:host { display: block; position: absolute; left: 0; top: 0; right: 0; bottom: 0; pointer-events: none; border-radius: inherit; } :host(:not([unbounded])) { overflow: hidden; } .ripple { display: block; position: absolute; left: 0; top: 0; right: 0; bottom: 0; pointer-events: none; transform: scale(0); border-radius: ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.shape.corner.full}; background-color: color-mix(in srgb, ${$ca7aa15aa0ba1e7b$var$RippleToken.color} ${$ca7aa15aa0ba1e7b$var$RippleToken.opacity}, transparent); will-change: background-color, opacity; animation: ripple ${$ca7aa15aa0ba1e7b$var$RippleToken.enterDuration} linear; } .ripple.persistent.pressed { transform: scale(${$ca7aa15aa0ba1e7b$var$RippleToken.scaleFactor}); } .ripple.exit { transition: opacity ${$ca7aa15aa0ba1e7b$var$RippleToken.exitDuration} cubic-bezier(0, 0, 0.2, 0.1); opacity: 0; } @keyframes ripple { to { transform: scale(${$ca7aa15aa0ba1e7b$var$RippleToken.scaleFactor}); } } @media (prefers-reduced-motion) { .ripple { transform: scale(${$ca7aa15aa0ba1e7b$var$RippleToken.scaleFactor}); animation-duration: 90ms; } .ripple.exit { transition-duration: 10ms; } } @media (forced-colors: active) { .ripple { display: none; } }`;
(0, $gkQP3.__decorate)([
    (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $ca7aa15aa0ba1e7b$export$4ab7a510e6d61011.prototype, "disabled", void 0);
(0, $gkQP3.__decorate)([
    (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $ca7aa15aa0ba1e7b$export$4ab7a510e6d61011.prototype, "centered", void 0);
(0, $gkQP3.__decorate)([
    (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $ca7aa15aa0ba1e7b$export$4ab7a510e6d61011.prototype, "unbounded", void 0);
(0, $gkQP3.__decorate)([
    (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
        type: Number
    })
], $ca7aa15aa0ba1e7b$export$4ab7a510e6d61011.prototype, "radius", void 0);
$ca7aa15aa0ba1e7b$export$4ab7a510e6d61011 = (0, $gkQP3.__decorate)([
    $ca7aa15aa0ba1e7b$export$da64fc29f17f9d0e("m3e-ripple")
], $ca7aa15aa0ba1e7b$export$4ab7a510e6d61011);
var $ca7aa15aa0ba1e7b$var$_M3eScrollContainerElement_scrollHandler;
/**
 * A vertically oriented content container which presents dividers above and below content when scrolled.
 *
 * @description
 * The `m3e-scroll-container` component provides a vertically oriented scrollable container with dynamic
 * dividers above and below content. Designed according to Material 3 principles, it supports custom scrollbar
 * thickness, divider styling, and focus ring theming via CSS custom properties.
 *
 * @example
 * This example shows a scrollable container with dividers above and below the content, and thin scrollbars enabled.
 * ```html
 * <m3e-scroll-container dividers="above-below" thin>
 *   <div>Scrollable content goes here</div>
 * </m3e-scroll-container>
 * ```
 *
 * @tag m3e-scroll-container
 *
 * @slot - Renders the scrollable content.
 *
 * @attr dividers - The dividers used to separate scrollable content.
 * @attr thin - Whether to present thin scrollbars.
 *
 * @cssprop --m3e-divider-thickness - Thickness of the divider lines above and below content.
 * @cssprop --m3e-divider-color - Color of the divider lines when visible.
 * @cssprop --m3e-focus-ring-color - Color of the focus ring outline.
 * @cssprop --m3e-focus-ring-thickness - Thickness of the focus ring outline.
 * @cssprop --m3e-focus-ring-factor - Animation factor for focus ring thickness.
 * @cssprop --m3e-focus-ring-duration - Duration of the focus ring animation.
 */ let $ca7aa15aa0ba1e7b$export$2da5fcece8f45700 = class M3eScrollContainerElement extends $ca7aa15aa0ba1e7b$export$282c9fa792fbac93((0, $fa29e5b5c67837a0$export$3f2f9f5909897157)) {
    constructor(){
        super(...arguments);
        /** @private */ $ca7aa15aa0ba1e7b$var$_M3eScrollContainerElement_scrollHandler.set(this, ()=>this._updateScroll());
        /**
     * The dividers used to separate scrollable content.
     * @default "above-below"
     */ this.dividers = "above-below";
        /**
     * Whether to present thin scrollbars.
     * @default false
     */ this.thin = false;
    }
    /** @inheritdoc */ disconnectedCallback() {
        super.disconnectedCallback();
        this.removeEventListener("scroll", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eScrollContainerElement_scrollHandler, "f"));
    }
    /** @inheritdoc */ update(changedProperties) {
        super.update(changedProperties);
        if (changedProperties.has("dividers")) {
            this.removeEventListener("scroll", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eScrollContainerElement_scrollHandler, "f"));
            if (this.dividers !== "none") this.addEventListener("scroll", (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eScrollContainerElement_scrollHandler, "f"), {
                passive: true
            });
        }
    }
    /** @inheritdoc */ render() {
        return (0, $00a10a29322bb2a1$export$c0bb0b647f701bb5)`<slot @slotchange="${this._updateScroll}"></slot>`;
    }
    /** @private */ _updateScroll() {
        const before = (this.dividers === "above" || this.dividers === "above-below") && this.scrollTop > 0;
        const after = (this.dividers === "below" || this.dividers === "above-below") && this.scrollHeight - this.scrollTop - this.clientHeight > 1;
        $ca7aa15aa0ba1e7b$export$a6b7fbc1acf03e5b(this, "-above", before);
        $ca7aa15aa0ba1e7b$export$a6b7fbc1acf03e5b(this, "-below", after);
    }
};
$ca7aa15aa0ba1e7b$var$_M3eScrollContainerElement_scrollHandler = new WeakMap();
/** The styles of the element. */ $ca7aa15aa0ba1e7b$export$2da5fcece8f45700.styles = (0, $fbf856437f99196f$export$dbf350e5966cf602)`:host { display: block; overflow-y: auto; position: relative; box-sizing: border-box; scrollbar-color: ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.scrollbar.color}; border-top: var(--m3e-divider-thickness, 1px) solid transparent; border-bottom: var(--m3e-divider-thickness, 1px) solid transparent; outline-color: ${$ca7aa15aa0ba1e7b$var$FocusRingToken.color}; outline-width: ${$ca7aa15aa0ba1e7b$var$FocusRingToken.thickness}; outline-offset: ${$ca7aa15aa0ba1e7b$var$FocusRingToken.outwardOffset}; } :host([thin]) { scrollbar-width: ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.scrollbar.thinWidth}; } :host(:not([thin])) { scrollbar-width: ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.scrollbar.width}; } :host(:not(:focus-visible):state(-above)) { border-top-color: var(--m3e-divider-color, ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.color.outlineVariant}); } :host(:not(:focus-visible):state(-below)) { border-bottom-color: var(--m3e-divider-color, ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.color.outlineVariant}); } :host(:focus-visible) { outline-style: solid; animation: grow-shrink ${$ca7aa15aa0ba1e7b$var$FocusRingToken.duration}; } @keyframes grow-shrink { 50% { outline-width: calc(${$ca7aa15aa0ba1e7b$var$FocusRingToken.thickness} * ${$ca7aa15aa0ba1e7b$var$FocusRingToken.growthFactor}); } } @media (forced-colors: active) { :host { border-top: var(--m3e-divider-thickness, 1px) solid Canvas; border-bottom: var(--m3e-divider-thickness, 1px) solid Canvas; } :host(:not(:focus-visible):state(-above)) { border-top-color: GrayText; } :host(:not(:focus-visible):state(-below)) { border-bottom-color: GrayText; } } @media (prefers-reduced-motion) { :host(:focus-visible) { animation: none; } }`;
(0, $gkQP3.__decorate)([
    (0, $21eb6a58ce309899$export$d541bacb2bda4494)()
], $ca7aa15aa0ba1e7b$export$2da5fcece8f45700.prototype, "dividers", void 0);
(0, $gkQP3.__decorate)([
    (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $ca7aa15aa0ba1e7b$export$2da5fcece8f45700.prototype, "thin", void 0);
(0, $gkQP3.__decorate)([
    $ca7aa15aa0ba1e7b$export$61fc7d43ac8f84b0(40)
], $ca7aa15aa0ba1e7b$export$2da5fcece8f45700.prototype, "_updateScroll", null);
$ca7aa15aa0ba1e7b$export$2da5fcece8f45700 = (0, $gkQP3.__decorate)([
    $ca7aa15aa0ba1e7b$export$da64fc29f17f9d0e("m3e-scroll-container")
], $ca7aa15aa0ba1e7b$export$2da5fcece8f45700);
var $ca7aa15aa0ba1e7b$var$_M3eSlideElement_instances, $ca7aa15aa0ba1e7b$var$_M3eSlideElement_items, $ca7aa15aa0ba1e7b$var$_M3eSlideElement_handleSlotChange, $ca7aa15aa0ba1e7b$var$_M3eSlideElement_updateItems;
/**
 * A carousel-like container used to horizontally cycle through slotted items.
 *
 * @example
 * The following example illustrates the use of `m3e-slide` to cycle through content.
 * In this example, `selected-index` is set to `1` so that "Content at index 1" is presented
 * by the component.
 * ```html
 * <m3e-slide selected-index="1">
 *  <div>Content at index 0</div>
 *  <div>Content at index 1</div>
 *  <div>Content at index 2</div>
 *  <div>Content at index 3</div>
 * </m3e-slide>
 * ```
 *
 * @tag m3e-slide
 *
 * @attr selected-index - The zero-based index of the visible item.
 *
 * @cssprop --m3e-slide-animation-duration - The duration of transitions between slotted items.
 */ let $ca7aa15aa0ba1e7b$export$84a19532d31c2af4 = class M3eSlideElement extends $ca7aa15aa0ba1e7b$export$282c9fa792fbac93((0, $fa29e5b5c67837a0$export$3f2f9f5909897157)) {
    constructor(){
        super(...arguments);
        $ca7aa15aa0ba1e7b$var$_M3eSlideElement_instances.add(this);
        /** @private */ $ca7aa15aa0ba1e7b$var$_M3eSlideElement_items.set(this, new Array());
        /**
     * The zero-based index of the visible item.
     * @default null
     */ this.selectedIndex = null;
    }
    /** @inheritdoc */ connectedCallback() {
        super.connectedCallback();
        $ca7aa15aa0ba1e7b$export$ddd0a0ac12dd84d8(this, "-no-animate");
    }
    /** @inheritdoc */ update(changedProperties) {
        super.update(changedProperties);
        if (changedProperties.has("selectedIndex")) {
            if (this.selectedIndex === null) $ca7aa15aa0ba1e7b$export$ddd0a0ac12dd84d8(this, "-no-animate");
            (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eSlideElement_instances, "m", $ca7aa15aa0ba1e7b$var$_M3eSlideElement_updateItems).call(this);
            if (this.selectedIndex !== null && $ca7aa15aa0ba1e7b$export$6bae5520ca265d22(this, "-no-animate")) requestAnimationFrame(()=>{
                if (this.selectedIndex !== null) $ca7aa15aa0ba1e7b$export$eda34dc61103d62e(this, "-no-animate");
            });
        }
    }
    /** @inheritdoc */ render() {
        return (0, $00a10a29322bb2a1$export$c0bb0b647f701bb5)`<slot @slotchange="${(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eSlideElement_instances, "m", $ca7aa15aa0ba1e7b$var$_M3eSlideElement_handleSlotChange)}"></slot>`;
    }
};
$ca7aa15aa0ba1e7b$var$_M3eSlideElement_items = new WeakMap();
$ca7aa15aa0ba1e7b$var$_M3eSlideElement_instances = new WeakSet();
$ca7aa15aa0ba1e7b$var$_M3eSlideElement_handleSlotChange = function _M3eSlideElement_handleSlotChange(e) {
    const items = [
        ...e.target.assignedElements({
            flatten: true
        })
    ];
    for (const removed of (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eSlideElement_items, "f").filter((x)=>!items.includes(x))){
        removed.classList.remove("-before");
        removed.classList.remove("-after");
        removed.removeAttribute("inert");
    }
    (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_M3eSlideElement_items, items, "f");
    (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eSlideElement_instances, "m", $ca7aa15aa0ba1e7b$var$_M3eSlideElement_updateItems).call(this);
};
$ca7aa15aa0ba1e7b$var$_M3eSlideElement_updateItems = function _M3eSlideElement_updateItems() {
    const selectedIndex = this.selectedIndex ?? (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eSlideElement_items, "f").length;
    for(let i = 0; i < (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eSlideElement_items, "f").length; i++){
        const item = (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eSlideElement_items, "f")[i];
        item.classList.toggle("-before", i < selectedIndex);
        item.classList.toggle("-after", i > selectedIndex);
        item.toggleAttribute("inert", i !== selectedIndex);
    }
};
/** The styles of the element. */ $ca7aa15aa0ba1e7b$export$84a19532d31c2af4.styles = (0, $fbf856437f99196f$export$dbf350e5966cf602)`:host { display: flex; position: relative; overflow: hidden; } ::slotted(*) { width: 100%; top: 0; transition: ${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`inset-inline-start var(--m3e-slide-animation-duration, ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.motion.duration.long2}) ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.motion.easing.standard},
        visibility var(--m3e-slide-animation-duration, ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.motion.duration.long2}) ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.motion.easing.standard} allow-discrete`)}; } ::slotted(.-before), ::slotted(.-after) { visibility: hidden; position: absolute; } ::slotted(.-before) { inset-inline-start: -100%; } ::slotted(.-after) { inset-inline-start: 100%; } ::slotted(:not(.-before):not(.-after)) { position: relative; inset-inline-start: 0; } :host(:state(-no-animate)) ::slotted(*) { transition: none; } @media (prefers-reduced-motion) { ::slotted(*) { transition: none; } }`;
(0, $gkQP3.__decorate)([
    (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
        attribute: "selected-index",
        type: Number,
        reflect: true
    })
], $ca7aa15aa0ba1e7b$export$84a19532d31c2af4.prototype, "selectedIndex", void 0);
$ca7aa15aa0ba1e7b$export$84a19532d31c2af4 = (0, $gkQP3.__decorate)([
    $ca7aa15aa0ba1e7b$export$da64fc29f17f9d0e("m3e-slide")
], $ca7aa15aa0ba1e7b$export$84a19532d31c2af4);
/**
 * Component design tokens that control the `M3eStateLayerElement`.
 * @internal
 */ const $ca7aa15aa0ba1e7b$var$StateLayerToken = {
    hoverColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-state-layer-hover-color, ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.color.onSurface})`),
    hoverOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-state-layer-hover-opacity, ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.state.hoverStateLayerOpacity})`),
    focusColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-state-layer-focus-color, ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.color.onSurface})`),
    focusOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-state-layer-focus-opacity, ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.state.focusStateLayerOpacity})`),
    duration: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-state-layer-duration, ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.motion.duration.medium1})`),
    easing: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-state-layer-easing, ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.motion.easing.standard})`)
};
var $ca7aa15aa0ba1e7b$var$_M3eStateLayerElement_instances, $ca7aa15aa0ba1e7b$var$_M3eStateLayerElement_hoverController, $ca7aa15aa0ba1e7b$var$_M3eStateLayerElement_focusController, $ca7aa15aa0ba1e7b$var$_M3eStateLayerElement_handleHoverChange, $ca7aa15aa0ba1e7b$var$_M3eStateLayerElement_handleFocusChange;
/**
 * Provides focus and hover state layer treatment for an interactive element.
 *
 * @description
 * The `m3e-state-layer` component is an absolute positioned element used to depict hover and focus overlays.
 * The parenting element must be a relative positioned element.
 *
 * This element can be attached to an interactive element using the `for` attribute or programmatically using the `attach` method.
 * The state layer is displayed when the interactive element is either hovered or focused.  This can be disabled using
 * the `disabled` attribute.
 *
 * @example
 * The following example illustrates attaching a state layer to an interactive element. In this example, the parenting div
 * has relative positioning and is given an `id` referenced by `m3e-state-layer` using the `for` attribute.  Note that `#myDiv`
 * is not used when specifying the attached element's identifier.  The `#` is inferred.
 *
 * ```html
 * <div id="myDiv" tabindex="0" style="position: relative;">
 *  <m3e-state-layer for="myDiv"></m3e-state-layer>
 * <div>
 * ```
 *
 * @tag m3e-state-layer
 *
 * @attr disabled - Whether hover and focus events will not trigger the state layer. State layers can still be controlled manually using the `show` and `hide` methods.
 * @attr disable-hover - Whether hover events will not trigger the state layer. State layers can still be controlled manually using the `show` and `hide` methods.
 *
 * @cssprop --m3e-state-layer-duration - Duration of state layer changes.
 * @cssprop --m3e-state-layer-easing - Easing curve of state layer changes.
 * @cssprop --m3e-state-layer-focus-color - Color on hover.
 * @cssprop --m3e-state-layer-focus-opacity - Opacity on focus.
 * @cssprop --m3e-state-layer-hover-color - Color on hover.
 * @cssprop --m3e-state-layer-hover-opacity - Opacity on hover.
 */ let $ca7aa15aa0ba1e7b$export$c4e02de320ba9d5f = class M3eStateLayerElement extends $ca7aa15aa0ba1e7b$export$ccf21c713b2bbcbb($ca7aa15aa0ba1e7b$export$46919bad18fb2f76((0, $fa29e5b5c67837a0$export$3f2f9f5909897157), "none")) {
    constructor(){
        super(...arguments);
        $ca7aa15aa0ba1e7b$var$_M3eStateLayerElement_instances.add(this);
        /** @private */ $ca7aa15aa0ba1e7b$var$_M3eStateLayerElement_hoverController.set(this, new $ca7aa15aa0ba1e7b$export$e97521e950437f92(this, {
            target: null,
            callback: (hovering)=>(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eStateLayerElement_instances, "m", $ca7aa15aa0ba1e7b$var$_M3eStateLayerElement_handleHoverChange).call(this, hovering)
        }));
        /** @private */ $ca7aa15aa0ba1e7b$var$_M3eStateLayerElement_focusController.set(this, new $ca7aa15aa0ba1e7b$export$766c876d58dec02e(this, {
            target: null,
            callback: (_, focusVisible)=>(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eStateLayerElement_instances, "m", $ca7aa15aa0ba1e7b$var$_M3eStateLayerElement_handleFocusChange).call(this, focusVisible)
        }));
        /**
     * Whether hover and focus events will not trigger the state layer. State layers can still
     * be controlled manually using the `show` and `hide` methods.
     * @default false
     */ this.disabled = false;
        /**
     * Whether hover events will not trigger the state layer. State layers can still
     * be controlled manually using the `show` and `hide` methods.
     * @default false
     */ this.disableHover = false;
    }
    /**
   * Launches a manual state layer.
   * @param {"hover" | "focused"} state The state of the layer to show.
   */ show(state) {
        this._layer?.classList.toggle(state, true);
    }
    /**
   * Hides the state layer.
   * @param {"hover" | "focused"} state The state of the layer to hide.
   */ hide(state) {
        this._layer?.classList.toggle(state, false);
    }
    /** @inheritdoc */ attach(control) {
        super.attach(control);
        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eStateLayerElement_hoverController, "f").observe(control);
        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eStateLayerElement_focusController, "f").observe(control);
    }
    /** @inheritdoc */ detach() {
        if (this.control) {
            (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eStateLayerElement_hoverController, "f").unobserve(this.control);
            (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eStateLayerElement_focusController, "f").unobserve(this.control);
        }
        super.detach();
    }
    /** @inheritdoc */ connectedCallback() {
        this.ariaHidden = "true";
        super.connectedCallback();
    }
    /** @inheritdoc */ disconnectedCallback() {
        super.disconnectedCallback();
        this.hide("hover");
        this.hide("focused");
    }
    /** @inheritdoc */ updated(_changedProperties) {
        super.updated(_changedProperties);
        if (_changedProperties.has("disabled") && this.disabled) {
            this.hide("hover");
            this.hide("focused");
        }
        if (_changedProperties.has("disableHover") && this.disableHover) this.hide("hover");
    }
    /** @inheritdoc */ render() {
        return (0, $00a10a29322bb2a1$export$c0bb0b647f701bb5)`<div class="layer"></div>`;
    }
};
$ca7aa15aa0ba1e7b$var$_M3eStateLayerElement_hoverController = new WeakMap();
$ca7aa15aa0ba1e7b$var$_M3eStateLayerElement_focusController = new WeakMap();
$ca7aa15aa0ba1e7b$var$_M3eStateLayerElement_instances = new WeakSet();
$ca7aa15aa0ba1e7b$var$_M3eStateLayerElement_handleHoverChange = function _M3eStateLayerElement_handleHoverChange(hovering) {
    if (!this.disabled && !this.disableHover) {
        if (hovering) this.show("hover");
        else this.hide("hover");
    }
};
$ca7aa15aa0ba1e7b$var$_M3eStateLayerElement_handleFocusChange = function _M3eStateLayerElement_handleFocusChange(focusVisible) {
    if (!this.disabled) {
        if (focusVisible) this.show("focused");
        else this.hide("focused");
    }
};
/** The styles of the element. */ $ca7aa15aa0ba1e7b$export$c4e02de320ba9d5f.styles = (0, $fbf856437f99196f$export$dbf350e5966cf602)`:host { display: block; } :host, .layer { position: absolute; left: 0; top: 0; right: 0; bottom: 0; pointer-events: none; border-radius: inherit; } .layer { will-change: background-color; transition: ${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`background-color ${$ca7aa15aa0ba1e7b$var$StateLayerToken.duration} ${$ca7aa15aa0ba1e7b$var$StateLayerToken.easing}`)}; } .layer.focused { background-color: color-mix(in srgb, ${$ca7aa15aa0ba1e7b$var$StateLayerToken.focusColor} ${$ca7aa15aa0ba1e7b$var$StateLayerToken.focusOpacity}, transparent); } .layer.hover { background-color: color-mix(in srgb, ${$ca7aa15aa0ba1e7b$var$StateLayerToken.hoverColor} ${$ca7aa15aa0ba1e7b$var$StateLayerToken.hoverOpacity}, transparent); } @media (prefers-reduced-motion) { .layer { transition: none; } } @media (forced-colors: active) { .layer { display: none; } }`;
(0, $gkQP3.__decorate)([
    (0, $540200038ed52347$export$2fa187e846a241c4)(".layer")
], $ca7aa15aa0ba1e7b$export$c4e02de320ba9d5f.prototype, "_layer", void 0);
(0, $gkQP3.__decorate)([
    (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $ca7aa15aa0ba1e7b$export$c4e02de320ba9d5f.prototype, "disabled", void 0);
(0, $gkQP3.__decorate)([
    (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
        attribute: "disable-hover",
        type: Boolean,
        reflect: true
    })
], $ca7aa15aa0ba1e7b$export$c4e02de320ba9d5f.prototype, "disableHover", void 0);
$ca7aa15aa0ba1e7b$export$c4e02de320ba9d5f = (0, $gkQP3.__decorate)([
    $ca7aa15aa0ba1e7b$export$da64fc29f17f9d0e("m3e-state-layer")
], $ca7aa15aa0ba1e7b$export$c4e02de320ba9d5f);
var $ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_instances, $ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_id, $ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_ranges, $ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_styles, $ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_isTextNode, $ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_findTextNodes, $ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_highlight;
var $ca7aa15aa0ba1e7b$var$M3eTextHighlightElement_1;
/**
 * Highlights text which matches a given search term.
 *
 * @description
 * Highlights all text ranges in slotted content that match a given search term using the CSS Custom Highlight API.
 *
 * @example
 * The following example illustrates highlighting "Lor".
 * ```html
 * <m3e-text-highlight term="Lor">
 *  <p>
 *    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt
 *    ut labore et dolore magna aliqua.
 *  </p>
 * </m3e-text-highlight>
 * ```
 *
 * @tag m3e-text-highlight
 *
 * @slot - Renders the content to highlight.
 *
 * @attr case-sensitive - Whether matching is case sensitive.
 * @attr disabled - A value indicating whether text highlighting is disabled.
 * @attr mode - The mode in which to highlight text.
 * @attr term - The term to highlight.
 *
 * @fires highlight - Emitted when content is highlighted.
 *
 * @cssprop --m3e-text-highlight-container-color - Background color applied to highlighted text ranges.
 * @cssprop --m3e-text-highlight-color - Foreground color of highlighted text content.
 * @cssprop --m3e-text-highlight-decoration - Optional text decoration (e.g., underline, line-through) for highlighted text.
 * @cssprop --m3e-text-highlight-shadow - Optional text shadow for emphasis or contrast.
 */ let $ca7aa15aa0ba1e7b$export$3d345992ff2fb87e = $ca7aa15aa0ba1e7b$var$M3eTextHighlightElement_1 = class M3eTextHighlightElement extends (0, $fa29e5b5c67837a0$export$3f2f9f5909897157) {
    constructor(){
        super();
        $ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_instances.add(this);
        /** @private */ $ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_id.set(this, `m3e-text-highlight-${$ca7aa15aa0ba1e7b$var$M3eTextHighlightElement_1.__nextId++}`);
        /** @private */ $ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_ranges.set(this, new Array());
        /** @private */ $ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_styles.set(this, null);
        /**
     * A value indicating whether text highlighting is disabled.
     * @default false
     */ this.disabled = false;
        /**
     * The term to highlight.
     * @default ""
     */ this.term = "";
        /**
     * Whether matching is case sensitive.
     * @default false
     */ this.caseSensitive = false;
        /**
     * The mode in which to highlight text.
     * @default "contains"
     */ this.mode = "contains";
        if (this.isSupported) {
            (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_styles, new CSSStyleSheet(), "f");
            (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_styles, "f").replaceSync((0, $fbf856437f99196f$export$dbf350e5966cf602)`::highlight(${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_id, "f"))}) { background-color: var(--m3e-text-highlight-container-color, ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.color.secondaryContainer}); color: var(--m3e-text-highlight-color, ${$ca7aa15aa0ba1e7b$export$b6ce77d07cd22443.color.onSecondaryContainer}); text-decoration: var(--m3e-text-highlight-decoration); text-shadow: var(--m3e-text-highlight-shadow); }`.toString());
        }
    }
    /** A value indicating whether text highlighting is supported by the browser. */ get isSupported() {
        return !(0, $63b56f98105c10d3$export$6acf61af03e62db) && CSS.highlights ? true : false;
    }
    /** The ranges that match the current term. */ get ranges() {
        return (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_ranges, "f");
    }
    /** @inheritdoc */ firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);
        if (this.shadowRoot && (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_styles, "f") && !this.shadowRoot.adoptedStyleSheets.includes((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_styles, "f"))) this.shadowRoot.adoptedStyleSheets.push((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_styles, "f"));
    }
    /** @inheritdoc */ updated(_changedProperties) {
        super.updated(_changedProperties);
        if (_changedProperties.has("term") || _changedProperties.has("caseSensitive") || _changedProperties.has("disabled")) (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_instances, "m", $ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_highlight).call(this);
    }
    /** @inheritdoc */ render() {
        return (0, $00a10a29322bb2a1$export$c0bb0b647f701bb5)`<slot @slotchange="${(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_instances, "m", $ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_highlight)}"></slot>`;
    }
};
$ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_id = new WeakMap();
$ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_ranges = new WeakMap();
$ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_styles = new WeakMap();
$ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_instances = new WeakSet();
$ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_isTextNode = function _M3eTextHighlightElement_isTextNode(node) {
    return !/^\s*$/.test(node.data);
};
$ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_findTextNodes = function _M3eTextHighlightElement_findTextNodes(parent, nodes) {
    if (parent instanceof HTMLSlotElement) parent.assignedNodes({
        flatten: true
    }).forEach((x)=>{
        switch(x.nodeType){
            case Node.TEXT_NODE:
                if ((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_instances, "m", $ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_isTextNode).call(this, x)) nodes.push(x);
                break;
            case Node.ELEMENT_NODE:
                (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_instances, "m", _M3eTextHighlightElement_findTextNodes).call(this, x, nodes);
                break;
        }
    });
    else parent.childNodes.forEach((x)=>{
        switch(x.nodeType){
            case Node.TEXT_NODE:
                if ((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_instances, "m", $ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_isTextNode).call(this, x)) nodes.push(x);
                break;
            case Node.ELEMENT_NODE:
                (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_instances, "m", _M3eTextHighlightElement_findTextNodes).call(this, x, nodes);
                break;
        }
    });
};
$ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_highlight = function _M3eTextHighlightElement_highlight() {
    if (!this.isSupported || !this.isConnected) return;
    CSS.highlights.delete((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_id, "f"));
    (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_ranges, "f").length = 0;
    if (this.disabled) return;
    if (!this.term) {
        this.dispatchEvent(new CustomEvent("highlight", {
            detail: [
                ...(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_ranges, "f")
            ],
            bubbles: false,
            composed: false
        }));
        return;
    }
    const texts = new Array();
    (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_instances, "m", $ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_findTextNodes).call(this, this, texts);
    if (texts.length > 0) {
        const term = !this.caseSensitive ? this.term.toLowerCase() : this.term;
        switch(this.mode){
            case "starts-with":
                {
                    const first = texts[0];
                    const text = (this.caseSensitive ? first.textContent : first.textContent?.toLowerCase()) ?? "";
                    if (text.startsWith(term)) {
                        const range = new Range();
                        range.setStart(first, 0);
                        range.setEnd(first, term.length);
                        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_ranges, "f").push(range);
                    }
                }
                break;
            case "ends-with":
                {
                    const last = texts[texts.length - 1];
                    const text = (this.caseSensitive ? last.textContent : last.textContent?.toLowerCase()) ?? "";
                    if (text.endsWith(term)) {
                        const start = text.length - term.length;
                        const end = start + term.length;
                        const range = new Range();
                        range.setStart(last, start);
                        range.setEnd(last, end);
                        (0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_ranges, "f").push(range);
                    }
                }
                break;
            case "contains":
                (0, $gkQP3.__classPrivateFieldSet)(this, $ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_ranges, texts.map((x)=>{
                    return {
                        el: x,
                        text: (!this.caseSensitive ? x.textContent?.toLowerCase() : x.textContent) ?? ""
                    };
                }).map(({ el: el, text: text })=>{
                    const indices = new Array();
                    let startPos = 0;
                    while(startPos < text.length){
                        const index = text.indexOf(term, startPos);
                        if (index === -1) break;
                        indices.push(index);
                        startPos = index + term.length;
                    }
                    return indices.map((index)=>{
                        const range = new Range();
                        range.setStart(el, index);
                        range.setEnd(el, index + term.length);
                        return range;
                    });
                }).flat(), "f");
                break;
        }
        if ((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_ranges, "f").length > 0) CSS.highlights.set((0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_id, "f"), new Highlight(...(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_ranges, "f")));
    }
    this.dispatchEvent(new CustomEvent("highlight", {
        detail: [
            ...(0, $gkQP3.__classPrivateFieldGet)(this, $ca7aa15aa0ba1e7b$var$_M3eTextHighlightElement_ranges, "f")
        ],
        bubbles: false,
        composed: false
    }));
};
/** The styles of the element. */ $ca7aa15aa0ba1e7b$export$3d345992ff2fb87e.styles = (0, $fbf856437f99196f$export$dbf350e5966cf602)`:host { display: contents; }`;
/** @private */ $ca7aa15aa0ba1e7b$export$3d345992ff2fb87e.__nextId = 0;
(0, $gkQP3.__decorate)([
    (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $ca7aa15aa0ba1e7b$export$3d345992ff2fb87e.prototype, "disabled", void 0);
(0, $gkQP3.__decorate)([
    (0, $21eb6a58ce309899$export$d541bacb2bda4494)()
], $ca7aa15aa0ba1e7b$export$3d345992ff2fb87e.prototype, "term", void 0);
(0, $gkQP3.__decorate)([
    (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
        attribute: "case-sensitive",
        type: Boolean
    })
], $ca7aa15aa0ba1e7b$export$3d345992ff2fb87e.prototype, "caseSensitive", void 0);
(0, $gkQP3.__decorate)([
    (0, $21eb6a58ce309899$export$d541bacb2bda4494)()
], $ca7aa15aa0ba1e7b$export$3d345992ff2fb87e.prototype, "mode", void 0);
$ca7aa15aa0ba1e7b$export$3d345992ff2fb87e = $ca7aa15aa0ba1e7b$var$M3eTextHighlightElement_1 = (0, $gkQP3.__decorate)([
    $ca7aa15aa0ba1e7b$export$da64fc29f17f9d0e("m3e-text-highlight")
], $ca7aa15aa0ba1e7b$export$3d345992ff2fb87e);
/**
 * An inline container which presents an ellipsis when content overflows.
 *
 * @description
 * The `m3e-text-overflow` component truncates inline content with an ellipsis when it
 * exceeds the available width. It's intended for use inside flex or otherwise
 * constrained containers to preserve layout while providing predictable, single-line
 * truncation behavior for long text.
 *
 * @example
 * A typical usage inside a flex container where the heading and trailing actions are
 * constrained, allowing the center text to truncate with an ellipsis.
 *
 * ```html
 * <div style="display:flex;align-items:center;gap:12px;">
 *   <m3e-icon name="menu"></m3e-icon>
 *   <m3e-text-overflow>Very long title or breadcrumb that should truncate gracefully</m3e-text-overflow>
 *   <m3e-icon name="more_vert"></m3e-icon>
 * </div>
 * ```
 *
 * @tag m3e-text-overflow
 *
 * @slot - Renders the content to truncate with an ellipsis.
 */ let $ca7aa15aa0ba1e7b$export$5aa27e0fcf302586 = class M3eTextOverflowElement extends (0, $fa29e5b5c67837a0$export$3f2f9f5909897157) {
    /** @inheritdoc */ render() {
        return (0, $00a10a29322bb2a1$export$c0bb0b647f701bb5)`<span class="base"><slot></slot></span>`;
    }
};
/** The styles of the element. */ $ca7aa15aa0ba1e7b$export$5aa27e0fcf302586.styles = (0, $fbf856437f99196f$export$dbf350e5966cf602)`:host { flex: 1 1 auto; display: inline-flex; align-items: center; flex-wrap: nowrap; min-width: 0; } .base { flex: 1 1 auto; display: inline; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }`;
$ca7aa15aa0ba1e7b$export$5aa27e0fcf302586 = (0, $gkQP3.__decorate)([
    $ca7aa15aa0ba1e7b$export$da64fc29f17f9d0e("m3e-text-overflow")
], $ca7aa15aa0ba1e7b$export$5aa27e0fcf302586);


/**
 * Component design tokens that control the `M3eAppBarElement` for all size variants.
 * @internal
 */ const $93b4754f898d01ec$var$AppBarSizeToken = {
    small: {
        containerHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-small-container-height, 4rem)`),
        titleTextFontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-small-title-text-font-size, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.title.large.fontSize})`),
        titleTextFontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-small-title-text-font-weight, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.title.large.fontWeight})`),
        titleTextLineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-small-title-text-line-height, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.title.large.lineHeight})`),
        titleTextTracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-small-subtitle-text-tracking, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.title.large.tracking})`),
        subtitleTextFontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-small-subtitle-text-font-size, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.label.medium.fontSize})`),
        subtitleTextFontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-small-subtitle-text-font-weight, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.label.medium.fontWeight})`),
        subtitleTextLineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-small-subtitle-text-line-height, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.label.medium.lineHeight})`),
        subtitleTextTracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-small-subtitle-text-tracking, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.label.medium.tracking})`),
        headingPaddingLeft: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-small-heading-padding-left, 0.25rem)`),
        headingPaddingRight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-small-heading-padding-right, 0.25rem)`)
    },
    medium: {
        containerHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-medium-container-height, 7rem)`),
        containerHeightWithSubtitle: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-medium-container-height-with-subtitle, 8.5rem)`),
        titleTextFontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-medium-title-text-font-size, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.headline.medium.fontSize})`),
        titleTextFontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-medium-title-text-font-weight, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.headline.medium.fontWeight})`),
        titleTextLineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-medium-title-text-line-height, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.headline.medium.lineHeight})`),
        titleTextTracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-medium-subtitle-text-tracking, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.headline.medium.tracking})`),
        subtitleTextFontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-medium-subtitle-text-font-size, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.title.small.fontSize})`),
        subtitleTextFontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-medium-subtitle-text-font-weight, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.title.small.fontWeight})`),
        subtitleTextLineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-medium-subtitle-text-line-height, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.title.small.lineHeight})`),
        subtitleTextTracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-medium-subtitle-text-tracking, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.title.small.tracking})`),
        headingPaddingLeft: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-medium-heading-padding-left, 1rem)`),
        headingPaddingRight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-medium-heading-padding-right, 0.25rem)`),
        paddingTop: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-medium-padding-top, 0.5rem)`),
        paddingBottom: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-medium-padding-bottom, 0.75rem)`),
        titleMaxLines: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-medium-title-max-lines, 2)`),
        subtitleMaxLines: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-medium-subtitle-max-lines, 1)`)
    },
    large: {
        containerHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-large-container-height, 7.5rem)`),
        containerHeightWithSubtitle: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-large-container-height-with-subtitle, 9.5rem)`),
        titleTextFontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-large-title-text-font-size, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.display.small.fontSize})`),
        titleTextFontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-large-title-text-font-weight, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.display.small.fontWeight})`),
        titleTextLineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-large-title-text-line-height, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.display.small.lineHeight})`),
        titleTextTracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-large-subtitle-text-tracking, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.display.small.tracking})`),
        subtitleTextFontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-large-subtitle-text-font-size, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.title.medium.fontSize})`),
        subtitleTextFontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-large-subtitle-text-font-weight, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.title.medium.fontWeight})`),
        subtitleTextLineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-large-subtitle-text-line-height, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.title.medium.lineHeight})`),
        subtitleTextTracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-large-subtitle-text-tracking, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.title.medium.tracking})`),
        headingPaddingLeft: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-large-heading-padding-left, 1rem)`),
        headingPaddingRight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-large-heading-padding-right, 0.25rem)`),
        paddingTop: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-large-padding-top, 0.5rem)`),
        paddingBottom: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-large-padding-bottom, 0.75rem)`),
        titleMaxLines: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-large-title-max-lines, 2)`),
        subtitleMaxLines: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-large-subtitle-max-lines, 1)`)
    }
};
/** @private */ function $93b4754f898d01ec$var$appBarStyle(size) {
    return (0, $fbf856437f99196f$export$dbf350e5966cf602)`:host([size="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(size)}"]) .base:not(.with-subtitle) { min-height: ${$93b4754f898d01ec$var$AppBarSizeToken[size].containerHeight}; } :host([size="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(size)}"]) .base.with-subtitle { min-height: ${$93b4754f898d01ec$var$AppBarSizeToken[size].containerHeightWithSubtitle ?? $93b4754f898d01ec$var$AppBarSizeToken[size].containerHeight}; } :host([size="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(size)}"]) .title { font-size: ${$93b4754f898d01ec$var$AppBarSizeToken[size].titleTextFontSize}; font-weight: ${$93b4754f898d01ec$var$AppBarSizeToken[size].titleTextFontWeight}; line-height: ${$93b4754f898d01ec$var$AppBarSizeToken[size].titleTextLineHeight}; letter-spacing: ${$93b4754f898d01ec$var$AppBarSizeToken[size].titleTextTracking}; } :host([size="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(size)}"]) .subtitle { font-size: ${$93b4754f898d01ec$var$AppBarSizeToken[size].subtitleTextFontSize}; font-weight: ${$93b4754f898d01ec$var$AppBarSizeToken[size].subtitleTextFontWeight}; line-height: ${$93b4754f898d01ec$var$AppBarSizeToken[size].subtitleTextLineHeight}; letter-spacing: ${$93b4754f898d01ec$var$AppBarSizeToken[size].subtitleTextTracking}; } :host(:not([centered])[size="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(size)}"]) .label { padding-inline-start: ${$93b4754f898d01ec$var$AppBarSizeToken[size].headingPaddingLeft}; padding-inline-end: ${$93b4754f898d01ec$var$AppBarSizeToken[size].headingPaddingRight}; } :host([centered][size="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(size)}"]) .label { padding-inline: ${$93b4754f898d01ec$var$AppBarSizeToken[size].headingPaddingLeft}; } :host([size="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(size)}"]) .base { padding-block-start: ${$93b4754f898d01ec$var$AppBarSizeToken[size].paddingTop ?? (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("unset")}; padding-block-end: ${$93b4754f898d01ec$var$AppBarSizeToken[size].paddingBottom ?? (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("unset")}; } ${$93b4754f898d01ec$var$AppBarSizeToken[size].titleMaxLines ? (0, $fbf856437f99196f$export$dbf350e5966cf602)`:host([size="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(size)}"]) .title { display: -webkit-box; -webkit-line-clamp: ${$93b4754f898d01ec$var$AppBarSizeToken[size].titleMaxLines}; -webkit-box-orient: vertical; overflow: hidden; line-clamp: ${$93b4754f898d01ec$var$AppBarSizeToken[size].titleMaxLines}; }` : (0, $fbf856437f99196f$export$dbf350e5966cf602)``} ${$93b4754f898d01ec$var$AppBarSizeToken[size].subtitleMaxLines ? (0, $fbf856437f99196f$export$dbf350e5966cf602)`:host([size="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(size)}"]) .subtitle { display: -webkit-box; -webkit-line-clamp: ${$93b4754f898d01ec$var$AppBarSizeToken[size].subtitleMaxLines}; -webkit-box-orient: vertical; overflow: hidden; line-clamp: ${$93b4754f898d01ec$var$AppBarSizeToken[size].subtitleMaxLines}; }` : (0, $fbf856437f99196f$export$dbf350e5966cf602)``}`;
}
/**
 * Size variant styles for `M3eAppBarElement`.
 * @internal
 */ const $93b4754f898d01ec$var$AppBarSizeStyle = [
    $93b4754f898d01ec$var$appBarStyle("small"),
    $93b4754f898d01ec$var$appBarStyle("medium"),
    $93b4754f898d01ec$var$appBarStyle("large")
];
/**
 * Component design tokens that control `M3eAppBarElement`.
 * @internal
 */ const $93b4754f898d01ec$var$AppBarToken = {
    containerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-container-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.surface})`),
    containerColorOnScroll: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-container-color-on-scroll, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.surfaceContainer})`),
    containerElevation: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-container-elevation, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).elevation.level0})`),
    containerElevationOnScroll: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-container-elevation-on-scroll, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).elevation.level1})`),
    titleTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-title-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface})`),
    subtitleTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-subtitle-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurfaceVariant})`),
    paddingLeft: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-padding-left, 0.25rem)`),
    paddingRight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-app-bar-padding-right, 0.25rem)`)
};
/**
 * Baseline styles for `M3eAppBarElement`.
 * @internal
 */ const $93b4754f898d01ec$var$AppBarStyle = (0, $fbf856437f99196f$export$dbf350e5966cf602)`:host { display: block; flex: none; } :host([size="small"]) .base, :host(:not([size="small"]):not([centered])) .heading { padding-inline-start: ${$93b4754f898d01ec$var$AppBarToken.paddingLeft}; padding-inline-end: ${$93b4754f898d01ec$var$AppBarToken.paddingRight}; } .base { box-sizing: border-box; display: flex; transition: ${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`background-color ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).motion.duration.medium1} ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).motion.easing.standard},
      box-shadow ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).motion.duration.medium1} ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).motion.easing.standard}`)}; } .base:not(.on-scroll) { background-color: ${$93b4754f898d01ec$var$AppBarToken.containerColor}; box-shadow: ${$93b4754f898d01ec$var$AppBarToken.containerElevation}; } .base.on-scroll { background-color: ${$93b4754f898d01ec$var$AppBarToken.containerColorOnScroll}; box-shadow: ${$93b4754f898d01ec$var$AppBarToken.containerElevationOnScroll}; } .leading-icon, .trailing-icon { display: flex; flex: none; align-items: center; } .leading-icon { min-width: var(--_leading-icon-min-width); } .trailing-icon { min-width: var(--_trailing-icon-min-width); } .heading { display: flex; align-items: center; } :host([size="small"]) .heading { flex: 1 1 auto; } .spacer { flex: 1 1 auto; } .label { display: flex; flex-direction: column; flex: none; } .title { color: ${$93b4754f898d01ec$var$AppBarToken.titleTextColor}; } .subtitle { color: ${$93b4754f898d01ec$var$AppBarToken.subtitleTextColor}; } .base:not(.with-title) .title, .base:not(.with-subtitle) .subtitle, .base:not(.with-title):not(.with-subtitle) .label, .base:not(.with-trailing-icon) .trailing-icon { display: none; } :host([size="small"]) .base { align-items: center; } :host([size="small"]) .heading { min-width: 0; } :host([size="small"]) .label { flex: 1 1 auto; min-width: 0; } :host([size="small"]) .title, :host([size="small"]) .subtitle { display: block; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; } :host(:not([size="small"])) .base { flex-direction: column; } :host([centered]) .title, :host([centered]) .subtitle { text-align: center; } @media (prefers-reduced-motion) { .base { transition: none; } } @media (forced-colors: active) { .base { transition: none; } .base:not(.on-scroll), .base.on-scroll { background-color: Canvas; box-shadow: unset; } .title { color: CanvasText; } .subtitle { color: FieldText; } }`;
var $93b4754f898d01ec$var$_M3eAppBarElement_instances, $93b4754f898d01ec$var$_M3eAppBarElement_scrollHandler, $93b4754f898d01ec$var$_M3eAppBarElement_frameLoadHandler, $93b4754f898d01ec$var$_M3eAppBarElement_handleTitleSlotChange, $93b4754f898d01ec$var$_M3eAppBarElement_handleSubtitleSlotChange, $93b4754f898d01ec$var$_M3eAppBarElement_handleLeadingIconSlotChange, $93b4754f898d01ec$var$_M3eAppBarElement_handleTrailingIconsSlotChange, $93b4754f898d01ec$var$_M3eAppBarElement_handleDeprecatedSlotChange, $93b4754f898d01ec$var$_M3eAppBarElement_clearCentered, $93b4754f898d01ec$var$_M3eAppBarElement_computeCentered, $93b4754f898d01ec$var$_M3eAppBarElement_handleFrameLoad, $93b4754f898d01ec$var$_M3eAppBarElement_getFrameScrollTop;
/**
 * A bar, placed a the top of a screen, used to help users navigate through an application.
 *
 * @description
 * The `m3e-app-bar` component is a prominent user interface component that provides consistent
 * access to key actions, navigation, and contextual information at the top of an application screen.
 * Designed according to Material 3 principles, it organizes content with clear hierarchy, supports
 * dynamic color, elevation, and shape, and adapts to scrolling behavior.
 *
 * @example
 * ```html
 * <m3e-app-bar size="medium">
 *  <m3e-icon-button slot="leading-icon" aria-label="Back">
 *    <m3e-icon name="arrow_back"></m3e-icon>
 *  </m3e-icon-button>
 *  <span slot="title">Top 10 hiking trails</span>
 *  <span slot="subtitle">Discover popular trails</span>
 *  <m3e-icon-button slot="trailing-icon" aria-label="Bookmark" variant="tonal">
 *    <m3e-icon name="bookmark" filled></m3e-icon>
 *  </m3e-icon-button>
 * <m3e-app-bar>
 * ```
 * @example
 * The next example illustrates how to attach an app bar to a parenting scroll container
 * to produce elevation on scroll. In this example, the `for` attribute is used to attach a
 * sticky positioned `m3e-app-bar` to a parenting container styled to overflow vertically.
 * When scrolled, the app bar will automatically transition to an elevated state.
 * ```html
 * <div style="overflow-y: auto; height: 300px" id="scrollContainer">
 *  <m3e-app-bar for="scrollContainer" style="position: sticky; top: 0">
 *    <span slot="title">Title</span>
 *  </m3e-app-bar>
 *  <div style="height: 400px; display: flex; align-items: center; justify-content: center">
 *    I am scrolling content
 *  </div>
 * </div>
 * ```
 *
 * @tag m3e-app-bar
 *
 * @slot leading - Renders content positioned at the start of the bar.
 * @slot subtitle - Renders the subtitle of the bar.
 * @slot title - Renders the title of the bar.
 * @slot trailing - Renders one or more action buttons aligned to the end of the bar.
 * @slot leading-icon - Deprecated: use the `leading` slot.
 * @slot trailing-icon - Deprecated: use the `trailing` slot.
 *
 * @attr centered - Whether the title and subtitle are centered.
 * @attr for - The identifier of the interactive control to which this element is attached.
 * @attr size - The size of the bar.
 *
 * @cssprop --m3e-app-bar-container-color - Background color of the app bar container.
 * @cssprop --m3e-app-bar-container-color-on-scroll - Background color of the app bar container when scrolled.
 * @cssprop --m3e-app-bar-container-elevation - Elevation (shadow) of the app bar container.
 * @cssprop --m3e-app-bar-container-elevation-on-scroll - Elevation (shadow) of the app bar container when scrolled.
 * @cssprop --m3e-app-bar-title-text-color - Color of the app bar title text.
 * @cssprop --m3e-app-bar-subtitle-text-color - Color of the app bar subtitle text.
 * @cssprop --m3e-app-bar-padding-left - Left padding for the app bar container.
 * @cssprop --m3e-app-bar-padding-right - Right padding for the app bar container.
 * @cssprop --m3e-app-bar-small-container-height - Height of the small app bar container.
 * @cssprop --m3e-app-bar-small-title-text-font-size - Font size for the small app bar title text.
 * @cssprop --m3e-app-bar-small-title-text-font-weight - Font weight for the small app bar title text.
 * @cssprop --m3e-app-bar-small-title-text-line-height - Line height for the small app bar title text.
 * @cssprop --m3e-app-bar-small-subtitle-text-tracking - Letter spacing (tracking) for the small app bar title text.
 * @cssprop --m3e-app-bar-small-subtitle-text-font-size - Font size for the small app bar subtitle text.
 * @cssprop --m3e-app-bar-small-subtitle-text-font-weight - Font weight for the small app bar subtitle text.
 * @cssprop --m3e-app-bar-small-subtitle-text-line-height - Line height for the small app bar subtitle text.
 * @cssprop --m3e-app-bar-small-subtitle-text-tracking - Letter spacing (tracking) for the small app bar subtitle text.
 * @cssprop --m3e-app-bar-small-heading-padding-left - Left padding for the small app bar heading.
 * @cssprop --m3e-app-bar-small-heading-padding-right - Right padding for the small app bar heading.
 * @cssprop --m3e-app-bar-medium-container-height - Height of the medium app bar container.
 * @cssprop --m3e-app-bar-medium-container-height-with-subtitle - Height of the medium app bar container with subtitle.
 * @cssprop --m3e-app-bar-medium-title-text-font-size - Font size for the medium app bar title text.
 * @cssprop --m3e-app-bar-medium-title-text-font-weight - Font weight for the medium app bar title text.
 * @cssprop --m3e-app-bar-medium-title-text-line-height - Line height for the medium app bar title text.
 * @cssprop --m3e-app-bar-medium-subtitle-text-tracking - Letter spacing (tracking) for the medium app bar title text.
 * @cssprop --m3e-app-bar-medium-subtitle-text-font-size - Font size for the medium app bar subtitle text.
 * @cssprop --m3e-app-bar-medium-subtitle-text-font-weight - Font weight for the medium app bar subtitle text.
 * @cssprop --m3e-app-bar-medium-subtitle-text-line-height - Line height for the medium app bar subtitle text.
 * @cssprop --m3e-app-bar-medium-subtitle-text-tracking - Letter spacing (tracking) for the medium app bar subtitle text.
 * @cssprop --m3e-app-bar-medium-heading-padding-left - Left padding for the medium app bar heading.
 * @cssprop --m3e-app-bar-medium-heading-padding-right - Right padding for the medium app bar heading.
 * @cssprop --m3e-app-bar-medium-padding-top - Top padding for the medium app bar.
 * @cssprop --m3e-app-bar-medium-padding-bottom - Bottom padding for the medium app bar.
 * @cssprop --m3e-app-bar-medium-title-max-lines - Maximum number of lines for the medium app bar title.
 * @cssprop --m3e-app-bar-medium-subtitle-max-lines - Maximum number of lines for the medium app bar subtitle.
 * @cssprop --m3e-app-bar-large-container-height - Height of the large app bar container.
 * @cssprop --m3e-app-bar-large-container-height-with-subtitle - Height of the large app bar container with subtitle.
 * @cssprop --m3e-app-bar-large-title-text-font-size - Font size for the large app bar title text.
 * @cssprop --m3e-app-bar-large-title-text-font-weight - Font weight for the large app bar title text.
 * @cssprop --m3e-app-bar-large-title-text-line-height - Line height for the large app bar title text.
 * @cssprop --m3e-app-bar-large-subtitle-text-tracking - Letter spacing (tracking) for the large app bar title text.
 * @cssprop --m3e-app-bar-large-subtitle-text-font-size - Font size for the large app bar subtitle text.
 * @cssprop --m3e-app-bar-large-subtitle-text-font-weight - Font weight for the large app bar subtitle text.
 * @cssprop --m3e-app-bar-large-subtitle-text-line-height - Line height for the large app bar subtitle text.
 * @cssprop --m3e-app-bar-large-subtitle-text-tracking - Letter spacing (tracking) for the large app bar subtitle text.
 * @cssprop --m3e-app-bar-large-heading-padding-left - Left padding for the large app bar heading.
 * @cssprop --m3e-app-bar-large-heading-padding-right - Right padding for the large app bar heading.
 * @cssprop --m3e-app-bar-large-padding-top - Top padding for the large app bar.
 * @cssprop --m3e-app-bar-large-padding-bottom - Bottom padding for the large app bar.
 * @cssprop --m3e-app-bar-large-title-max-lines - Maximum number of lines for the large app bar title.
 * @cssprop --m3e-app-bar-large-subtitle-max-lines - Maximum number of lines for the large app bar subtitle.
 */ let $93b4754f898d01ec$export$e384126ccb8cb333 = class M3eAppBarElement extends (0, $ca7aa15aa0ba1e7b$export$ccf21c713b2bbcbb)((0, $ca7aa15aa0ba1e7b$export$46919bad18fb2f76)((0, $fa29e5b5c67837a0$export$3f2f9f5909897157), "banner")) {
    constructor(){
        super(...arguments);
        $93b4754f898d01ec$var$_M3eAppBarElement_instances.add(this);
        /** @private */ $93b4754f898d01ec$var$_M3eAppBarElement_scrollHandler.set(this, (e)=>this._updateScroll(e));
        /** @private */ $93b4754f898d01ec$var$_M3eAppBarElement_frameLoadHandler.set(this, ()=>(0, $gkQP3.__classPrivateFieldGet)(this, $93b4754f898d01ec$var$_M3eAppBarElement_instances, "m", $93b4754f898d01ec$var$_M3eAppBarElement_handleFrameLoad).call(this));
        /**
     * Whether the title and subtitle are centered.
     * @default false
     */ this.centered = false;
        /**
     * The size of the bar.
     * @default "small"
     */ this.size = "small";
    }
    /** @inheritdoc */ attach(control) {
        super.attach(control);
        if (control instanceof HTMLIFrameElement) {
            control.addEventListener("load", (0, $gkQP3.__classPrivateFieldGet)(this, $93b4754f898d01ec$var$_M3eAppBarElement_frameLoadHandler, "f"));
            (0, $gkQP3.__classPrivateFieldGet)(this, $93b4754f898d01ec$var$_M3eAppBarElement_instances, "m", $93b4754f898d01ec$var$_M3eAppBarElement_handleFrameLoad).call(this);
        } else control.addEventListener("scroll", (0, $gkQP3.__classPrivateFieldGet)(this, $93b4754f898d01ec$var$_M3eAppBarElement_scrollHandler, "f"), {
            passive: true
        });
    }
    /** @inheritdoc */ detach() {
        if (this.control instanceof HTMLIFrameElement) {
            this.control.removeEventListener("load", (0, $gkQP3.__classPrivateFieldGet)(this, $93b4754f898d01ec$var$_M3eAppBarElement_frameLoadHandler, "f"));
            this.control.contentDocument?.removeEventListener("scroll", (0, $gkQP3.__classPrivateFieldGet)(this, $93b4754f898d01ec$var$_M3eAppBarElement_scrollHandler, "f"));
        }
        if (this.control) this.control.removeEventListener("scroll", (0, $gkQP3.__classPrivateFieldGet)(this, $93b4754f898d01ec$var$_M3eAppBarElement_scrollHandler, "f"));
        super.detach();
    }
    /** @inheritdoc */ updated(_changedProperties) {
        super.updated(_changedProperties);
        if (_changedProperties.has("centered") || _changedProperties.has("size")) {
            if (this.centered && this.size === "small") (0, $gkQP3.__classPrivateFieldGet)(this, $93b4754f898d01ec$var$_M3eAppBarElement_instances, "m", $93b4754f898d01ec$var$_M3eAppBarElement_computeCentered).call(this);
            else (0, $gkQP3.__classPrivateFieldGet)(this, $93b4754f898d01ec$var$_M3eAppBarElement_instances, "m", $93b4754f898d01ec$var$_M3eAppBarElement_clearCentered).call(this);
        }
    }
    /** @inheritdoc */ render() {
        switch(this.size){
            case "small":
                return (0, $00a10a29322bb2a1$export$c0bb0b647f701bb5)`<div class="base"><div class="leading-icon"><slot name="leading" @slotchange="${(0, $gkQP3.__classPrivateFieldGet)(this, $93b4754f898d01ec$var$_M3eAppBarElement_instances, "m", $93b4754f898d01ec$var$_M3eAppBarElement_handleLeadingIconSlotChange)}"><slot name="leading-icon" @slotchange="${(0, $gkQP3.__classPrivateFieldGet)(this, $93b4754f898d01ec$var$_M3eAppBarElement_instances, "m", $93b4754f898d01ec$var$_M3eAppBarElement_handleDeprecatedSlotChange)}"></slot></slot></div><div class="heading"><div class="label"><div class="title"><slot name="title" @slotchange="${(0, $gkQP3.__classPrivateFieldGet)(this, $93b4754f898d01ec$var$_M3eAppBarElement_instances, "m", $93b4754f898d01ec$var$_M3eAppBarElement_handleTitleSlotChange)}"></slot></div><div class="subtitle"><slot name="subtitle" @slotchange="${(0, $gkQP3.__classPrivateFieldGet)(this, $93b4754f898d01ec$var$_M3eAppBarElement_instances, "m", $93b4754f898d01ec$var$_M3eAppBarElement_handleSubtitleSlotChange)}"></slot></div></div></div><div class="trailing-icon"><slot name="trailing" @slotchange="${(0, $gkQP3.__classPrivateFieldGet)(this, $93b4754f898d01ec$var$_M3eAppBarElement_instances, "m", $93b4754f898d01ec$var$_M3eAppBarElement_handleTrailingIconsSlotChange)}"><slot name="trailing-icon" @slotchange="${(0, $gkQP3.__classPrivateFieldGet)(this, $93b4754f898d01ec$var$_M3eAppBarElement_instances, "m", $93b4754f898d01ec$var$_M3eAppBarElement_handleDeprecatedSlotChange)}"></slot></slot></div></div>`;
            default:
                return (0, $00a10a29322bb2a1$export$c0bb0b647f701bb5)`<div class="base"><div class="heading"><div class="leading-icon"><slot name="leading" @slotchange="${(0, $gkQP3.__classPrivateFieldGet)(this, $93b4754f898d01ec$var$_M3eAppBarElement_instances, "m", $93b4754f898d01ec$var$_M3eAppBarElement_handleLeadingIconSlotChange)}"><slot name="leading-icon" @slotchange="${(0, $gkQP3.__classPrivateFieldGet)(this, $93b4754f898d01ec$var$_M3eAppBarElement_instances, "m", $93b4754f898d01ec$var$_M3eAppBarElement_handleDeprecatedSlotChange)}"></slot></slot></div><div class="spacer"></div><div class="trailing-icon"><slot name="trailing" @slotchange="${(0, $gkQP3.__classPrivateFieldGet)(this, $93b4754f898d01ec$var$_M3eAppBarElement_instances, "m", $93b4754f898d01ec$var$_M3eAppBarElement_handleTrailingIconsSlotChange)}"><slot name="trailing-icon" @slotchange="${(0, $gkQP3.__classPrivateFieldGet)(this, $93b4754f898d01ec$var$_M3eAppBarElement_instances, "m", $93b4754f898d01ec$var$_M3eAppBarElement_handleDeprecatedSlotChange)}"></slot></slot></div></div><div class="spacer"></div><div class="label"><div class="title"><slot name="title" @slotchange="${(0, $gkQP3.__classPrivateFieldGet)(this, $93b4754f898d01ec$var$_M3eAppBarElement_instances, "m", $93b4754f898d01ec$var$_M3eAppBarElement_handleTitleSlotChange)}"></slot></div><div class="subtitle"><slot name="subtitle" @slotchange="${(0, $gkQP3.__classPrivateFieldGet)(this, $93b4754f898d01ec$var$_M3eAppBarElement_instances, "m", $93b4754f898d01ec$var$_M3eAppBarElement_handleSubtitleSlotChange)}"></slot></div></div></div>`;
        }
    }
    /** @private */ _updateScroll(e) {
        let scrollTop = 0;
        if (this.control instanceof HTMLIFrameElement) scrollTop = (0, $gkQP3.__classPrivateFieldGet)(this, $93b4754f898d01ec$var$_M3eAppBarElement_instances, "m", $93b4754f898d01ec$var$_M3eAppBarElement_getFrameScrollTop).call(this, this.control);
        else if (e.target instanceof HTMLElement) scrollTop = e.target.scrollTop;
        this._base?.classList.toggle("on-scroll", scrollTop > 0);
    }
};
$93b4754f898d01ec$var$_M3eAppBarElement_scrollHandler = new WeakMap();
$93b4754f898d01ec$var$_M3eAppBarElement_frameLoadHandler = new WeakMap();
$93b4754f898d01ec$var$_M3eAppBarElement_instances = new WeakSet();
$93b4754f898d01ec$var$_M3eAppBarElement_handleTitleSlotChange = function _M3eAppBarElement_handleTitleSlotChange(e) {
    this._base?.classList.toggle("with-title", (0, $ca7aa15aa0ba1e7b$export$e0478d61fdced58c)(e.target));
};
$93b4754f898d01ec$var$_M3eAppBarElement_handleSubtitleSlotChange = function _M3eAppBarElement_handleSubtitleSlotChange(e) {
    this._base?.classList.toggle("with-subtitle", (0, $ca7aa15aa0ba1e7b$export$e0478d61fdced58c)(e.target));
};
$93b4754f898d01ec$var$_M3eAppBarElement_handleLeadingIconSlotChange = function _M3eAppBarElement_handleLeadingIconSlotChange(e) {
    this._base?.classList.toggle("with-leading-icon", (0, $ca7aa15aa0ba1e7b$export$e0478d61fdced58c)(e.target));
    if (this.centered && this.size === "small") setTimeout(()=>(0, $gkQP3.__classPrivateFieldGet)(this, $93b4754f898d01ec$var$_M3eAppBarElement_instances, "m", $93b4754f898d01ec$var$_M3eAppBarElement_computeCentered).call(this), 40);
};
$93b4754f898d01ec$var$_M3eAppBarElement_handleTrailingIconsSlotChange = function _M3eAppBarElement_handleTrailingIconsSlotChange(e) {
    this._base?.classList.toggle("with-trailing-icon", (0, $ca7aa15aa0ba1e7b$export$e0478d61fdced58c)(e.target));
    if (this.centered && this.size === "small") setTimeout(()=>(0, $gkQP3.__classPrivateFieldGet)(this, $93b4754f898d01ec$var$_M3eAppBarElement_instances, "m", $93b4754f898d01ec$var$_M3eAppBarElement_computeCentered).call(this), 40);
};
$93b4754f898d01ec$var$_M3eAppBarElement_handleDeprecatedSlotChange = function _M3eAppBarElement_handleDeprecatedSlotChange(e) {
    const deprecatedSlot = e.target.name;
    const useSlot = deprecatedSlot.replace("-icon", "");
    console.warn(`[m3e-app-bar] Slot "${deprecatedSlot}" is deprecated and will be removed in a future release. Use "${useSlot}" instead.`);
};
$93b4754f898d01ec$var$_M3eAppBarElement_clearCentered = function _M3eAppBarElement_clearCentered() {
    this._base?.style.removeProperty("--_leading-icon-min-width");
    this._base?.style.removeProperty("--_trailing-icon-min-width");
};
$93b4754f898d01ec$var$_M3eAppBarElement_computeCentered = function _M3eAppBarElement_computeCentered() {
    (0, $gkQP3.__classPrivateFieldGet)(this, $93b4754f898d01ec$var$_M3eAppBarElement_instances, "m", $93b4754f898d01ec$var$_M3eAppBarElement_clearCentered).call(this);
    const leadingWidth = this._leadingIcon?.getBoundingClientRect().width ?? 0;
    const trailingWidth = this._trailingIcon?.getBoundingClientRect().width ?? 0;
    if (leadingWidth < trailingWidth) this._base?.style.setProperty("--_leading-icon-min-width", `${trailingWidth}px`);
    else if (leadingWidth > trailingWidth) this._base?.style.setProperty("--_trailing-icon-min-width", `${leadingWidth}px`);
};
$93b4754f898d01ec$var$_M3eAppBarElement_handleFrameLoad = function _M3eAppBarElement_handleFrameLoad() {
    if (this.control instanceof HTMLIFrameElement) {
        this.control.contentDocument?.addEventListener("scroll", (0, $gkQP3.__classPrivateFieldGet)(this, $93b4754f898d01ec$var$_M3eAppBarElement_scrollHandler, "f"), {
            passive: true
        });
        this._base?.classList.toggle("on-scroll", (0, $gkQP3.__classPrivateFieldGet)(this, $93b4754f898d01ec$var$_M3eAppBarElement_instances, "m", $93b4754f898d01ec$var$_M3eAppBarElement_getFrameScrollTop).call(this, this.control) > 0);
    }
};
$93b4754f898d01ec$var$_M3eAppBarElement_getFrameScrollTop = function _M3eAppBarElement_getFrameScrollTop(frame) {
    // Both document element (<html>) and body are tested for scroll top, taking the maximum.
    return Math.max(frame.contentDocument?.documentElement?.scrollTop ?? 0, frame.contentDocument?.body?.scrollTop ?? 0);
};
/** The styles of the element. */ $93b4754f898d01ec$export$e384126ccb8cb333.styles = [
    $93b4754f898d01ec$var$AppBarStyle,
    $93b4754f898d01ec$var$AppBarSizeStyle
];
(0, $gkQP3.__decorate)([
    (0, $540200038ed52347$export$2fa187e846a241c4)(".base")
], $93b4754f898d01ec$export$e384126ccb8cb333.prototype, "_base", void 0);
(0, $gkQP3.__decorate)([
    (0, $540200038ed52347$export$2fa187e846a241c4)(".leading-icon")
], $93b4754f898d01ec$export$e384126ccb8cb333.prototype, "_leadingIcon", void 0);
(0, $gkQP3.__decorate)([
    (0, $540200038ed52347$export$2fa187e846a241c4)(".trailing-icon")
], $93b4754f898d01ec$export$e384126ccb8cb333.prototype, "_trailingIcon", void 0);
(0, $gkQP3.__decorate)([
    (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $93b4754f898d01ec$export$e384126ccb8cb333.prototype, "centered", void 0);
(0, $gkQP3.__decorate)([
    (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
        reflect: true
    })
], $93b4754f898d01ec$export$e384126ccb8cb333.prototype, "size", void 0);
(0, $gkQP3.__decorate)([
    (0, $ca7aa15aa0ba1e7b$export$61fc7d43ac8f84b0)(40)
], $93b4754f898d01ec$export$e384126ccb8cb333.prototype, "_updateScroll", null);
$93b4754f898d01ec$export$e384126ccb8cb333 = (0, $gkQP3.__decorate)([
    (0, $ca7aa15aa0ba1e7b$export$da64fc29f17f9d0e)("m3e-app-bar")
], $93b4754f898d01ec$export$e384126ccb8cb333);


/**
 * @license MIT
 * Copyright (c) 2025–2026 matraic
 * See LICENSE file in the project root for full license text.
 */ 
var $gkQP3 = parcelRequire("gkQP3");



/**
 * Component design tokens that control the `M3eButtonElement` for all size variants.
 * @internal
 */ const $207ea8a68f1aa848$var$ButtonSizeToken = {
    "extra-small": {
        containerHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`calc(var(--m3e-button-extra-small-container-height, var(--m3e-button-container-height, 2rem)) + ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).density.calc(0)})`),
        outlineThickness: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--m3e-button-extra-small-outline-thickness, var(--m3e-button-outline-thickness, 1px))"),
        labelTextFontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-extra-small-label-text-font-size, var(--m3e-button-label-text-font-size, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.label.large.fontSize}))`),
        labelTextFontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-extra-small-label-text-font-weight, var(--m3e-button-label-text-font-weight, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.label.large.fontWeight}))`),
        labelTextLineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-extra-small-label-text-line-height, var(--m3e-button-label-text-line-height, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.label.large.lineHeight}))`),
        labelTextTracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-extra-small-label-text-tracking, var(--m3e-button-label-text-tracking, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.label.large.tracking}))`),
        iconSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--m3e-button-extra-small-icon-size, var(--m3e-button-icon-size, 1.25rem))"),
        shapeRound: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-extra-small-shape-round, var(--m3e-button-shape-round, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).shape.corner.full}))`),
        shapeSquare: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-extra-small-shape-square, var(--m3e-button-shape-square, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).shape.corner.medium}))`),
        selectedShapeRound: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-extra-small-selected-shape-round, var(--m3e-button-selected-shape-round, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).shape.corner.medium}))`),
        selectedShapeSquare: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-extra-small-selected-shape-square, var(--m3e-button-selected-shape-square, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).shape.corner.full}))`),
        shapePressedMorph: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-extra-small-shape-pressed-morph, var(--m3e-button-shape-pressed-morph, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).shape.corner.small}))`),
        leadingSpace: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--m3e-button-extra-small-leading-space, var(--m3e-button-leading-space, 0.75rem))"),
        trailingSpace: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--m3e-button-extra-small-trailing-space, var(--m3e-button-trailing-space, 0.75rem))"),
        iconLabelSpace: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--m3e-button-extra-small-icon-label-space, var(--m3e-button-icon-label-space, 0.5rem))")
    },
    small: {
        containerHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`calc(var(--m3e-button-small-container-height, var(--m3e-button-container-height, 2.5rem)) + ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).density.calc(-1)})`),
        outlineThickness: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--m3e-button-small-outline-thickness, var(--m3e-button-outline-thickness, 1px))"),
        labelTextFontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-small-label-text-font-size, var(--m3e-button-label-text-font-size, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.label.large.fontSize}))`),
        labelTextFontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-small-label-text-font-weight, var(--m3e-button-label-text-font-weight, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.label.large.fontWeight}))`),
        labelTextLineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-small-label-text-line-height, var(--m3e-button-label-text-line-height, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.label.large.lineHeight}))`),
        labelTextTracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-small-label-text-tracking, var(--m3e-button-label-text-tracking, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.label.large.tracking}))`),
        iconSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--m3e-button-small-icon-size, var(--m3e-button-icon-size, 1.25rem))"),
        shapeRound: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-small-shape-round, var(--m3e-button-shape-round, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).shape.corner.full}))`),
        shapeSquare: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-small-shape-square, var(--m3e-button-shape-square, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).shape.corner.medium}))`),
        selectedShapeRound: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-small-selected-shape-round, var(--m3e-button-selected-shape-round, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).shape.corner.medium}))`),
        selectedShapeSquare: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-small-selected-shape-square, var(--m3e-button-selected-shape-square, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).shape.corner.full}))`),
        shapePressedMorph: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-small-shape-pressed-morph, var(--m3e-button-shape-pressed-morph, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).shape.corner.small}))`),
        leadingSpace: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--m3e-button-small-leading-space, var(--m3e-button-leading-space, 1rem))"),
        trailingSpace: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--m3e-button-small-trailing-space, var(--m3e-button-trailing-space, 1rem))"),
        iconLabelSpace: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--m3e-button-small-icon-label-space, var(--m3e-button-icon-label-space, 0.5rem))")
    },
    medium: {
        containerHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`calc(var(--m3e-button-medium-container-height, var(--m3e-button-container-height, 3.5rem)) + ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).density.calc(-2)})`),
        outlineThickness: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--m3e-button-medium-outline-thickness, var(--m3e-button-outline-thickness, 1px))"),
        labelTextFontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-medium-label-text-font-size, var(--m3e-button-label-text-font-size, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.body.large.fontSize}))`),
        labelTextFontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-medium-label-text-font-weight, var(--m3e-button-label-text-font-weight, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.body.large.fontWeight}))`),
        labelTextLineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-medium-label-text-line-height, var(--m3e-button-label-text-line-height, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.body.large.lineHeight}))`),
        labelTextTracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-medium-label-text-tracking, var(--m3e-button-label-text-tracking, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.body.large.tracking}))`),
        iconSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--m3e-button-medium-icon-size, var(--m3e-button-icon-size, 1.5rem))"),
        shapeRound: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-medium-shape-round, var(--m3e-button-shape-round, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).shape.corner.full}))`),
        shapeSquare: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-medium-shape-square, var(--m3e-button-shape-square, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).shape.corner.large}))`),
        selectedShapeRound: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-medium-selected-shape-round, var(--m3e-button-selected-shape-round, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).shape.corner.large}))`),
        selectedShapeSquare: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-medium-selected-shape-square, var(--m3e-button-selected-shape-square, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).shape.corner.full}))`),
        shapePressedMorph: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-medium-shape-pressed-morph, var(--m3e-button-shape-pressed-morph, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).shape.corner.medium}))`),
        leadingSpace: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--m3e-button-medium-leading-space, var(--m3e-button-leading-space, 1.5rem))"),
        trailingSpace: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--m3e-button-medium-trailing-space, var(--m3e-button-trailing-space, 1.5rem))"),
        iconLabelSpace: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--m3e-button-medium-icon-label-space, var(--m3e-button-icon-label-space, 0.5rem))")
    },
    large: {
        containerHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`calc(var(--m3e-button-large-container-height, var(--m3e-button-container-height, 6rem)) + ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).density.calc(-3)})`),
        outlineThickness: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--m3e-button-large-outline-thickness, var(--m3e-button-outline-thickness, 2px))"),
        labelTextFontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-large-label-text-font-size, var(--m3e-button-label-text-font-size, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.headline.small.fontSize}))`),
        labelTextFontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-large-label-text-font-weight, var(--m3e-button-label-text-font-weight, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.headline.small.fontWeight}))`),
        labelTextLineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-large-label-text-line-height, var(--m3e-button-label-text-line-height, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.headline.small.lineHeight}))`),
        labelTextTracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-large-label-text-tracking, var(--m3e-button-label-text-tracking, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.headline.small.tracking}))`),
        iconSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--m3e-button-large-icon-size, var(--m3e-button-icon-size, 2rem))"),
        shapeRound: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-large-shape-round, var(--m3e-button-shape-round, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).shape.corner.full}))`),
        shapeSquare: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-large-shape-square, var(--m3e-button-shape-square, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).shape.corner.extraLarge}))`),
        selectedShapeRound: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-large-selected-shape-round, var(--m3e-button-selected-shape-round, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).shape.corner.extraLarge}))`),
        selectedShapeSquare: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-large-selected-shape-square, var(--m3e-button-selected-shape-square, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).shape.corner.full}))`),
        shapePressedMorph: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-large-shape-pressed-morph, var(--m3e-button-shape-pressed-morph, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).shape.corner.large}))`),
        leadingSpace: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--m3e-button-large-leading-space, var(--m3e-button-leading-space, 3rem))"),
        trailingSpace: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--m3e-button-large-trailing-space, var(--m3e-button-trailing-space, 3rem))"),
        iconLabelSpace: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--m3e-button-large-icon-label-space, var(--m3e-button-icon-label-space, 0.75rem))")
    },
    "extra-large": {
        containerHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`calc(var(--m3e-button-extra-large-container-height, var(--m3e-button-container-height, 8.5rem)) + ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).density.calc(-3)})`),
        outlineThickness: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--m3e-button-extra-large-outline-thickness, var(--m3e-button-outline-thickness, 3px))"),
        labelTextFontSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-extra-large-label-text-font-size, var(--m3e-button-label-text-font-size, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.headline.large.fontSize}))`),
        labelTextFontWeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-extra-large-label-text-font-weight, var(--m3e-button-label-text-font-weight, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.headline.large.fontWeight}))`),
        labelTextLineHeight: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-extra-large-label-text-line-height, var(--m3e-button-label-text-line-height, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.headline.large.lineHeight}))`),
        labelTextTracking: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-extra-large-label-text-tracking, var(--m3e-button-label-text-tracking, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.headline.large.tracking}))`),
        iconSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--m3e-button-extra-large-icon-size, var(--m3e-button-icon-size, 2.5rem))"),
        shapeRound: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-extra-large-shape-round, var(--m3e-button-shape-round, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).shape.corner.full}))`),
        shapeSquare: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-extra-large-shape-square, var(--m3e-button-shape-square, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).shape.corner.extraLarge}))`),
        selectedShapeRound: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-extra-large-selected-shape-round, var(--m3e-button-selected-shape-round, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).shape.corner.extraLarge}))`),
        selectedShapeSquare: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-extra-large-selected-shape-square, var(--m3e-button-selected-shape-square, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).shape.corner.full}))`),
        shapePressedMorph: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-button-extra-large-shape-pressed-morph, var(--m3e-button-shape-pressed-morph, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).shape.corner.large}))`),
        leadingSpace: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--m3e-button-extra-large-leading-space, var(--m3e-button-leading-space, 4rem))"),
        trailingSpace: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--m3e-button-extra-large-trailing-space, var(--m3e-button-trailing-space, 4rem))"),
        iconLabelSpace: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--m3e-button-extra-large-icon-label-space, var(--m3e-button-icon-label-space, 1rem))")
    }
};
/** @private */ function $207ea8a68f1aa848$var$buttonStyle(size) {
    return (0, $fbf856437f99196f$export$dbf350e5966cf602)`:host([size="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(size)}"]) .base { height: ${$207ea8a68f1aa848$var$ButtonSizeToken[size].containerHeight}; } :host([size="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(size)}"]) .wrapper { padding-inline-start: ${$207ea8a68f1aa848$var$ButtonSizeToken[size].leadingSpace}; padding-inline-end: ${$207ea8a68f1aa848$var$ButtonSizeToken[size].trailingSpace}; column-gap: ${$207ea8a68f1aa848$var$ButtonSizeToken[size].iconLabelSpace}; } :host( [size="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(size)}"]:state(-grouped):not(:state(-connected)):state(-adjacent-pressed):not( :state(-pressed) ) ) .wrapper { padding-inline-start: calc( ${$207ea8a68f1aa848$var$ButtonSizeToken[size].leadingSpace} - calc( calc(var(--_adjacent-button-width) * var(--m3e-standard-button-group-width-multiplier, 0.15)) / 4.25 ) ); padding-inline-end: calc( ${$207ea8a68f1aa848$var$ButtonSizeToken[size].trailingSpace} - calc( calc(var(--_adjacent-button-width) * var(--m3e-standard-button-group-width-multiplier, 0.15)) / 4.25 ) ); } :host([size="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(size)}"]) .label { font-size: ${$207ea8a68f1aa848$var$ButtonSizeToken[size].labelTextFontSize}; font-weight: ${$207ea8a68f1aa848$var$ButtonSizeToken[size].labelTextFontWeight}; line-height: ${$207ea8a68f1aa848$var$ButtonSizeToken[size].labelTextLineHeight}; letter-spacing: ${$207ea8a68f1aa848$var$ButtonSizeToken[size].labelTextTracking}; } :host([size="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(size)}"]) .icon { font-size: ${$207ea8a68f1aa848$var$ButtonSizeToken[size].iconSize}; --m3e-icon-size: ${$207ea8a68f1aa848$var$ButtonSizeToken[size].iconSize}; } :host([size="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(size)}"]) .base { outline-offset: calc(0px - ${$207ea8a68f1aa848$var$ButtonSizeToken[size].outlineThickness}); outline-width: ${$207ea8a68f1aa848$var$ButtonSizeToken[size].outlineThickness}; } :host(:not(:state(-connected))[size="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(size)}"][shape="rounded"]) .base { border-radius: var(--_button-shape, ${$207ea8a68f1aa848$var$ButtonSizeToken[size].shapeRound}); } :host(:not(:state(-connected))[size="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(size)}"][shape="rounded"][toggle][selected]:not(:state(-pressed))) .base { border-radius: ${$207ea8a68f1aa848$var$ButtonSizeToken[size].selectedShapeRound}; } :host(:not(:state(-connected))[size="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(size)}"][shape="square"]) .base { border-radius: ${$207ea8a68f1aa848$var$ButtonSizeToken[size].shapeSquare}; } :host(:not(:state(-connected))[size="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(size)}"][shape="square"][toggle][selected]:not(:state(-pressed))) .base { border-radius: var(--_button-shape, ${$207ea8a68f1aa848$var$ButtonSizeToken[size].selectedShapeSquare}); } :host(:not(:state(-connected))[size="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(size)}"]:state(-pressed)) .base { border-radius: ${$207ea8a68f1aa848$var$ButtonSizeToken[size].shapePressedMorph}; } :host(:state(-connected)[size="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(size)}"][shape="rounded"]) .base { border-start-start-radius: var( --_button-rounded-start-shape, var(--_button-shape, ${$207ea8a68f1aa848$var$ButtonSizeToken[size].shapeRound}) ); border-end-start-radius: var( --_button-rounded-start-shape, var(--_button-shape, ${$207ea8a68f1aa848$var$ButtonSizeToken[size].shapeRound}) ); border-start-end-radius: var( --_button-rounded-end-shape, var(--_button-shape, ${$207ea8a68f1aa848$var$ButtonSizeToken[size].shapeRound}) ); border-end-end-radius: var( --_button-rounded-end-shape, var(--_button-shape, ${$207ea8a68f1aa848$var$ButtonSizeToken[size].shapeRound}) ); } :host(:state(-connected)[size="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(size)}"][shape="square"]) .base { border-start-start-radius: var(--_button-square-start-shape, ${$207ea8a68f1aa848$var$ButtonSizeToken[size].shapeSquare}); border-end-start-radius: var(--_button-square-start-shape, ${$207ea8a68f1aa848$var$ButtonSizeToken[size].shapeSquare}); border-start-end-radius: var(--_button-square-end-shape, ${$207ea8a68f1aa848$var$ButtonSizeToken[size].shapeSquare}); border-end-end-radius: var(--_button-square-end-shape, ${$207ea8a68f1aa848$var$ButtonSizeToken[size].shapeSquare}); } :host(:state(-connected)[size="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(size)}"][shape="square"][toggle][selected]:not(:state(-pressed))) .base { border-radius: var(--_button-shape, ${$207ea8a68f1aa848$var$ButtonSizeToken[size].selectedShapeSquare}); } :host(:state(-connected)[size="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(size)}"]:state(-pressed)) .base { border-start-start-radius: var(--_button-start-shape-pressed-morph, ${$207ea8a68f1aa848$var$ButtonSizeToken[size].shapePressedMorph}); border-end-start-radius: var(--_button-start-shape-pressed-morph, ${$207ea8a68f1aa848$var$ButtonSizeToken[size].shapePressedMorph}); border-start-end-radius: var(--_button-end-shape-pressed-morph, ${$207ea8a68f1aa848$var$ButtonSizeToken[size].shapePressedMorph}); border-end-end-radius: var(--_button-end-shape-pressed-morph, ${$207ea8a68f1aa848$var$ButtonSizeToken[size].shapePressedMorph}); }`;
}
/**
 * Size variant styles for `M3eButtonElement`.
 * @internal
 */ const $207ea8a68f1aa848$var$ButtonSizeStyle = [
    $207ea8a68f1aa848$var$buttonStyle("extra-small"),
    $207ea8a68f1aa848$var$buttonStyle("small"),
    $207ea8a68f1aa848$var$buttonStyle("medium"),
    $207ea8a68f1aa848$var$buttonStyle("large"),
    $207ea8a68f1aa848$var$buttonStyle("extra-large")
];
/**
 * Baseline styles for `M3eButtonElement`.
 * @internal
 */ const $207ea8a68f1aa848$var$ButtonStyle = (0, $fbf856437f99196f$export$dbf350e5966cf602)`:host { display: inline-block; outline: none; user-select: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0); } .base { box-sizing: border-box; vertical-align: middle; display: inline-flex; align-items: center; justify-content: center; position: relative; width: 100%; transition: ${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`background-color ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).motion.duration.short4} ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).motion.easing.standard}`)}; } .touch { position: absolute; height: 3rem; left: 0; right: 0; } :host(:state(-pressed)) .base, :host(:state(-resting)) .base { transition: ${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`background-color ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).motion.duration.short4} ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).motion.easing.standard},
          border-radius ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).motion.spring.fastEffects}`)}; } .wrapper { width: 100%; overflow: hidden; display: inline-flex; align-items: center; } .label { justify-self: center; flex: 1 1 auto; text-align: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; transition: ${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`color ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).motion.duration.short4} ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).motion.easing.standard}`)}; } .icon { transition: ${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`color ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).motion.duration.short4} ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).motion.easing.standard}`)}; } :host(:not(:disabled):not([disabled-interactive])) { cursor: pointer; } :host([disabled-interactive]) { cursor: not-allowed; } ::slotted([slot="icon"]), ::slotted([slot="selected-icon"]), ::slotted([slot="trailing-icon"]) { font-size: inherit !important; flex: none; } ::slotted(svg[slot="icon"]), ::slotted(svg[slot="selected-icon"]), ::slotted(svg[slot="trailing-icon"]) { width: 1em; height: 1em; } :host([toggle]:not([selected])) .base.with-selected-icon slot[name="selected-icon"], :host([toggle][selected]) .base.with-selected-icon slot[name="icon"] { display: none; } a { all: unset; display: block; position: absolute; top: 0px; left: 0px; right: 0px; bottom: 0px; z-index: 1; } :host(:state(-grouped):state(-connected)) { flex: 1 1 auto; } :host(:state(-grouped):not(:state(-connected))) { transition: ${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`padding-inline ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).motion.spring.fastEffects}`)}; } :host(:state(-grouped):not(:state(-connected)):not(:state(-adjacent-pressed)):not(:state(-pressed))) { flex-shrink: 0; flex-grow: 0; } :host(:state(-grouped):not(:state(-connected)):state(-adjacent-pressed):not(:state(-pressed))) { flex-shrink: 1; min-width: 0; } :host(:state(-grouped):not(:state(-connected)):state(-adjacent-pressed):not(:state(-pressed))) .label { text-overflow: clip; } :host(:state(-grouped):not(:state(-connected)):state(-pressed):not([disabled-interactive]):not(:disabled)) { flex-shrink: 0; flex-basis: calc( var(--_button-width) + calc(var(--_button-width) * var(--m3e-standard-button-group-width-multiplier, 0.15)) ); } @media (forced-colors: active) { .base, .label, .icon { transition: none; } :host(:state(-pressed)) .base, :host(:state(-resting)) .base { transition: ${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`border-radius ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).motion.spring.fastEffects}`)}; } :host([variant]:not(:disabled):not([disabled-interactive]):not([toggle])) .base { background-color: ButtonFace; outline-color: ButtonText; } :host([variant]:not(:disabled):not([disabled-interactive]):not([toggle])) .label, :host([variant]:not(:disabled):not([disabled-interactive]):not([toggle])) .icon { color: ButtonText; } :host([variant]:not(:disabled):not([disabled-interactive])[toggle]:not([selected])) .base { background-color: ButtonFace; outline-color: ButtonText; } :host([variant]:not(:disabled):not([disabled-interactive])[toggle]:not([selected])) .label, :host([variant]:hover:not(:disabled):not([disabled-interactive])[toggle]:not([selected])) .label, :host([variant]:not(:disabled):not([disabled-interactive])[toggle]:not([selected]):focus) .label, :host([variant]:not(:disabled):not([disabled-interactive])[toggle]:not([selected])) .icon, :host([variant]:hover:not(:disabled):not([disabled-interactive])[toggle]:not([selected])) .icon, :host([variant]:not(:disabled):not([disabled-interactive])[toggle]:not([selected]):focus) .icon { color: ButtonText; } :host([variant]:not(:disabled):not([disabled-interactive])[toggle][selected]) .base { background-color: ButtonText; outline: none; } :host([variant]:not(:disabled):not([disabled-interactive])[toggle][selected]) .label, :host([variant]:hover:not(:disabled):not([disabled-interactive])[toggle][selected]) .label, :host([variant]:not(:disabled):not([disabled-interactive])[toggle][selected]:focus) .label, :host([variant]:not(:disabled):not([disabled-interactive])[toggle][selected]) .icon, :host([variant]:hover:not(:disabled):not([disabled-interactive])[toggle][selected]) .icon, :host([variant]:not(:disabled):not([disabled-interactive])[toggle][selected]:focus) .icon { forced-color-adjust: none; color: ButtonFace; background-color: ButtonText; } :host([variant]:disabled) .base, :host([variant][disabled-interactive]) .base { outline-color: GrayText; background-color: unset; } :host([variant]:disabled) .label, :host([variant][disabled-interactive]) .label, :host([variant]:disabled) .icon, :host([variant][disabled-interactive]) .icon { color: GrayText; } .base { outline-style: solid; } :host([size="extra-small"]) .base { outline-offset: calc(0px - var(--m3e-button-extra-small-outline-thickness, 1px)); outline-width: var(--m3e-button-extra-small-outline-thickness, 1px); } :host([size="small"]) .base { outline-offset: calc(0px - var(--m3e-button-small-outline-thickness, 1px)); outline-width: var(--m3e-button-small-outline-thickness, 1px); } :host([size="medium"]) .base { outline-offset: calc(0px - var(--m3e-button-medium-outline-thickness, 1px)); outline-width: var(--m3e-button-medium-outline-thickness, 1px); } :host([size="large"]) .base { outline-offset: calc(0px - var(--m3e-button-large-outline-thickness, 2px)); outline-width: var(--m3e-button-large-outline-thickness, 2px); } :host([size="extra-large"]) .base { outline-offset: calc(0px - var(--m3e-button-extra-large-outline-thickness, 3px)); outline-width: var(--m3e-button-extra-large-outline-thickness, 3px); } } @media (prefers-reduced-motion) { :host(:state(-pressed)) .base, :host(:state(-resting)) .base, .base, .label, .icon { transition: none; } }`;
/**
 * Component design tokens that control the appearance variants of `M3eButtonElement`.
 * @internal
 */ const $207ea8a68f1aa848$var$ButtonVariantToken = {
    /** Design tokens that control the `elevated` variant. */ elevated: {
        /** Default label color. */ labelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-label-text-color, var(--m3e-button-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
        /** Default icon color. */ iconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-icon-color, var(--m3e-button-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
        /** Default container background color. */ containerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-container-color, var(--m3e-button-container-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.surfaceContainerLow}))`),
        /** Resting elevation. */ containerElevation: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-container-elevation, var(--m3e-button-container-elevation, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).elevation.level1}))`),
        /** Unselected label color. */ unselectedLabelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-unselected-label-text-color, var(--m3e-button-unselected-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
        /** Unselected icon color. */ unselectedIconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-unselected-icon-color, var(--m3e-button-unselected-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
        /** Unselected container background color. */ unselectedContainerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-unselected-container-color, var(--m3e-button-unselected-container-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.surfaceContainerLow}))`),
        /** Selected label color. */ selectedLabelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-selected-label-text-color, var(--m3e-button-selected-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onPrimary}))`),
        /** Selected icon color. */ selectedIconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-selected-icon-color, var(--m3e-button-selected-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onPrimary}))`),
        /** Selected container background color. */ selectedContainerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-selected-container-color, var(--m3e-button-selected-container-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
        /** Design tokens that control disabled state. */ disabled: {
            /** Container background color when disabled. */ containerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-disabled-container-color, var(--m3e-button-disabled-container-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
            /** Opacity of container when disabled. */ containerOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-disabled-container-opacity, var(--m3e-button-disabled-container-opacity, 10%))`),
            /** Icon color when disabled. */ iconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-disabled-icon-color, var(--m3e-button-disabled-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
            /** Icon opacity when disabled. */ iconOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-disabled-icon-opacity, var(--m3e-button-disabled-icon-opacity, 38%))`),
            /** Label color when disabled. */ labelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-disabled-label-text-color, var(--m3e-button-disabled-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
            /** Label opacity when disabled. */ labelTextOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-disabled-label-text-opacity, var(--m3e-button-disabled-label-text-opacity, 38%))`),
            /** Elevation when disabled. */ containerElevation: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-disabled-container-elevation, var(--m3e-button-disabled-container-elevation, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).elevation.level0}))`)
        },
        /** Design tokens that control hover state. */ hover: {
            /** Icon color on hover. */ iconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-hover-icon-color, var(--m3e-button-hover-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /** Label color on hover. */ labelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-hover-label-text-color, var(--m3e-button-hover-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /** State layer color on hover. */ stateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-hover-state-layer-color, var(--m3e-button-hover-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /** State layer opacity on hover. */ stateLayerOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-hover-state-layer-opacity, var(--m3e-button-hover-state-layer-opacity, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).state.hoverStateLayerOpacity}))`),
            /** Elevation on hover. */ containerElevation: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-hover-container-elevation, var(--m3e-button-hover-container-elevation, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).elevation.level2}))`),
            /** Unselected icon color on hover. */ unselectedIconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-hover-unselected-icon-color, var(--m3e-button-hover-unselected-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /** Unselected label color on hover. */ unselectedLabelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-hover-unselected-label-text-color, var(--m3e-button-hover-unselected-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /** Unselected state layer color on hover. */ unselectedStateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-hover-unselected-state-layer-color, var(--m3e-button-hover-unselected-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /** Selected icon color on hover. */ selectedIconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-hover-selected-icon-color, var(--m3e-button-hover-selected-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onPrimary}))`),
            /** Selected label color on hover. */ selectedLabelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-hover-selected-label-text-color, var(--m3e-button-hover-selected-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onPrimary}))`),
            /** Selected ripple color on hover. */ selectedStateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-hover-selected-state-layer-color, var(--m3e-button-hover-selected-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onPrimary}))`)
        },
        /** Design tokens that control focus state. */ focus: {
            /** Icon color on focus. */ iconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-focus-icon-color, var(--m3e-button-focus-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /** Label color on focus. */ labelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-focus-label-text-color, var(--m3e-button-focus-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /** State layer color on focus. */ stateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-focus-state-layer-color, var(--m3e-button-focus-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /**State layer opacity on focus. */ stateLayerOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-focus-state-layer-opacity, var(--m3e-button-focus-state-layer-opacity, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).state.focusStateLayerOpacity}))`),
            /** Elevation on focus. */ containerElevation: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-focus-container-elevation, var(--m3e-button-focus-container-elevation, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).elevation.level1}))`),
            /** Unselected label color on focus. */ unselectedLabelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-focus-unselected-label-text-color, var(--m3e-button-focus-unselected-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /** Unselected icon color on focus. */ unselectedIconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-focus-unselected-icon-color, var(--m3e-button-focus-unselected-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /** Unselected ripple color on focus. */ unselectedStateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-focus-unselected-state-layer-color, var(--m3e-button-focus-unselected-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /** Selected icon color on focus. */ selectedIconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-focus-selected-icon-color, var(--m3e-button-focus-selected-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onPrimary}))`),
            /** Selected label color on focus. */ selectedLabelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-focus-selected-label-text-color, var(--m3e-button-focus-selected-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onPrimary}))`),
            /** Selected ripple color on focus. */ selectedStateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-focus-selected-state-layer-color, var(--m3e-button-focus-selected-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onPrimary}))`)
        },
        /** Design tokens that control pressed state. */ pressed: {
            /** Icon color on pressed. */ iconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-pressed-icon-color, var(--m3e-button-pressed-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /** Label color on pressed. */ labelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-pressed-label-text-color, var(--m3e-button-pressed-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /** State layer color on pressed. */ stateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-pressed-state-layer-color, var(--m3e-button-pressed-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /** State layer opacity on pressed. */ stateLayerOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-pressed-state-layer-opacity, var(--m3e-button-pressed-state-layer-opacity, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).state.pressedStateLayerOpacity}))`),
            /** Elevation on pressed. */ containerElevation: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-pressed-container-elevation, var(--m3e-button-pressed-container-elevation, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).elevation.level1}))`),
            /** Unselected label color on pressed. */ unselectedLabelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-pressed-unselected-label-text-color, var(--m3e-button-pressed-unselected-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /** Unselected icon color on pressed. */ unselectedIconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-pressed-unselected-icon-color, var(--m3e-button-pressed-unselected-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /** Unselected ripple color on pressed. */ unselectedStateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-pressed-unselected-state-layer-color, var(--m3e-button-pressed-unselected-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /** Selected icon color on pressed. */ selectedIconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-pressed-selected-icon-color, var(--m3e-button-pressed-selected-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onPrimary}))`),
            /** Selected label color on pressed. */ selectedLabelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-pressed-selected-label-text-color, var(--m3e-button-pressed-selected-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onPrimary}))`),
            /** Selected ripple color on pressed. */ selectedStateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-button-pressed-selected-state-layer-color, var(--m3e-button-pressed-selected-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onPrimary}))`)
        }
    },
    /** Design tokens that control the `outlined` variant. */ outlined: {
        /** Default label color. */ labelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-label-text-color, var(--m3e-button-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurfaceVariant}))`),
        /** Default icon color. */ iconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-icon-color, var(--m3e-button-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurfaceVariant}))`),
        /** Default outline color. */ outlineColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-outline-color, var(--m3e-button-outline-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.outlineVariant}))`),
        /** Unselected label color. */ unselectedLabelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-unselected-label-text-color, var(--m3e-button-unselected-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurfaceVariant}))`),
        /** Unselected icon color. */ unselectedIconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-unselected-icon-color, var(--m3e-button-unselected-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurfaceVariant}))`),
        /** Selected label color. */ selectedLabelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-selected-label-text-color, var(--m3e-button-selected-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.inverseOnSurface}))`),
        /** Selected icon color. */ selectedIconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-selected-icon-color, var(--m3e-button-selected-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.inverseOnSurface}))`),
        /** Selected container background color. */ selectedContainerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-selected-container-color, var(--m3e-button-selected-container-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.inverseSurface}))`),
        /** Design tokens that control disabled state. */ disabled: {
            /** Container background color when disabled. */ containerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-disabled-container-color, var(--m3e-button-disabled-container-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
            /** Opacity of container when disabled. */ containerOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-disabled-container-opacity, var(--m3e-button-disabled-container-opacity, 10%))`),
            /** Icon color when disabled. */ iconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-disabled-icon-color, var(--m3e-button-disabled-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
            /** Icon opacity when disabled. */ iconOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-disabled-icon-opacity, var(--m3e-button-disabled-icon-opacity, 38%))`),
            /** Label color when disabled. */ labelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-disabled-label-text-color, var(--m3e-button-disabled-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
            /** Label opacity when disabled. */ labelTextOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-disabled-label-text-opacity, var(--m3e-button-disabled-label-text-opacity, 38%))`),
            /** Outline color when disabled. */ outlineColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-disabled-outline-color, var(--m3e-button-disabled-outline-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.outlineVariant}))`)
        },
        /** Design tokens that control hover state. */ hover: {
            /** Icon color on hover. */ iconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-hover-icon-color, var(--m3e-button-hover-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurfaceVariant}))`),
            /** Label color on hover. */ labelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-hover-label-text-color, var(--m3e-button-hover-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurfaceVariant}))`),
            /** Outline color on hover. */ outlineColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-hover-outline-color, var(--m3e-button-hover-outline-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.outlineVariant}))`),
            /** State layer color on hover. */ stateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-hover-state-layer-color, var(--m3e-button-hover-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurfaceVariant}))`),
            /** State layer opacity on hover. */ stateLayerOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-hover-state-layer-opacity, var(--m3e-button-hover-state-layer-opacity, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).state.hoverStateLayerOpacity}))`),
            /** Unselected icon color on hover. */ unselectedIconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-hover-unselected-icon-color, var(--m3e-button-hover-unselected-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurfaceVariant}))`),
            /** Unselected label color on hover. */ unselectedLabelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-hover-unselected-label-text-color, var(--m3e-button-hover-unselected-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurfaceVariant}))`),
            /** Unselected state layer color on hover. */ unselectedStateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-hover-unselected-state-layer-color, var(--m3e-button-hover-unselected-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurfaceVariant}))`),
            /** Selected icon color on hover. */ selectedIconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-hover-selected-icon-color, var(--m3e-button-hover-selected-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.inverseOnSurface}))`),
            /** Selected label color on hover. */ selectedLabelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-hover-selected-label-text-color, var(--m3e-button-hover-selected-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.inverseOnSurface}))`),
            /** Selected state layer color on hover. */ selectedStateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-hover-selected-state-layer-color, var(--m3e-button-hover-selected-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.inverseOnSurface}))`)
        },
        /** Design tokens that control focus state. */ focus: {
            /** Icon color on focus. */ iconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-focus-icon-color, var(--m3e-button-focus-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurfaceVariant}))`),
            /** Label color on focus. */ labelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-focus-label-text-color, var(--m3e-button-focus-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurfaceVariant}))`),
            /** Outline color on focus. */ outlineColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-focus-outline-color, var(--m3e-button-focus-outline-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.outlineVariant}))`),
            /** State layer color on focus. */ stateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-focus-state-layer-color, var(--m3e-button-focus-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurfaceVariant}))`),
            /**State layer opacity on focus. */ stateLayerOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-focus-state-layer-opacity, var(--m3e-button-focus-state-layer-opacity, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).state.focusStateLayerOpacity}))`),
            /** Unselected icon color on focus. */ unselectedIconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-focus-unselected-icon-color, var(--m3e-button-focus-unselected-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurfaceVariant}))`),
            /** Unselected label color on focus. */ unselectedLabelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-focus-unselected-label-text-color, var(--m3e-button-focus-unselected-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurfaceVariant}))`),
            /** Unselected state layer color on focus. */ unselectedStateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-focus-unselected-state-layer-color, var(--m3e-button-focus-unselected-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurfaceVariant}))`),
            /** Selected icon color on focus. */ selectedIconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-focus-selected-icon-color, var(--m3e-button-focus-selected-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.inverseOnSurface}))`),
            /** Selected label color on focus. */ selectedLabelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-focus-selected-label-text-color, var(--m3e-button-focus-selected-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.inverseOnSurface}))`),
            /** Selected state layer color on focus. */ selectedStateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-focus-selected-state-layer-color, var(--m3e-button-focus-selected-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.inverseOnSurface}))`)
        },
        /** Design tokens that control pressed state. */ pressed: {
            /** Icon color on pressed. */ iconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-pressed-icon-color, var(--m3e-button-pressed-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurfaceVariant}))`),
            /** Label color on pressed. */ labelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-pressed-label-text-color, var(--m3e-button-pressed-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurfaceVariant}))`),
            /** Outline color on pressed. */ outlineColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-pressed-outline-color, var(--m3e-button-pressed-outline-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.outlineVariant}))`),
            /** State layer color on pressed. */ stateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-pressed-state-layer-color, var(--m3e-button-pressed-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurfaceVariant}))`),
            /** State layer opacity on pressed. */ stateLayerOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-pressed-state-layer-opacity, var(--m3e-button-pressed-state-layer-opacity, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).state.pressedStateLayerOpacity}))`),
            /** Unselected icon color on pressed. */ unselectedIconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-pressed-unselected-icon-color, var(--m3e-button-pressed-unselected-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurfaceVariant}))`),
            /** Unselected label color on pressed. */ unselectedLabelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-pressed-unselected-label-text-color, var(--m3e-button-pressed-unselected-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurfaceVariant}))`),
            /** Unselected state layer color on pressed. */ unselectedStateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-pressed-unselected-state-layer-color, var(--m3e-button-pressed-unselected-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurfaceVariant}))`),
            /** Selected icon color on pressed. */ selectedIconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-pressed-selected-icon-color, var(--m3e-button-pressed-selected-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.inverseOnSurface}))`),
            /** Selected label color on pressed. */ selectedLabelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-pressed-selected-label-text-color, var(--m3e-button-pressed-selected-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.inverseOnSurface}))`),
            /** Selected state layer color on pressed. */ selectedStateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-button-pressed-selected-state-layer-color, var(--m3e-button-pressed-selected-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.inverseOnSurface}))`)
        }
    },
    /** Design tokens that control the `filled` variant. */ filled: {
        /** Default label color. */ labelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-label-text-color, var(--m3e-button-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onPrimary}))`),
        /** Default icon color. */ iconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-icon-color, var(--m3e-button-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onPrimary}))`),
        /** Default container background color. */ containerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-container-color, var(--m3e-button-container-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
        /** Resting elevation. */ containerElevation: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-container-elevation, var(--m3e-button-container-elevation, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).elevation.level0}))`),
        /** Unselected label color. */ unselectedLabelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-unselected-label-text-color, var(--m3e-button-unselected-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurfaceVariant}))`),
        /** Unselected icon color. */ unselectedIconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-unselected-icon-color, var(--m3e-button-unselected-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurfaceVariant}))`),
        /** Unselected container background color. */ unselectedContainerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-unselected-container-color, var(--m3e-button-unselected-container-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.surfaceContainer}))`),
        /** Selected label color. */ selectedLabelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-selected-label-text-color, var(--m3e-button-selected-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onPrimary}))`),
        /** Selected icon color. */ selectedIconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-selected-icon-color, var(--m3e-button-selected-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onPrimary}))`),
        /** Selected container background color. */ selectedContainerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-selected-container-color, var(--m3e-button-selected-container-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
        /** Design tokens that control disabled state. */ disabled: {
            /** Container background color when disabled. */ containerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-disabled-container-color, var(--m3e-button-disabled-container-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
            /** Opacity of container when disabled. */ containerOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-disabled-container-opacity, var(--m3e-button-disabled-container-opacity, 10%))`),
            /** Icon color when disabled. */ iconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-disabled-icon-color, var(--m3e-button-disabled-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
            /** Icon opacity when disabled. */ iconOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-disabled-icon-opacity, var(--m3e-button-disabled-icon-opacity, 38%))`),
            /** Label color when disabled. */ labelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-disabled-label-text-color, var(--m3e-button-disabled-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
            /** Label opacity when disabled. */ labelTextOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-disabled-label-text-opacity, var(--m3e-button-disabled-label-text-opacity, 38%))`),
            /** Elevation when disabled. */ containerElevation: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-disabled-container-elevation, var(--m3e-button-disabled-container-elevation, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).elevation.level0}))`)
        },
        /** Design tokens that control hover state. */ hover: {
            /** Icon color on hover. */ iconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-hover-icon-color, var(--m3e-button-hover-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onPrimary}))`),
            /** Label color on hover. */ labelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-hover-label-text-color, var(--m3e-button-hover-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onPrimary}))`),
            /** State layer color on hover. */ stateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-hover-state-layer-color, var(--m3e-button-hover-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onPrimary}))`),
            /** State layer opacity on hover. */ stateLayerOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-hover-state-layer-opacity, var(--m3e-button-hover-state-layer-opacity, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).state.hoverStateLayerOpacity}))`),
            /** Elevation on hover. */ containerElevation: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-hover-container-elevation, var(--m3e-button-hover-container-elevation, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).elevation.level1}))`),
            /** Unselected icon color on hover. */ unselectedIconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-hover-unselected-icon-color, var(--m3e-button-hover-unselected-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurfaceVariant}))`),
            /** Unselected label color on hover. */ unselectedLabelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-hover-unselected-label-text-color, var(--m3e-button-hover-unselected-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurfaceVariant}))`),
            /** Unselected state layer color on hover. */ unselectedStateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-hover-unselected-state-layer-color, var(--m3e-button-hover-unselected-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurfaceVariant}))`),
            /** Selected icon color on hover. */ selectedIconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-hover-selected-icon-color, var(--m3e-button-hover-selected-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onPrimary}))`),
            /** Selected label color on hover. */ selectedLabelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-hover-selected-label-text-color, var(--m3e-button-hover-selected-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onPrimary}))`),
            /** Selected state layer color on hover. */ selectedStateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-hover-selected-state-layer-color, var(--m3e-button-hover-selected-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onPrimary}))`)
        },
        /** Design tokens that control focus state. */ focus: {
            /** Icon color on focus. */ iconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-focus-icon-color, var(--m3e-button-focus-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onPrimary}))`),
            /** Label color on focus. */ labelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-focus-label-text-color, var(--m3e-button-focus-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onPrimary}))`),
            /** State layer color on focus. */ stateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-focus-state-layer-color, var(--m3e-button-focus-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onPrimary}))`),
            /**State layer opacity on focus. */ stateLayerOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-focus-state-layer-opacity, var(--m3e-button-focus-state-layer-opacity, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).state.focusStateLayerOpacity}))`),
            /** Elevation on focus. */ containerElevation: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-focus-container-elevation, var(--m3e-button-focus-container-elevation, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).elevation.level0}))`),
            /** Unselected icon color on focus. */ unselectedIconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-focus-unselected-icon-color, var(--m3e-button-focus-unselected-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurfaceVariant}))`),
            /** Unselected label color on focus. */ unselectedLabelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-focus-unselected-label-text-color, var(--m3e-button-focus-unselected-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurfaceVariant}))`),
            /** Unselected state layer color on focus. */ unselectedStateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-focus-unselected-state-layer-color, var(--m3e-button-focus-unselected-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurfaceVariant}))`),
            /** Selected icon color on focus. */ selectedIconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-focus-selected-icon-color, var(--m3e-button-focus-selected-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onPrimary}))`),
            /** Selected label color on focus. */ selectedLabelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-focus-selected-label-text-color, var(--m3e-button-focus-selected-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onPrimary}))`),
            /** Selected state layer color on focus. */ selectedStateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-focus-selected-state-layer-color, var(--m3e-button-focus-selected-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onPrimary}))`)
        },
        /** Design tokens that control pressed state. */ pressed: {
            /** Icon color on pressed. */ iconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-pressed-icon-color, var(--m3e-button-pressed-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onPrimary}))`),
            /** Label color on pressed. */ labelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-pressed-label-text-color, var(--m3e-button-pressed-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onPrimary}))`),
            /** State layer color on pressed. */ stateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-pressed-state-layer-color, var(--m3e-button-pressed-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onPrimary}))`),
            /** State layer opacity on pressed. */ stateLayerOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-pressed-state-layer-opacity, var(--m3e-button-pressed-state-layer-opacity, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).state.pressedStateLayerOpacity}))`),
            /** Elevation on pressed. */ containerElevation: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-pressed-container-elevation, var(--m3e-button-pressed-container-elevation, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).elevation.level0}))`),
            /** Unselected icon color on pressed. */ unselectedIconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-pressed-unselected-icon-color, var(--m3e-button-pressed-unselected-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurfaceVariant}))`),
            /** Unselected label color on pressed. */ unselectedLabelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-pressed-unselected-label-text-color, var(--m3e-button-pressed-unselected-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurfaceVariant}))`),
            /** Unselected state layer color on pressed. */ unselectedStateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-pressed-unselected-state-layer-color, var(--m3e-button-pressed-unselected-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurfaceVariant}))`),
            /** Selected icon color on pressed. */ selectedIconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-pressed-selected-icon-color, var(--m3e-button-pressed-selected-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onPrimary}))`),
            /** Selected label color on pressed. */ selectedLabelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-pressed-selected-label-text-color, var(--m3e-button-pressed-selected-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onPrimary}))`),
            /** Selected state layer color on pressed. */ selectedStateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-button-pressed-selected-state-layer-color, var(--m3e-button-pressed-selected-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onPrimary}))`)
        }
    },
    /** Design tokens that control the `tonal` variant. */ tonal: {
        /** Default label color. */ labelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-label-text-color, var(--m3e-button-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSecondaryContainer}))`),
        /** Default icon color. */ iconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-icon-color, var(--m3e-button-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSecondaryContainer}))`),
        /** Default container background color. */ containerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-container-color, var(--m3e-button-container-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.secondaryContainer}))`),
        /** Resting elevation. */ containerElevation: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-container-elevation, var(--m3e-button-container-elevation, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).elevation.level0}))`),
        /** Unselected label color. */ unselectedLabelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-unselected-label-text-color, var(--m3e-button-unselected-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSecondaryContainer}))`),
        /** Unselected icon color. */ unselectedIconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-unselected-icon-color, var(--m3e-button-unselected-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSecondaryContainer}))`),
        /** Unselected container background color. */ unselectedContainerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-unselected-container-color, var(--m3e-button-unselected-container-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.secondaryContainer}))`),
        /** Selected label color. */ selectedLabelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-selected-label-text-color, var(--m3e-button-selected-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSecondary}))`),
        /** Selected icon color. */ selectedIconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-selected-icon-color, var(--m3e-button-selected-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSecondary}))`),
        /** Selected container background color. */ selectedContainerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-selected-container-color, var(--m3e-button-selected-container-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.secondary}))`),
        /** Design tokens that control disabled state. */ disabled: {
            /** Container background color when disabled. */ containerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-disabled-container-color, var(--m3e-button-disabled-container-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
            /** Opacity of container when disabled. */ containerOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-disabled-container-opacity, var(--m3e-button-disabled-container-opacity, 10%))`),
            /** Icon color when disabled. */ iconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-disabled-icon-color, var(--m3e-button-disabled-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
            /** Icon opacity when disabled. */ iconOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-disabled-icon-opacity, var(--m3e-button-disabled-icon-opacity, 38%))`),
            /** Label color when disabled. */ labelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-disabled-label-text-color, var(--m3e-button-disabled-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
            /** Label opacity when disabled. */ labelTextOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-disabled-label-text-opacity, var(--m3e-button-disabled-label-text-opacity, 38%))`),
            /** Elevation when disabled. */ containerElevation: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-disabled-container-elevation, var(--m3e-button-disabled-container-elevation, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).elevation.level0}))`)
        },
        /** Design tokens that control hover state. */ hover: {
            /** Icon color on hover. */ iconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-hover-icon-color, var(--m3e-button-hover-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSecondaryContainer}))`),
            /** Label color on hover. */ labelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-hover-label-text-color, var(--m3e-button-hover-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSecondaryContainer}))`),
            /** State layer color on hover. */ stateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-hover-state-layer-color, var(--m3e-button-hover-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSecondaryContainer}))`),
            /** State layer opacity on hover. */ stateLayerOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-hover-state-layer-opacity, var(--m3e-button-hover-state-layer-opacity, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).state.hoverStateLayerOpacity}))`),
            /** Elevation on hover. */ containerElevation: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-hover-container-elevation, var(--m3e-button-hover-container-elevation, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).elevation.level1}))`),
            /** Unselected icon color on hover. */ unselectedIconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-hover-unselected-icon-color, var(--m3e-button-hover-unselected-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSecondaryContainer}))`),
            /** Unselected label color on hover. */ unselectedLabelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-hover-unselected-label-text-color, var(--m3e-button-hover-unselected-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSecondaryContainer}))`),
            /** Unselected state layer color on hover. */ unselectedStateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-hover-unselected-state-layer-color, var(--m3e-button-hover-unselected-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSecondaryContainer}))`),
            /** Selected icon color on hover. */ selectedIconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-hover-selected-icon-color, var(--m3e-button-hover-selected-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSecondary}))`),
            /** Selected label color on hover. */ selectedLabelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-hover-selected-label-text-color, var(--m3e-button-hover-selected-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSecondary}))`),
            /** Selected state layer color on hover. */ selectedStateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-hover-selected-state-layer-color, var(--m3e-button-hover-selected-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSecondary}))`)
        },
        /** Design tokens that control focus state. */ focus: {
            /** Icon color on focus. */ iconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-focus-icon-color, var(--m3e-button-focus-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSecondaryContainer}))`),
            /** Label color on focus. */ labelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-focus-label-text-color, var(--m3e-button-focus-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSecondaryContainer}))`),
            /** State layer color on focus. */ stateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-focus-state-layer-color, var(--m3e-button-focus-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSecondaryContainer}))`),
            /**State layer opacity on focus. */ stateLayerOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-focus-state-layer-opacity, var(--m3e-button-focus-state-layer-opacity, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).state.focusStateLayerOpacity}))`),
            /** Elevation on focus. */ containerElevation: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-focus-container-elevation, var(--m3e-button-focus-container-elevation, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).elevation.level0}))`),
            /** Unselected icon color on focus. */ unselectedIconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-focus-unselected-icon-color, var(--m3e-button-focus-unselected-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSecondaryContainer}))`),
            /** Unselected label color on focus. */ unselectedLabelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-focus-unselected-label-text-color, var(--m3e-button-focus-unselected-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSecondaryContainer}))`),
            /** Unselected state layer color on focus. */ unselectedStateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-focus-unselected-state-layer-color, var(--m3e-button-focus-unselected-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSecondaryContainer}))`),
            /** Selected icon color on focus. */ selectedIconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-focus-selected-icon-color, var(--m3e-button-focus-selected-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSecondary}))`),
            /** Selected label color on focus. */ selectedLabelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-focus-selected-label-text-color, var(--m3e-button-focus-selected-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSecondary}))`),
            /** Selected state layer color on focus. */ selectedStateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-focus-selected-state-layer-color, var(--m3e-button-focus-selected-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSecondary}))`)
        },
        /** Design tokens that control pressed state. */ pressed: {
            /** Icon color on pressed. */ iconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-pressed-icon-color, var(--m3e-button-pressed-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSecondaryContainer}))`),
            /** Label color on pressed. */ labelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-pressed-label-text-color, var(--m3e-button-pressed-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSecondaryContainer}))`),
            /** State layer color on pressed. */ stateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-pressed-state-layer-color, var(--m3e-button-pressed-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSecondaryContainer}))`),
            /** State layer opacity on pressed. */ stateLayerOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-pressed-state-layer-opacity, var(--m3e-button-pressed-state-layer-opacity, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).state.pressedStateLayerOpacity}))`),
            /** Elevation on pressed. */ containerElevation: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-pressed-container-elevation, var(--m3e-button-pressed-container-elevation, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).elevation.level0}))`),
            /** Unselected icon color on pressed. */ unselectedIconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-pressed-unselected-icon-color, var(--m3e-button-pressed-unselected-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSecondaryContainer}))`),
            /** Unselected label color on pressed. */ unselectedLabelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-pressed-unselected-label-text-color, var(--m3e-button-pressed-unselected-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSecondaryContainer}))`),
            /** Unselected state layer color on pressed. */ unselectedStateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-pressed-unselected-state-layer-color, var(--m3e-button-pressed-unselected-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSecondaryContainer}))`),
            /** Selected icon color on pressed. */ selectedIconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-pressed-selected-icon-color, var(--m3e-button-pressed-selected-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSecondary}))`),
            /** Selected label color on pressed. */ selectedLabelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-pressed-selected-label-text-color, var(--m3e-button-pressed-selected-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSecondary}))`),
            /** Selected state layer color on pressed. */ selectedStateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-tonal-button-pressed-selected-state-layer-color, var(--m3e-button-pressed-selected-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSecondary}))`)
        }
    },
    /** Design tokens that control the `text` variant. */ text: {
        /** Default label color. */ labelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-label-text-color, var(--m3e-button-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
        /** Default icon color. */ iconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-icon-color, var(--m3e-button-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
        /** Unselected label color. */ unselectedLabelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-unselected-label-text-color, var(--m3e-button-unselected-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
        /** Unselected icon color. */ unselectedIconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-unselected-icon-color, var(--m3e-button-unselected-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
        /** Selected label color. */ selectedLabelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-selected-label-text-color, var(--m3e-button-selected-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
        /** Selected icon color. */ selectedIconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-selected-icon-color, var(--m3e-button-selected-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
        /** Design tokens that control disabled state. */ disabled: {
            /** Container background color when disabled. */ containerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-disabled-container-color, var(--m3e-button-disabled-container-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
            /** Opacity of container when disabled. */ containerOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-disabled-container-opacity, var(--m3e-button-disabled-container-opacity, 10%))`),
            /** Icon color when disabled. */ iconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-disabled-icon-color, var(--m3e-button-disabled-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
            /** Icon opacity when disabled. */ iconOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-disabled-icon-opacity, var(--m3e-button-disabled-icon-opacity, 38%))`),
            /** Label color when disabled. */ labelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-disabled-label-text-color, var(--m3e-button-disabled-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
            /** Label opacity when disabled. */ labelTextOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-disabled-label-text-opacity, var(--m3e-button-disabled-label-text-opacity, 38%))`)
        },
        /** Design tokens that control hover state. */ hover: {
            /** Icon color on hover. */ iconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-hover-icon-color, var(--m3e-button-hover-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /** Label color on hover. */ labelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-hover-label-text-color, var(--m3e-button-hover-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /** State layer color on hover. */ stateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-hover-state-layer-color, var(--m3e-button-hover-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /** State layer opacity on hover. */ stateLayerOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-hover-state-layer-opacity, var(--m3e-button-hover-state-layer-opacity, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).state.hoverStateLayerOpacity}))`),
            /** Unselected icon color on hover. */ unselectedIconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-hover-unselected-icon-color, var(--m3e-button-hover-unselected-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /** Unselected label color on hover. */ unselectedLabelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-hover-unselected-label-text-color, var(--m3e-button-hover-unselected-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /** Unselected state layer color on hover. */ unselectedStateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-hover-unselected-state-layer-color, var(--m3e-button-hover-unselected-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /** Selected icon color on hover. */ selectedIconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-hover-selected-icon-color, var(--m3e-button-hover-selected-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /** Selected label color on hover. */ selectedLabelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-hover-selected-label-text-color, var(--m3e-button-hover-selected-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /** Selected state layer color on hover. */ selectedStateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-hover-selected-state-layer-color, var(--m3e-button-hover-selected-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`)
        },
        /** Design tokens that control focus state. */ focus: {
            /** Icon color on focus. */ iconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-focus-icon-color, var(--m3e-button-focus-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /** Label color on focus. */ labelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-focus-label-text-color, var(--m3e-button-focus-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /** State layer color on focus. */ stateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-focus-state-layer-color, var(--m3e-button-focus-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /**State layer opacity on focus. */ stateLayerOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-focus-state-layer-opacity, var(--m3e-button-focus-state-layer-opacity, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).state.focusStateLayerOpacity}))`),
            /** Unselected icon color on focus. */ unselectedIconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-focus-unselected-icon-color, var(--m3e-button-focus-unselected-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /** Unselected label color on focus. */ unselectedLabelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-focus-unselected-label-text-color, var(--m3e-button-focus-unselected-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /** Unselected state layer color on focus. */ unselectedStateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-focus-unselected-state-layer-color, var(--m3e-button-focus-unselected-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /** Selected icon color on focus. */ selectedIconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-focus-selected-icon-color, var(--m3e-button-focus-selected-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /** Selected label color on focus. */ selectedLabelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-focus-selected-label-text-color, var(--m3e-button-focus-selected-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /** Selected state layer color on focus. */ selectedStateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-focus-selected-state-layer-color, var(--m3e-button-focus-selected-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`)
        },
        /** Design tokens that control pressed state. */ pressed: {
            /** Icon color on pressed. */ iconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-pressed-icon-color, var(--m3e-button-pressed-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /** Label color on pressed. */ labelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-pressed-label-text-color, var(--m3e-button-pressed-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /** State layer color on pressed. */ stateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-pressed-state-layer-color, var(--m3e-button-pressed-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /** State layer opacity on pressed. */ stateLayerOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-pressed-state-layer-opacity, var(--m3e-button-pressed-state-layer-opacity, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).state.pressedStateLayerOpacity}))`),
            /** Unselected icon color on pressed. */ unselectedIconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-pressed-unselected-icon-color, var(--m3e-button-pressed-unselected-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /** Unselected label color on pressed. */ unselectedLabelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-pressed-unselected-label-text-color, var(--m3e-button-pressed-unselected-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /** Unselected state layer color on pressed. */ unselectedStateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-pressed-unselected-state-layer-color, var(--m3e-button-pressed-unselected-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /** Selected icon color on pressed. */ selectedIconColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-pressed-selected-icon-color, var(--m3e-button-pressed-selected-icon-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /** Selected label color on pressed. */ selectedLabelTextColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-pressed-selected-label-text-color, var(--m3e-button-pressed-selected-label-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`),
            /** Selected state layer color on pressed. */ selectedStateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-text-button-pressed-selected-state-layer-color, var(--m3e-button-pressed-selected-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary}))`)
        }
    }
};
/** @private */ function $207ea8a68f1aa848$var$buttonVariantStyle(variant) {
    return (0, $fbf856437f99196f$export$dbf350e5966cf602)`:host([variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"]:not(:disabled):not([disabled-interactive])) .base { background-color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].containerColor ?? (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("unset")}; --m3e-state-layer-hover-color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].hover.stateLayerColor}; --m3e-state-layer-hover-opacity: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].hover.stateLayerOpacity}; --m3e-state-layer-focus-color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].focus.stateLayerColor}; --m3e-state-layer-focus-opacity: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].focus.stateLayerOpacity}; --m3e-ripple-color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].pressed.stateLayerColor}; --m3e-ripple-opacity: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].pressed.stateLayerOpacity}; --m3e-elevation-level: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].containerElevation ?? (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("unset")}; --m3e-elevation-hover-level: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].hover.containerElevation ?? (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("unset")}; --m3e-elevation-focus-level: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].focus.containerElevation ?? (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("unset")}; --m3e-elevation-pressed-level: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].pressed.containerElevation ?? (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("unset")}; } :host([variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"][toggle]:not([selected]):not(:disabled):not([disabled-interactive])) .base { background-color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].unselectedContainerColor ?? (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("unset")}; --m3e-state-layer-hover-color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].hover.unselectedStateLayerColor}; --m3e-state-layer-focus-color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].focus.unselectedStateLayerColor}; --m3e-ripple-color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].pressed.unselectedStateLayerColor}; } :host([variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"][toggle][selected]:not(:disabled):not([disabled-interactive])) .base { background-color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].selectedContainerColor ?? (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("unset")}; --m3e-state-layer-hover-color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].hover.selectedStateLayerColor}; --m3e-state-layer-focus-color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].focus.selectedStateLayerColor}; --m3e-ripple-color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].pressed.selectedStateLayerColor}; } :host([variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"]:not(:disabled):not([disabled-interactive])) .base { outline-color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].outlineColor ?? (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("unset")}; } :host([variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"]:focus:not(:disabled):not([disabled-interactive])) .base { outline-color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].focus.outlineColor ?? (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("unset")}; } :host([variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"]:hover:not(:disabled):not([disabled-interactive])) .base { outline-color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].hover.outlineColor ?? (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("unset")}; } :host([variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"]:state(-pressed):not(:disabled):not([disabled-interactive])) .base { outline-color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].pressed.outlineColor ?? (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("unset")}; } :host([variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"]:not(:disabled):not([disabled-interactive])) .label { color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].labelTextColor}; } :host([variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"][toggle]:not([selected]):not(:disabled):not([disabled-interactive])) .label { color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].unselectedLabelTextColor}; } :host([variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"][toggle][selected]:not(:disabled):not([disabled-interactive])) .label { color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].selectedLabelTextColor}; } :host([variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"]:focus:not(:disabled):not([disabled-interactive])) .label { color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].focus.labelTextColor}; } :host([variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"][toggle]:not([selected]):focus:not(:disabled):not([disabled-interactive])) .label { color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].focus.unselectedLabelTextColor}; } :host([variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"][toggle][selected]:focus:not(:disabled):not([disabled-interactive])) .label { color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].focus.selectedLabelTextColor}; } :host([variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"]:hover:not(:disabled):not([disabled-interactive])) .label { color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].hover.labelTextColor}; } :host([variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"][toggle]:not([selected]):hover:not(:disabled):not([disabled-interactive])) .label { color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].hover.unselectedLabelTextColor}; } :host([variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"][toggle][selected]:hover:not(:disabled):not([disabled-interactive])) .label { color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].hover.selectedLabelTextColor}; } :host([variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"]:state(-pressed):not(:disabled):not([disabled-interactive])) .label { color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].pressed.labelTextColor}; } :host( [variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"][toggle]:not([selected]):state(-pressed):not(:disabled):not( [disabled-interactive] ) ) .label { color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].pressed.unselectedLabelTextColor}; } :host( [variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"][toggle][selected]:state(-pressed):not(:disabled):not([disabled-interactive]) ) .label { color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].pressed.selectedLabelTextColor}; } :host([variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"]:not(:disabled):not([disabled-interactive])) .icon { color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].iconColor}; } :host([variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"][toggle]:not([selected]):not(:disabled):not([disabled-interactive])) .icon { color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].unselectedIconColor}; } :host([variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"][toggle][selected]:not(:disabled):not([disabled-interactive])) .icon { color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].selectedIconColor}; } :host([variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"]:focus:not(:disabled):not([disabled-interactive])) .icon { color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].focus.iconColor}; } :host([variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"][toggle]:not([selected]):focus:not(:disabled):not([disabled-interactive])) .icon { color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].focus.unselectedIconColor}; } :host([variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"][toggle][selected]:focus:not(:disabled):not([disabled-interactive])) .icon { color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].focus.selectedIconColor}; } :host([variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"]:hover:not(:disabled):not([disabled-interactive])) .icon { color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].hover.iconColor}; } :host([variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"][toggle]:not([selected]):hover:not(:disabled):not([disabled-interactive])) .icon { color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].hover.unselectedIconColor}; } :host([variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"][toggle][selected]:hover:not(:disabled):not([disabled-interactive])) .icon { color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].hover.selectedIconColor}; } :host([variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"]:state(-pressed):not(:disabled):not([disabled-interactive])) .icon { color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].pressed.iconColor}; } :host( [variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"][toggle]:not([selected]):state(-pressed):not(:disabled):not( [disabled-interactive] ) ) .icon { color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].pressed.unselectedIconColor}; } :host( [variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"][toggle][selected]:state(-pressed):not(:disabled):not([disabled-interactive]) ) .icon { color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].pressed.selectedIconColor}; } :host([variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"]:disabled) .base, :host([variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"][disabled-interactive]) .base { --m3e-elevation-level: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].disabled.containerElevation ?? (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("unset")}; outline-color: ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].disabled.outlineColor ?? (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("unset")}; background-color: color-mix( in srgb, ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].disabled.containerColor} ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].disabled.containerOpacity}, transparent ); } :host([variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"]:disabled) .label, :host([variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"][disabled-interactive]) .label { color: color-mix( in srgb, ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].disabled.labelTextColor} ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].disabled.labelTextOpacity}, transparent ); } :host([variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"]:disabled) .icon, :host([variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"][disabled-interactive]) .icon { color: color-mix( in srgb, ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].disabled.iconColor} ${$207ea8a68f1aa848$var$ButtonVariantToken[variant].disabled.iconOpacity}, transparent ); }`;
}
/**
 * Appearance variant styles for `M3eButtonElement`.
 * @internal
 */ const $207ea8a68f1aa848$var$ButtonVariantStyle = [
    $207ea8a68f1aa848$var$buttonVariantStyle("text"),
    $207ea8a68f1aa848$var$buttonVariantStyle("elevated"),
    $207ea8a68f1aa848$var$buttonVariantStyle("outlined"),
    $207ea8a68f1aa848$var$buttonVariantStyle("filled"),
    $207ea8a68f1aa848$var$buttonVariantStyle("tonal"),
    (0, $fbf856437f99196f$export$dbf350e5966cf602)`:host([variant="outlined"]:not([toggle][selected]):not(:disabled):not([disabled-interactive])) .base { outline-style: solid; }`
];
var $207ea8a68f1aa848$var$_M3eButtonElement_instances, $207ea8a68f1aa848$var$_M3eButtonElement_clickHandler, $207ea8a68f1aa848$var$_M3eButtonElement_handleClick, $207ea8a68f1aa848$var$_M3eButtonElement_handleSelectedIconSlotChange, $207ea8a68f1aa848$var$_M3eButtonElement_updateButtonShape, $207ea8a68f1aa848$var$_M3eButtonElement_handlePressedChange;
/**
 * A button users interact with to perform an action.
 *
 * @description
 * The `m3e-button` component is a semantic, expressive UI primitive users interact with to perform an action.
 * Designed according to Material Design 3 guidelines, it supports five visual variants, specified using the
 * `variant` attribute—`filled`, `tonal`, `elevated`, `outlined`, and `text`—each with dynamic elevation,
 * shape morphing, and adaptive color theming. The component responds to interaction states (hover, focus, press, disabled)
 * with smooth motion transitions, ensuring emotional clarity and visual hierarchy.
 *
 * The component is accessible by default, with ARIA roles, contrast-safe color tokens, and strong focus indicators.
 * It supports optional icons and states for binary actions.  When using `m3e-icon` for icons, `filled` is automatically
 * set based on the selected state of a toggle button. It can also function as a link or be used to submit form data.
 *
 * Native disabled `<button>` elements cannot receive focus. This can be problematic in some cases because it can prevent you
 * from telling the user why the button is disabled. You can use the `disabled-interactive` attribute to style a `m3e-button`
 * as disabled but allow for it to receive focus. The button will have `aria-disabled="true"` for assistive technology.
 *
 * @example
 * The following example illustrates changing the appearance from `text` (default), to `tonal` using the `variant` attribute.
 * ```html
 * <m3e-button variant="tonal">Tonal Button</m3e-button>
 * ```
 *
 * @tag m3e-button
 *
 * @slot - Renders the label of the button.
 * @slot icon - Renders an icon before the button's label.
 * @slot selected - Renders the label of the button, when selected.
 * @slot selected-icon - Renders an icon before the button's label, when selected.
 * @slot trailing-icon - Renders an icon after the button's label.
 *
 * @attr disabled - Whether the element is disabled.
 * @attr disabled-interactive - Whether the element is disabled and interactive.
 * @attr download - A value indicating whether the `target` of the link button will be downloaded, optionally specifying the new name of the file.
 * @attr href - The URL to which the link button points.
 * @attr name - The name of the element, submitted as a pair with the element's `value` as part of form data, when the element is used to submit a form.
 * @attr rel - The relationship between the `target` of the link button and the document.
 * @attr selected - Whether the toggle button is selected.
 * @attr shape - The shape of the button.
 * @attr size - The size of the button.
 * @attr target - The target of the link button.
 * @attr toggle - Whether the button will toggle between selected and unselected states.
 * @attr type - The type of the element.
 * @attr value - The value associated with the element's name when it's submitted with form data.
 * @attr variant - The appearance variant of the button.
 *
 * @fires input - Dispatched when a toggle button's selected state changes.
 * @fires change - Dispatched when a toggle button's selected state changes.
 * @fires click - Emitted when the element is clicked.
 *
 * @cssprop --m3e-button-container-height - Height of the button container, for all size variants.
 * @cssprop --m3e-button-outline-thickness - Thickness of the button outline, for all size variants.
 * @cssprop --m3e-button-label-text-font-size - Font size for the label text, for all size variants.
 * @cssprop --m3e-button-label-text-font-weight - Font weight for the label text, for all size variants.
 * @cssprop --m3e-button-label-text-line-height - Line height for the label text, for all size variants.
 * @cssprop --m3e-button-label-text-tracking - Letter tracking for the label text, for all size variants.
 * @cssprop --m3e-button-icon-size - Size of the icon, for all size variants.
 * @cssprop --m3e-button-shape-round - Corner radius for round shape, for all size variants.
 * @cssprop --m3e-button-shape-square - Corner radius for square shape, for all size variants.
 * @cssprop --m3e-button-selected-shape-round - Corner radius when selected (round), for all size variants.
 * @cssprop --m3e-button-selected-shape-square - Corner radius when selected (square), for all size variants.
 * @cssprop --m3e-button-shape-pressed-morph - Corner radius when pressed, for all size variants.
 * @cssprop --m3e-button-leading-space - Space before icon or label, for all size variants.
 * @cssprop --m3e-button-trailing-space - Space after icon or label, for all size variants.
 * @cssprop --m3e-button-icon-label-space - Space between icon and label, for all size variants.
 * @cssprop --m3e-button-extra-small-container-height - Height of the button container, for the extra-small size variant.
 * @cssprop --m3e-button-extra-small-outline-thickness - Thickness of the button outline, for the extra-small size variant.
 * @cssprop --m3e-button-extra-small-label-text-font-size - Font size for the label text, for the extra-small size variant.
 * @cssprop --m3e-button-extra-small-label-text-font-weight - Font weight for the label text, for the extra-small size variant.
 * @cssprop --m3e-button-extra-small-label-text-line-height - Line height for the label text, for the extra-small size variant.
 * @cssprop --m3e-button-extra-small-label-text-tracking - Letter tracking for the label text, for the extra-small size variant.
 * @cssprop --m3e-button-extra-small-icon-size - Size of the icon, for the extra-small size variant.
 * @cssprop --m3e-button-extra-small-shape-round - Corner radius for round shape, for the extra-small size variant.
 * @cssprop --m3e-button-extra-small-shape-square - Corner radius for square shape, for the extra-small size variant.
 * @cssprop --m3e-button-extra-small-selected-shape-round - Corner radius when selected (round), for the extra-small size variant.
 * @cssprop --m3e-button-extra-small-selected-shape-square - Corner radius when selected (square), for the extra-small size variant.
 * @cssprop --m3e-button-extra-small-shape-pressed-morph - Corner radius when pressed, for the extra-small size variant.
 * @cssprop --m3e-button-extra-small-leading-space - Space before icon or label, for the extra-small size variant.
 * @cssprop --m3e-button-extra-small-trailing-space - Space after icon or label, for the extra-small size variant.
 * @cssprop --m3e-button-extra-small-icon-label-space - Space between icon and label, for the extra-small size variant.
 * @cssprop --m3e-button-small-container-height - Height of the button container, for the small size variant.
 * @cssprop --m3e-button-small-outline-thickness - Thickness of the button outline, for the small size variant.
 * @cssprop --m3e-button-small-label-text-font-size - Font size for the label text, for the small size variant.
 * @cssprop --m3e-button-small-label-text-font-weight - Font weight for the label text, for the small size variant.
 * @cssprop --m3e-button-small-label-text-line-height - Line height for the label text, for the small size variant.
 * @cssprop --m3e-button-small-label-text-tracking - Letter tracking for the label text, for the small size variant.
 * @cssprop --m3e-button-small-icon-size - Size of the icon, for the small size variant.
 * @cssprop --m3e-button-small-shape-round - Corner radius for round shape, for the small size variant.
 * @cssprop --m3e-button-small-shape-square - Corner radius for square shape, for the small size variant.
 * @cssprop --m3e-button-small-selected-shape-round - Corner radius when selected (round), for the small size variant.
 * @cssprop --m3e-button-small-selected-shape-square - Corner radius when selected (square), for the small size variant.
 * @cssprop --m3e-button-small-shape-pressed-morph - Corner radius when pressed, for the small size variant.
 * @cssprop --m3e-button-small-leading-space - Space before icon or label, for the small size variant.
 * @cssprop --m3e-button-small-trailing-space - Space after icon or label, for the small size variant.
 * @cssprop --m3e-button-small-icon-label-space - Space between icon and label, for the small size variant.
 * @cssprop --m3e-button-medium-container-height - Height of the button container, for the medium size variant.
 * @cssprop --m3e-button-medium-outline-thickness - Thickness of the button outline, for the medium size variant.
 * @cssprop --m3e-button-medium-label-text-font-size - Font size for the label text, for the medium size variant.
 * @cssprop --m3e-button-medium-label-text-font-weight - Font weight for the label text, for the medium size variant.
 * @cssprop --m3e-button-medium-label-text-line-height - Line height for the label text, for the medium size variant.
 * @cssprop --m3e-button-medium-label-text-tracking - Letter tracking for the label text, for the medium size variant.
 * @cssprop --m3e-button-medium-icon-size - Size of the icon, for the medium size variant.
 * @cssprop --m3e-button-medium-shape-round - Corner radius for round shape, for the medium size variant.
 * @cssprop --m3e-button-medium-shape-square - Corner radius for square shape, for the medium size variant.
 * @cssprop --m3e-button-medium-selected-shape-round - Corner radius when selected (round), for the medium size variant.
 * @cssprop --m3e-button-medium-selected-shape-square - Corner radius when selected (square), for the medium size variant.
 * @cssprop --m3e-button-medium-shape-pressed-morph - Corner radius when pressed, for the medium size variant.
 * @cssprop --m3e-button-medium-leading-space - Space before icon or label, for the medium size variant.
 * @cssprop --m3e-button-medium-trailing-space - Space after icon or label, for the medium size variant.
 * @cssprop --m3e-button-medium-icon-label-space - Space between icon and label, for the medium size variant.
 * @cssprop --m3e-button-large-container-height - Height of the button container, for the large size variant.
 * @cssprop --m3e-button-large-outline-thickness - Thickness of the button outline, for the large size variant.
 * @cssprop --m3e-button-large-label-text-font-size - Font size for the label text, for the large size variant.
 * @cssprop --m3e-button-large-label-text-font-weight - Font weight for the label text, for the large size variant.
 * @cssprop --m3e-button-large-label-text-line-height - Line height for the label text, for the large size variant.
 * @cssprop --m3e-button-large-label-text-tracking - Letter tracking for the label text, for the large size variant.
 * @cssprop --m3e-button-large-icon-size - Size of the icon, for the large size variant.
 * @cssprop --m3e-button-large-shape-round - Corner radius for round shape, for the large size variant.
 * @cssprop --m3e-button-large-shape-square - Corner radius for square shape, for the large size variant.
 * @cssprop --m3e-button-large-selected-shape-round - Corner radius when selected (round), for the large size variant.
 * @cssprop --m3e-button-large-selected-shape-square - Corner radius when selected (square), for the large size variant.
 * @cssprop --m3e-button-large-shape-pressed-morph - Corner radius when pressed, for the large size variant.
 * @cssprop --m3e-button-large-leading-space - Space before icon or label, for the large size variant.
 * @cssprop --m3e-button-large-trailing-space - Space after icon or label, for the large size variant.
 * @cssprop --m3e-button-large-icon-label-space - Space between icon and label, for the large size variant.
 * @cssprop --m3e-button-extra-large-container-height - Height of the button container, for the extra-large size variant.
 * @cssprop --m3e-button-extra-large-outline-thickness - Thickness of the button outline, for the extra-large size variant.
 * @cssprop --m3e-button-extra-large-label-text-font-size - Font size for the label text, for the extra-large size variant.
 * @cssprop --m3e-button-extra-large-label-text-font-weight - Font weight for the label text, for the extra-large size variant.
 * @cssprop --m3e-button-extra-large-label-text-line-height - Line height for the label text, for the extra-large size variant.
 * @cssprop --m3e-button-extra-large-label-text-tracking - Letter tracking for the label text, for the extra-large size variant.
 * @cssprop --m3e-button-extra-large-icon-size - Size of the icon, for the extra-large size variant.
 * @cssprop --m3e-button-extra-large-shape-round - Corner radius for round shape, for the extra-large size variant.
 * @cssprop --m3e-button-extra-large-shape-square - Corner radius for square shape, for the extra-large size variant.
 * @cssprop --m3e-button-extra-large-selected-shape-round - Corner radius when selected (round), for the extra-large size variant.
 * @cssprop --m3e-button-extra-large-selected-shape-square - Corner radius when selected (square), for the extra-large size variant.
 * @cssprop --m3e-button-extra-large-shape-pressed-morph - Corner radius when pressed, for the extra-large size variant.
 * @cssprop --m3e-button-extra-large-leading-space - Space before icon or label, for the extra-large size variant.
 * @cssprop --m3e-button-extra-large-trailing-space - Space after icon or label, for the extra-large size variant.
 * @cssprop --m3e-button-extra-large-icon-label-space - Space between icon and label, for the extra-large size variant.
 * @cssprop --m3e-button-outline-color - Outline color, for all variants.
 * @cssprop --m3e-button-disabled-outline-color - Disabled outline color, for all variants.
 * @cssprop --m3e-button-hover-outline-color - Hover outline color, for all variants.
 * @cssprop --m3e-button-focus-outline-color - Focus outline color, for all variants.
 * @cssprop --m3e-button-pressed-outline-color - Pressed outline color, for all variants.
 * @cssprop --m3e-button-container-color - Container background color, for all variants.
 * @cssprop --m3e-button-container-elevation - Elevation, for all variants.
 * @cssprop --m3e-button-unselected-container-color - Unselected container color, for all variants.
 * @cssprop --m3e-button-selected-container-color - Selected container color, for all variants.
 * @cssprop --m3e-button-disabled-container-elevation - Disabled elevation, for all variants.
 * @cssprop --m3e-button-hover-container-elevation - Hover elevation, for all variants.
 * @cssprop --m3e-button-focus-container-elevation - Focus elevation, for all variants.
 * @cssprop --m3e-button-pressed-container-elevation - Pressed elevation, for all variants.
 * @cssprop --m3e-button-label-text-color - Label color, for all variants.
 * @cssprop --m3e-button-icon-color - Icon color, for all variants.
 * @cssprop --m3e-button-unselected-label-text-color - Unselected label color, for all variants.
 * @cssprop --m3e-button-unselected-icon-color - Unselected icon color, for all variants.
 * @cssprop --m3e-button-selected-label-text-color - Selected label color, for all variants.
 * @cssprop --m3e-button-selected-icon-color - Selected icon color, for all variants.
 * @cssprop --m3e-button-disabled-container-color - Disabled container color, for all variants.
 * @cssprop --m3e-button-disabled-container-opacity - Disabled container opacity, for all variants.
 * @cssprop --m3e-button-disabled-icon-color - Disabled icon color, for all variants.
 * @cssprop --m3e-button-disabled-icon-opacity - Disabled icon opacity, for all variants.
 * @cssprop --m3e-button-disabled-label-text-color - Disabled label color, for all variants.
 * @cssprop --m3e-button-disabled-label-text-opacity - Disabled label opacity, for all variants.
 * @cssprop --m3e-button-hover-icon-color - Hover icon color, for all variants.
 * @cssprop --m3e-button-hover-label-text-color - Hover label color, for all variants.
 * @cssprop --m3e-button-hover-state-layer-color - Hover state layer color, for all variants.
 * @cssprop --m3e-button-hover-state-layer-opacity - Hover state layer opacity, for all variants.
 * @cssprop --m3e-button-hover-unselected-icon-color - Hover unselected icon color, for all variants.
 * @cssprop --m3e-button-hover-unselected-label-text-color - Hover unselected label color, for all variants.
 * @cssprop --m3e-button-hover-unselected-state-layer-color - Hover unselected state layer color, for all variants.
 * @cssprop --m3e-button-hover-selected-icon-color - Hover selected icon color, for all variants.
 * @cssprop --m3e-button-hover-selected-label-text-color - Hover selected label color, for all variants.
 * @cssprop --m3e-button-hover-selected-state-layer-color - Hover selected state layer color, for all variants.
 * @cssprop --m3e-button-focus-icon-color - Focus icon color, for all variants.
 * @cssprop --m3e-button-focus-label-text-color - Focus label color, for all variants.
 * @cssprop --m3e-button-focus-state-layer-color - Focus state layer color, for all variants.
 * @cssprop --m3e-button-focus-state-layer-opacity - Focus state layer opacity, for all variants.
 * @cssprop --m3e-button-focus-unselected-icon-color - Focus unselected icon color, for all variants.
 * @cssprop --m3e-button-focus-unselected-label-text-color - Focus unselected label color, for all variants.
 * @cssprop --m3e-button-focus-unselected-state-layer-color - Focus unselected state layer color, for all variants.
 * @cssprop --m3e-button-focus-selected-icon-color - Focus selected icon color, for all variants.
 * @cssprop --m3e-button-focus-selected-label-text-color - Focus selected label color, for all variants.
 * @cssprop --m3e-button-focus-selected-state-layer-color - Focus selected state layer color, for all variants.
 * @cssprop --m3e-button-pressed-icon-color - Pressed icon color, for all variants.
 * @cssprop --m3e-button-pressed-label-text-color - Pressed label color, for all variants.
 * @cssprop --m3e-button-pressed-state-layer-color - Pressed state layer color, for all variants.
 * @cssprop --m3e-button-pressed-state-layer-opacity - Pressed state layer opacity, for all variants.
 * @cssprop --m3e-button-pressed-unselected-icon-color - Pressed unselected icon color, for all variants.
 * @cssprop --m3e-button-pressed-unselected-label-text-color - Pressed unselected label color, for all variants.
 * @cssprop --m3e-button-pressed-unselected-state-layer-color - Pressed unselected state layer color, for all variants.
 * @cssprop --m3e-button-pressed-selected-icon-color - Pressed selected icon color, for all variants.
 * @cssprop --m3e-button-pressed-selected-label-text-color - Pressed selected label color, for all variants.
 * @cssprop --m3e-button-pressed-selected-state-layer-color - Pressed selected state layer color, for all variants.
 * @cssprop --m3e-elevated-button-label-text-color - Label color, for the elevated variant.
 * @cssprop --m3e-elevated-button-icon-color - Icon color, for the elevated variant.
 * @cssprop --m3e-elevated-button-container-color - Container background color, for the elevated variant.
 * @cssprop --m3e-elevated-button-container-elevation - Elevation, for the elevated variant.
 * @cssprop --m3e-elevated-button-unselected-label-text-color - Unselected label color, for the elevated variant.
 * @cssprop --m3e-elevated-button-unselected-icon-color - Unselected icon color, for the elevated variant.
 * @cssprop --m3e-elevated-button-unselected-container-color - Unselected container color, for the elevated variant.
 * @cssprop --m3e-elevated-button-selected-label-text-color - Selected label color, for the elevated variant.
 * @cssprop --m3e-elevated-button-selected-icon-color - Selected icon color, for the elevated variant.
 * @cssprop --m3e-elevated-button-selected-container-color - Selected container color, for the elevated variant.
 * @cssprop --m3e-elevated-button-disabled-container-color - Disabled container color, for the elevated variant.
 * @cssprop --m3e-elevated-button-disabled-container-opacity - Disabled container opacity, for the elevated variant.
 * @cssprop --m3e-elevated-button-disabled-icon-color - Disabled icon color, for the elevated variant.
 * @cssprop --m3e-elevated-button-disabled-icon-opacity - Disabled icon opacity, for the elevated variant.
 * @cssprop --m3e-elevated-button-disabled-label-text-color - Disabled label color, for the elevated variant.
 * @cssprop --m3e-elevated-button-disabled-label-text-opacity - Disabled label opacity, for the elevated variant.
 * @cssprop --m3e-elevated-button-disabled-container-elevation - Disabled elevation, for the elevated variant.
 * @cssprop --m3e-elevated-button-hover-icon-color - Hover icon color, for the elevated variant.
 * @cssprop --m3e-elevated-button-hover-label-text-color - Hover label color, for the elevated variant.
 * @cssprop --m3e-elevated-button-hover-state-layer-color - Hover state layer color, for the elevated variant.
 * @cssprop --m3e-elevated-button-hover-state-layer-opacity - Hover state layer opacity, for the elevated variant.
 * @cssprop --m3e-elevated-button-hover-container-elevation - Hover elevation, for the elevated variant.
 * @cssprop --m3e-elevated-button-hover-unselected-icon-color - Hover unselected icon color, for the elevated variant.
 * @cssprop --m3e-elevated-button-hover-unselected-label-text-color - Hover unselected label color, for the elevated variant.
 * @cssprop --m3e-elevated-button-hover-unselected-state-layer-color - Hover unselected state layer color, for the elevated variant.
 * @cssprop --m3e-elevated-button-hover-selected-icon-color - Hover selected icon color, for the elevated variant.
 * @cssprop --m3e-elevated-button-hover-selected-label-text-color - Hover selected label color, for the elevated variant.
 * @cssprop --m3e-elevated-button-hover-selected-state-layer-color - Hover selected state layer color, for the elevated variant.
 * @cssprop --m3e-elevated-button-focus-icon-color - Focus icon color, for the elevated variant.
 * @cssprop --m3e-elevated-button-focus-label-text-color - Focus label color, for the elevated variant.
 * @cssprop --m3e-elevated-button-focus-state-layer-color - Focus state layer color, for the elevated variant.
 * @cssprop --m3e-elevated-button-focus-state-layer-opacity - Focus state layer opacity, for the elevated variant.
 * @cssprop --m3e-elevated-button-focus-container-elevation - Focus elevation, for the elevated variant.
 * @cssprop --m3e-elevated-button-focus-unselected-label-text-color - Focus unselected label color, for the elevated variant.
 * @cssprop --m3e-elevated-button-focus-unselected-icon-color - Focus unselected icon color, for the elevated variant.
 * @cssprop --m3e-elevated-button-focus-unselected-state-layer-color - Focus unselected state layer color, for the elevated variant.
 * @cssprop --m3e-elevated-button-focus-selected-icon-color - Focus selected icon color, for the elevated variant.
 * @cssprop --m3e-elevated-button-focus-selected-label-text-color - Focus selected label color, for the elevated variant.
 * @cssprop --m3e-elevated-button-focus-selected-state-layer-color - Focus selected state layer color, for the elevated variant.
 * @cssprop --m3e-elevated-button-pressed-icon-color - Pressed icon color, for the elevated variant.
 * @cssprop --m3e-elevated-button-pressed-label-text-color - Pressed label color, for the elevated variant.
 * @cssprop --m3e-elevated-button-pressed-state-layer-color - Pressed state layer color, for the elevated variant.
 * @cssprop --m3e-elevated-button-pressed-state-layer-opacity - Pressed state layer opacity, for the elevated variant.
 * @cssprop --m3e-elevated-button-pressed-container-elevation - Pressed elevation, for the elevated variant.
 * @cssprop --m3e-elevated-button-pressed-unselected-label-text-color - Pressed unselected label color, for the elevated variant.
 * @cssprop --m3e-elevated-button-pressed-unselected-icon-color - Pressed unselected icon color, for the elevated variant.
 * @cssprop --m3e-elevated-button-pressed-unselected-state-layer-color - Pressed unselected state layer color, for the elevated variant.
 * @cssprop --m3e-elevated-button-pressed-selected-icon-color - Pressed selected icon color, for the elevated variant.
 * @cssprop --m3e-elevated-button-pressed-selected-label-text-color - Pressed selected label color, for the elevated variant.
 * @cssprop --m3e-elevated-button-pressed-selected-state-layer-color - Pressed selected state layer color, for the elevated variant.
 * @cssprop --m3e-outlined-button-label-text-color - Label color, for the outlined variant.
 * @cssprop --m3e-outlined-button-icon-color - Icon color, for the outlined variant.
 * @cssprop --m3e-outlined-button-outline-color - Outline color, for the outlined variant.
 * @cssprop --m3e-outlined-button-unselected-label-text-color - Unselected label color, for the outlined variant.
 * @cssprop --m3e-outlined-button-unselected-icon-color - Unselected icon color, for the outlined variant.
 * @cssprop --m3e-outlined-button-selected-label-text-color - Selected label color, for the outlined variant.
 * @cssprop --m3e-outlined-button-selected-icon-color - Selected icon color, for the outlined variant.
 * @cssprop --m3e-outlined-button-selected-container-color - Selected container color, for the outlined variant.
 * @cssprop --m3e-outlined-button-disabled-container-color - Disabled container color, for the outlined variant.
 * @cssprop --m3e-outlined-button-disabled-container-opacity - Disabled container opacity, for the outlined variant.
 * @cssprop --m3e-outlined-button-disabled-icon-color - Disabled icon color, for the outlined variant.
 * @cssprop --m3e-outlined-button-disabled-icon-opacity - Disabled icon opacity, for the outlined variant.
 * @cssprop --m3e-outlined-button-disabled-label-text-color - Disabled label color, for the outlined variant.
 * @cssprop --m3e-outlined-button-disabled-label-text-opacity - Disabled label opacity, for the outlined variant.
 * @cssprop --m3e-outlined-button-disabled-outline-color - Disabled outline color, for the outlined variant.
 * @cssprop --m3e-outlined-button-hover-icon-color - Hover icon color, for the outlined variant.
 * @cssprop --m3e-outlined-button-hover-label-text-color - Hover label color, for the outlined variant.
 * @cssprop --m3e-outlined-button-hover-outline-color - Hover outline color, for the outlined variant.
 * @cssprop --m3e-outlined-button-hover-state-layer-color - Hover state layer color, for the outlined variant.
 * @cssprop --m3e-outlined-button-hover-state-layer-opacity - Hover state layer opacity, for the outlined variant.
 * @cssprop --m3e-outlined-button-hover-unselected-icon-color - Hover unselected icon color, for the outlined variant.
 * @cssprop --m3e-outlined-button-hover-unselected-label-text-color - Hover unselected label color, for the outlined variant.
 * @cssprop --m3e-outlined-button-hover-unselected-state-layer-color - Hover unselected state layer color, for the outlined variant.
 * @cssprop --m3e-outlined-button-hover-selected-icon-color - Hover selected icon color, for the outlined variant.
 * @cssprop --m3e-outlined-button-hover-selected-label-text-color - Hover selected label color, for the outlined variant.
 * @cssprop --m3e-outlined-button-hover-selected-state-layer-color - Hover selected state layer color, for the outlined variant.
 * @cssprop --m3e-outlined-button-focus-icon-color - Focus icon color, for the outlined variant.
 * @cssprop --m3e-outlined-button-focus-label-text-color - Focus label color, for the outlined variant.
 * @cssprop --m3e-outlined-button-focus-outline-color - Focus outline color, for the outlined variant.
 * @cssprop --m3e-outlined-button-focus-state-layer-color - Focus state layer color, for the outlined variant.
 * @cssprop --m3e-outlined-button-focus-state-layer-opacity - Focus state layer opacity, for the outlined variant.
 * @cssprop --m3e-outlined-button-focus-unselected-icon-color - Focus unselected icon color, for the outlined variant.
 * @cssprop --m3e-outlined-button-focus-unselected-label-text-color - Focus unselected label color, for the outlined variant.
 * @cssprop --m3e-outlined-button-focus-unselected-state-layer-color - Focus unselected state layer color, for the outlined variant.
 * @cssprop --m3e-outlined-button-focus-selected-icon-color - Focus selected icon color, for the outlined variant.
 * @cssprop --m3e-outlined-button-focus-selected-label-text-color - Focus selected label color, for the outlined variant.
 * @cssprop --m3e-outlined-button-focus-selected-state-layer-color - Focus selected state layer color, for the outlined variant.
 * @cssprop --m3e-outlined-button-pressed-icon-color - Pressed icon color, for the outlined variant.
 * @cssprop --m3e-outlined-button-pressed-label-text-color - Pressed label color, for the outlined variant.
 * @cssprop --m3e-outlined-button-pressed-outline-color - Pressed outline color, for the outlined variant.
 * @cssprop --m3e-outlined-button-pressed-state-layer-color - Pressed state layer color, for the outlined variant.
 * @cssprop --m3e-outlined-button-pressed-state-layer-opacity - Pressed state layer opacity, for the outlined variant.
 * @cssprop --m3e-outlined-button-pressed-unselected-icon-color - Pressed unselected icon color, for the outlined variant.
 * @cssprop --m3e-outlined-button-pressed-unselected-label-text-color - Pressed unselected label color, for the outlined variant.
 * @cssprop --m3e-outlined-button-pressed-unselected-state-layer-color - Pressed unselected state layer color, for the outlined variant.
 * @cssprop --m3e-outlined-button-pressed-selected-icon-color - Pressed selected icon color, for the outlined variant.
 * @cssprop --m3e-outlined-button-pressed-selected-label-text-color - Pressed selected label color, for the outlined variant.
 * @cssprop --m3e-outlined-button-pressed-selected-state-layer-color - Pressed selected state layer color, for the outlined variant.
 * @cssprop --m3e-filled-button-label-text-color - Label color, for the filled variant.
 * @cssprop --m3e-filled-button-icon-color - Icon color, for the filled variant.
 * @cssprop --m3e-filled-button-container-color - Container background color, for the filled variant.
 * @cssprop --m3e-filled-button-container-elevation - Elevation, for the filled variant.
 * @cssprop --m3e-filled-button-unselected-label-text-color - Unselected label color, for the filled variant.
 * @cssprop --m3e-filled-button-unselected-icon-color - Unselected icon color, for the filled variant.
 * @cssprop --m3e-filled-button-unselected-container-color - Unselected container color, for the filled variant.
 * @cssprop --m3e-filled-button-selected-label-text-color - Selected label color, for the filled variant.
 * @cssprop --m3e-filled-button-selected-icon-color - Selected icon color, for the filled variant.
 * @cssprop --m3e-filled-button-selected-container-color - Selected container color, for the filled variant.
 * @cssprop --m3e-filled-button-disabled-container-color - Disabled container color, for the filled variant.
 * @cssprop --m3e-filled-button-disabled-container-opacity - Disabled container opacity, for the filled variant.
 * @cssprop --m3e-filled-button-disabled-icon-color - Disabled icon color, for the filled variant.
 * @cssprop --m3e-filled-button-disabled-icon-opacity - Disabled icon opacity, for the filled variant.
 * @cssprop --m3e-filled-button-disabled-label-text-color - Disabled label color, for the filled variant.
 * @cssprop --m3e-filled-button-disabled-label-text-opacity - Disabled label opacity, for the filled variant.
 * @cssprop --m3e-filled-button-disabled-container-elevation - Disabled elevation, for the filled variant.
 * @cssprop --m3e-filled-button-hover-icon-color - Hover icon color, for the filled variant.
 * @cssprop --m3e-filled-button-hover-label-text-color - Hover label color, for the filled variant.
 * @cssprop --m3e-filled-button-hover-state-layer-color - Hover state layer color, for the filled variant.
 * @cssprop --m3e-filled-button-hover-state-layer-opacity - Hover state layer opacity, for the filled variant.
 * @cssprop --m3e-filled-button-hover-container-elevation - Hover elevation, for the filled variant.
 * @cssprop --m3e-filled-button-hover-unselected-icon-color - Hover unselected icon color, for the filled variant.
 * @cssprop --m3e-filled-button-hover-unselected-label-text-color - Hover unselected label color, for the filled variant.
 * @cssprop --m3e-filled-button-hover-unselected-state-layer-color - Hover unselected state layer color, for the filled variant.
 * @cssprop --m3e-filled-button-hover-selected-icon-color - Hover selected icon color, for the filled variant.
 * @cssprop --m3e-filled-button-hover-selected-label-text-color - Hover selected label color, for the filled variant.
 * @cssprop --m3e-filled-button-hover-selected-state-layer-color - Hover selected state layer color, for the filled variant.
 * @cssprop --m3e-filled-button-focus-icon-color - Focus icon color, for the filled variant.
 * @cssprop --m3e-filled-button-focus-label-text-color - Focus label color, for the filled variant.
 * @cssprop --m3e-filled-button-focus-state-layer-color - Focus state layer color, for the filled variant.
 * @cssprop --m3e-filled-button-focus-state-layer-opacity - Focus state layer opacity, for the filled variant.
 * @cssprop --m3e-filled-button-focus-container-elevation - Focus elevation, for the filled variant.
 * @cssprop --m3e-filled-button-focus-unselected-icon-color - Focus unselected icon color, for the filled variant.
 * @cssprop --m3e-filled-button-focus-unselected-label-text-color - Focus unselected label color, for the filled variant.
 * @cssprop --m3e-filled-button-focus-unselected-state-layer-color - Focus unselected state layer color, for the filled variant.
 * @cssprop --m3e-filled-button-focus-selected-icon-color - Focus selected icon color, for the filled variant.
 * @cssprop --m3e-filled-button-focus-selected-label-text-color - Focus selected label color, for the filled variant.
 * @cssprop --m3e-filled-button-focus-selected-state-layer-color - Focus selected state layer color, for the filled variant.
 * @cssprop --m3e-filled-button-pressed-icon-color - Pressed icon color, for the filled variant.
 * @cssprop --m3e-filled-button-pressed-label-text-color - Pressed label color, for the filled variant.
 * @cssprop --m3e-filled-button-pressed-state-layer-color - Pressed state layer color, for the filled variant.
 * @cssprop --m3e-filled-button-pressed-state-layer-opacity - Pressed state layer opacity, for the filled variant.
 * @cssprop --m3e-filled-button-pressed-container-elevation - Pressed elevation, for the filled variant.
 * @cssprop --m3e-filled-button-pressed-unselected-icon-color - Pressed unselected icon color, for the filled variant.
 * @cssprop --m3e-filled-button-pressed-unselected-label-text-color - Pressed unselected label color, for the filled variant.
 * @cssprop --m3e-filled-button-pressed-unselected-state-layer-color - Pressed unselected state layer color, for the filled variant.
 * @cssprop --m3e-filled-button-pressed-selected-icon-color - Pressed selected icon color, for the filled variant.
 * @cssprop --m3e-filled-button-pressed-selected-label-text-color - Pressed selected label color, for the filled variant.
 * @cssprop --m3e-filled-button-pressed-selected-state-layer-color - Pressed selected state layer color, for the filled variant.
 * @cssprop --m3e-tonal-button-label-text-color - Label color, for the tonal variant.
 * @cssprop --m3e-tonal-button-icon-color - Icon color, for the tonal variant.
 * @cssprop --m3e-tonal-button-container-color - Container background color, for the tonal variant.
 * @cssprop --m3e-tonal-button-container-elevation - Elevation, for the tonal variant.
 * @cssprop --m3e-tonal-button-unselected-label-text-color - Unselected label color, for the tonal variant.
 * @cssprop --m3e-tonal-button-unselected-icon-color - Unselected icon color, for the tonal variant.
 * @cssprop --m3e-tonal-button-unselected-container-color - Unselected container color, for the tonal variant.
 * @cssprop --m3e-tonal-button-selected-label-text-color - Selected label color, for the tonal variant.
 * @cssprop --m3e-tonal-button-selected-icon-color - Selected icon color, for the tonal variant.
 * @cssprop --m3e-tonal-button-selected-container-color - Selected container color, for the tonal variant.
 * @cssprop --m3e-tonal-button-disabled-container-color - Disabled container color, for the tonal variant.
 * @cssprop --m3e-tonal-button-disabled-container-opacity - Disabled container opacity, for the tonal variant.
 * @cssprop --m3e-tonal-button-disabled-icon-color - Disabled icon color, for the tonal variant.
 * @cssprop --m3e-tonal-button-disabled-icon-opacity - Disabled icon opacity, for the tonal variant.
 * @cssprop --m3e-tonal-button-disabled-label-text-color - Disabled label color, for the tonal variant.
 * @cssprop --m3e-tonal-button-disabled-label-text-opacity - Disabled label opacity, for the tonal variant.
 * @cssprop --m3e-tonal-button-disabled-container-elevation - Disabled elevation, for the tonal variant.
 * @cssprop --m3e-tonal-button-hover-icon-color - Hover icon color, for the tonal variant.
 * @cssprop --m3e-tonal-button-hover-label-text-color - Hover label color, for the tonal variant.
 * @cssprop --m3e-tonal-button-hover-state-layer-color - Hover state layer color, for the tonal variant.
 * @cssprop --m3e-tonal-button-hover-state-layer-opacity - Hover state layer opacity, for the tonal variant.
 * @cssprop --m3e-tonal-button-hover-container-elevation - Hover elevation, for the tonal variant.
 * @cssprop --m3e-tonal-button-hover-unselected-icon-color - Hover unselected icon color, for the tonal variant.
 * @cssprop --m3e-tonal-button-hover-unselected-label-text-color - Hover unselected label color, for the tonal variant.
 * @cssprop --m3e-tonal-button-hover-unselected-state-layer-color - Hover unselected state layer color, for the tonal variant.
 * @cssprop --m3e-tonal-button-hover-selected-icon-color - Hover selected icon color, for the tonal variant.
 * @cssprop --m3e-tonal-button-hover-selected-label-text-color - Hover selected label color, for the tonal variant.
 * @cssprop --m3e-tonal-button-hover-selected-state-layer-color - Hover selected state layer color, for the tonal variant.
 * @cssprop --m3e-tonal-button-focus-icon-color - Focus icon color, for the tonal variant.
 * @cssprop --m3e-tonal-button-focus-label-text-color - Focus label color, for the tonal variant.
 * @cssprop --m3e-tonal-button-focus-state-layer-color - Focus state layer color, for the tonal variant.
 * @cssprop --m3e-tonal-button-focus-state-layer-opacity - Focus state layer opacity, for the tonal variant.
 * @cssprop --m3e-tonal-button-focus-container-elevation - Focus elevation, for the tonal variant.
 * @cssprop --m3e-tonal-button-focus-unselected-icon-color - Focus unselected icon color, for the tonal variant.
 * @cssprop --m3e-tonal-button-focus-unselected-label-text-color - Focus unselected label color, for the tonal variant.
 * @cssprop --m3e-tonal-button-focus-unselected-state-layer-color - Focus unselected state layer color, for the tonal variant.
 * @cssprop --m3e-tonal-button-focus-selected-icon-color - Focus selected icon color, for the tonal variant.
 * @cssprop --m3e-tonal-button-focus-selected-label-text-color - Focus selected label color, for the tonal variant.
 * @cssprop --m3e-tonal-button-focus-selected-state-layer-color - Focus selected state layer color, for the tonal variant.
 * @cssprop --m3e-tonal-button-pressed-icon-color - Pressed icon color, for the tonal variant.
 * @cssprop --m3e-tonal-button-pressed-label-text-color - Pressed label color, for the tonal variant.
 * @cssprop --m3e-tonal-button-pressed-state-layer-color - Pressed state layer color, for the tonal variant.
 * @cssprop --m3e-tonal-button-pressed-state-layer-opacity - Pressed state layer opacity, for the tonal variant.
 * @cssprop --m3e-tonal-button-pressed-container-elevation - Pressed elevation, for the tonal variant.
 * @cssprop --m3e-tonal-button-pressed-unselected-icon-color - Pressed unselected icon color, for the tonal variant.
 * @cssprop --m3e-tonal-button-pressed-unselected-label-text-color - Pressed unselected label color, for the tonal variant.
 * @cssprop --m3e-tonal-button-pressed-unselected-state-layer-color - Pressed unselected state layer color, for the tonal variant.
 * @cssprop --m3e-tonal-button-pressed-selected-icon-color - Pressed selected icon color, for the tonal variant.
 * @cssprop --m3e-tonal-button-pressed-selected-label-text-color - Pressed selected label color, for the tonal variant.
 * @cssprop --m3e-tonal-button-pressed-selected-state-layer-color - Pressed selected state layer color, for the tonal variant.
 * @cssprop --m3e-text-button-label-text-color - Label color, for the text variant.
 * @cssprop --m3e-text-button-icon-color - Icon color, for the text variant.
 * @cssprop --m3e-text-button-unselected-label-text-color - Unselected label color, for the text variant.
 * @cssprop --m3e-text-button-unselected-icon-color - Unselected icon color, for the text variant.
 * @cssprop --m3e-text-button-selected-label-text-color - Selected label color, for the text variant.
 * @cssprop --m3e-text-button-selected-icon-color - Selected icon color, for the text variant.
 * @cssprop --m3e-text-button-disabled-container-color - Disabled container color, for the text variant.
 * @cssprop --m3e-text-button-disabled-container-opacity - Disabled container opacity, for the text variant.
 * @cssprop --m3e-text-button-disabled-icon-color - Disabled icon color, for the text variant.
 * @cssprop --m3e-text-button-disabled-icon-opacity - Disabled icon opacity, for the text variant.
 * @cssprop --m3e-text-button-disabled-label-text-color - Disabled label color, for the text variant.
 * @cssprop --m3e-text-button-disabled-label-text-opacity - Disabled label opacity, for the text variant.
 * @cssprop --m3e-text-button-hover-icon-color - Hover icon color, for the text variant.
 * @cssprop --m3e-text-button-hover-label-text-color - Hover label color, for the text variant.
 * @cssprop --m3e-text-button-hover-state-layer-color - Hover state layer color, for the text variant.
 * @cssprop --m3e-text-button-hover-state-layer-opacity - Hover state layer opacity, for the text variant.
 * @cssprop --m3e-text-button-hover-unselected-icon-color - Hover unselected icon color, for the text variant.
 * @cssprop --m3e-text-button-hover-unselected-label-text-color - Hover unselected label color, for the text variant.
 * @cssprop --m3e-text-button-hover-unselected-state-layer-color - Hover unselected state layer color, for the text variant.
 * @cssprop --m3e-text-button-hover-selected-icon-color - Hover selected icon color, for the text variant.
 * @cssprop --m3e-text-button-hover-selected-label-text-color - Hover selected label color, for the text variant.
 * @cssprop --m3e-text-button-hover-selected-state-layer-color - Hover selected state layer color, for the text variant.
 * @cssprop --m3e-text-button-focus-icon-color - Focus icon color, for the text variant.
 * @cssprop --m3e-text-button-focus-label-text-color - Focus label color, for the text variant.
 * @cssprop --m3e-text-button-focus-state-layer-color - Focus state layer color, for the text variant.
 * @cssprop --m3e-text-button-focus-state-layer-opacity - Focus state layer opacity, for the text variant.
 * @cssprop --m3e-text-button-focus-unselected-icon-color - Focus unselected icon color, for the text variant.
 * @cssprop --m3e-text-button-focus-unselected-label-text-color - Focus unselected label color, for the text variant.
 * @cssprop --m3e-text-button-focus-unselected-state-layer-color - Focus unselected state layer color, for the text variant.
 * @cssprop --m3e-text-button-focus-selected-icon-color - Focus selected icon color, for the text variant.
 * @cssprop --m3e-text-button-focus-selected-label-text-color - Focus selected label color, for the text variant.
 * @cssprop --m3e-text-button-focus-selected-state-layer-color - Focus selected state layer color, for the text variant.
 * @cssprop --m3e-text-button-pressed-icon-color - Pressed icon color, for the text variant.
 * @cssprop --m3e-text-button-pressed-label-text-color - Pressed label color, for the text variant.
 * @cssprop --m3e-text-button-pressed-state-layer-color - Pressed state layer color, for the text variant.
 * @cssprop --m3e-text-button-pressed-state-layer-opacity - Pressed state layer opacity, for the text variant.
 * @cssprop --m3e-text-button-pressed-unselected-icon-color - Pressed unselected icon color, for the text variant.
 * @cssprop --m3e-text-button-pressed-unselected-label-text-color - Pressed unselected label color, for the text variant.
 * @cssprop --m3e-text-button-pressed-unselected-state-layer-color - Pressed unselected state layer color, for the text variant.
 * @cssprop --m3e-text-button-pressed-selected-icon-color - Pressed selected icon color, for the text variant.
 * @cssprop --m3e-text-button-pressed-selected-label-text-color - Pressed selected label color, for the text variant.
 * @cssprop --m3e-text-button-pressed-selected-state-layer-color - Pressed selected state layer color, for the text variant.
 */ let $207ea8a68f1aa848$export$df1260532f1fcc98 = class M3eButtonElement extends (0, $ca7aa15aa0ba1e7b$export$d564d59935f4debe)((0, $ca7aa15aa0ba1e7b$export$29d11c0fe2fc51d8)((0, $ca7aa15aa0ba1e7b$export$f7d03dabd73ead6b)((0, $ca7aa15aa0ba1e7b$export$35a3bebf7ef2d934)((0, $ca7aa15aa0ba1e7b$export$3d1d3384b4efc6c3)((0, $ca7aa15aa0ba1e7b$export$9a986b15f53d6d10)((0, $ca7aa15aa0ba1e7b$export$282c9fa792fbac93)((0, $ca7aa15aa0ba1e7b$export$46919bad18fb2f76)((0, $fa29e5b5c67837a0$export$3f2f9f5909897157), "button"), true))))))) {
    constructor(){
        super();
        $207ea8a68f1aa848$var$_M3eButtonElement_instances.add(this);
        /** @private */ $207ea8a68f1aa848$var$_M3eButtonElement_clickHandler.set(this, (e)=>(0, $gkQP3.__classPrivateFieldGet)(this, $207ea8a68f1aa848$var$_M3eButtonElement_instances, "m", $207ea8a68f1aa848$var$_M3eButtonElement_handleClick).call(this, e));
        /**
     * The appearance variant of the button.
     * @default "text"
     */ this.variant = "text";
        /**
     * The shape of the button.
     * @default "rounded"
     */ this.shape = "rounded";
        /**
     * The size of the button.
     * @default "small"
     */ this.size = "small";
        /**
     * Whether the button will toggle between selected and unselected states.
     * @default false
     */ this.toggle = false;
        /**
     * Whether the toggle button is selected.
     * @default false
     */ this.selected = false;
        new (0, $ca7aa15aa0ba1e7b$export$8ba29cfbcbd8efc8)(this, {
            callback: ()=>{
                if (this.grouped) this._handleResize();
            }
        });
        new (0, $ca7aa15aa0ba1e7b$export$766c876d58dec02e)(this, {
            callback: (focused)=>{
                if (!this.disabledInteractive && !focused && !this.grouped) this._base?.style.removeProperty("--_button-shape");
            }
        });
        new (0, $ca7aa15aa0ba1e7b$export$1351ab2eef382c23)(this, {
            isPressedKey: (key)=>key === " ",
            minPressedDuration: 150,
            callback: (pressed)=>{
                if (!this.disabled && !this.disabledInteractive) {
                    if (pressed) {
                        (0, $gkQP3.__classPrivateFieldGet)(this, $207ea8a68f1aa848$var$_M3eButtonElement_instances, "m", $207ea8a68f1aa848$var$_M3eButtonElement_updateButtonShape).call(this);
                        if ((0, $ca7aa15aa0ba1e7b$export$ff7706047246b98b)()) (0, $gkQP3.__classPrivateFieldGet)(this, $207ea8a68f1aa848$var$_M3eButtonElement_instances, "m", $207ea8a68f1aa848$var$_M3eButtonElement_handlePressedChange).call(this, true);
                        else requestAnimationFrame(()=>(0, $gkQP3.__classPrivateFieldGet)(this, $207ea8a68f1aa848$var$_M3eButtonElement_instances, "m", $207ea8a68f1aa848$var$_M3eButtonElement_handlePressedChange).call(this, true));
                    } else (0, $gkQP3.__classPrivateFieldGet)(this, $207ea8a68f1aa848$var$_M3eButtonElement_instances, "m", $207ea8a68f1aa848$var$_M3eButtonElement_handlePressedChange).call(this, false);
                }
            }
        });
    }
    /** Whether the button is contained by a button group. */ get grouped() {
        return (0, $ca7aa15aa0ba1e7b$export$6bae5520ca265d22)(this, "-grouped");
    }
    /** @inheritdoc */ render() {
        return (0, $00a10a29322bb2a1$export$c0bb0b647f701bb5)`<div class="base"><m3e-elevation class="elevation" ?disabled="${this.disabled || this.disabledInteractive}"></m3e-elevation><m3e-state-layer class="state-layer" ?disabled="${this.disabled || this.disabledInteractive}"></m3e-state-layer><m3e-focus-ring class="focus-ring" ?disabled="${this.disabled}"></m3e-focus-ring><m3e-ripple class="ripple" ?disabled="${this.disabled || this.disabledInteractive}"></m3e-ripple><div class="touch" aria-hidden="true"></div>${this[0, $ca7aa15aa0ba1e7b$export$6118a8e97d251010]()}<div class="wrapper">${this.toggle ? (0, $00a10a29322bb2a1$export$c0bb0b647f701bb5)`<slot class="icon" name="selected-icon" aria-hidden="true" @slotchange="${(0, $gkQP3.__classPrivateFieldGet)(this, $207ea8a68f1aa848$var$_M3eButtonElement_instances, "m", $207ea8a68f1aa848$var$_M3eButtonElement_handleSelectedIconSlotChange)}"></slot>` : (0, $00a10a29322bb2a1$export$45b790e32b2810ee)}<slot class="icon" name="icon" aria-hidden="true"></slot><div class="label">${this.toggle && this.selected ? (0, $00a10a29322bb2a1$export$c0bb0b647f701bb5)`<slot name="selected"><slot></slot></slot>` : (0, $00a10a29322bb2a1$export$c0bb0b647f701bb5)`<slot></slot>`}</div><slot class="icon" name="trailing-icon" aria-hidden="true"></slot></div></div>`;
    }
    /** @inheritdoc */ connectedCallback() {
        super.connectedCallback();
        this.addEventListener("click", (0, $gkQP3.__classPrivateFieldGet)(this, $207ea8a68f1aa848$var$_M3eButtonElement_clickHandler, "f"));
    }
    /** @inheritdoc */ disconnectedCallback() {
        super.disconnectedCallback();
        [
            "-pressed",
            "-resting",
            "-grouped",
            "-connected"
        ].forEach((x)=>(0, $ca7aa15aa0ba1e7b$export$eda34dc61103d62e)(this, x));
        this._base?.style.removeProperty("--_button-shape");
        this.style.removeProperty("--_button-width");
        this.style.removeProperty("--_adjacent-button-width");
        (0, $ca7aa15aa0ba1e7b$export$eda34dc61103d62e)(this, "-adjacent-pressed");
        this.removeEventListener("click", (0, $gkQP3.__classPrivateFieldGet)(this, $207ea8a68f1aa848$var$_M3eButtonElement_clickHandler, "f"));
    }
    /** @inheritdoc */ firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);
        [
            this._elevation,
            this._focusRing,
            this._stateLayer,
            this._ripple
        ].forEach((x)=>x?.attach(this));
    }
    /** @inheritdoc */ updated(_changedProperties) {
        super.updated(_changedProperties);
        if (_changedProperties.has("disabled") && this.disabled || _changedProperties.has("disabledInteractive") && this.disabledInteractive) {
            (0, $ca7aa15aa0ba1e7b$export$eda34dc61103d62e)(this, "-pressed");
            (0, $ca7aa15aa0ba1e7b$export$eda34dc61103d62e)(this, "-resting");
        }
        if (_changedProperties.has("toggle") || _changedProperties.has("selected")) {
            this.ariaPressed = this.toggle ? `${this.selected}` : null;
            if (this.toggle) for (const icon of this.querySelectorAll("m3e-icon"))icon.toggleAttribute("filled", this.selected);
        }
    }
    /** @private */ _handleResize() {
        if (this.grouped && !(0, $ca7aa15aa0ba1e7b$export$6bae5520ca265d22)(this, "-pressed")) {
            this.style.setProperty("--_button-width", `${this.clientWidth}px`);
            (0, $gkQP3.__classPrivateFieldGet)(this, $207ea8a68f1aa848$var$_M3eButtonElement_instances, "m", $207ea8a68f1aa848$var$_M3eButtonElement_updateButtonShape).call(this, true);
        }
    }
};
$207ea8a68f1aa848$var$_M3eButtonElement_clickHandler = new WeakMap();
$207ea8a68f1aa848$var$_M3eButtonElement_instances = new WeakSet();
$207ea8a68f1aa848$var$_M3eButtonElement_handleClick = function _M3eButtonElement_handleClick(e) {
    if (this.disabled || this.disabledInteractive) {
        e.preventDefault();
        e.stopImmediatePropagation();
    }
    if (this.toggle && !e.defaultPrevented) {
        this.selected = !this.selected;
        // Dispatch an input event and if not prevented, dispatch a change event.
        // Otherwise, reset the selected state.
        if (this.dispatchEvent(new Event("input", {
            bubbles: true,
            composed: true,
            cancelable: true
        }))) this.dispatchEvent(new Event("change", {
            bubbles: true
        }));
        else this.selected = !this.selected;
    }
};
$207ea8a68f1aa848$var$_M3eButtonElement_handleSelectedIconSlotChange = function _M3eButtonElement_handleSelectedIconSlotChange(e) {
    this._base?.classList.toggle("with-selected-icon", (0, $ca7aa15aa0ba1e7b$export$e0478d61fdced58c)(e.target));
};
$207ea8a68f1aa848$var$_M3eButtonElement_updateButtonShape = function _M3eButtonElement_updateButtonShape(force = false) {
    if (!this._base) return;
    const shape = parseFloat(getComputedStyle(this._base).borderRadius);
    if (!isNaN(shape) || force) {
        const adjustedShape = this.clientHeight / 2;
        if (adjustedShape < shape || force) this._base?.style.setProperty("--_button-shape", `${adjustedShape}px`);
    }
};
$207ea8a68f1aa848$var$_M3eButtonElement_handlePressedChange = function _M3eButtonElement_handlePressedChange(pressed) {
    (0, $ca7aa15aa0ba1e7b$export$a6b7fbc1acf03e5b)(this, "-pressed", pressed);
    (0, $ca7aa15aa0ba1e7b$export$a6b7fbc1acf03e5b)(this, "-resting", !pressed);
    const group = this.closest("m3e-button-group");
    if (group) {
        const clientWidth = this.getBoundingClientRect().width;
        const buttons = [
            ...group.querySelectorAll("m3e-button,m3e-icon-button")
        ];
        const index = buttons.indexOf(this);
        for(let i = 0; i < buttons.length; i++){
            const button = buttons[i];
            if (i === index - 1) {
                button.style.setProperty("--_adjacent-button-width", `${clientWidth}px`);
                (0, $ca7aa15aa0ba1e7b$export$a6b7fbc1acf03e5b)(button, "-adjacent-pressed", pressed);
            } else if (i === index + 1) {
                button.style.setProperty("--_adjacent-button-width", `${clientWidth}px`);
                (0, $ca7aa15aa0ba1e7b$export$a6b7fbc1acf03e5b)(button, "-adjacent-pressed", pressed);
            } else {
                button.style.removeProperty("--_adjacent-button-width");
                (0, $ca7aa15aa0ba1e7b$export$eda34dc61103d62e)(button, "-adjacent-pressed");
            }
        }
    }
};
/** The styles of the element. */ $207ea8a68f1aa848$export$df1260532f1fcc98.styles = [
    $207ea8a68f1aa848$var$ButtonSizeStyle,
    $207ea8a68f1aa848$var$ButtonVariantStyle,
    $207ea8a68f1aa848$var$ButtonStyle
];
(0, $gkQP3.__decorate)([
    (0, $540200038ed52347$export$2fa187e846a241c4)(".base")
], $207ea8a68f1aa848$export$df1260532f1fcc98.prototype, "_base", void 0);
(0, $gkQP3.__decorate)([
    (0, $540200038ed52347$export$2fa187e846a241c4)(".elevation")
], $207ea8a68f1aa848$export$df1260532f1fcc98.prototype, "_elevation", void 0);
(0, $gkQP3.__decorate)([
    (0, $540200038ed52347$export$2fa187e846a241c4)(".focus-ring")
], $207ea8a68f1aa848$export$df1260532f1fcc98.prototype, "_focusRing", void 0);
(0, $gkQP3.__decorate)([
    (0, $540200038ed52347$export$2fa187e846a241c4)(".state-layer")
], $207ea8a68f1aa848$export$df1260532f1fcc98.prototype, "_stateLayer", void 0);
(0, $gkQP3.__decorate)([
    (0, $540200038ed52347$export$2fa187e846a241c4)(".ripple")
], $207ea8a68f1aa848$export$df1260532f1fcc98.prototype, "_ripple", void 0);
(0, $gkQP3.__decorate)([
    (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
        reflect: true
    })
], $207ea8a68f1aa848$export$df1260532f1fcc98.prototype, "variant", void 0);
(0, $gkQP3.__decorate)([
    (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
        reflect: true
    })
], $207ea8a68f1aa848$export$df1260532f1fcc98.prototype, "shape", void 0);
(0, $gkQP3.__decorate)([
    (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
        reflect: true
    })
], $207ea8a68f1aa848$export$df1260532f1fcc98.prototype, "size", void 0);
(0, $gkQP3.__decorate)([
    (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $207ea8a68f1aa848$export$df1260532f1fcc98.prototype, "toggle", void 0);
(0, $gkQP3.__decorate)([
    (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $207ea8a68f1aa848$export$df1260532f1fcc98.prototype, "selected", void 0);
(0, $gkQP3.__decorate)([
    (0, $ca7aa15aa0ba1e7b$export$61fc7d43ac8f84b0)(40)
], $207ea8a68f1aa848$export$df1260532f1fcc98.prototype, "_handleResize", null);
$207ea8a68f1aa848$export$df1260532f1fcc98 = (0, $gkQP3.__decorate)([
    (0, $ca7aa15aa0ba1e7b$export$da64fc29f17f9d0e)("m3e-button")
], $207ea8a68f1aa848$export$df1260532f1fcc98);


/**
 * @license MIT
 * Copyright (c) 2025–2026 matraic
 * See LICENSE file in the project root for full license text.
 */ 
var $gkQP3 = parcelRequire("gkQP3");



/**
 * Component design tokens for `M3eCardElement`.
 * @internal
 */ const $d75e28d33e9acdba$var$CardToken = {
    padding: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--m3e-card-padding, 1rem)"),
    shape: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-card-shape, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).shape.corner.medium});`)
};
/**
 * Component design tokens that control the appearance variants of `M3eCardElement`.
 * @internal
 */ const $d75e28d33e9acdba$var$CardVariantToken = {
    filled: {
        textColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-card-text-color, var(--m3e-card-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
        containerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-card-container-color, var(--m3e-card-container-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.surfaceContainerHighest}))`),
        containerElevation: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-card-container-elevation, var(--m3e-card-container-elevation, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).elevation.level0}))`),
        disabled: {
            textColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-card-disabled-text-color, var(--m3e-card-disabled-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
            textOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-card-disabled-text-opacity, var(--m3e-card-disabled-text-opacity, 38%))`),
            imageOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-card-disabled-image-opacity, var(--m3e-card-disabled-image-opacity, 38%))`),
            containerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-card-disabled-container-color, var(--m3e-card-disabled-container-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.surfaceVariant}))`),
            containerElevation: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-card-disabled-container-elevation, var(--m3e-card-disabled-container-elevation, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).elevation.level0}))`),
            containerElevationColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-card-disabled-container-elevation-color, var(--m3e-card-disabled-container-elevation-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
            containerElevationOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-card-disabled-container-elevation-opacity, var(--m3e-card-disabled-container-elevation-opacity, 38%))`),
            containerOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-card-disabled-container-opacity, var(--m3e-card-disabled-container-opacity, 38%))`)
        },
        hover: {
            textColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-card-hover-text-color, var(--m3e-card-hover-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
            stateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-card-hover-state-layer-color, var(--m3e-card-hover-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
            stateLayerOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-card-hover-state-layer-opacity, var(--m3e-card-hover-state-layer-opacity, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).state.hoverStateLayerOpacity}))`),
            containerElevation: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-card-hover-container-elevation, var(--m3e-card-hover-container-elevation, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).elevation.level1}))`)
        },
        focus: {
            textColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-card-focus-text-color, var(--m3e-card-focus-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
            stateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-card-focus-state-layer-color, var(--m3e-card-focus-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
            stateLayerOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-card-focus-state-layer-opacity, var(--m3e-card-focus-state-layer-opacity, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).state.focusStateLayerOpacity}))`),
            containerElevation: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-card-focus-container-elevation, var(--m3e-card-focus-container-elevation, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).elevation.level0}))`)
        },
        pressed: {
            textColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-card-pressed-text-color, var(--m3e-card-pressed-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
            stateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-card-pressed-state-layer-color, var(--m3e-card-pressed-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
            stateLayerOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-card-pressed-state-layer-opacity, var(--m3e-card-pressed-state-layer-opacity, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).state.pressedStateLayerOpacity}))`),
            containerElevation: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-filled-card-pressed-container-elevation, var(--m3e-card-pressed-container-elevation, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).elevation.level0}))`)
        }
    },
    elevated: {
        textColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-card-text-color, var(--m3e-card-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
        containerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-card-container-color, var(--m3e-card-container-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.surfaceContainerLow}))`),
        containerElevation: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-card-container-elevation, var(--m3e-card-container-elevation, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).elevation.level1}))`),
        disabled: {
            textColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-card-disabled-text-color, var(--m3e-card-disabled-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
            textOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-card-disabled-text-opacity, var(--m3e-card-disabled-text-opacity, 38%))`),
            imageOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-card-disabled-image-opacity, var(--m3e-card-disabled-image-opacity, 38%))`),
            containerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-card-disabled-container-color, var(--m3e-card-disabled-container-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.surface}))`),
            containerElevation: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-card-disabled-container-elevation, var(--m3e-card-disabled-container-elevation, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).elevation.level1}))`),
            containerElevationColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-card-disabled-container-elevation-color, var(--m3e-card-disabled-container-elevation-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
            containerElevationOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-card-disabled-container-elevation-opacity, var(--m3e-card-disabled-container-elevation-opacity, 38%))`),
            containerOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-card-disabled-container-opacity, var(--m3e-card-disabled-container-opacity, 38%))`)
        },
        hover: {
            textColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-card-hover-text-color, var(--m3e-card-hover-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
            stateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-card-hover-state-layer-color, var(--m3e-card-hover-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
            stateLayerOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-card-hover-state-layer-opacity, var(--m3e-card-hover-state-layer-opacity, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).state.hoverStateLayerOpacity}))`),
            containerElevation: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-card-hover-container-elevation, var(--m3e-card-hover-container-elevation, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).elevation.level2}))`)
        },
        focus: {
            textColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-card-focus-text-color, var(--m3e-card-focus-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
            stateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-card-focus-state-layer-color, var(--m3e-card-focus-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
            stateLayerOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-card-focus-state-layer-opacity, var(--m3e-card-focus-state-layer-opacity, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).state.focusStateLayerOpacity}))`),
            containerElevation: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-card-focus-container-elevation, var(--m3e-card-focus-container-elevation, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).elevation.level1}))`)
        },
        pressed: {
            textColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-card-pressed-text-color, var(--m3e-card-pressed-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
            stateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-card-pressed-state-layer-color, var(--m3e-card-pressed-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
            stateLayerOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-card-pressed-state-layer-opacity, var(--m3e-card-pressed-state-layer-opacity, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).state.pressedStateLayerOpacity}))`),
            containerElevation: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-elevated-card-pressed-container-elevation, var(--m3e-card-pressed-container-elevation, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).elevation.level1}))`)
        }
    },
    outlined: {
        textColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-card-text-color, var(--m3e-card-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
        containerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-card-container-color, var(--m3e-card-container-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.surface}))`),
        containerElevation: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-card-container-elevation, var(--m3e-card-container-elevation, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).elevation.level0}))`),
        outlineColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-card-outline-color, var(--m3e-card-outline-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.outlineVariant}))`),
        outlineThickness: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("var(--m3e-outlined-card-outline-thickness, var(--m3e-card-outline-thickness, 1px))"),
        disabled: {
            textColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-card-disabled-text-color, var(--m3e-card-disabled-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
            textOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-card-disabled-text-opacity, var(--m3e-card-disabled-text-opacity, 38%))`),
            imageOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-card-disabled-image-opacity, var(--m3e-card-disabled-image-opacity, 38%))`),
            containerElevation: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-card-disabled-container-elevation, var(--m3e-card-disabled-container-elevation, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).elevation.level0}))`),
            containerElevationColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-card-disabled-container-elevation-color, var(--m3e-card-disabled-container-elevation-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
            containerElevationOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-card-disabled-container-elevation-opacity, var(--m3e-card-disabled-container-elevation-opacity, 38%))`),
            outlineColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-card-disabled-outline-color, var(--m3e-card-disabled-outline-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.outline}))`),
            outlineOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-card-disabled-outline-opacity, var(--m3e-card-disabled-outline-opacity, 12%))`)
        },
        hover: {
            textColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-card-hover-text-color, var(--m3e-card-hover-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
            stateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-card-hover-state-layer-color, var(--m3e-card-hover-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
            stateLayerOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-card-hover-state-layer-opacity, var(--m3e-card-hover-state-layer-opacity, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).state.hoverStateLayerOpacity}))`),
            containerElevation: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-card-hover-container-elevation, var(--m3e-card-hover-container-elevation, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).elevation.level1}))`),
            outlineColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-card-hover-outline-color, var(--m3e-card-hover-outline-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.outlineVariant}))`)
        },
        focus: {
            textColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-card-focus-text-color, var(--m3e-card-focus-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
            stateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-card-focus-state-layer-color, var(--m3e-card-focus-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
            stateLayerOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-card-focus-state-layer-opacity, var(--m3e-card-focus-state-layer-opacity, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).state.focusStateLayerOpacity}))`),
            containerElevation: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-card-focus-container-elevation, var(--m3e-card-focus-container-elevation, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).elevation.level0}))`),
            outlineColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-card-focus-outline-color, var(--m3e-card-focus-outline-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`)
        },
        pressed: {
            textColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-card-pressed-text-color, var(--m3e-card-pressed-text-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
            stateLayerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-card-pressed-state-layer-color, var(--m3e-card-pressed-state-layer-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onSurface}))`),
            stateLayerOpacity: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-card-pressed-state-layer-opacity, var(--m3e-card-pressed-state-layer-opacity, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).state.pressedStateLayerOpacity}))`),
            containerElevation: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-card-pressed-container-elevation, var(--m3e-card-pressed-container-elevation, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).elevation.level0}))`),
            outlineColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-outlined-card-pressed-outline-color, var(--m3e-card-pressed-outline-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.outlineVariant}))`)
        }
    }
};
/**
 * Baseline styles for `M3eCardElement`.
 * @internal
 */ const $d75e28d33e9acdba$var$CardStyle = (0, $fbf856437f99196f$export$dbf350e5966cf602)`:host { outline: none; } :host(:not([inline])) { display: block; } :host(:not([inline])) .base { display: flex; } :host([inline]) { display: inline-block; vertical-align: middle; } :host([inline]) .base { display: inline-flex; } .base { width: 100%; height: 100%; position: relative; box-sizing: border-box; border-radius: ${$d75e28d33e9acdba$var$CardToken.shape}; transition: ${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`background-color ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).motion.duration.short4} ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).motion.easing.standard},
      border-color ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).motion.duration.short4} ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).motion.easing.standard}`)}; } :host([actionable]) { user-select: none; -webkit-tap-highlight-color: rgba(0, 0, 0, 0); } :host([actionable]:not(:disabled):not([disabled-interactive])) { cursor: pointer; } :host([actionable][disabled-interactive]) { cursor: not-allowed; } :host(:not([actionable])) .focus-ring, :host(:not([actionable])) .state-layer, :host(:not([actionable])) .ripple { display: none; } :host([variant="outlined"]) .base { border-style: solid; } ::slotted([slot="content"]) { flex: 1 1 auto; } ::slotted(img), ::slotted(video) { inset: 0; object-fit: cover; } ::slotted(img[slot="header"]), ::slotted(video[slot="header"]) { border-radius: ${$d75e28d33e9acdba$var$CardToken.shape}; } ::slotted([slot="actions"][end]) { justify-content: flex-end; } ::slotted([slot="header"]), ::slotted([slot="actions"]), ::slotted([slot="footer"]) { flex: none; display: flex; align-items: center; } :host([orientation="vertical"]) .base, :host([orientation="horizontal"]) ::slotted([slot="header"]), :host([orientation="horizontal"]) ::slotted([slot="actions"]), :host([orientation="horizontal"]) ::slotted([slot="footer"]) { flex-direction: column; } :host([orientation="horizontal"]) .base, :host([orientation="vertical"]) ::slotted([slot="header"]), :host([orientation="vertical"]) ::slotted([slot="actions"]), :host([orientation="vertical"]) ::slotted([slot="footer"]) { flex-direction: row; } :host([orientation="horizontal"]) ::slotted(img), :host([orientation="horizontal"]) ::slotted(video) { aspect-ratio: 16 / 9; } .has-content:not(.has-default) slot[name="content"], .has-content.has-default slot:not([name]) { display: inherit; flex-direction: inherit; flex: 1 1 auto; } .has-header slot[name="header"], .has-actions slot[name="actions"], .has-footer slot[name="footer"] { display: inherit; flex-direction: inherit; flex: none; } :host([orientation="vertical"]) .has-content:not(.has-default) slot[name="content"] { margin-inline: ${$d75e28d33e9acdba$var$CardToken.padding}; } :host([orientation="vertical"]) .has-content:not(.has-default):not(.has-header) slot[name="content"] { margin-block-start: ${$d75e28d33e9acdba$var$CardToken.padding}; } :host([orientation="vertical"]) .has-content:not(.has-default):not(.has-actions):not(.has-footer) slot[name="content"] { margin-block-end: ${$d75e28d33e9acdba$var$CardToken.padding}; } :host([orientation="horizontal"]) .has-content:not(.has-default) slot[name="content"] { margin-block: ${$d75e28d33e9acdba$var$CardToken.padding}; } :host([orientation="horizontal"]) .has-content:not(.has-default):not(.has-header) slot[name="content"] { margin-inline-start: ${$d75e28d33e9acdba$var$CardToken.padding}; } :host([orientation="horizontal"]) .has-content:not(.has-default):not(.has-actions):not(.has-footer) slot[name="content"] { margin-inline-end: ${$d75e28d33e9acdba$var$CardToken.padding}; } :host([orientation="vertical"]) .has-header:not(.has-header-media) slot[name="header"] { margin-inline: ${$d75e28d33e9acdba$var$CardToken.padding}; margin-block-start: ${$d75e28d33e9acdba$var$CardToken.padding}; } :host([orientation="horizontal"]) .has-header:not(.has-header-media) slot[name="header"] { margin-inline-start: ${$d75e28d33e9acdba$var$CardToken.padding}; margin-block: ${$d75e28d33e9acdba$var$CardToken.padding}; } .has-actions slot[name="actions"] { margin-inline: ${$d75e28d33e9acdba$var$CardToken.padding}; margin-block: ${$d75e28d33e9acdba$var$CardToken.padding}; } :host([orientation="vertical"]) .has-footer slot[name="footer"] { margin-inline: ${$d75e28d33e9acdba$var$CardToken.padding}; margin-block-end: ${$d75e28d33e9acdba$var$CardToken.padding}; } :host([orientation="horizontal"]) .has-footer slot[name="footer"] { margin-block: ${$d75e28d33e9acdba$var$CardToken.padding}; margin-inline-end: ${$d75e28d33e9acdba$var$CardToken.padding}; } a { all: unset; display: block; position: absolute; top: 0px; left: 0px; right: 0px; bottom: 0px; z-index: 1; } @media (forced-colors: active) { .base { transition: none; } :host([variant]) .base { border-style: solid; border-color: CanvasText; border-width: ${$d75e28d33e9acdba$var$CardVariantToken.outlined.outlineThickness ?? (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("unset")}; } :host([actionable][variant]:disabled) .base, :host([actionable][variant][disabled-interactive]) .base { color: GrayText; border-color: GrayText; } } @media (prefers-reduced-motion) { .base { transition: none; } }`;
/** @private */ function $d75e28d33e9acdba$var$cardVariantStyle(variant) {
    return (0, $fbf856437f99196f$export$dbf350e5966cf602)`:host([variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"]) .base { background-color: ${$d75e28d33e9acdba$var$CardVariantToken[variant].containerColor ?? (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("unset")}; box-shadow: ${$d75e28d33e9acdba$var$CardVariantToken[variant].containerElevation ?? (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("unset")}; border-width: ${$d75e28d33e9acdba$var$CardVariantToken[variant].outlineThickness ?? (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("unset")}; } :host([actionable][variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"]) .base { --m3e-state-layer-hover-color: ${$d75e28d33e9acdba$var$CardVariantToken[variant].hover.stateLayerColor}; --m3e-state-layer-hover-opacity: ${$d75e28d33e9acdba$var$CardVariantToken[variant].hover.stateLayerOpacity}; --m3e-state-layer-focus-color: ${$d75e28d33e9acdba$var$CardVariantToken[variant].focus.stateLayerColor}; --m3e-state-layer-focus-opacity: ${$d75e28d33e9acdba$var$CardVariantToken[variant].focus.stateLayerOpacity}; --m3e-ripple-color: ${$d75e28d33e9acdba$var$CardVariantToken[variant].pressed.stateLayerColor}; --m3e-ripple-opacity: ${$d75e28d33e9acdba$var$CardVariantToken[variant].pressed.stateLayerOpacity}; --m3e-elevation-level: ${$d75e28d33e9acdba$var$CardVariantToken[variant].containerElevation ?? (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("unset")}; --m3e-elevation-hover-level: ${$d75e28d33e9acdba$var$CardVariantToken[variant].hover.containerElevation ?? (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("unset")}; --m3e-elevation-focus-level: ${$d75e28d33e9acdba$var$CardVariantToken[variant].focus.containerElevation ?? (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("unset")}; --m3e-elevation-pressed-level: ${$d75e28d33e9acdba$var$CardVariantToken[variant].pressed.containerElevation ?? (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("unset")}; } :host([variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"]) .base { border-color: ${$d75e28d33e9acdba$var$CardVariantToken[variant].outlineColor ?? (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("unset")}; } :host([actionable][variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"]:focus .base) { border-color: ${$d75e28d33e9acdba$var$CardVariantToken[variant].focus.outlineColor ?? (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("unset")}; } :host([actionable][variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"]:hover .base) { border-color: ${$d75e28d33e9acdba$var$CardVariantToken[variant].hover.outlineColor ?? (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("unset")}; } :host([actionable][variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"]) .base.pressed { border-color: ${$d75e28d33e9acdba$var$CardVariantToken[variant].pressed.outlineColor ?? (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("unset")}; } :host([variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"]) .base { color: ${$d75e28d33e9acdba$var$CardVariantToken[variant].textColor ?? (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("unset")}; } :host([actionable][variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"]:focus) .base { color: ${$d75e28d33e9acdba$var$CardVariantToken[variant].focus.textColor ?? (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("unset")}; } :host([actionable][variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"]:hover) .base { color: ${$d75e28d33e9acdba$var$CardVariantToken[variant].hover.textColor ?? (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("unset")}; } :host([actionable][variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"]) .base.pressed { color: ${$d75e28d33e9acdba$var$CardVariantToken[variant].pressed.textColor ?? (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("unset")}; } :host([actionable][variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"]:disabled) .base, :host([actionable][variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"][disabled-interactive]) .base { --m3e-elevation-level: ${$d75e28d33e9acdba$var$CardVariantToken[variant].disabled.containerElevation ?? (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("unset")}; --m3e-elevation-color: color-mix( in srgb, ${$d75e28d33e9acdba$var$CardVariantToken[variant].disabled.containerElevationColor} ${$d75e28d33e9acdba$var$CardVariantToken[variant].disabled.containerElevationOpacity}, transparent ); color: color-mix( in srgb, ${$d75e28d33e9acdba$var$CardVariantToken[variant].disabled.textColor} ${$d75e28d33e9acdba$var$CardVariantToken[variant].disabled.textOpacity}, transparent ); background-color: ${$d75e28d33e9acdba$var$CardVariantToken[variant].disabled.containerColor && $d75e28d33e9acdba$var$CardVariantToken[variant].disabled.containerOpacity ? (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`color-mix(
        in srgb,
        ${$d75e28d33e9acdba$var$CardVariantToken[variant].disabled.containerColor} ${$d75e28d33e9acdba$var$CardVariantToken[variant].disabled.containerOpacity},
        transparent
      )`) : (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("unset")}; border-color: ${$d75e28d33e9acdba$var$CardVariantToken[variant].disabled.outlineColor && $d75e28d33e9acdba$var$CardVariantToken[variant].disabled.outlineOpacity ? (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`color-mix(
        in srgb,
        ${$d75e28d33e9acdba$var$CardVariantToken[variant].disabled.outlineColor} ${$d75e28d33e9acdba$var$CardVariantToken[variant].disabled.outlineOpacity},
        transparent
      )`) : (0, $fbf856437f99196f$export$8d80f9cac07cdb3)("unset")}; } :host([actionable][variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"]:disabled) ::slotted(img), :host([actionable][variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"][disabled-interactive]) ::slotted(img), :host([actionable][variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"]:disabled) ::slotted(video), :host([actionable][variant="${(0, $fbf856437f99196f$export$8d80f9cac07cdb3)(variant)}"][disabled-interactive]) ::slotted(video) { opacity: ${$d75e28d33e9acdba$var$CardVariantToken[variant].disabled.imageOpacity}; }`;
}
/**
 * Appearance variant styles for `M3eCardElement`.
 * @internal
 */ const $d75e28d33e9acdba$var$CardVariantStyle = [
    $d75e28d33e9acdba$var$cardVariantStyle("filled"),
    $d75e28d33e9acdba$var$cardVariantStyle("elevated"),
    $d75e28d33e9acdba$var$cardVariantStyle("outlined")
];
var $d75e28d33e9acdba$var$_M3eCardElement_instances, $d75e28d33e9acdba$var$_M3eCardElement_clickHandler, $d75e28d33e9acdba$var$_M3eCardElement_handleHeaderSlotChange, $d75e28d33e9acdba$var$_M3eCardElement_handleContentSlotChange, $d75e28d33e9acdba$var$_M3eCardElement_handleDefaultSlotChange, $d75e28d33e9acdba$var$_M3eCardElement_handleActionsSlotChange, $d75e28d33e9acdba$var$_M3eCardElement_handleFooterSlotChange, $d75e28d33e9acdba$var$_M3eCardElement_handleClick;
/**
 * A content container for text, images (or other media), and actions in the context of a single subject.
 *
 * @description
 * The `m3e-card` component is a flexible, expressive container for presenting a unified subject—text,
 * media, and actions—on a visually distinct surface. It supports multiple appearance variants via the
 * `variant` attribute: `filled` (default, for solid emphasis), `outlined` (for subtle framing with a border),
 * and `elevated` (for depth and motion with shadow elevation).
 *
 * Cards can be made actionable, responding to user interaction when the `actionable` attribute is set, and can be
 * presented inline with surrounding content using the `inline` attribute.
 *
 * It supports both vertical and horizontal layouts through the `orientation` attribute. Content organization is
 * enabled via dedicated slots for `header`, `content`, `actions`, and `footer`, or developers can use the default
 * slot for custom layouts.
 *
 * The component provides dynamic elevation, adaptive shape, and expressive color theming, and responds to interaction states
 * (hover, focus, press, disabled) with smooth motion and visual feedback, ensuring clarity, accessibility,
 * and a cohesive user experience in accordance with Material Design 3 guidelines.
 *
 * @example
 * The following example illustrates each of the dedicated slots of a card.
 * ```html
 * <m3e-card>
 *  <div slot="header">Header section</div>
 *  <div slot="content">Content section</div>
 *  <div slot="actions">Actions section</div>
 *  <div slot="footer">Footer section</div>
 * </m3e-card>
 * ```
 *
 * @tag m3e-card
 *
 * @slot - Renders the content of the card without padding.
 * @slot header - Renders the header of the card.
 * @slot content - Renders the content of the card with padding.
 * @slot actions - Renders the actions of the card.
 * @slot footer - Renders the footer of the card.
 *
 * @attr actionable - Whether the card is "actionable" and will respond to use interaction.
 * @attr inline - Whether to present the card inline with surrounding content.
 * @attr orientation - The orientation of the card.
 * @attr variant - The appearance variant of the card.
 *
 * @fires click - Emitted when the element is clicked.
 *
 * @cssprop --m3e-card-padding - Internal spacing for all slotted regions
 * @cssprop --m3e-card-shape - Corner radius of the card container.
 * @cssprop --m3e-filled-card-text-color - Foreground color for text content in filled cards.
 * @cssprop --m3e-filled-card-container-color - Background color of the filled card container.
 * @cssprop --m3e-filled-card-container-elevation - Elevation level for filled card container.
 * @cssprop --m3e-filled-card-disabled-text-color - Text color when filled card is disabled.
 * @cssprop --m3e-filled-card-disabled-text-opacity - Opacity applied to text when disabled.
 * @cssprop --m3e-filled-card-disabled-container-color - Background color when disabled.
 * @cssprop --m3e-filled-card-disabled-container-elevation - Elevation level when disabled.
 * @cssprop --m3e-filled-card-disabled-container-elevation-color - Shadow color when disabled.
 * @cssprop --m3e-filled-card-disabled-container-elevation-opacity - Shadow opacity when disabled.
 * @cssprop --m3e-filled-card-disabled-container-opacity - Overall container opacity when disabled.
 * @cssprop --m3e-filled-card-hover-text-color - Text color on hover.
 * @cssprop --m3e-filled-card-hover-state-layer-color - State layer color on hover.
 * @cssprop --m3e-filled-card-hover-state-layer-opacity - State layer opacity on hover.
 * @cssprop --m3e-filled-card-hover-container-elevation - Elevation level on hover.
 * @cssprop --m3e-filled-card-focus-text-color - Text color on focus.
 * @cssprop --m3e-filled-card-focus-state-layer-color - State layer color on focus.
 * @cssprop --m3e-filled-card-focus-state-layer-opacity - State layer opacity on focus.
 * @cssprop --m3e-filled-card-focus-container-elevation - Elevation level on focus.
 * @cssprop --m3e-filled-card-pressed-text-color - Text color on press.
 * @cssprop --m3e-filled-card-pressed-state-layer-color - State layer color on press.
 * @cssprop --m3e-filled-card-pressed-state-layer-opacity - State layer opacity on press.
 * @cssprop --m3e-filled-card-pressed-container-elevation - Elevation level on press.
 * @cssprop --m3e-elevated-card-text-color - Foreground color for text content in elevated cards.
 * @cssprop --m3e-elevated-card-container-color - Background color of the elevated card container.
 * @cssprop --m3e-elevated-card-container-elevation - Elevation level for elevated card container.
 * @cssprop --m3e-elevated-card-disabled-text-color - Text color when elevated card is disabled.
 * @cssprop --m3e-elevated-card-disabled-text-opacity - Opacity applied to text when disabled.
 * @cssprop --m3e-elevated-card-disabled-container-color - Background color when disabled.
 * @cssprop --m3e-elevated-card-disabled-container-elevation - Elevation level when disabled.
 * @cssprop --m3e-elevated-card-disabled-container-elevation-color - Shadow color when disabled.
 * @cssprop --m3e-elevated-card-disabled-container-elevation-opacity - Shadow opacity when disabled.
 * @cssprop --m3e-elevated-card-disabled-container-opacity - Overall container opacity when disabled.
 * @cssprop --m3e-elevated-card-hover-text-color - Text color on hover.
 * @cssprop --m3e-elevated-card-hover-state-layer-color - State layer color on hover.
 * @cssprop --m3e-elevated-card-hover-state-layer-opacity - State layer opacity on hover.
 * @cssprop --m3e-elevated-card-hover-container-elevation - Elevation level on hover.
 * @cssprop --m3e-elevated-card-focus-text-color - Text color on focus.
 * @cssprop --m3e-elevated-card-focus-state-layer-color - State layer color on focus.
 * @cssprop --m3e-elevated-card-focus-state-layer-opacity - State layer opacity on focus.
 * @cssprop --m3e-elevated-card-focus-container-elevation - Elevation level on focus.
 * @cssprop --m3e-elevated-card-pressed-text-color - Text color on press.
 * @cssprop --m3e-elevated-card-pressed-state-layer-color - State layer color on press.
 * @cssprop --m3e-elevated-card-pressed-state-layer-opacity - State layer opacity on press.
 * @cssprop --m3e-elevated-card-pressed-container-elevation - Elevation level on press.
 * @cssprop --m3e-outlined-card-text-color - Foreground color for text content in outlined cards.
 * @cssprop --m3e-outlined-card-container-color - Background color of the outlined card container.
 * @cssprop --m3e-outlined-card-container-elevation - Elevation level for outlined card container.
 * @cssprop --m3e-outlined-card-outline-color - Border color for outlined cards.
 * @cssprop --m3e-outlined-card-outline-thickness - Border thickness for outlined cards.
 * @cssprop --m3e-outlined-card-disabled-text-color - Text color when outlined card is disabled.
 * @cssprop --m3e-outlined-card-disabled-text-opacity - Opacity applied to text when disabled.
 * @cssprop --m3e-outlined-card-disabled-container-elevation - Elevation level when disabled.
 * @cssprop --m3e-outlined-card-disabled-container-elevation-color - Shadow color when disabled.
 * @cssprop --m3e-outlined-card-disabled-container-elevation-opacity - Shadow opacity when disabled.
 * @cssprop --m3e-outlined-card-disabled-outline-color - Border color when disabled.
 * @cssprop --m3e-outlined-card-disabled-outline-opacity - Border opacity when disabled.
 * @cssprop --m3e-outlined-card-hover-text-color - Text color on hover.
 * @cssprop --m3e-outlined-card-hover-state-layer-color - State layer color on hover.
 * @cssprop --m3e-outlined-card-hover-state-layer-opacity - State layer opacity on hover.
 * @cssprop --m3e-outlined-card-hover-container-elevation - Elevation level on hover.
 * @cssprop --m3e-outlined-card-hover-outline-color - Border color on hover.
 * @cssprop --m3e-outlined-card-focus-text-color - Text color on focus.
 * @cssprop --m3e-outlined-card-focus-state-layer-color - State layer color on focus.
 * @cssprop --m3e-outlined-card-focus-state-layer-opacity - State layer opacity on focus.
 * @cssprop --m3e-outlined-card-focus-container-elevation - Elevation level on focus.
 * @cssprop --m3e-outlined-card-focus-outline-color - Border color on focus.
 * @cssprop --m3e-outlined-card-pressed-text-color - Text color on press.
 * @cssprop --m3e-outlined-card-pressed-state-layer-color - State layer color on press.
 * @cssprop --m3e-outlined-card-pressed-state-layer-opacity - State layer opacity on press.
 * @cssprop --m3e-outlined-card-pressed-container-elevation - Elevation level on press.
 * @cssprop --m3e-outlined-card-pressed-outline-color - Border color on press.
 */ let $d75e28d33e9acdba$export$b295160d62046d3b = class M3eCardElement extends (0, $ca7aa15aa0ba1e7b$export$d564d59935f4debe)((0, $ca7aa15aa0ba1e7b$export$29d11c0fe2fc51d8)((0, $ca7aa15aa0ba1e7b$export$f7d03dabd73ead6b)((0, $ca7aa15aa0ba1e7b$export$35a3bebf7ef2d934)((0, $ca7aa15aa0ba1e7b$export$3d1d3384b4efc6c3)((0, $ca7aa15aa0ba1e7b$export$9a986b15f53d6d10)((0, $ca7aa15aa0ba1e7b$export$282c9fa792fbac93)((0, $fa29e5b5c67837a0$export$3f2f9f5909897157)), true)))))) {
    constructor(){
        super();
        $d75e28d33e9acdba$var$_M3eCardElement_instances.add(this);
        /** @private */ $d75e28d33e9acdba$var$_M3eCardElement_clickHandler.set(this, (e)=>(0, $gkQP3.__classPrivateFieldGet)(this, $d75e28d33e9acdba$var$_M3eCardElement_instances, "m", $d75e28d33e9acdba$var$_M3eCardElement_handleClick).call(this, e));
        /**
     * Whether to present the card inline with surrounding content.
     * @default false
     */ this.inline = false;
        /**
     * Whether the card is "actionable" and will respond to use interaction.
     * @default false
     */ this.actionable = false;
        /**
     * The appearance variant of the card.
     * @default "filled"
     */ this.variant = "filled";
        /**
     * The orientation of the card.
     * @default "vertical"
     */ this.orientation = "vertical";
        new (0, $ca7aa15aa0ba1e7b$export$1351ab2eef382c23)(this, {
            isPressedKey: (key)=>key === " ",
            callback: (pressed)=>{
                if (this.actionable && !this.disabled && !this.disabledInteractive) this._base?.classList.toggle("pressed", pressed);
            }
        });
    }
    /** @inheritdoc */ connectedCallback() {
        if (this.hasAttribute("actionable")) // If href is specified, the LinkButton mixin changes this to "link" if role is "button".
        this.role = "button";
        super.connectedCallback();
        this.addEventListener("click", (0, $gkQP3.__classPrivateFieldGet)(this, $d75e28d33e9acdba$var$_M3eCardElement_clickHandler, "f"));
    }
    /** @inheritdoc */ disconnectedCallback() {
        super.disconnectedCallback();
        this._base?.classList.toggle("pressed", false);
        this.removeEventListener("click", (0, $gkQP3.__classPrivateFieldGet)(this, $d75e28d33e9acdba$var$_M3eCardElement_clickHandler, "f"));
    }
    /** @inheritdoc */ render() {
        return (0, $00a10a29322bb2a1$export$c0bb0b647f701bb5)`<div class="base"><m3e-elevation class="elevation" ?disabled="${!this.actionable || this.disabled || this.disabledInteractive}"></m3e-elevation><m3e-focus-ring class="focus-ring" ?disabled="${!this.actionable || this.disabled}"></m3e-focus-ring><m3e-state-layer class="state-layer" ?disabled="${!this.actionable || this.disabled || this.disabledInteractive}"></m3e-state-layer><m3e-ripple class="ripple" ?disabled="${!this.actionable || this.disabled || this.disabledInteractive}"></m3e-ripple>${this[0, $ca7aa15aa0ba1e7b$export$6118a8e97d251010]()}<slot name="header" @slotchange="${(0, $gkQP3.__classPrivateFieldGet)(this, $d75e28d33e9acdba$var$_M3eCardElement_instances, "m", $d75e28d33e9acdba$var$_M3eCardElement_handleHeaderSlotChange)}"></slot><slot name="content" @slotchange="${(0, $gkQP3.__classPrivateFieldGet)(this, $d75e28d33e9acdba$var$_M3eCardElement_instances, "m", $d75e28d33e9acdba$var$_M3eCardElement_handleContentSlotChange)}"><slot @slotchange="${(0, $gkQP3.__classPrivateFieldGet)(this, $d75e28d33e9acdba$var$_M3eCardElement_instances, "m", $d75e28d33e9acdba$var$_M3eCardElement_handleDefaultSlotChange)}"></slot></slot><slot name="actions" @slotchange="${(0, $gkQP3.__classPrivateFieldGet)(this, $d75e28d33e9acdba$var$_M3eCardElement_instances, "m", $d75e28d33e9acdba$var$_M3eCardElement_handleActionsSlotChange)}"></slot><slot name="footer" @slotchange="${(0, $gkQP3.__classPrivateFieldGet)(this, $d75e28d33e9acdba$var$_M3eCardElement_instances, "m", $d75e28d33e9acdba$var$_M3eCardElement_handleFooterSlotChange)}"></slot></div>`;
    }
    /** @inheritdoc */ firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);
        [
            this._elevation,
            this._focusRing,
            this._stateLayer,
            this._ripple
        ].forEach((x)=>x?.attach(this));
        if (!this.actionable && this.hasAttribute("tabindex")) this.removeAttribute("tabindex");
    }
    /** @inheritdoc */ update(changedProperties) {
        super.update(changedProperties);
        if (!this.actionable && this.hasAttribute("tabindex")) this.removeAttribute("tabindex");
    }
};
$d75e28d33e9acdba$var$_M3eCardElement_clickHandler = new WeakMap();
$d75e28d33e9acdba$var$_M3eCardElement_instances = new WeakSet();
$d75e28d33e9acdba$var$_M3eCardElement_handleHeaderSlotChange = function _M3eCardElement_handleHeaderSlotChange(e) {
    const assignedNodes = e.target.assignedNodes({
        flatten: true
    });
    const base = this.shadowRoot?.querySelector(".base");
    base?.classList.toggle("has-header", assignedNodes.length > 0);
    base?.classList.toggle("has-header-media", assignedNodes.some((x)=>x instanceof HTMLElement && (x.tagName === "IMG" || x.tagName === "VIDEO")));
};
$d75e28d33e9acdba$var$_M3eCardElement_handleContentSlotChange = function _M3eCardElement_handleContentSlotChange() {
    this.shadowRoot?.querySelector(".base")?.classList.toggle("has-content", this.querySelector("[slot='content']") !== null);
};
$d75e28d33e9acdba$var$_M3eCardElement_handleDefaultSlotChange = function _M3eCardElement_handleDefaultSlotChange(e) {
    this.shadowRoot?.querySelector(".base")?.classList.toggle("has-default", (0, $ca7aa15aa0ba1e7b$export$e0478d61fdced58c)(e.target) && this.querySelector("[slot='content']") === null);
};
$d75e28d33e9acdba$var$_M3eCardElement_handleActionsSlotChange = function _M3eCardElement_handleActionsSlotChange(e) {
    this.shadowRoot?.querySelector(".base")?.classList.toggle("has-actions", (0, $ca7aa15aa0ba1e7b$export$e0478d61fdced58c)(e.target));
};
$d75e28d33e9acdba$var$_M3eCardElement_handleFooterSlotChange = function _M3eCardElement_handleFooterSlotChange(e) {
    this.shadowRoot?.querySelector(".base")?.classList.toggle("has-footer", (0, $ca7aa15aa0ba1e7b$export$e0478d61fdced58c)(e.target));
};
$d75e28d33e9acdba$var$_M3eCardElement_handleClick = function _M3eCardElement_handleClick(e) {
    if (this.disabled || this.disabledInteractive) {
        e.preventDefault();
        e.stopImmediatePropagation();
    }
};
/** The styles of the element. */ $d75e28d33e9acdba$export$b295160d62046d3b.styles = [
    $d75e28d33e9acdba$var$CardVariantStyle,
    $d75e28d33e9acdba$var$CardStyle
];
(0, $gkQP3.__decorate)([
    (0, $540200038ed52347$export$2fa187e846a241c4)(".base")
], $d75e28d33e9acdba$export$b295160d62046d3b.prototype, "_base", void 0);
(0, $gkQP3.__decorate)([
    (0, $540200038ed52347$export$2fa187e846a241c4)(".elevation")
], $d75e28d33e9acdba$export$b295160d62046d3b.prototype, "_elevation", void 0);
(0, $gkQP3.__decorate)([
    (0, $540200038ed52347$export$2fa187e846a241c4)(".focus-ring")
], $d75e28d33e9acdba$export$b295160d62046d3b.prototype, "_focusRing", void 0);
(0, $gkQP3.__decorate)([
    (0, $540200038ed52347$export$2fa187e846a241c4)(".state-layer")
], $d75e28d33e9acdba$export$b295160d62046d3b.prototype, "_stateLayer", void 0);
(0, $gkQP3.__decorate)([
    (0, $540200038ed52347$export$2fa187e846a241c4)(".ripple")
], $d75e28d33e9acdba$export$b295160d62046d3b.prototype, "_ripple", void 0);
(0, $gkQP3.__decorate)([
    (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $d75e28d33e9acdba$export$b295160d62046d3b.prototype, "inline", void 0);
(0, $gkQP3.__decorate)([
    (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $d75e28d33e9acdba$export$b295160d62046d3b.prototype, "actionable", void 0);
(0, $gkQP3.__decorate)([
    (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
        reflect: true
    })
], $d75e28d33e9acdba$export$b295160d62046d3b.prototype, "variant", void 0);
(0, $gkQP3.__decorate)([
    (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
        reflect: true
    })
], $d75e28d33e9acdba$export$b295160d62046d3b.prototype, "orientation", void 0);
$d75e28d33e9acdba$export$b295160d62046d3b = (0, $gkQP3.__decorate)([
    (0, $ca7aa15aa0ba1e7b$export$da64fc29f17f9d0e)("m3e-card")
], $d75e28d33e9acdba$export$b295160d62046d3b);


/**
 * @license MIT
 * Copyright (c) 2025–2026 matraic
 * See LICENSE file in the project root for full license text.
 */ 
var $gkQP3 = parcelRequire("gkQP3");



const $7da47c7e3b65d601$var$LoadingIndicatorToken = {
    activeIndicatorSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-loading-indicator-size, 2.375rem)`),
    activeIndicatorColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-loading-indicator-active-indicator-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.primary})`),
    containedActiveIndicatorColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-loading-indicator-contained-active-indicator-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.onPrimaryContainer})`),
    containedContainerColor: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-loading-indicator-contained-container-color, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).color.secondaryContainer})`),
    containerShape: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-loading-indicator-container-shape, ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).shape.corner.full})`),
    containerSize: (0, $fbf856437f99196f$export$8d80f9cac07cdb3)(`var(--m3e-loading-indicator-container-size, 3rem)`)
};
const $7da47c7e3b65d601$var$SHAPE_PATHS = {
    "4-sided-cookie": "M230.389 50.473C293.109 23.2328 356.767 86.8908 329.527 149.611L325.023 159.981C316.707 179.13 316.707 200.87 325.023 220.019L329.527 230.389C356.767 293.109 293.109 356.767 230.389 329.527L220.019 325.023C200.87 316.707 179.13 316.707 159.981 325.023L149.611 329.527C86.8908 356.767 23.2328 293.109 50.473 230.389L54.9768 220.019C63.2934 200.87 63.2934 179.13 54.9768 159.981L50.473 149.611C23.2328 86.8908 86.8908 23.2328 149.611 50.473L159.981 54.9768C179.13 63.2934 200.87 63.2934 220.019 54.9768L230.389 50.473Z",
    "7-sided-cookie": "M142.67 51.7842C146.243 48.6394 148.029 47.067 149.671 45.7954C173.425 27.4015 206.575 27.4015 230.329 45.7954C231.971 47.067 233.757 48.6394 237.33 51.7842C238.526 52.8372 239.124 53.3636 239.724 53.8672C248.136 60.9247 258.171 65.7683 268.92 67.9594C269.688 68.1158 270.471 68.2562 272.038 68.537C276.719 69.3756 279.059 69.7949 281.075 70.2889C310.234 77.4346 330.902 103.411 331.364 133.493C331.396 135.573 331.283 137.953 331.057 142.713C330.982 144.307 330.944 145.104 330.925 145.888C330.665 156.88 333.143 167.763 338.136 177.553C338.493 178.252 338.872 178.953 339.63 180.356C341.894 184.547 343.026 186.642 343.897 188.53C356.503 215.834 349.127 248.226 325.949 267.344C324.347 268.666 322.42 270.061 318.566 272.852C317.276 273.787 316.63 274.254 316.007 274.729C307.27 281.377 300.326 290.105 295.803 300.122C295.48 300.837 295.169 301.571 294.547 303.04C292.69 307.427 291.761 309.62 290.832 311.48C277.393 338.382 247.526 352.798 218.162 346.556C216.132 346.124 213.842 345.484 209.262 344.204C207.728 343.776 206.962 343.562 206.203 343.369C195.569 340.668 184.431 340.668 173.797 343.369C173.038 343.562 172.272 343.776 170.738 344.204C166.158 345.484 163.868 346.124 161.838 346.556C132.474 352.798 102.607 338.382 89.168 311.48C88.2388 309.62 87.3102 307.427 85.453 303.04C84.8311 301.571 84.5202 300.837 84.1975 300.122C79.6741 290.105 72.7297 281.377 63.993 274.729C63.3696 274.254 62.7244 273.787 61.434 272.852C57.5801 270.061 55.6532 268.666 54.0507 267.344C30.873 248.226 23.4965 215.834 36.1027 188.53C36.9742 186.642 38.1062 184.547 40.3703 180.356C41.1283 178.953 41.5074 178.252 41.8636 177.553C46.8568 167.763 49.3353 156.88 49.0745 145.888C49.0559 145.104 49.0182 144.307 48.9426 142.713C48.7168 137.953 48.6039 135.573 48.6359 133.493C49.0982 103.411 69.7665 77.4346 98.9252 70.2889C100.941 69.7949 103.281 69.3756 107.962 68.537C109.529 68.2562 110.312 68.1158 111.08 67.9594C121.829 65.7683 131.864 60.9247 140.276 53.8672C140.876 53.3636 141.474 52.8372 142.67 51.7842Z",
    oval: "M271.309 271.309C201.705 340.913 108.877 360.935 63.9707 316.029C19.0648 271.123 39.0867 178.295 108.691 108.691C178.295 39.0867 271.123 19.0648 316.029 63.9707C360.935 108.877 340.913 201.705 271.309 271.309Z",
    pentagon: "M155.064 49.459C176.093 34.1803 204.569 34.1803 225.598 49.459L322.926 120.171C343.955 135.45 352.754 162.532 344.722 187.253L307.546 301.668C299.514 326.39 276.476 343.127 250.483 343.127H130.18C104.186 343.127 81.1489 326.39 73.1164 301.668L35.9407 187.253C27.9082 162.532 36.7077 135.45 57.737 120.171L155.064 49.459Z",
    pill: "M116.116 71.7851C169.162 18.7383 255.168 18.7383 308.215 71.7851C361.262 124.832 361.262 210.838 308.215 263.884L263.884 308.215C210.838 361.262 124.832 361.262 71.7851 308.215C18.7383 255.168 18.7383 169.162 71.7851 116.116L116.116 71.7851Z",
    "soft-burst": "M175.147 33.1508C181.983 22.2831 198.017 22.2831 204.853 33.1508L221.238 59.2009C225.731 66.3458 234.797 69.2506 242.692 66.0751L271.475 54.4972C283.482 49.6671 296.455 58.9613 295.507 71.7154L293.235 102.288C292.612 110.673 298.215 118.278 306.494 120.284L336.681 127.601C349.275 130.653 354.23 145.692 345.861 155.461L325.8 178.877C320.298 185.3 320.298 194.7 325.8 201.123L345.861 224.539C354.23 234.308 349.275 249.347 336.681 252.399L306.494 259.716C298.215 261.722 292.612 269.327 293.235 277.712L295.507 308.285C296.455 321.039 283.482 330.333 271.475 325.503L242.692 313.925C234.797 310.749 225.731 313.654 221.238 320.799L204.853 346.849C198.017 357.717 181.983 357.717 175.147 346.849L158.762 320.799C154.269 313.654 145.203 310.749 137.308 313.925L108.525 325.503C96.5177 330.333 83.5454 321.039 84.4931 308.285L86.7649 277.712C87.388 269.327 81.785 261.722 73.5056 259.716L43.3186 252.399C30.7252 249.347 25.7702 234.308 34.1391 224.539L54.1997 201.123C59.7018 194.7 59.7018 185.3 54.1997 178.877L34.1391 155.461C25.7702 145.692 30.7252 130.653 43.3186 127.601L73.5056 120.284C81.785 118.278 87.388 110.673 86.7649 102.288L84.4931 71.7154C83.5454 58.9613 96.5177 49.6671 108.525 54.4972L137.308 66.0751C145.203 69.2506 154.269 66.3458 158.762 59.201L175.147 33.1508Z",
    "very-sunny": "M166.725 43.1869C177.261 25.6044 202.739 25.6044 213.275 43.1868L225.124 62.9597C231.268 73.2136 243.399 78.2385 254.995 75.3327L277.355 69.7294C297.237 64.7468 315.253 82.7627 310.271 102.645L304.667 125.005C301.762 136.601 306.786 148.732 317.04 154.876L336.813 166.725C354.396 177.261 354.396 202.739 336.813 213.275L317.04 225.124C306.786 231.268 301.762 243.399 304.667 254.995L310.271 277.355C315.253 297.237 297.237 315.253 277.355 310.271L254.995 304.667C243.399 301.762 231.268 306.786 225.124 317.04L213.275 336.813C202.739 354.396 177.261 354.396 166.725 336.813L154.876 317.04C148.732 306.786 136.601 301.762 125.005 304.667L102.646 310.271C82.7627 315.253 64.7468 297.237 69.7294 277.355L75.3327 254.995C78.2385 243.399 73.2136 231.268 62.9597 225.124L43.1869 213.275C25.6044 202.739 25.6044 177.261 43.1868 166.725L62.9597 154.876C73.2136 148.732 78.2385 136.601 75.3327 125.005L69.7294 102.646C64.7468 82.7627 82.7627 64.7468 102.645 69.7294L125.005 75.3327C136.601 78.2385 148.732 73.2136 154.876 62.9597L166.725 43.1869Z"
};
let $7da47c7e3b65d601$var$shapes = new Array();
const $7da47c7e3b65d601$var$indexMap = new Map();
for(const key in $7da47c7e3b65d601$var$SHAPE_PATHS){
    $7da47c7e3b65d601$var$shapes.push($7da47c7e3b65d601$var$SHAPE_PATHS[key]);
    $7da47c7e3b65d601$var$indexMap.set(key, $7da47c7e3b65d601$var$shapes.length - 1);
}
const $7da47c7e3b65d601$var$_ShapePolygon = {};
$7da47c7e3b65d601$var$shapes = (0, $ca7aa15aa0ba1e7b$export$bd65317e0df81807)($7da47c7e3b65d601$var$shapes, 300);
for (const item of $7da47c7e3b65d601$var$indexMap)$7da47c7e3b65d601$var$_ShapePolygon[item[0]] = (0, $fbf856437f99196f$export$8d80f9cac07cdb3)($7da47c7e3b65d601$var$shapes[item[1]]);
/**
 * Normalized polygons for each shape.
 * @internal
 */ const $7da47c7e3b65d601$var$ShapePolygon = $7da47c7e3b65d601$var$_ShapePolygon;
/**
 * Shows indeterminate progress for a short wait time.
 *
 * @description
 * The `m3e-loading-indicator` component uses animation to grab attention, mitigate perceived latency, and indicate
 * that an activity is in progress.
 *
 * When placed over other content, use the `variant` attribute to change the appearance from `uncontained` (the default),
 * to `contained` so that it has strong contrast to help it stand out better.
 *
 * @example
 * The following example illustrates an uncontained loading indicator.
 * ```html
 * <m3e-loading-indicator></m3e-loading-indicator>
 * ```
 *
 * @tag m3e-loading-indicator
 *
 * @attr variant - The appearance variant of the indicator.
 *
 * @cssprop --m3e-loading-indicator-active-indicator-color - Uncontained active indicator color.
 * @cssprop --m3e-loading-indicator-contained-active-indicator-color - Contained active indicator color.
 * @cssprop --m3e-loading-indicator-contained-container-color - Contained container (background) color.
 * @cssprop --m3e-loading-indicator-active-indicator-size - Size of the active indicator.
 * @cssprop --m3e-loading-indicator-container-shape - Container shape.
 * @cssprop --m3e-loading-indicator-container-size - Container size.
 */ let $7da47c7e3b65d601$export$e29b457650c98207 = class M3eLoadingIndicatorElement extends (0, $ca7aa15aa0ba1e7b$export$625d28f11806c030)((0, $ca7aa15aa0ba1e7b$export$46919bad18fb2f76)((0, $fa29e5b5c67837a0$export$3f2f9f5909897157), "progressbar")) {
    constructor(){
        super(...arguments);
        /**
     * The appearance variant of the indicator.
     * @default "uncontained"
     */ this.variant = "uncontained";
    }
    /** @inheritdoc */ connectedCallback() {
        super.connectedCallback();
        this.ariaValueMin = this.ariaValueMin || "0";
        this.ariaValueMax = this.ariaValueMax || "100";
    }
    /** @inheritdoc */ disconnectedCallback() {
        super.disconnectedCallback();
        this._activeIndicator?.classList.toggle("animate", false);
    }
    /** @inheritdoc */ reconnectedCallback() {
        super.reconnectedCallback();
        this._activeIndicator?.classList.toggle("animate", true);
    }
    /** @inheritdoc */ firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);
        this._activeIndicator?.classList.toggle("animate", true);
    }
    /** @inheritdoc */ render() {
        return (0, $00a10a29322bb2a1$export$c0bb0b647f701bb5)`<div class="container" aria-hidden="true"><div class="active-indicator"></div></div>`;
    }
};
/** The styles of the element. */ $7da47c7e3b65d601$export$e29b457650c98207.styles = (0, $fbf856437f99196f$export$dbf350e5966cf602)`:host { display: inline-block; aspect-ratio: 1 / 1; contain: strict; vertical-align: middle; content-visibility: auto; } :host([variant="uncontained"]) { width: ${$7da47c7e3b65d601$var$LoadingIndicatorToken.activeIndicatorSize}; } :host([variant="contained"]) { width: ${$7da47c7e3b65d601$var$LoadingIndicatorToken.containerSize}; } :host([variant="uncontained"]) .active-indicator { background-color: ${$7da47c7e3b65d601$var$LoadingIndicatorToken.activeIndicatorColor}; } :host([variant="contained"]) .active-indicator { background-color: ${$7da47c7e3b65d601$var$LoadingIndicatorToken.containedActiveIndicatorColor}; } :host([variant="contained"]) .container { background-color: ${$7da47c7e3b65d601$var$LoadingIndicatorToken.containedContainerColor}; } .container { width: 100%; height: 100%; display: flex; align-items: center; justify-content: center; border-radius: ${$7da47c7e3b65d601$var$LoadingIndicatorToken.containerShape}; } .active-indicator { margin: auto; aspect-ratio: 1 / 1; width: calc(${$7da47c7e3b65d601$var$LoadingIndicatorToken.activeIndicatorSize} * 0.842); transform-origin: center; transition: clip-path ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).motion.spring.slowEffects}; will-change: transform, clip-path; --_polygon-soft-burst: polygon(${$7da47c7e3b65d601$var$ShapePolygon["soft-burst"]}); --_polygon-7-sided-cookie: polygon(${$7da47c7e3b65d601$var$ShapePolygon["7-sided-cookie"]}); --_polygon-pentagon: polygon(${$7da47c7e3b65d601$var$ShapePolygon["pentagon"]}); --_polygon-pill: polygon(${$7da47c7e3b65d601$var$ShapePolygon["pill"]}); --_polygon-very-sunny: polygon(${$7da47c7e3b65d601$var$ShapePolygon["very-sunny"]}); --_polygon-4-sided-cookie: polygon(${$7da47c7e3b65d601$var$ShapePolygon["4-sided-cookie"]}); --_polygon-oval: polygon(${$7da47c7e3b65d601$var$ShapePolygon["oval"]}); } .active-indicator.animate { animation: rotate 4998ms infinite; } @keyframes rotate { 0% { clip-path: var(--_polygon-soft-burst); transform: rotate(0deg); animation-timing-function: cubic-bezier(0.5, 0.2, 0, 0.8); } 14% { clip-path: var(--_polygon-7-sided-cookie); transform: rotate(154deg); animation-timing-function: cubic-bezier(0.5, 0.2, 0, 0.8); } 29% { clip-path: var(--_polygon-pentagon); transform: rotate(309deg); animation-timing-function: cubic-bezier(0.5, 0.2, 0, 0.8); } 43% { clip-path: var(--_polygon-pill); transform: rotate(463deg); animation-timing-function: cubic-bezier(0.5, 0.2, 0, 0.8); } 57% { clip-path: var(--_polygon-very-sunny); transform: rotate(617deg); animation-timing-function: cubic-bezier(0.5, 0.2, 0, 0.8); } 71% { clip-path: var(--_polygon-4-sided-cookie); transform: rotate(771deg); animation-timing-function: cubic-bezier(0.5, 0.2, 0, 0.8); } 83% { clip-path: var(--_polygon-oval); transform: rotate(926deg); animation-timing-function: cubic-bezier(0.5, 0.2, 0, 0.8); } 100% { clip-path: var(--_polygon-soft-burst); transform: rotate(1080deg); } } @media (forced-colors: active) { .active-indicator { background-color: CanvasText !important; } }`;
(0, $gkQP3.__decorate)([
    (0, $540200038ed52347$export$2fa187e846a241c4)(".active-indicator")
], $7da47c7e3b65d601$export$e29b457650c98207.prototype, "_activeIndicator", void 0);
(0, $gkQP3.__decorate)([
    (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
        reflect: true
    })
], $7da47c7e3b65d601$export$e29b457650c98207.prototype, "variant", void 0);
$7da47c7e3b65d601$export$e29b457650c98207 = (0, $gkQP3.__decorate)([
    (0, $ca7aa15aa0ba1e7b$export$da64fc29f17f9d0e)("m3e-loading-indicator")
], $7da47c7e3b65d601$export$e29b457650c98207);


/**
 * @license MIT
 * Copyright (c) 2025–2026 matraic
 * See LICENSE file in the project root for full license text.
 */ 
var $gkQP3 = parcelRequire("gkQP3");



/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // This file is automatically generated. Do not modify it.
/**
 * Utility methods for mathematical operations.
 */ /**
 * The signum function.
 *
 * @return 1 if num > 0, -1 if num < 0, and 0 if num = 0
 */ function $ad39de81c51fbcac$var$signum(num) {
    if (num < 0) return -1;
    else if (num === 0) return 0;
    else return 1;
}
/**
 * The linear interpolation function.
 *
 * @return start if amount = 0 and stop if amount = 1
 */ function $ad39de81c51fbcac$var$lerp(start, stop, amount) {
    return (1.0 - amount) * start + amount * stop;
}
/**
 * Clamps an integer between two integers.
 *
 * @return input when min <= input <= max, and either min or max
 * otherwise.
 */ function $ad39de81c51fbcac$var$clampInt(min, max, input) {
    if (input < min) return min;
    else if (input > max) return max;
    return input;
}
/**
 * Clamps an integer between two floating-point numbers.
 *
 * @return input when min <= input <= max, and either min or max
 * otherwise.
 */ function $ad39de81c51fbcac$var$clampDouble(min, max, input) {
    if (input < min) return min;
    else if (input > max) return max;
    return input;
}
/**
 * Sanitizes a degree measure as a floating-point number.
 *
 * @return a degree measure between 0.0 (inclusive) and 360.0
 * (exclusive).
 */ function $ad39de81c51fbcac$var$sanitizeDegreesDouble(degrees) {
    degrees = degrees % 360.0;
    if (degrees < 0) degrees = degrees + 360.0;
    return degrees;
}
/**
 * Multiplies a 1x3 row vector with a 3x3 matrix.
 */ function $ad39de81c51fbcac$var$matrixMultiply(row, matrix) {
    const a = row[0] * matrix[0][0] + row[1] * matrix[0][1] + row[2] * matrix[0][2];
    const b = row[0] * matrix[1][0] + row[1] * matrix[1][1] + row[2] * matrix[1][2];
    const c = row[0] * matrix[2][0] + row[1] * matrix[2][1] + row[2] * matrix[2][2];
    return [
        a,
        b,
        c
    ];
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // This file is automatically generated. Do not modify it.
/**
 * Color science utilities.
 *
 * Utility methods for color science constants and color space
 * conversions that aren't HCT or CAM16.
 */ const $ad39de81c51fbcac$var$SRGB_TO_XYZ = [
    [
        0.41233895,
        0.35762064,
        0.18051042
    ],
    [
        0.2126,
        0.7152,
        0.0722
    ],
    [
        0.01932141,
        0.11916382,
        0.95034478
    ]
];
const $ad39de81c51fbcac$var$XYZ_TO_SRGB = [
    [
        3.2413774792388685,
        -1.5376652402851851,
        -0.49885366846268053
    ],
    [
        -0.9691452513005321,
        1.8758853451067872,
        0.04156585616912061
    ],
    [
        0.05562093689691305,
        -0.20395524564742123,
        1.0571799111220335
    ]
];
const $ad39de81c51fbcac$var$WHITE_POINT_D65 = [
    95.047,
    100.0,
    108.883
];
/**
 * Converts a color from RGB components to ARGB format.
 */ function $ad39de81c51fbcac$var$argbFromRgb(red, green, blue) {
    return (-16777216 | (red & 255) << 16 | (green & 255) << 8 | blue & 255) >>> 0;
}
/**
 * Converts a color from linear RGB components to ARGB format.
 */ function $ad39de81c51fbcac$var$argbFromLinrgb(linrgb) {
    const r = $ad39de81c51fbcac$var$delinearized(linrgb[0]);
    const g = $ad39de81c51fbcac$var$delinearized(linrgb[1]);
    const b = $ad39de81c51fbcac$var$delinearized(linrgb[2]);
    return $ad39de81c51fbcac$var$argbFromRgb(r, g, b);
}
/**
 * Returns the red component of a color in ARGB format.
 */ function $ad39de81c51fbcac$var$redFromArgb(argb) {
    return argb >> 16 & 255;
}
/**
 * Returns the green component of a color in ARGB format.
 */ function $ad39de81c51fbcac$var$greenFromArgb(argb) {
    return argb >> 8 & 255;
}
/**
 * Returns the blue component of a color in ARGB format.
 */ function $ad39de81c51fbcac$var$blueFromArgb(argb) {
    return argb & 255;
}
/**
 * Converts a color from ARGB to XYZ.
 */ function $ad39de81c51fbcac$var$argbFromXyz(x, y, z) {
    const matrix = $ad39de81c51fbcac$var$XYZ_TO_SRGB;
    const linearR = matrix[0][0] * x + matrix[0][1] * y + matrix[0][2] * z;
    const linearG = matrix[1][0] * x + matrix[1][1] * y + matrix[1][2] * z;
    const linearB = matrix[2][0] * x + matrix[2][1] * y + matrix[2][2] * z;
    const r = $ad39de81c51fbcac$var$delinearized(linearR);
    const g = $ad39de81c51fbcac$var$delinearized(linearG);
    const b = $ad39de81c51fbcac$var$delinearized(linearB);
    return $ad39de81c51fbcac$var$argbFromRgb(r, g, b);
}
/**
 * Converts a color from XYZ to ARGB.
 */ function $ad39de81c51fbcac$var$xyzFromArgb(argb) {
    const r = $ad39de81c51fbcac$var$linearized($ad39de81c51fbcac$var$redFromArgb(argb));
    const g = $ad39de81c51fbcac$var$linearized($ad39de81c51fbcac$var$greenFromArgb(argb));
    const b = $ad39de81c51fbcac$var$linearized($ad39de81c51fbcac$var$blueFromArgb(argb));
    return $ad39de81c51fbcac$var$matrixMultiply([
        r,
        g,
        b
    ], $ad39de81c51fbcac$var$SRGB_TO_XYZ);
}
/**
 * Converts an L* value to an ARGB representation.
 *
 * @param lstar L* in L*a*b*
 * @return ARGB representation of grayscale color with lightness
 * matching L*
 */ function $ad39de81c51fbcac$var$argbFromLstar(lstar) {
    const y = $ad39de81c51fbcac$var$yFromLstar(lstar);
    const component = $ad39de81c51fbcac$var$delinearized(y);
    return $ad39de81c51fbcac$var$argbFromRgb(component, component, component);
}
/**
 * Computes the L* value of a color in ARGB representation.
 *
 * @param argb ARGB representation of a color
 * @return L*, from L*a*b*, coordinate of the color
 */ function $ad39de81c51fbcac$var$lstarFromArgb(argb) {
    const y = $ad39de81c51fbcac$var$xyzFromArgb(argb)[1];
    return 116.0 * $ad39de81c51fbcac$var$labF(y / 100.0) - 16.0;
}
/**
 * Converts an L* value to a Y value.
 *
 * L* in L*a*b* and Y in XYZ measure the same quantity, luminance.
 *
 * L* measures perceptual luminance, a linear scale. Y in XYZ
 * measures relative luminance, a logarithmic scale.
 *
 * @param lstar L* in L*a*b*
 * @return Y in XYZ
 */ function $ad39de81c51fbcac$var$yFromLstar(lstar) {
    return 100.0 * $ad39de81c51fbcac$var$labInvf((lstar + 16.0) / 116.0);
}
/**
 * Converts a Y value to an L* value.
 *
 * L* in L*a*b* and Y in XYZ measure the same quantity, luminance.
 *
 * L* measures perceptual luminance, a linear scale. Y in XYZ
 * measures relative luminance, a logarithmic scale.
 *
 * @param y Y in XYZ
 * @return L* in L*a*b*
 */ function $ad39de81c51fbcac$var$lstarFromY(y) {
    return $ad39de81c51fbcac$var$labF(y / 100.0) * 116.0 - 16.0;
}
/**
 * Linearizes an RGB component.
 *
 * @param rgbComponent 0 <= rgb_component <= 255, represents R/G/B
 * channel
 * @return 0.0 <= output <= 100.0, color channel converted to
 * linear RGB space
 */ function $ad39de81c51fbcac$var$linearized(rgbComponent) {
    const normalized = rgbComponent / 255.0;
    if (normalized <= 0.040449936) return normalized / 12.92 * 100.0;
    else return Math.pow((normalized + 0.055) / 1.055, 2.4) * 100.0;
}
/**
 * Delinearizes an RGB component.
 *
 * @param rgbComponent 0.0 <= rgb_component <= 100.0, represents
 * linear R/G/B channel
 * @return 0 <= output <= 255, color channel converted to regular
 * RGB space
 */ function $ad39de81c51fbcac$var$delinearized(rgbComponent) {
    const normalized = rgbComponent / 100.0;
    let delinearized = 0.0;
    if (normalized <= 0.0031308) delinearized = normalized * 12.92;
    else delinearized = 1.055 * Math.pow(normalized, 1.0 / 2.4) - 0.055;
    return $ad39de81c51fbcac$var$clampInt(0, 255, Math.round(delinearized * 255.0));
}
/**
 * Returns the standard white point; white on a sunny day.
 *
 * @return The white point
 */ function $ad39de81c51fbcac$var$whitePointD65() {
    return $ad39de81c51fbcac$var$WHITE_POINT_D65;
}
function $ad39de81c51fbcac$var$labF(t) {
    const e = 216.0 / 24389.0;
    const kappa = 24389.0 / 27.0;
    if (t > e) return Math.pow(t, 1.0 / 3.0);
    else return (kappa * t + 16) / 116;
}
function $ad39de81c51fbcac$var$labInvf(ft) {
    const e = 216.0 / 24389.0;
    const kappa = 24389.0 / 27.0;
    const ft3 = ft * ft * ft;
    if (ft3 > e) return ft3;
    else return (116 * ft - 16) / kappa;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * In traditional color spaces, a color can be identified solely by the
 * observer's measurement of the color. Color appearance models such as CAM16
 * also use information about the environment where the color was
 * observed, known as the viewing conditions.
 *
 * For example, white under the traditional assumption of a midday sun white
 * point is accurately measured as a slightly chromatic blue by CAM16. (roughly,
 * hue 203, chroma 3, lightness 100)
 *
 * This class caches intermediate values of the CAM16 conversion process that
 * depend only on viewing conditions, enabling speed ups.
 */ class $ad39de81c51fbcac$var$ViewingConditions {
    /**
   * Create ViewingConditions from a simple, physically relevant, set of
   * parameters.
   *
   * @param whitePoint White point, measured in the XYZ color space.
   *     default = D65, or sunny day afternoon
   * @param adaptingLuminance The luminance of the adapting field. Informally,
   *     how bright it is in the room where the color is viewed. Can be
   *     calculated from lux by multiplying lux by 0.0586. default = 11.72,
   *     or 200 lux.
   * @param backgroundLstar The lightness of the area surrounding the color.
   *     measured by L* in L*a*b*. default = 50.0
   * @param surround A general description of the lighting surrounding the
   *     color. 0 is pitch dark, like watching a movie in a theater. 1.0 is a
   *     dimly light room, like watching TV at home at night. 2.0 means there
   *     is no difference between the lighting on the color and around it.
   *     default = 2.0
   * @param discountingIlluminant Whether the eye accounts for the tint of the
   *     ambient lighting, such as knowing an apple is still red in green light.
   *     default = false, the eye does not perform this process on
   *       self-luminous objects like displays.
   */ static make(whitePoint = $ad39de81c51fbcac$var$whitePointD65(), adaptingLuminance = 200.0 / Math.PI * $ad39de81c51fbcac$var$yFromLstar(50.0) / 100.0, backgroundLstar = 50.0, surround = 2.0, discountingIlluminant = false) {
        const xyz = whitePoint;
        const rW = xyz[0] * 0.401288 + xyz[1] * 0.650173 + xyz[2] * -0.051461;
        const gW = xyz[0] * -0.250268 + xyz[1] * 1.204414 + xyz[2] * 0.045854;
        const bW = xyz[0] * -0.002079 + xyz[1] * 0.048952 + xyz[2] * 0.953127;
        const f = 0.8 + surround / 10.0;
        const c = f >= 0.9 ? $ad39de81c51fbcac$var$lerp(0.59, 0.69, (f - 0.9) * 10.0) : $ad39de81c51fbcac$var$lerp(0.525, 0.59, (f - 0.8) * 10.0);
        let d = discountingIlluminant ? 1.0 : f * (1.0 - 1.0 / 3.6 * Math.exp((-adaptingLuminance - 42.0) / 92.0));
        d = d > 1.0 ? 1.0 : d < 0.0 ? 0.0 : d;
        const nc = f;
        const rgbD = [
            d * (100.0 / rW) + 1.0 - d,
            d * (100.0 / gW) + 1.0 - d,
            d * (100.0 / bW) + 1.0 - d
        ];
        const k = 1.0 / (5.0 * adaptingLuminance + 1.0);
        const k4 = k * k * k * k;
        const k4F = 1.0 - k4;
        const fl = k4 * adaptingLuminance + 0.1 * k4F * k4F * Math.cbrt(5.0 * adaptingLuminance);
        const n = $ad39de81c51fbcac$var$yFromLstar(backgroundLstar) / whitePoint[1];
        const z = 1.48 + Math.sqrt(n);
        const nbb = 0.725 / Math.pow(n, 0.2);
        const ncb = nbb;
        const rgbAFactors = [
            Math.pow(fl * rgbD[0] * rW / 100.0, 0.42),
            Math.pow(fl * rgbD[1] * gW / 100.0, 0.42),
            Math.pow(fl * rgbD[2] * bW / 100.0, 0.42)
        ];
        const rgbA = [
            400.0 * rgbAFactors[0] / (rgbAFactors[0] + 27.13),
            400.0 * rgbAFactors[1] / (rgbAFactors[1] + 27.13),
            400.0 * rgbAFactors[2] / (rgbAFactors[2] + 27.13)
        ];
        const aw = (2.0 * rgbA[0] + rgbA[1] + 0.05 * rgbA[2]) * nbb;
        return new $ad39de81c51fbcac$var$ViewingConditions(n, aw, nbb, ncb, c, nc, rgbD, fl, Math.pow(fl, 0.25), z);
    }
    /**
   * Parameters are intermediate values of the CAM16 conversion process. Their
   * names are shorthand for technical color science terminology, this class
   * would not benefit from documenting them individually. A brief overview
   * is available in the CAM16 specification, and a complete overview requires
   * a color science textbook, such as Fairchild's Color Appearance Models.
   */ constructor(n, aw, nbb, ncb, c, nc, rgbD, fl, fLRoot, z){
        this.n = n;
        this.aw = aw;
        this.nbb = nbb;
        this.ncb = ncb;
        this.c = c;
        this.nc = nc;
        this.rgbD = rgbD;
        this.fl = fl;
        this.fLRoot = fLRoot;
        this.z = z;
    }
}
/** sRGB-like viewing conditions.  */ $ad39de81c51fbcac$var$ViewingConditions.DEFAULT = $ad39de81c51fbcac$var$ViewingConditions.make();
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * CAM16, a color appearance model. Colors are not just defined by their hex
 * code, but rather, a hex code and viewing conditions.
 *
 * CAM16 instances also have coordinates in the CAM16-UCS space, called J*, a*,
 * b*, or jstar, astar, bstar in code. CAM16-UCS is included in the CAM16
 * specification, and should be used when measuring distances between colors.
 *
 * In traditional color spaces, a color can be identified solely by the
 * observer's measurement of the color. Color appearance models such as CAM16
 * also use information about the environment where the color was
 * observed, known as the viewing conditions.
 *
 * For example, white under the traditional assumption of a midday sun white
 * point is accurately measured as a slightly chromatic blue by CAM16. (roughly,
 * hue 203, chroma 3, lightness 100)
 */ class $ad39de81c51fbcac$var$Cam16 {
    /**
   * All of the CAM16 dimensions can be calculated from 3 of the dimensions, in
   * the following combinations:
   *      -  {j or q} and {c, m, or s} and hue
   *      - jstar, astar, bstar
   * Prefer using a static method that constructs from 3 of those dimensions.
   * This constructor is intended for those methods to use to return all
   * possible dimensions.
   *
   * @param hue
   * @param chroma informally, colorfulness / color intensity. like saturation
   *     in HSL, except perceptually accurate.
   * @param j lightness
   * @param q brightness; ratio of lightness to white point's lightness
   * @param m colorfulness
   * @param s saturation; ratio of chroma to white point's chroma
   * @param jstar CAM16-UCS J coordinate
   * @param astar CAM16-UCS a coordinate
   * @param bstar CAM16-UCS b coordinate
   */ constructor(hue, chroma, j, q, m, s, jstar, astar, bstar){
        this.hue = hue;
        this.chroma = chroma;
        this.j = j;
        this.q = q;
        this.m = m;
        this.s = s;
        this.jstar = jstar;
        this.astar = astar;
        this.bstar = bstar;
    }
    /**
   * CAM16 instances also have coordinates in the CAM16-UCS space, called J*,
   * a*, b*, or jstar, astar, bstar in code. CAM16-UCS is included in the CAM16
   * specification, and is used to measure distances between colors.
   */ distance(other) {
        const dJ = this.jstar - other.jstar;
        const dA = this.astar - other.astar;
        const dB = this.bstar - other.bstar;
        const dEPrime = Math.sqrt(dJ * dJ + dA * dA + dB * dB);
        const dE = 1.41 * Math.pow(dEPrime, 0.63);
        return dE;
    }
    /**
   * @param argb ARGB representation of a color.
   * @return CAM16 color, assuming the color was viewed in default viewing
   *     conditions.
   */ static fromInt(argb) {
        return $ad39de81c51fbcac$var$Cam16.fromIntInViewingConditions(argb, $ad39de81c51fbcac$var$ViewingConditions.DEFAULT);
    }
    /**
   * @param argb ARGB representation of a color.
   * @param viewingConditions Information about the environment where the color
   *     was observed.
   * @return CAM16 color.
   */ static fromIntInViewingConditions(argb, viewingConditions) {
        const red = (argb & 0x00ff0000) >> 16;
        const green = (argb & 0x0000ff00) >> 8;
        const blue = argb & 0x000000ff;
        const redL = $ad39de81c51fbcac$var$linearized(red);
        const greenL = $ad39de81c51fbcac$var$linearized(green);
        const blueL = $ad39de81c51fbcac$var$linearized(blue);
        const x = 0.41233895 * redL + 0.35762064 * greenL + 0.18051042 * blueL;
        const y = 0.2126 * redL + 0.7152 * greenL + 0.0722 * blueL;
        const z = 0.01932141 * redL + 0.11916382 * greenL + 0.95034478 * blueL;
        const rC = 0.401288 * x + 0.650173 * y - 0.051461 * z;
        const gC = -0.250268 * x + 1.204414 * y + 0.045854 * z;
        const bC = -0.002079 * x + 0.048952 * y + 0.953127 * z;
        const rD = viewingConditions.rgbD[0] * rC;
        const gD = viewingConditions.rgbD[1] * gC;
        const bD = viewingConditions.rgbD[2] * bC;
        const rAF = Math.pow(viewingConditions.fl * Math.abs(rD) / 100.0, 0.42);
        const gAF = Math.pow(viewingConditions.fl * Math.abs(gD) / 100.0, 0.42);
        const bAF = Math.pow(viewingConditions.fl * Math.abs(bD) / 100.0, 0.42);
        const rA = $ad39de81c51fbcac$var$signum(rD) * 400.0 * rAF / (rAF + 27.13);
        const gA = $ad39de81c51fbcac$var$signum(gD) * 400.0 * gAF / (gAF + 27.13);
        const bA = $ad39de81c51fbcac$var$signum(bD) * 400.0 * bAF / (bAF + 27.13);
        const a = (11.0 * rA + -12 * gA + bA) / 11.0;
        const b = (rA + gA - 2.0 * bA) / 9.0;
        const u = (20.0 * rA + 20.0 * gA + 21.0 * bA) / 20.0;
        const p2 = (40.0 * rA + 20.0 * gA + bA) / 20.0;
        const atan2 = Math.atan2(b, a);
        const atanDegrees = atan2 * 180.0 / Math.PI;
        const hue = atanDegrees < 0 ? atanDegrees + 360.0 : atanDegrees >= 360 ? atanDegrees - 360.0 : atanDegrees;
        const hueRadians = hue * Math.PI / 180.0;
        const ac = p2 * viewingConditions.nbb;
        const j = 100.0 * Math.pow(ac / viewingConditions.aw, viewingConditions.c * viewingConditions.z);
        const q = 4.0 / viewingConditions.c * Math.sqrt(j / 100.0) * (viewingConditions.aw + 4.0) * viewingConditions.fLRoot;
        const huePrime = hue < 20.14 ? hue + 360 : hue;
        const eHue = 0.25 * (Math.cos(huePrime * Math.PI / 180.0 + 2.0) + 3.8);
        const p1 = 50000.0 / 13.0 * eHue * viewingConditions.nc * viewingConditions.ncb;
        const t = p1 * Math.sqrt(a * a + b * b) / (u + 0.305);
        const alpha = Math.pow(t, 0.9) * Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73);
        const c = alpha * Math.sqrt(j / 100.0);
        const m = c * viewingConditions.fLRoot;
        const s = 50.0 * Math.sqrt(alpha * viewingConditions.c / (viewingConditions.aw + 4.0));
        const jstar = (1.0 + 100.0 * 0.007) * j / (1.0 + 0.007 * j);
        const mstar = 1.0 / 0.0228 * Math.log(1.0 + 0.0228 * m);
        const astar = mstar * Math.cos(hueRadians);
        const bstar = mstar * Math.sin(hueRadians);
        return new $ad39de81c51fbcac$var$Cam16(hue, c, j, q, m, s, jstar, astar, bstar);
    }
    /**
   * @param j CAM16 lightness
   * @param c CAM16 chroma
   * @param h CAM16 hue
   */ static fromJch(j, c, h) {
        return $ad39de81c51fbcac$var$Cam16.fromJchInViewingConditions(j, c, h, $ad39de81c51fbcac$var$ViewingConditions.DEFAULT);
    }
    /**
   * @param j CAM16 lightness
   * @param c CAM16 chroma
   * @param h CAM16 hue
   * @param viewingConditions Information about the environment where the color
   *     was observed.
   */ static fromJchInViewingConditions(j, c, h, viewingConditions) {
        const q = 4.0 / viewingConditions.c * Math.sqrt(j / 100.0) * (viewingConditions.aw + 4.0) * viewingConditions.fLRoot;
        const m = c * viewingConditions.fLRoot;
        const alpha = c / Math.sqrt(j / 100.0);
        const s = 50.0 * Math.sqrt(alpha * viewingConditions.c / (viewingConditions.aw + 4.0));
        const hueRadians = h * Math.PI / 180.0;
        const jstar = (1.0 + 100.0 * 0.007) * j / (1.0 + 0.007 * j);
        const mstar = 1.0 / 0.0228 * Math.log(1.0 + 0.0228 * m);
        const astar = mstar * Math.cos(hueRadians);
        const bstar = mstar * Math.sin(hueRadians);
        return new $ad39de81c51fbcac$var$Cam16(h, c, j, q, m, s, jstar, astar, bstar);
    }
    /**
   * @param jstar CAM16-UCS lightness.
   * @param astar CAM16-UCS a dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the Y axis.
   * @param bstar CAM16-UCS b dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the X axis.
   */ static fromUcs(jstar, astar, bstar) {
        return $ad39de81c51fbcac$var$Cam16.fromUcsInViewingConditions(jstar, astar, bstar, $ad39de81c51fbcac$var$ViewingConditions.DEFAULT);
    }
    /**
   * @param jstar CAM16-UCS lightness.
   * @param astar CAM16-UCS a dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the Y axis.
   * @param bstar CAM16-UCS b dimension. Like a* in L*a*b*, it is a Cartesian
   *     coordinate on the X axis.
   * @param viewingConditions Information about the environment where the color
   *     was observed.
   */ static fromUcsInViewingConditions(jstar, astar, bstar, viewingConditions) {
        const a = astar;
        const b = bstar;
        const m = Math.sqrt(a * a + b * b);
        const M = (Math.exp(m * 0.0228) - 1.0) / 0.0228;
        const c = M / viewingConditions.fLRoot;
        let h = Math.atan2(b, a) * (180.0 / Math.PI);
        if (h < 0.0) h += 360.0;
        const j = jstar / (1 - (jstar - 100) * 0.007);
        return $ad39de81c51fbcac$var$Cam16.fromJchInViewingConditions(j, c, h, viewingConditions);
    }
    /**
   *  @return ARGB representation of color, assuming the color was viewed in
   *     default viewing conditions, which are near-identical to the default
   *     viewing conditions for sRGB.
   */ toInt() {
        return this.viewed($ad39de81c51fbcac$var$ViewingConditions.DEFAULT);
    }
    /**
   * @param viewingConditions Information about the environment where the color
   *     will be viewed.
   * @return ARGB representation of color
   */ viewed(viewingConditions) {
        const alpha = this.chroma === 0.0 || this.j === 0.0 ? 0.0 : this.chroma / Math.sqrt(this.j / 100.0);
        const t = Math.pow(alpha / Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73), 1.0 / 0.9);
        const hRad = this.hue * Math.PI / 180.0;
        const eHue = 0.25 * (Math.cos(hRad + 2.0) + 3.8);
        const ac = viewingConditions.aw * Math.pow(this.j / 100.0, 1.0 / viewingConditions.c / viewingConditions.z);
        const p1 = eHue * (50000.0 / 13.0) * viewingConditions.nc * viewingConditions.ncb;
        const p2 = ac / viewingConditions.nbb;
        const hSin = Math.sin(hRad);
        const hCos = Math.cos(hRad);
        const gamma = 23.0 * (p2 + 0.305) * t / (23.0 * p1 + 11.0 * t * hCos + 108.0 * t * hSin);
        const a = gamma * hCos;
        const b = gamma * hSin;
        const rA = (460.0 * p2 + 451.0 * a + 288.0 * b) / 1403.0;
        const gA = (460.0 * p2 - 891.0 * a - 261.0 * b) / 1403.0;
        const bA = (460.0 * p2 - 220.0 * a - 6300.0 * b) / 1403.0;
        const rCBase = Math.max(0, 27.13 * Math.abs(rA) / (400.0 - Math.abs(rA)));
        const rC = $ad39de81c51fbcac$var$signum(rA) * (100.0 / viewingConditions.fl) * Math.pow(rCBase, 1.0 / 0.42);
        const gCBase = Math.max(0, 27.13 * Math.abs(gA) / (400.0 - Math.abs(gA)));
        const gC = $ad39de81c51fbcac$var$signum(gA) * (100.0 / viewingConditions.fl) * Math.pow(gCBase, 1.0 / 0.42);
        const bCBase = Math.max(0, 27.13 * Math.abs(bA) / (400.0 - Math.abs(bA)));
        const bC = $ad39de81c51fbcac$var$signum(bA) * (100.0 / viewingConditions.fl) * Math.pow(bCBase, 1.0 / 0.42);
        const rF = rC / viewingConditions.rgbD[0];
        const gF = gC / viewingConditions.rgbD[1];
        const bF = bC / viewingConditions.rgbD[2];
        const x = 1.86206786 * rF - 1.01125463 * gF + 0.14918677 * bF;
        const y = 0.38752654 * rF + 0.62144744 * gF - 0.00897398 * bF;
        const z = -0.0158415 * rF - 0.03412294 * gF + 1.04996444 * bF;
        const argb = $ad39de81c51fbcac$var$argbFromXyz(x, y, z);
        return argb;
    }
    /// Given color expressed in XYZ and viewed in [viewingConditions], convert to
    /// CAM16.
    static fromXyzInViewingConditions(x, y, z, viewingConditions) {
        // Transform XYZ to 'cone'/'rgb' responses
        const rC = 0.401288 * x + 0.650173 * y - 0.051461 * z;
        const gC = -0.250268 * x + 1.204414 * y + 0.045854 * z;
        const bC = -0.002079 * x + 0.048952 * y + 0.953127 * z;
        // Discount illuminant
        const rD = viewingConditions.rgbD[0] * rC;
        const gD = viewingConditions.rgbD[1] * gC;
        const bD = viewingConditions.rgbD[2] * bC;
        // chromatic adaptation
        const rAF = Math.pow(viewingConditions.fl * Math.abs(rD) / 100.0, 0.42);
        const gAF = Math.pow(viewingConditions.fl * Math.abs(gD) / 100.0, 0.42);
        const bAF = Math.pow(viewingConditions.fl * Math.abs(bD) / 100.0, 0.42);
        const rA = $ad39de81c51fbcac$var$signum(rD) * 400.0 * rAF / (rAF + 27.13);
        const gA = $ad39de81c51fbcac$var$signum(gD) * 400.0 * gAF / (gAF + 27.13);
        const bA = $ad39de81c51fbcac$var$signum(bD) * 400.0 * bAF / (bAF + 27.13);
        // redness-greenness
        const a = (11.0 * rA + -12 * gA + bA) / 11.0;
        // yellowness-blueness
        const b = (rA + gA - 2.0 * bA) / 9.0;
        // auxiliary components
        const u = (20.0 * rA + 20.0 * gA + 21.0 * bA) / 20.0;
        const p2 = (40.0 * rA + 20.0 * gA + bA) / 20.0;
        // hue
        const atan2 = Math.atan2(b, a);
        const atanDegrees = atan2 * 180.0 / Math.PI;
        const hue = atanDegrees < 0 ? atanDegrees + 360.0 : atanDegrees >= 360 ? atanDegrees - 360 : atanDegrees;
        const hueRadians = hue * Math.PI / 180.0;
        // achromatic response to color
        const ac = p2 * viewingConditions.nbb;
        // CAM16 lightness and brightness
        const J = 100.0 * Math.pow(ac / viewingConditions.aw, viewingConditions.c * viewingConditions.z);
        const Q = 4.0 / viewingConditions.c * Math.sqrt(J / 100.0) * (viewingConditions.aw + 4.0) * viewingConditions.fLRoot;
        const huePrime = hue < 20.14 ? hue + 360 : hue;
        const eHue = 0.25 * (Math.cos(huePrime * Math.PI / 180.0 + 2.0) + 3.8);
        const p1 = 50000.0 / 13.0 * eHue * viewingConditions.nc * viewingConditions.ncb;
        const t = p1 * Math.sqrt(a * a + b * b) / (u + 0.305);
        const alpha = Math.pow(t, 0.9) * Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73);
        // CAM16 chroma, colorfulness, chroma
        const C = alpha * Math.sqrt(J / 100.0);
        const M = C * viewingConditions.fLRoot;
        const s = 50.0 * Math.sqrt(alpha * viewingConditions.c / (viewingConditions.aw + 4.0));
        // CAM16-UCS components
        const jstar = (1.0 + 100.0 * 0.007) * J / (1.0 + 0.007 * J);
        const mstar = Math.log(1.0 + 0.0228 * M) / 0.0228;
        const astar = mstar * Math.cos(hueRadians);
        const bstar = mstar * Math.sin(hueRadians);
        return new $ad39de81c51fbcac$var$Cam16(hue, C, J, Q, M, s, jstar, astar, bstar);
    }
    /// XYZ representation of CAM16 seen in [viewingConditions].
    xyzInViewingConditions(viewingConditions) {
        const alpha = this.chroma === 0.0 || this.j === 0.0 ? 0.0 : this.chroma / Math.sqrt(this.j / 100.0);
        const t = Math.pow(alpha / Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73), 1.0 / 0.9);
        const hRad = this.hue * Math.PI / 180.0;
        const eHue = 0.25 * (Math.cos(hRad + 2.0) + 3.8);
        const ac = viewingConditions.aw * Math.pow(this.j / 100.0, 1.0 / viewingConditions.c / viewingConditions.z);
        const p1 = eHue * (50000.0 / 13.0) * viewingConditions.nc * viewingConditions.ncb;
        const p2 = ac / viewingConditions.nbb;
        const hSin = Math.sin(hRad);
        const hCos = Math.cos(hRad);
        const gamma = 23.0 * (p2 + 0.305) * t / (23.0 * p1 + 11 * t * hCos + 108.0 * t * hSin);
        const a = gamma * hCos;
        const b = gamma * hSin;
        const rA = (460.0 * p2 + 451.0 * a + 288.0 * b) / 1403.0;
        const gA = (460.0 * p2 - 891.0 * a - 261.0 * b) / 1403.0;
        const bA = (460.0 * p2 - 220.0 * a - 6300.0 * b) / 1403.0;
        const rCBase = Math.max(0, 27.13 * Math.abs(rA) / (400.0 - Math.abs(rA)));
        const rC = $ad39de81c51fbcac$var$signum(rA) * (100.0 / viewingConditions.fl) * Math.pow(rCBase, 1.0 / 0.42);
        const gCBase = Math.max(0, 27.13 * Math.abs(gA) / (400.0 - Math.abs(gA)));
        const gC = $ad39de81c51fbcac$var$signum(gA) * (100.0 / viewingConditions.fl) * Math.pow(gCBase, 1.0 / 0.42);
        const bCBase = Math.max(0, 27.13 * Math.abs(bA) / (400.0 - Math.abs(bA)));
        const bC = $ad39de81c51fbcac$var$signum(bA) * (100.0 / viewingConditions.fl) * Math.pow(bCBase, 1.0 / 0.42);
        const rF = rC / viewingConditions.rgbD[0];
        const gF = gC / viewingConditions.rgbD[1];
        const bF = bC / viewingConditions.rgbD[2];
        const x = 1.86206786 * rF - 1.01125463 * gF + 0.14918677 * bF;
        const y = 0.38752654 * rF + 0.62144744 * gF - 0.00897398 * bF;
        const z = -0.0158415 * rF - 0.03412294 * gF + 1.04996444 * bF;
        return [
            x,
            y,
            z
        ];
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // This file is automatically generated. Do not modify it.
// material_color_utilities is designed to have a consistent API across
// platforms and modular components that can be moved around easily. Using a
// class as a namespace facilitates this.
//
// tslint:disable:class-as-namespace
/**
 * A class that solves the HCT equation.
 */ class $ad39de81c51fbcac$var$HctSolver {
    /**
   * Sanitizes a small enough angle in radians.
   *
   * @param angle An angle in radians; must not deviate too much
   * from 0.
   * @return A coterminal angle between 0 and 2pi.
   */ static sanitizeRadians(angle) {
        return (angle + Math.PI * 8) % (Math.PI * 2);
    }
    /**
   * Delinearizes an RGB component, returning a floating-point
   * number.
   *
   * @param rgbComponent 0.0 <= rgb_component <= 100.0, represents
   * linear R/G/B channel
   * @return 0.0 <= output <= 255.0, color channel converted to
   * regular RGB space
   */ static trueDelinearized(rgbComponent) {
        const normalized = rgbComponent / 100.0;
        let delinearized = 0.0;
        if (normalized <= 0.0031308) delinearized = normalized * 12.92;
        else delinearized = 1.055 * Math.pow(normalized, 1.0 / 2.4) - 0.055;
        return delinearized * 255.0;
    }
    static chromaticAdaptation(component) {
        const af = Math.pow(Math.abs(component), 0.42);
        return $ad39de81c51fbcac$var$signum(component) * 400.0 * af / (af + 27.13);
    }
    /**
   * Returns the hue of a linear RGB color in CAM16.
   *
   * @param linrgb The linear RGB coordinates of a color.
   * @return The hue of the color in CAM16, in radians.
   */ static hueOf(linrgb) {
        const scaledDiscount = $ad39de81c51fbcac$var$matrixMultiply(linrgb, $ad39de81c51fbcac$var$HctSolver.SCALED_DISCOUNT_FROM_LINRGB);
        const rA = $ad39de81c51fbcac$var$HctSolver.chromaticAdaptation(scaledDiscount[0]);
        const gA = $ad39de81c51fbcac$var$HctSolver.chromaticAdaptation(scaledDiscount[1]);
        const bA = $ad39de81c51fbcac$var$HctSolver.chromaticAdaptation(scaledDiscount[2]);
        // redness-greenness
        const a = (11.0 * rA + -12 * gA + bA) / 11.0;
        // yellowness-blueness
        const b = (rA + gA - 2.0 * bA) / 9.0;
        return Math.atan2(b, a);
    }
    static areInCyclicOrder(a, b, c) {
        const deltaAB = $ad39de81c51fbcac$var$HctSolver.sanitizeRadians(b - a);
        const deltaAC = $ad39de81c51fbcac$var$HctSolver.sanitizeRadians(c - a);
        return deltaAB < deltaAC;
    }
    /**
   * Solves the lerp equation.
   *
   * @param source The starting number.
   * @param mid The number in the middle.
   * @param target The ending number.
   * @return A number t such that lerp(source, target, t) = mid.
   */ static intercept(source, mid, target) {
        return (mid - source) / (target - source);
    }
    static lerpPoint(source, t, target) {
        return [
            source[0] + (target[0] - source[0]) * t,
            source[1] + (target[1] - source[1]) * t,
            source[2] + (target[2] - source[2]) * t
        ];
    }
    /**
   * Intersects a segment with a plane.
   *
   * @param source The coordinates of point A.
   * @param coordinate The R-, G-, or B-coordinate of the plane.
   * @param target The coordinates of point B.
   * @param axis The axis the plane is perpendicular with. (0: R, 1:
   * G, 2: B)
   * @return The intersection point of the segment AB with the plane
   * R=coordinate, G=coordinate, or B=coordinate
   */ static setCoordinate(source, coordinate, target, axis) {
        const t = $ad39de81c51fbcac$var$HctSolver.intercept(source[axis], coordinate, target[axis]);
        return $ad39de81c51fbcac$var$HctSolver.lerpPoint(source, t, target);
    }
    static isBounded(x) {
        return 0.0 <= x && x <= 100.0;
    }
    /**
   * Returns the nth possible vertex of the polygonal intersection.
   *
   * @param y The Y value of the plane.
   * @param n The zero-based index of the point. 0 <= n <= 11.
   * @return The nth possible vertex of the polygonal intersection
   * of the y plane and the RGB cube, in linear RGB coordinates, if
   * it exists. If this possible vertex lies outside of the cube,
   * [-1.0, -1.0, -1.0] is returned.
   */ static nthVertex(y, n) {
        const kR = $ad39de81c51fbcac$var$HctSolver.Y_FROM_LINRGB[0];
        const kG = $ad39de81c51fbcac$var$HctSolver.Y_FROM_LINRGB[1];
        const kB = $ad39de81c51fbcac$var$HctSolver.Y_FROM_LINRGB[2];
        const coordA = n % 4 <= 1 ? 0.0 : 100.0;
        const coordB = n % 2 === 0 ? 0.0 : 100.0;
        if (n < 4) {
            const g = coordA;
            const b = coordB;
            const r = (y - g * kG - b * kB) / kR;
            if ($ad39de81c51fbcac$var$HctSolver.isBounded(r)) return [
                r,
                g,
                b
            ];
            else return [
                -1,
                -1,
                -1
            ];
        } else if (n < 8) {
            const b = coordA;
            const r = coordB;
            const g = (y - r * kR - b * kB) / kG;
            if ($ad39de81c51fbcac$var$HctSolver.isBounded(g)) return [
                r,
                g,
                b
            ];
            else return [
                -1,
                -1,
                -1
            ];
        } else {
            const r = coordA;
            const g = coordB;
            const b = (y - r * kR - g * kG) / kB;
            if ($ad39de81c51fbcac$var$HctSolver.isBounded(b)) return [
                r,
                g,
                b
            ];
            else return [
                -1,
                -1,
                -1
            ];
        }
    }
    /**
   * Finds the segment containing the desired color.
   *
   * @param y The Y value of the color.
   * @param targetHue The hue of the color.
   * @return A list of two sets of linear RGB coordinates, each
   * corresponding to an endpoint of the segment containing the
   * desired color.
   */ static bisectToSegment(y, targetHue) {
        let left = [
            -1,
            -1,
            -1
        ];
        let right = left;
        let leftHue = 0.0;
        let rightHue = 0.0;
        let initialized = false;
        let uncut = true;
        for(let n = 0; n < 12; n++){
            const mid = $ad39de81c51fbcac$var$HctSolver.nthVertex(y, n);
            if (mid[0] < 0) continue;
            const midHue = $ad39de81c51fbcac$var$HctSolver.hueOf(mid);
            if (!initialized) {
                left = mid;
                right = mid;
                leftHue = midHue;
                rightHue = midHue;
                initialized = true;
                continue;
            }
            if (uncut || $ad39de81c51fbcac$var$HctSolver.areInCyclicOrder(leftHue, midHue, rightHue)) {
                uncut = false;
                if ($ad39de81c51fbcac$var$HctSolver.areInCyclicOrder(leftHue, targetHue, midHue)) {
                    right = mid;
                    rightHue = midHue;
                } else {
                    left = mid;
                    leftHue = midHue;
                }
            }
        }
        return [
            left,
            right
        ];
    }
    static midpoint(a, b) {
        return [
            (a[0] + b[0]) / 2,
            (a[1] + b[1]) / 2,
            (a[2] + b[2]) / 2
        ];
    }
    static criticalPlaneBelow(x) {
        return Math.floor(x - 0.5);
    }
    static criticalPlaneAbove(x) {
        return Math.ceil(x - 0.5);
    }
    /**
   * Finds a color with the given Y and hue on the boundary of the
   * cube.
   *
   * @param y The Y value of the color.
   * @param targetHue The hue of the color.
   * @return The desired color, in linear RGB coordinates.
   */ static bisectToLimit(y, targetHue) {
        const segment = $ad39de81c51fbcac$var$HctSolver.bisectToSegment(y, targetHue);
        let left = segment[0];
        let leftHue = $ad39de81c51fbcac$var$HctSolver.hueOf(left);
        let right = segment[1];
        for(let axis = 0; axis < 3; axis++)if (left[axis] !== right[axis]) {
            let lPlane = -1;
            let rPlane = 255;
            if (left[axis] < right[axis]) {
                lPlane = $ad39de81c51fbcac$var$HctSolver.criticalPlaneBelow($ad39de81c51fbcac$var$HctSolver.trueDelinearized(left[axis]));
                rPlane = $ad39de81c51fbcac$var$HctSolver.criticalPlaneAbove($ad39de81c51fbcac$var$HctSolver.trueDelinearized(right[axis]));
            } else {
                lPlane = $ad39de81c51fbcac$var$HctSolver.criticalPlaneAbove($ad39de81c51fbcac$var$HctSolver.trueDelinearized(left[axis]));
                rPlane = $ad39de81c51fbcac$var$HctSolver.criticalPlaneBelow($ad39de81c51fbcac$var$HctSolver.trueDelinearized(right[axis]));
            }
            for(let i = 0; i < 8; i++){
                if (Math.abs(rPlane - lPlane) <= 1) break;
                else {
                    const mPlane = Math.floor((lPlane + rPlane) / 2.0);
                    const midPlaneCoordinate = $ad39de81c51fbcac$var$HctSolver.CRITICAL_PLANES[mPlane];
                    const mid = $ad39de81c51fbcac$var$HctSolver.setCoordinate(left, midPlaneCoordinate, right, axis);
                    const midHue = $ad39de81c51fbcac$var$HctSolver.hueOf(mid);
                    if ($ad39de81c51fbcac$var$HctSolver.areInCyclicOrder(leftHue, targetHue, midHue)) {
                        right = mid;
                        rPlane = mPlane;
                    } else {
                        left = mid;
                        leftHue = midHue;
                        lPlane = mPlane;
                    }
                }
            }
        }
        return $ad39de81c51fbcac$var$HctSolver.midpoint(left, right);
    }
    static inverseChromaticAdaptation(adapted) {
        const adaptedAbs = Math.abs(adapted);
        const base = Math.max(0, 27.13 * adaptedAbs / (400.0 - adaptedAbs));
        return $ad39de81c51fbcac$var$signum(adapted) * Math.pow(base, 1.0 / 0.42);
    }
    /**
   * Finds a color with the given hue, chroma, and Y.
   *
   * @param hueRadians The desired hue in radians.
   * @param chroma The desired chroma.
   * @param y The desired Y.
   * @return The desired color as a hexadecimal integer, if found; 0
   * otherwise.
   */ static findResultByJ(hueRadians, chroma, y) {
        // Initial estimate of j.
        let j = Math.sqrt(y) * 11.0;
        // ===========================================================
        // Operations inlined from Cam16 to avoid repeated calculation
        // ===========================================================
        const viewingConditions = $ad39de81c51fbcac$var$ViewingConditions.DEFAULT;
        const tInnerCoeff = 1 / Math.pow(1.64 - Math.pow(0.29, viewingConditions.n), 0.73);
        const eHue = 0.25 * (Math.cos(hueRadians + 2.0) + 3.8);
        const p1 = eHue * (50000.0 / 13.0) * viewingConditions.nc * viewingConditions.ncb;
        const hSin = Math.sin(hueRadians);
        const hCos = Math.cos(hueRadians);
        for(let iterationRound = 0; iterationRound < 5; iterationRound++){
            // ===========================================================
            // Operations inlined from Cam16 to avoid repeated calculation
            // ===========================================================
            const jNormalized = j / 100.0;
            const alpha = chroma === 0.0 || j === 0.0 ? 0.0 : chroma / Math.sqrt(jNormalized);
            const t = Math.pow(alpha * tInnerCoeff, 1.0 / 0.9);
            const ac = viewingConditions.aw * Math.pow(jNormalized, 1.0 / viewingConditions.c / viewingConditions.z);
            const p2 = ac / viewingConditions.nbb;
            const gamma = 23.0 * (p2 + 0.305) * t / (23.0 * p1 + 11 * t * hCos + 108.0 * t * hSin);
            const a = gamma * hCos;
            const b = gamma * hSin;
            const rA = (460.0 * p2 + 451.0 * a + 288.0 * b) / 1403.0;
            const gA = (460.0 * p2 - 891.0 * a - 261.0 * b) / 1403.0;
            const bA = (460.0 * p2 - 220.0 * a - 6300.0 * b) / 1403.0;
            const rCScaled = $ad39de81c51fbcac$var$HctSolver.inverseChromaticAdaptation(rA);
            const gCScaled = $ad39de81c51fbcac$var$HctSolver.inverseChromaticAdaptation(gA);
            const bCScaled = $ad39de81c51fbcac$var$HctSolver.inverseChromaticAdaptation(bA);
            const linrgb = $ad39de81c51fbcac$var$matrixMultiply([
                rCScaled,
                gCScaled,
                bCScaled
            ], $ad39de81c51fbcac$var$HctSolver.LINRGB_FROM_SCALED_DISCOUNT);
            // ===========================================================
            // Operations inlined from Cam16 to avoid repeated calculation
            // ===========================================================
            if (linrgb[0] < 0 || linrgb[1] < 0 || linrgb[2] < 0) return 0;
            const kR = $ad39de81c51fbcac$var$HctSolver.Y_FROM_LINRGB[0];
            const kG = $ad39de81c51fbcac$var$HctSolver.Y_FROM_LINRGB[1];
            const kB = $ad39de81c51fbcac$var$HctSolver.Y_FROM_LINRGB[2];
            const fnj = kR * linrgb[0] + kG * linrgb[1] + kB * linrgb[2];
            if (fnj <= 0) return 0;
            if (iterationRound === 4 || Math.abs(fnj - y) < 0.002) {
                if (linrgb[0] > 100.01 || linrgb[1] > 100.01 || linrgb[2] > 100.01) return 0;
                return $ad39de81c51fbcac$var$argbFromLinrgb(linrgb);
            }
            // Iterates with Newton method,
            // Using 2 * fn(j) / j as the approximation of fn'(j)
            j = j - (fnj - y) * j / (2 * fnj);
        }
        return 0;
    }
    /**
   * Finds an sRGB color with the given hue, chroma, and L*, if
   * possible.
   *
   * @param hueDegrees The desired hue, in degrees.
   * @param chroma The desired chroma.
   * @param lstar The desired L*.
   * @return A hexadecimal representing the sRGB color. The color
   * has sufficiently close hue, chroma, and L* to the desired
   * values, if possible; otherwise, the hue and L* will be
   * sufficiently close, and chroma will be maximized.
   */ static solveToInt(hueDegrees, chroma, lstar) {
        if (chroma < 0.0001 || lstar < 0.0001 || lstar > 99.9999) return $ad39de81c51fbcac$var$argbFromLstar(lstar);
        hueDegrees = $ad39de81c51fbcac$var$sanitizeDegreesDouble(hueDegrees);
        const hueRadians = hueDegrees / 180 * Math.PI;
        const y = $ad39de81c51fbcac$var$yFromLstar(lstar);
        const exactAnswer = $ad39de81c51fbcac$var$HctSolver.findResultByJ(hueRadians, chroma, y);
        if (exactAnswer !== 0) return exactAnswer;
        const linrgb = $ad39de81c51fbcac$var$HctSolver.bisectToLimit(y, hueRadians);
        return $ad39de81c51fbcac$var$argbFromLinrgb(linrgb);
    }
    /**
   * Finds an sRGB color with the given hue, chroma, and L*, if
   * possible.
   *
   * @param hueDegrees The desired hue, in degrees.
   * @param chroma The desired chroma.
   * @param lstar The desired L*.
   * @return An CAM16 object representing the sRGB color. The color
   * has sufficiently close hue, chroma, and L* to the desired
   * values, if possible; otherwise, the hue and L* will be
   * sufficiently close, and chroma will be maximized.
   */ static solveToCam(hueDegrees, chroma, lstar) {
        return $ad39de81c51fbcac$var$Cam16.fromInt($ad39de81c51fbcac$var$HctSolver.solveToInt(hueDegrees, chroma, lstar));
    }
}
$ad39de81c51fbcac$var$HctSolver.SCALED_DISCOUNT_FROM_LINRGB = [
    [
        0.001200833568784504,
        0.002389694492170889,
        0.0002795742885861124
    ],
    [
        0.0005891086651375999,
        0.0029785502573438758,
        0.0003270666104008398
    ],
    [
        0.00010146692491640572,
        0.0005364214359186694,
        0.0032979401770712076
    ]
];
$ad39de81c51fbcac$var$HctSolver.LINRGB_FROM_SCALED_DISCOUNT = [
    [
        1373.2198709594231,
        -1100.4251190754821,
        -7.278681089101213
    ],
    [
        -271.815969077903,
        559.6580465940733,
        -32.46047482791194
    ],
    [
        1.9622899599665666,
        -57.173814538844006,
        308.7233197812385
    ]
];
$ad39de81c51fbcac$var$HctSolver.Y_FROM_LINRGB = [
    0.2126,
    0.7152,
    0.0722
];
$ad39de81c51fbcac$var$HctSolver.CRITICAL_PLANES = [
    0.015176349177441876,
    0.045529047532325624,
    0.07588174588720938,
    0.10623444424209313,
    0.13658714259697685,
    0.16693984095186062,
    0.19729253930674434,
    0.2276452376616281,
    0.2579979360165119,
    0.28835063437139563,
    0.3188300904430532,
    0.350925934958123,
    0.3848314933096426,
    0.42057480301049466,
    0.458183274052838,
    0.4976837250274023,
    0.5391024159806381,
    0.5824650784040898,
    0.6277969426914107,
    0.6751227633498623,
    0.7244668422128921,
    0.775853049866786,
    0.829304845476233,
    0.8848452951698498,
    0.942497089126609,
    1.0022825574869039,
    1.0642236851973577,
    1.1283421258858297,
    1.1946592148522128,
    1.2631959812511864,
    1.3339731595349034,
    1.407011200216447,
    1.4823302800086415,
    1.5599503113873272,
    1.6398909516233677,
    1.7221716113234105,
    1.8068114625156377,
    1.8938294463134073,
    1.9832442801866852,
    2.075074464868551,
    2.1693382909216234,
    2.2660538449872063,
    2.36523901573795,
    2.4669114995532007,
    2.5710888059345764,
    2.6777882626779785,
    2.7870270208169257,
    2.898822059350997,
    3.0131901897720907,
    3.1301480604002863,
    3.2497121605402226,
    3.3718988244681087,
    3.4967242352587946,
    3.624204428461639,
    3.754355295633311,
    3.887192587735158,
    4.022731918402185,
    4.160988767090289,
    4.301978482107941,
    4.445716283538092,
    4.592217266055746,
    4.741496401646282,
    4.893568542229298,
    5.048448422192488,
    5.20615066083972,
    5.3666897647573375,
    5.5300801301023865,
    5.696336044816294,
    5.865471690767354,
    6.037501145825082,
    6.212438385869475,
    6.390297286737924,
    6.571091626112461,
    6.7548350853498045,
    6.941541251256611,
    7.131223617812143,
    7.323895587840543,
    7.5195704746346665,
    7.7182615035334345,
    7.919981813454504,
    8.124744458384042,
    8.332562408825165,
    8.543448553206703,
    8.757415699253682,
    8.974476575321063,
    9.194643831691977,
    9.417930041841839,
    9.644347703669503,
    9.873909240696694,
    10.106627003236781,
    10.342513269534024,
    10.58158024687427,
    10.8238400726681,
    11.069304815507364,
    11.317986476196008,
    11.569896988756009,
    11.825048221409341,
    12.083451977536606,
    12.345119996613247,
    12.610063955123938,
    12.878295467455942,
    13.149826086772048,
    13.42466730586372,
    13.702830557985108,
    13.984327217668513,
    14.269168601521828,
    14.55736596900856,
    14.848930523210871,
    15.143873411576273,
    15.44220572664832,
    15.743938506781891,
    16.04908273684337,
    16.35764934889634,
    16.66964922287304,
    16.985093187232053,
    17.30399201960269,
    17.62635644741625,
    17.95219714852476,
    18.281524751807332,
    18.614349837764564,
    18.95068293910138,
    19.290534541298456,
    19.633915083172692,
    19.98083495742689,
    20.331304511189067,
    20.685334046541502,
    21.042933821039977,
    21.404114048223256,
    21.76888489811322,
    22.137256497705877,
    22.50923893145328,
    22.884842241736916,
    23.264076429332462,
    23.6469514538663,
    24.033477234264016,
    24.42366364919083,
    24.817520537484558,
    25.21505769858089,
    25.61628489293138,
    26.021211842414342,
    26.429848230738664,
    26.842203703840827,
    27.258287870275353,
    27.678110301598522,
    28.10168053274597,
    28.529008062403893,
    28.96010235337422,
    29.39497283293396,
    29.83362889318845,
    30.276079891419332,
    30.722335150426627,
    31.172403958865512,
    31.62629557157785,
    32.08401920991837,
    32.54558406207592,
    33.010999283389665,
    33.4802739966603,
    33.953417292456834,
    34.430438229418264,
    34.911345834551085,
    35.39614910352207,
    35.88485700094671,
    36.37747846067349,
    36.87402238606382,
    37.37449765026789,
    37.87891309649659,
    38.38727753828926,
    38.89959975977785,
    39.41588851594697,
    39.93615253289054,
    40.460400508064545,
    40.98864111053629,
    41.520882981230194,
    42.05713473317016,
    42.597404951718396,
    43.141702194811224,
    43.6900349931913,
    44.24241185063697,
    44.798841244188324,
    45.35933162437017,
    45.92389141541209,
    46.49252901546552,
    47.065252796817916,
    47.64207110610409,
    48.22299226451468,
    48.808024568002054,
    49.3971762874833,
    49.9904556690408,
    50.587870934119984,
    51.189430279724725,
    51.79514187861014,
    52.40501387947288,
    53.0190544071392,
    53.637271562750364,
    54.259673423945976,
    54.88626804504493,
    55.517063457223934,
    56.15206766869424,
    56.79128866487574,
    57.43473440856916,
    58.08241284012621,
    58.734331877617365,
    59.39049941699807,
    60.05092333227251,
    60.715611475655585,
    61.38457167773311,
    62.057811747619894,
    62.7353394731159,
    63.417162620860914,
    64.10328893648692,
    64.79372614476921,
    65.48848194977529,
    66.18756403501224,
    66.89098006357258,
    67.59873767827808,
    68.31084450182222,
    69.02730813691093,
    69.74813616640164,
    70.47333615344107,
    71.20291564160104,
    71.93688215501312,
    72.67524319850172,
    73.41800625771542,
    74.16517879925733,
    74.9167682708136,
    75.67278210128072,
    76.43322770089146,
    77.1981124613393,
    77.96744375590167,
    78.74122893956174,
    79.51947534912904,
    80.30219030335869,
    81.08938110306934,
    81.88105503125999,
    82.67721935322541,
    83.4778813166706,
    84.28304815182372,
    85.09272707154808,
    85.90692527145302,
    86.72564993000343,
    87.54890820862819,
    88.3767072518277,
    89.2090541872801,
    90.04595612594655,
    90.88742016217518,
    91.73345337380438,
    92.58406282226491,
    93.43925555268066,
    94.29903859396902,
    95.16341895893969,
    96.03240364439274,
    96.9059996312159,
    97.78421388448044,
    98.6670533535366,
    99.55452497210776
];
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A color system built using CAM16 hue and chroma, and L* from
 * L*a*b*.
 *
 * Using L* creates a link between the color system, contrast, and thus
 * accessibility. Contrast ratio depends on relative luminance, or Y in the XYZ
 * color space. L*, or perceptual luminance can be calculated from Y.
 *
 * Unlike Y, L* is linear to human perception, allowing trivial creation of
 * accurate color tones.
 *
 * Unlike contrast ratio, measuring contrast in L* is linear, and simple to
 * calculate. A difference of 40 in HCT tone guarantees a contrast ratio >= 3.0,
 * and a difference of 50 guarantees a contrast ratio >= 4.5.
 */ /**
 * HCT, hue, chroma, and tone. A color system that provides a perceptually
 * accurate color measurement system that can also accurately render what colors
 * will appear as in different lighting environments.
 */ class $ad39de81c51fbcac$var$Hct {
    static from(hue, chroma, tone) {
        return new $ad39de81c51fbcac$var$Hct($ad39de81c51fbcac$var$HctSolver.solveToInt(hue, chroma, tone));
    }
    /**
   * @param argb ARGB representation of a color.
   * @return HCT representation of a color in default viewing conditions
   */ static fromInt(argb) {
        return new $ad39de81c51fbcac$var$Hct(argb);
    }
    toInt() {
        return this.argb;
    }
    /**
   * A number, in degrees, representing ex. red, orange, yellow, etc.
   * Ranges from 0 <= hue < 360.
   */ get hue() {
        return this.internalHue;
    }
    /**
   * @param newHue 0 <= newHue < 360; invalid values are corrected.
   * Chroma may decrease because chroma has a different maximum for any given
   * hue and tone.
   */ set hue(newHue) {
        this.setInternalState($ad39de81c51fbcac$var$HctSolver.solveToInt(newHue, this.internalChroma, this.internalTone));
    }
    get chroma() {
        return this.internalChroma;
    }
    /**
   * @param newChroma 0 <= newChroma < ?
   * Chroma may decrease because chroma has a different maximum for any given
   * hue and tone.
   */ set chroma(newChroma) {
        this.setInternalState($ad39de81c51fbcac$var$HctSolver.solveToInt(this.internalHue, newChroma, this.internalTone));
    }
    /** Lightness. Ranges from 0 to 100. */ get tone() {
        return this.internalTone;
    }
    /**
   * @param newTone 0 <= newTone <= 100; invalid valids are corrected.
   * Chroma may decrease because chroma has a different maximum for any given
   * hue and tone.
   */ set tone(newTone) {
        this.setInternalState($ad39de81c51fbcac$var$HctSolver.solveToInt(this.internalHue, this.internalChroma, newTone));
    }
    constructor(argb){
        this.argb = argb;
        const cam = $ad39de81c51fbcac$var$Cam16.fromInt(argb);
        this.internalHue = cam.hue;
        this.internalChroma = cam.chroma;
        this.internalTone = $ad39de81c51fbcac$var$lstarFromArgb(argb);
        this.argb = argb;
    }
    setInternalState(argb) {
        const cam = $ad39de81c51fbcac$var$Cam16.fromInt(argb);
        this.internalHue = cam.hue;
        this.internalChroma = cam.chroma;
        this.internalTone = $ad39de81c51fbcac$var$lstarFromArgb(argb);
        this.argb = argb;
    }
    /**
   * Translates a color into different [ViewingConditions].
   *
   * Colors change appearance. They look different with lights on versus off,
   * the same color, as in hex code, on white looks different when on black.
   * This is called color relativity, most famously explicated by Josef Albers
   * in Interaction of Color.
   *
   * In color science, color appearance models can account for this and
   * calculate the appearance of a color in different settings. HCT is based on
   * CAM16, a color appearance model, and uses it to make these calculations.
   *
   * See [ViewingConditions.make] for parameters affecting color appearance.
   */ inViewingConditions(vc) {
        // 1. Use CAM16 to find XYZ coordinates of color in specified VC.
        const cam = $ad39de81c51fbcac$var$Cam16.fromInt(this.toInt());
        const viewedInVc = cam.xyzInViewingConditions(vc);
        // 2. Create CAM16 of those XYZ coordinates in default VC.
        const recastInVc = $ad39de81c51fbcac$var$Cam16.fromXyzInViewingConditions(viewedInVc[0], viewedInVc[1], viewedInVc[2], $ad39de81c51fbcac$var$ViewingConditions.make());
        // 3. Create HCT from:
        // - CAM16 using default VC with XYZ coordinates in specified VC.
        // - L* converted from Y in XYZ coordinates in specified VC.
        const recastHct = $ad39de81c51fbcac$var$Hct.from(recastInVc.hue, recastInVc.chroma, $ad39de81c51fbcac$var$lstarFromY(viewedInVc[1]));
        return recastHct;
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // material_color_utilities is designed to have a consistent API across
// platforms and modular components that can be moved around easily. Using a
// class as a namespace facilitates this.
//
// tslint:disable:class-as-namespace
/**
 * Utility methods for calculating contrast given two colors, or calculating a
 * color given one color and a contrast ratio.
 *
 * Contrast ratio is calculated using XYZ's Y. When linearized to match human
 * perception, Y becomes HCT's tone and L*a*b*'s' L*. Informally, this is the
 * lightness of a color.
 *
 * Methods refer to tone, T in the the HCT color space.
 * Tone is equivalent to L* in the L*a*b* color space, or L in the LCH color
 * space.
 */ class $ad39de81c51fbcac$var$Contrast {
    /**
   * Returns a contrast ratio, which ranges from 1 to 21.
   *
   * @param toneA Tone between 0 and 100. Values outside will be clamped.
   * @param toneB Tone between 0 and 100. Values outside will be clamped.
   */ static ratioOfTones(toneA, toneB) {
        toneA = $ad39de81c51fbcac$var$clampDouble(0.0, 100.0, toneA);
        toneB = $ad39de81c51fbcac$var$clampDouble(0.0, 100.0, toneB);
        return $ad39de81c51fbcac$var$Contrast.ratioOfYs($ad39de81c51fbcac$var$yFromLstar(toneA), $ad39de81c51fbcac$var$yFromLstar(toneB));
    }
    static ratioOfYs(y1, y2) {
        const lighter = y1 > y2 ? y1 : y2;
        const darker = lighter === y2 ? y1 : y2;
        return (lighter + 5.0) / (darker + 5.0);
    }
    /**
   * Returns a tone >= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns -1 if ratio cannot be achieved with tone parameter.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in -1 being returned.
   * @param ratio Contrast ratio of return value and tone.
   * Range is 1 to 21, invalid values have undefined behavior.
   */ static lighter(tone, ratio) {
        if (tone < 0.0 || tone > 100.0) return -1;
        const darkY = $ad39de81c51fbcac$var$yFromLstar(tone);
        const lightY = ratio * (darkY + 5.0) - 5.0;
        const realContrast = $ad39de81c51fbcac$var$Contrast.ratioOfYs(lightY, darkY);
        const delta = Math.abs(realContrast - ratio);
        if (realContrast < ratio && delta > 0.04) return -1;
        // Ensure gamut mapping, which requires a 'range' on tone, will still result
        // the correct ratio by darkening slightly.
        const returnValue = $ad39de81c51fbcac$var$lstarFromY(lightY) + 0.4;
        if (returnValue < 0 || returnValue > 100) return -1;
        return returnValue;
    }
    /**
   * Returns a tone <= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns -1 if ratio cannot be achieved with tone parameter.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in -1 being returned.
   * @param ratio Contrast ratio of return value and tone.
   * Range is 1 to 21, invalid values have undefined behavior.
   */ static darker(tone, ratio) {
        if (tone < 0.0 || tone > 100.0) return -1;
        const lightY = $ad39de81c51fbcac$var$yFromLstar(tone);
        const darkY = (lightY + 5.0) / ratio - 5.0;
        const realContrast = $ad39de81c51fbcac$var$Contrast.ratioOfYs(lightY, darkY);
        const delta = Math.abs(realContrast - ratio);
        if (realContrast < ratio && delta > 0.04) return -1;
        // Ensure gamut mapping, which requires a 'range' on tone, will still result
        // the correct ratio by darkening slightly.
        const returnValue = $ad39de81c51fbcac$var$lstarFromY(darkY) - 0.4;
        if (returnValue < 0 || returnValue > 100) return -1;
        return returnValue;
    }
    /**
   * Returns a tone >= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns 100 if ratio cannot be achieved with tone parameter.
   *
   * This method is unsafe because the returned value is guaranteed to be in
   * bounds for tone, i.e. between 0 and 100. However, that value may not reach
   * the ratio with tone. For example, there is no color lighter than T100.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in 100 being returned.
   * @param ratio Desired contrast ratio of return value and tone parameter.
   * Range is 1 to 21, invalid values have undefined behavior.
   */ static lighterUnsafe(tone, ratio) {
        const lighterSafe = $ad39de81c51fbcac$var$Contrast.lighter(tone, ratio);
        return lighterSafe < 0.0 ? 100.0 : lighterSafe;
    }
    /**
   * Returns a tone >= tone parameter that ensures ratio parameter.
   * Return value is between 0 and 100.
   * Returns 100 if ratio cannot be achieved with tone parameter.
   *
   * This method is unsafe because the returned value is guaranteed to be in
   * bounds for tone, i.e. between 0 and 100. However, that value may not reach
   * the [ratio with [tone]. For example, there is no color darker than T0.
   *
   * @param tone Tone return value must contrast with.
   * Range is 0 to 100. Invalid values will result in 0 being returned.
   * @param ratio Desired contrast ratio of return value and tone parameter.
   * Range is 1 to 21, invalid values have undefined behavior.
   */ static darkerUnsafe(tone, ratio) {
        const darkerSafe = $ad39de81c51fbcac$var$Contrast.darker(tone, ratio);
        return darkerSafe < 0.0 ? 0.0 : darkerSafe;
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // material_color_utilities is designed to have a consistent API across
// platforms and modular components that can be moved around easily. Using a
// class as a namespace facilitates this.
//
// tslint:disable:class-as-namespace
/**
 * Check and/or fix universally disliked colors.
 * Color science studies of color preference indicate universal distaste for
 * dark yellow-greens, and also show this is correlated to distate for
 * biological waste and rotting food.
 *
 * See Palmer and Schloss, 2010 or Schloss and Palmer's Chapter 21 in Handbook
 * of Color Psychology (2015).
 */ class $ad39de81c51fbcac$var$DislikeAnalyzer {
    /**
   * Returns true if a color is disliked.
   *
   * @param hct A color to be judged.
   * @return Whether the color is disliked.
   *
   * Disliked is defined as a dark yellow-green that is not neutral.
   */ static isDisliked(hct) {
        const huePasses = Math.round(hct.hue) >= 90.0 && Math.round(hct.hue) <= 111.0;
        const chromaPasses = Math.round(hct.chroma) > 16.0;
        const tonePasses = Math.round(hct.tone) < 65.0;
        return huePasses && chromaPasses && tonePasses;
    }
    /**
   * If a color is disliked, lighten it to make it likable.
   *
   * @param hct A color to be judged.
   * @return A new color if the original color is disliked, or the original
   *   color if it is acceptable.
   */ static fixIfDisliked(hct) {
        if ($ad39de81c51fbcac$var$DislikeAnalyzer.isDisliked(hct)) return $ad39de81c51fbcac$var$Hct.from(hct.hue, hct.chroma, 70.0);
        return hct;
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A color that adjusts itself based on UI state provided by DynamicScheme.
 *
 * Colors without backgrounds do not change tone when contrast changes. Colors
 * with backgrounds become closer to their background as contrast lowers, and
 * further when contrast increases.
 *
 * Prefer static constructors. They require either a hexcode, a palette and
 * tone, or a hue and chroma. Optionally, they can provide a background
 * DynamicColor.
 */ class $ad39de81c51fbcac$var$DynamicColor {
    /**
   * Create a DynamicColor defined by a TonalPalette and HCT tone.
   *
   * @param args Functions with DynamicScheme as input. Must provide a palette
   * and tone. May provide a background DynamicColor and ToneDeltaConstraint.
   */ static fromPalette(args) {
        return new $ad39de81c51fbcac$var$DynamicColor(args.name ?? '', args.palette, args.tone, args.isBackground ?? false, args.background, args.secondBackground, args.contrastCurve, args.toneDeltaPair);
    }
    /**
   * The base constructor for DynamicColor.
   *
   * _Strongly_ prefer using one of the convenience constructors. This class is
   * arguably too flexible to ensure it can support any scenario. Functional
   * arguments allow  overriding without risks that come with subclasses.
   *
   * For example, the default behavior of adjust tone at max contrast
   * to be at a 7.0 ratio with its background is principled and
   * matches accessibility guidance. That does not mean it's the desired
   * approach for _every_ design system, and every color pairing,
   * always, in every case.
   *
   * @param name The name of the dynamic color. Defaults to empty.
   * @param palette Function that provides a TonalPalette given
   * DynamicScheme. A TonalPalette is defined by a hue and chroma, so this
   * replaces the need to specify hue/chroma. By providing a tonal palette, when
   * contrast adjustments are made, intended chroma can be preserved.
   * @param tone Function that provides a tone, given a DynamicScheme.
   * @param isBackground Whether this dynamic color is a background, with
   * some other color as the foreground. Defaults to false.
   * @param background The background of the dynamic color (as a function of a
   *     `DynamicScheme`), if it exists.
   * @param secondBackground A second background of the dynamic color (as a
   *     function of a `DynamicScheme`), if it
   * exists.
   * @param contrastCurve A `ContrastCurve` object specifying how its contrast
   * against its background should behave in various contrast levels options.
   * @param toneDeltaPair A `ToneDeltaPair` object specifying a tone delta
   * constraint between two colors. One of them must be the color being
   * constructed.
   */ constructor(name, palette, tone, isBackground, background, secondBackground, contrastCurve, toneDeltaPair){
        this.name = name;
        this.palette = palette;
        this.tone = tone;
        this.isBackground = isBackground;
        this.background = background;
        this.secondBackground = secondBackground;
        this.contrastCurve = contrastCurve;
        this.toneDeltaPair = toneDeltaPair;
        this.hctCache = new Map();
        if (!background && secondBackground) throw new Error(`Color ${name} has secondBackground` + `defined, but background is not defined.`);
        if (!background && contrastCurve) throw new Error(`Color ${name} has contrastCurve` + `defined, but background is not defined.`);
        if (background && !contrastCurve) throw new Error(`Color ${name} has background` + `defined, but contrastCurve is not defined.`);
    }
    /**
   * Return a ARGB integer (i.e. a hex code).
   *
   * @param scheme Defines the conditions of the user interface, for example,
   * whether or not it is dark mode or light mode, and what the desired
   * contrast level is.
   */ getArgb(scheme) {
        return this.getHct(scheme).toInt();
    }
    /**
   * Return a color, expressed in the HCT color space, that this
   * DynamicColor is under the conditions in scheme.
   *
   * @param scheme Defines the conditions of the user interface, for example,
   * whether or not it is dark mode or light mode, and what the desired
   * contrast level is.
   */ getHct(scheme) {
        const cachedAnswer = this.hctCache.get(scheme);
        if (cachedAnswer != null) return cachedAnswer;
        const tone = this.getTone(scheme);
        const answer = this.palette(scheme).getHct(tone);
        if (this.hctCache.size > 4) this.hctCache.clear();
        this.hctCache.set(scheme, answer);
        return answer;
    }
    /**
   * Return a tone, T in the HCT color space, that this DynamicColor is under
   * the conditions in scheme.
   *
   * @param scheme Defines the conditions of the user interface, for example,
   * whether or not it is dark mode or light mode, and what the desired
   * contrast level is.
   */ getTone(scheme) {
        const decreasingContrast = scheme.contrastLevel < 0;
        // Case 1: dual foreground, pair of colors with delta constraint.
        if (this.toneDeltaPair) {
            const toneDeltaPair = this.toneDeltaPair(scheme);
            const roleA = toneDeltaPair.roleA;
            const roleB = toneDeltaPair.roleB;
            const delta = toneDeltaPair.delta;
            const polarity = toneDeltaPair.polarity;
            const stayTogether = toneDeltaPair.stayTogether;
            const bg = this.background(scheme);
            const bgTone = bg.getTone(scheme);
            const aIsNearer = polarity === 'nearer' || polarity === 'lighter' && !scheme.isDark || polarity === 'darker' && scheme.isDark;
            const nearer = aIsNearer ? roleA : roleB;
            const farther = aIsNearer ? roleB : roleA;
            const amNearer = this.name === nearer.name;
            const expansionDir = scheme.isDark ? 1 : -1;
            // 1st round: solve to min, each
            const nContrast = nearer.contrastCurve.get(scheme.contrastLevel);
            const fContrast = farther.contrastCurve.get(scheme.contrastLevel);
            // If a color is good enough, it is not adjusted.
            // Initial and adjusted tones for `nearer`
            const nInitialTone = nearer.tone(scheme);
            let nTone = $ad39de81c51fbcac$var$Contrast.ratioOfTones(bgTone, nInitialTone) >= nContrast ? nInitialTone : $ad39de81c51fbcac$var$DynamicColor.foregroundTone(bgTone, nContrast);
            // Initial and adjusted tones for `farther`
            const fInitialTone = farther.tone(scheme);
            let fTone = $ad39de81c51fbcac$var$Contrast.ratioOfTones(bgTone, fInitialTone) >= fContrast ? fInitialTone : $ad39de81c51fbcac$var$DynamicColor.foregroundTone(bgTone, fContrast);
            if (decreasingContrast) {
                // If decreasing contrast, adjust color to the "bare minimum"
                // that satisfies contrast.
                nTone = $ad39de81c51fbcac$var$DynamicColor.foregroundTone(bgTone, nContrast);
                fTone = $ad39de81c51fbcac$var$DynamicColor.foregroundTone(bgTone, fContrast);
            }
            if ((fTone - nTone) * expansionDir >= delta) ;
            else {
                // 2nd round: expand farther to match delta.
                fTone = $ad39de81c51fbcac$var$clampDouble(0, 100, nTone + delta * expansionDir);
                if ((fTone - nTone) * expansionDir >= delta) ;
                else // 3rd round: contract nearer to match delta.
                nTone = $ad39de81c51fbcac$var$clampDouble(0, 100, fTone - delta * expansionDir);
            }
            // Avoids the 50-59 awkward zone.
            if (50 <= nTone && nTone < 60) {
                // If `nearer` is in the awkward zone, move it away, together with
                // `farther`.
                if (expansionDir > 0) {
                    nTone = 60;
                    fTone = Math.max(fTone, nTone + delta * expansionDir);
                } else {
                    nTone = 49;
                    fTone = Math.min(fTone, nTone + delta * expansionDir);
                }
            } else if (50 <= fTone && fTone < 60) {
                if (stayTogether) {
                    // Fixes both, to avoid two colors on opposite sides of the "awkward
                    // zone".
                    if (expansionDir > 0) {
                        nTone = 60;
                        fTone = Math.max(fTone, nTone + delta * expansionDir);
                    } else {
                        nTone = 49;
                        fTone = Math.min(fTone, nTone + delta * expansionDir);
                    }
                } else // Not required to stay together; fixes just one.
                if (expansionDir > 0) fTone = 60;
                else fTone = 49;
            }
            // Returns `nTone` if this color is `nearer`, otherwise `fTone`.
            return amNearer ? nTone : fTone;
        } else {
            // Case 2: No contrast pair; just solve for itself.
            let answer = this.tone(scheme);
            if (this.background == null) return answer; // No adjustment for colors with no background.
            const bgTone = this.background(scheme).getTone(scheme);
            const desiredRatio = this.contrastCurve.get(scheme.contrastLevel);
            if ($ad39de81c51fbcac$var$Contrast.ratioOfTones(bgTone, answer) >= desiredRatio) ;
            else // Rough improvement.
            answer = $ad39de81c51fbcac$var$DynamicColor.foregroundTone(bgTone, desiredRatio);
            if (decreasingContrast) answer = $ad39de81c51fbcac$var$DynamicColor.foregroundTone(bgTone, desiredRatio);
            if (this.isBackground && 50 <= answer && answer < 60) {
                // Must adjust
                if ($ad39de81c51fbcac$var$Contrast.ratioOfTones(49, bgTone) >= desiredRatio) answer = 49;
                else answer = 60;
            }
            if (this.secondBackground) {
                // Case 3: Adjust for dual backgrounds.
                const [bg1, bg2] = [
                    this.background,
                    this.secondBackground
                ];
                const [bgTone1, bgTone2] = [
                    bg1(scheme).getTone(scheme),
                    bg2(scheme).getTone(scheme)
                ];
                const [upper, lower] = [
                    Math.max(bgTone1, bgTone2),
                    Math.min(bgTone1, bgTone2)
                ];
                if ($ad39de81c51fbcac$var$Contrast.ratioOfTones(upper, answer) >= desiredRatio && $ad39de81c51fbcac$var$Contrast.ratioOfTones(lower, answer) >= desiredRatio) return answer;
                // The darkest light tone that satisfies the desired ratio,
                // or -1 if such ratio cannot be reached.
                const lightOption = $ad39de81c51fbcac$var$Contrast.lighter(upper, desiredRatio);
                // The lightest dark tone that satisfies the desired ratio,
                // or -1 if such ratio cannot be reached.
                const darkOption = $ad39de81c51fbcac$var$Contrast.darker(lower, desiredRatio);
                // Tones suitable for the foreground.
                const availables = [];
                if (lightOption !== -1) availables.push(lightOption);
                if (darkOption !== -1) availables.push(darkOption);
                const prefersLight = $ad39de81c51fbcac$var$DynamicColor.tonePrefersLightForeground(bgTone1) || $ad39de81c51fbcac$var$DynamicColor.tonePrefersLightForeground(bgTone2);
                if (prefersLight) return lightOption < 0 ? 100 : lightOption;
                if (availables.length === 1) return availables[0];
                return darkOption < 0 ? 0 : darkOption;
            }
            return answer;
        }
    }
    /**
   * Given a background tone, find a foreground tone, while ensuring they reach
   * a contrast ratio that is as close to [ratio] as possible.
   *
   * @param bgTone Tone in HCT. Range is 0 to 100, undefined behavior when it
   *     falls outside that range.
   * @param ratio The contrast ratio desired between bgTone and the return
   *     value.
   */ static foregroundTone(bgTone, ratio) {
        const lighterTone = $ad39de81c51fbcac$var$Contrast.lighterUnsafe(bgTone, ratio);
        const darkerTone = $ad39de81c51fbcac$var$Contrast.darkerUnsafe(bgTone, ratio);
        const lighterRatio = $ad39de81c51fbcac$var$Contrast.ratioOfTones(lighterTone, bgTone);
        const darkerRatio = $ad39de81c51fbcac$var$Contrast.ratioOfTones(darkerTone, bgTone);
        const preferLighter = $ad39de81c51fbcac$var$DynamicColor.tonePrefersLightForeground(bgTone);
        if (preferLighter) {
            // This handles an edge case where the initial contrast ratio is high
            // (ex. 13.0), and the ratio passed to the function is that high
            // ratio, and both the lighter and darker ratio fails to pass that
            // ratio.
            //
            // This was observed with Tonal Spot's On Primary Container turning
            // black momentarily between high and max contrast in light mode. PC's
            // standard tone was T90, OPC's was T10, it was light mode, and the
            // contrast value was 0.6568521221032331.
            const negligibleDifference = Math.abs(lighterRatio - darkerRatio) < 0.1 && lighterRatio < ratio && darkerRatio < ratio;
            return lighterRatio >= ratio || lighterRatio >= darkerRatio || negligibleDifference ? lighterTone : darkerTone;
        } else return darkerRatio >= ratio || darkerRatio >= lighterRatio ? darkerTone : lighterTone;
    }
    /**
   * Returns whether [tone] prefers a light foreground.
   *
   * People prefer white foregrounds on ~T60-70. Observed over time, and also
   * by Andrew Somers during research for APCA.
   *
   * T60 used as to create the smallest discontinuity possible when skipping
   * down to T49 in order to ensure light foregrounds.
   * Since `tertiaryContainer` in dark monochrome scheme requires a tone of
   * 60, it should not be adjusted. Therefore, 60 is excluded here.
   */ static tonePrefersLightForeground(tone) {
        return Math.round(tone) < 60.0;
    }
    /**
   * Returns whether [tone] can reach a contrast ratio of 4.5 with a lighter
   * color.
   */ static toneAllowsLightForeground(tone) {
        return Math.round(tone) <= 49.0;
    }
    /**
   * Adjust a tone such that white has 4.5 contrast, if the tone is
   * reasonably close to supporting it.
   */ static enableLightForeground(tone) {
        if ($ad39de81c51fbcac$var$DynamicColor.tonePrefersLightForeground(tone) && !$ad39de81c51fbcac$var$DynamicColor.toneAllowsLightForeground(tone)) return 49.0;
        return tone;
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 *  A convenience class for retrieving colors that are constant in hue and
 *  chroma, but vary in tone.
 */ class $ad39de81c51fbcac$var$TonalPalette {
    /**
   * @param argb ARGB representation of a color
   * @return Tones matching that color's hue and chroma.
   */ static fromInt(argb) {
        const hct = $ad39de81c51fbcac$var$Hct.fromInt(argb);
        return $ad39de81c51fbcac$var$TonalPalette.fromHct(hct);
    }
    /**
   * @param hct Hct
   * @return Tones matching that color's hue and chroma.
   */ static fromHct(hct) {
        return new $ad39de81c51fbcac$var$TonalPalette(hct.hue, hct.chroma, hct);
    }
    /**
   * @param hue HCT hue
   * @param chroma HCT chroma
   * @return Tones matching hue and chroma.
   */ static fromHueAndChroma(hue, chroma) {
        const keyColor = new $ad39de81c51fbcac$var$KeyColor(hue, chroma).create();
        return new $ad39de81c51fbcac$var$TonalPalette(hue, chroma, keyColor);
    }
    constructor(hue, chroma, keyColor){
        this.hue = hue;
        this.chroma = chroma;
        this.keyColor = keyColor;
        this.cache = new Map();
    }
    /**
   * @param tone HCT tone, measured from 0 to 100.
   * @return ARGB representation of a color with that tone.
   */ tone(tone) {
        let argb = this.cache.get(tone);
        if (argb === undefined) {
            argb = $ad39de81c51fbcac$var$Hct.from(this.hue, this.chroma, tone).toInt();
            this.cache.set(tone, argb);
        }
        return argb;
    }
    /**
   * @param tone HCT tone.
   * @return HCT representation of a color with that tone.
   */ getHct(tone) {
        return $ad39de81c51fbcac$var$Hct.fromInt(this.tone(tone));
    }
}
/**
 * Key color is a color that represents the hue and chroma of a tonal palette
 */ class $ad39de81c51fbcac$var$KeyColor {
    constructor(hue, requestedChroma){
        this.hue = hue;
        this.requestedChroma = requestedChroma;
        // Cache that maps tone to max chroma to avoid duplicated HCT calculation.
        this.chromaCache = new Map();
        this.maxChromaValue = 200.0;
    }
    /**
   * Creates a key color from a [hue] and a [chroma].
   * The key color is the first tone, starting from T50, matching the given hue
   * and chroma.
   *
   * @return Key color [Hct]
   */ create() {
        // Pivot around T50 because T50 has the most chroma available, on
        // average. Thus it is most likely to have a direct answer.
        const pivotTone = 50;
        const toneStepSize = 1;
        // Epsilon to accept values slightly higher than the requested chroma.
        const epsilon = 0.01;
        // Binary search to find the tone that can provide a chroma that is closest
        // to the requested chroma.
        let lowerTone = 0;
        let upperTone = 100;
        while(lowerTone < upperTone){
            const midTone = Math.floor((lowerTone + upperTone) / 2);
            const isAscending = this.maxChroma(midTone) < this.maxChroma(midTone + toneStepSize);
            const sufficientChroma = this.maxChroma(midTone) >= this.requestedChroma - epsilon;
            if (sufficientChroma) {
                // Either range [lowerTone, midTone] or [midTone, upperTone] has
                // the answer, so search in the range that is closer the pivot tone.
                if (Math.abs(lowerTone - pivotTone) < Math.abs(upperTone - pivotTone)) upperTone = midTone;
                else {
                    if (lowerTone === midTone) return $ad39de81c51fbcac$var$Hct.from(this.hue, this.requestedChroma, lowerTone);
                    lowerTone = midTone;
                }
            } else // As there is no sufficient chroma in the midTone, follow the direction
            // to the chroma peak.
            if (isAscending) lowerTone = midTone + toneStepSize;
            else // Keep midTone for potential chroma peak.
            upperTone = midTone;
        }
        return $ad39de81c51fbcac$var$Hct.from(this.hue, this.requestedChroma, lowerTone);
    }
    // Find the maximum chroma for a given tone
    maxChroma(tone) {
        if (this.chromaCache.has(tone)) return this.chromaCache.get(tone);
        const chroma = $ad39de81c51fbcac$var$Hct.from(this.hue, this.maxChromaValue, tone).chroma;
        this.chromaCache.set(tone, chroma);
        return chroma;
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class containing a value that changes with the contrast level.
 *
 * Usually represents the contrast requirements for a dynamic color on its
 * background. The four values correspond to values for contrast levels -1.0,
 * 0.0, 0.5, and 1.0, respectively.
 */ class $ad39de81c51fbcac$var$ContrastCurve {
    /**
   * Creates a `ContrastCurve` object.
   *
   * @param low Value for contrast level -1.0
   * @param normal Value for contrast level 0.0
   * @param medium Value for contrast level 0.5
   * @param high Value for contrast level 1.0
   */ constructor(low, normal, medium, high){
        this.low = low;
        this.normal = normal;
        this.medium = medium;
        this.high = high;
    }
    /**
   * Returns the value at a given contrast level.
   *
   * @param contrastLevel The contrast level. 0.0 is the default (normal); -1.0
   *     is the lowest; 1.0 is the highest.
   * @return The value. For contrast ratios, a number between 1.0 and 21.0.
   */ get(contrastLevel) {
        if (contrastLevel <= -1) return this.low;
        else if (contrastLevel < 0.0) return $ad39de81c51fbcac$var$lerp(this.low, this.normal, (contrastLevel - -1) / 1);
        else if (contrastLevel < 0.5) return $ad39de81c51fbcac$var$lerp(this.normal, this.medium, (contrastLevel - 0) / 0.5);
        else if (contrastLevel < 1.0) return $ad39de81c51fbcac$var$lerp(this.medium, this.high, (contrastLevel - 0.5) / 0.5);
        else return this.high;
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Documents a constraint between two DynamicColors, in which their tones must
 * have a certain distance from each other.
 *
 * Prefer a DynamicColor with a background, this is for special cases when
 * designers want tonal distance, literally contrast, between two colors that
 * don't have a background / foreground relationship or a contrast guarantee.
 */ class $ad39de81c51fbcac$var$ToneDeltaPair {
    /**
   * Documents a constraint in tone distance between two DynamicColors.
   *
   * The polarity is an adjective that describes "A", compared to "B".
   *
   * For instance, ToneDeltaPair(A, B, 15, 'darker', stayTogether) states that
   * A's tone should be at least 15 darker than B's.
   *
   * 'nearer' and 'farther' describes closeness to the surface roles. For
   * instance, ToneDeltaPair(A, B, 10, 'nearer', stayTogether) states that A
   * should be 10 lighter than B in light mode, and 10 darker than B in dark
   * mode.
   *
   * @param roleA The first role in a pair.
   * @param roleB The second role in a pair.
   * @param delta Required difference between tones. Absolute value, negative
   * values have undefined behavior.
   * @param polarity The relative relation between tones of roleA and roleB,
   * as described above.
   * @param stayTogether Whether these two roles should stay on the same side of
   * the "awkward zone" (T50-59). This is necessary for certain cases where
   * one role has two backgrounds.
   */ constructor(roleA, roleB, delta, polarity, stayTogether){
        this.roleA = roleA;
        this.roleB = roleB;
        this.delta = delta;
        this.polarity = polarity;
        this.stayTogether = stayTogether;
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Set of themes supported by Dynamic Color.
 * Instantiate the corresponding subclass, ex. SchemeTonalSpot, to create
 * colors corresponding to the theme.
 */ var $ad39de81c51fbcac$var$Variant;
(function(Variant) {
    Variant[Variant["MONOCHROME"] = 0] = "MONOCHROME";
    Variant[Variant["NEUTRAL"] = 1] = "NEUTRAL";
    Variant[Variant["TONAL_SPOT"] = 2] = "TONAL_SPOT";
    Variant[Variant["VIBRANT"] = 3] = "VIBRANT";
    Variant[Variant["EXPRESSIVE"] = 4] = "EXPRESSIVE";
    Variant[Variant["FIDELITY"] = 5] = "FIDELITY";
    Variant[Variant["CONTENT"] = 6] = "CONTENT";
    Variant[Variant["RAINBOW"] = 7] = "RAINBOW";
    Variant[Variant["FRUIT_SALAD"] = 8] = "FRUIT_SALAD";
})($ad39de81c51fbcac$var$Variant || ($ad39de81c51fbcac$var$Variant = {}));
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $ad39de81c51fbcac$var$isFidelity(scheme) {
    return scheme.variant === $ad39de81c51fbcac$var$Variant.FIDELITY || scheme.variant === $ad39de81c51fbcac$var$Variant.CONTENT;
}
function $ad39de81c51fbcac$var$isMonochrome(scheme) {
    return scheme.variant === $ad39de81c51fbcac$var$Variant.MONOCHROME;
}
function $ad39de81c51fbcac$var$findDesiredChromaByTone(hue, chroma, tone, byDecreasingTone) {
    let answer = tone;
    let closestToChroma = $ad39de81c51fbcac$var$Hct.from(hue, chroma, tone);
    if (closestToChroma.chroma < chroma) {
        let chromaPeak = closestToChroma.chroma;
        while(closestToChroma.chroma < chroma){
            answer += byDecreasingTone ? -1 : 1.0;
            const potentialSolution = $ad39de81c51fbcac$var$Hct.from(hue, chroma, answer);
            if (chromaPeak > potentialSolution.chroma) break;
            if (Math.abs(potentialSolution.chroma - chroma) < 0.4) break;
            const potentialDelta = Math.abs(potentialSolution.chroma - chroma);
            const currentDelta = Math.abs(closestToChroma.chroma - chroma);
            if (potentialDelta < currentDelta) closestToChroma = potentialSolution;
            chromaPeak = Math.max(chromaPeak, potentialSolution.chroma);
        }
    }
    return answer;
}
/**
 * DynamicColors for the colors in the Material Design system.
 */ // Material Color Utilities namespaces the various utilities it provides.
// tslint:disable-next-line:class-as-namespace
class $ad39de81c51fbcac$var$MaterialDynamicColors {
    static highestSurface(s) {
        return s.isDark ? $ad39de81c51fbcac$var$MaterialDynamicColors.surfaceBright : $ad39de81c51fbcac$var$MaterialDynamicColors.surfaceDim;
    }
}
$ad39de81c51fbcac$var$MaterialDynamicColors.contentAccentToneDelta = 15.0;
$ad39de81c51fbcac$var$MaterialDynamicColors.primaryPaletteKeyColor = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'primary_palette_key_color',
    palette: (s)=>s.primaryPalette,
    tone: (s)=>s.primaryPalette.keyColor.tone
});
$ad39de81c51fbcac$var$MaterialDynamicColors.secondaryPaletteKeyColor = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'secondary_palette_key_color',
    palette: (s)=>s.secondaryPalette,
    tone: (s)=>s.secondaryPalette.keyColor.tone
});
$ad39de81c51fbcac$var$MaterialDynamicColors.tertiaryPaletteKeyColor = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'tertiary_palette_key_color',
    palette: (s)=>s.tertiaryPalette,
    tone: (s)=>s.tertiaryPalette.keyColor.tone
});
$ad39de81c51fbcac$var$MaterialDynamicColors.neutralPaletteKeyColor = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'neutral_palette_key_color',
    palette: (s)=>s.neutralPalette,
    tone: (s)=>s.neutralPalette.keyColor.tone
});
$ad39de81c51fbcac$var$MaterialDynamicColors.neutralVariantPaletteKeyColor = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'neutral_variant_palette_key_color',
    palette: (s)=>s.neutralVariantPalette,
    tone: (s)=>s.neutralVariantPalette.keyColor.tone
});
$ad39de81c51fbcac$var$MaterialDynamicColors.background = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'background',
    palette: (s)=>s.neutralPalette,
    tone: (s)=>s.isDark ? 6 : 98,
    isBackground: true
});
$ad39de81c51fbcac$var$MaterialDynamicColors.onBackground = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'on_background',
    palette: (s)=>s.neutralPalette,
    tone: (s)=>s.isDark ? 90 : 10,
    background: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.background,
    contrastCurve: new $ad39de81c51fbcac$var$ContrastCurve(3, 3, 4.5, 7)
});
$ad39de81c51fbcac$var$MaterialDynamicColors.surface = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'surface',
    palette: (s)=>s.neutralPalette,
    tone: (s)=>s.isDark ? 6 : 98,
    isBackground: true
});
$ad39de81c51fbcac$var$MaterialDynamicColors.surfaceDim = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'surface_dim',
    palette: (s)=>s.neutralPalette,
    tone: (s)=>s.isDark ? 6 : new $ad39de81c51fbcac$var$ContrastCurve(87, 87, 80, 75).get(s.contrastLevel),
    isBackground: true
});
$ad39de81c51fbcac$var$MaterialDynamicColors.surfaceBright = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'surface_bright',
    palette: (s)=>s.neutralPalette,
    tone: (s)=>s.isDark ? new $ad39de81c51fbcac$var$ContrastCurve(24, 24, 29, 34).get(s.contrastLevel) : 98,
    isBackground: true
});
$ad39de81c51fbcac$var$MaterialDynamicColors.surfaceContainerLowest = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'surface_container_lowest',
    palette: (s)=>s.neutralPalette,
    tone: (s)=>s.isDark ? new $ad39de81c51fbcac$var$ContrastCurve(4, 4, 2, 0).get(s.contrastLevel) : 100,
    isBackground: true
});
$ad39de81c51fbcac$var$MaterialDynamicColors.surfaceContainerLow = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'surface_container_low',
    palette: (s)=>s.neutralPalette,
    tone: (s)=>s.isDark ? new $ad39de81c51fbcac$var$ContrastCurve(10, 10, 11, 12).get(s.contrastLevel) : new $ad39de81c51fbcac$var$ContrastCurve(96, 96, 96, 95).get(s.contrastLevel),
    isBackground: true
});
$ad39de81c51fbcac$var$MaterialDynamicColors.surfaceContainer = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'surface_container',
    palette: (s)=>s.neutralPalette,
    tone: (s)=>s.isDark ? new $ad39de81c51fbcac$var$ContrastCurve(12, 12, 16, 20).get(s.contrastLevel) : new $ad39de81c51fbcac$var$ContrastCurve(94, 94, 92, 90).get(s.contrastLevel),
    isBackground: true
});
$ad39de81c51fbcac$var$MaterialDynamicColors.surfaceContainerHigh = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'surface_container_high',
    palette: (s)=>s.neutralPalette,
    tone: (s)=>s.isDark ? new $ad39de81c51fbcac$var$ContrastCurve(17, 17, 21, 25).get(s.contrastLevel) : new $ad39de81c51fbcac$var$ContrastCurve(92, 92, 88, 85).get(s.contrastLevel),
    isBackground: true
});
$ad39de81c51fbcac$var$MaterialDynamicColors.surfaceContainerHighest = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'surface_container_highest',
    palette: (s)=>s.neutralPalette,
    tone: (s)=>s.isDark ? new $ad39de81c51fbcac$var$ContrastCurve(22, 22, 26, 30).get(s.contrastLevel) : new $ad39de81c51fbcac$var$ContrastCurve(90, 90, 84, 80).get(s.contrastLevel),
    isBackground: true
});
$ad39de81c51fbcac$var$MaterialDynamicColors.onSurface = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'on_surface',
    palette: (s)=>s.neutralPalette,
    tone: (s)=>s.isDark ? 90 : 10,
    background: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.highestSurface(s),
    contrastCurve: new $ad39de81c51fbcac$var$ContrastCurve(4.5, 7, 11, 21)
});
$ad39de81c51fbcac$var$MaterialDynamicColors.surfaceVariant = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'surface_variant',
    palette: (s)=>s.neutralVariantPalette,
    tone: (s)=>s.isDark ? 30 : 90,
    isBackground: true
});
$ad39de81c51fbcac$var$MaterialDynamicColors.onSurfaceVariant = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'on_surface_variant',
    palette: (s)=>s.neutralVariantPalette,
    tone: (s)=>s.isDark ? 80 : 30,
    background: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.highestSurface(s),
    contrastCurve: new $ad39de81c51fbcac$var$ContrastCurve(3, 4.5, 7, 11)
});
$ad39de81c51fbcac$var$MaterialDynamicColors.inverseSurface = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'inverse_surface',
    palette: (s)=>s.neutralPalette,
    tone: (s)=>s.isDark ? 90 : 20
});
$ad39de81c51fbcac$var$MaterialDynamicColors.inverseOnSurface = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'inverse_on_surface',
    palette: (s)=>s.neutralPalette,
    tone: (s)=>s.isDark ? 20 : 95,
    background: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.inverseSurface,
    contrastCurve: new $ad39de81c51fbcac$var$ContrastCurve(4.5, 7, 11, 21)
});
$ad39de81c51fbcac$var$MaterialDynamicColors.outline = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'outline',
    palette: (s)=>s.neutralVariantPalette,
    tone: (s)=>s.isDark ? 60 : 50,
    background: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.highestSurface(s),
    contrastCurve: new $ad39de81c51fbcac$var$ContrastCurve(1.5, 3, 4.5, 7)
});
$ad39de81c51fbcac$var$MaterialDynamicColors.outlineVariant = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'outline_variant',
    palette: (s)=>s.neutralVariantPalette,
    tone: (s)=>s.isDark ? 30 : 80,
    background: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.highestSurface(s),
    contrastCurve: new $ad39de81c51fbcac$var$ContrastCurve(1, 1, 3, 4.5)
});
$ad39de81c51fbcac$var$MaterialDynamicColors.shadow = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'shadow',
    palette: (s)=>s.neutralPalette,
    tone: (s)=>0
});
$ad39de81c51fbcac$var$MaterialDynamicColors.scrim = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'scrim',
    palette: (s)=>s.neutralPalette,
    tone: (s)=>0
});
$ad39de81c51fbcac$var$MaterialDynamicColors.surfaceTint = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'surface_tint',
    palette: (s)=>s.primaryPalette,
    tone: (s)=>s.isDark ? 80 : 40,
    isBackground: true
});
$ad39de81c51fbcac$var$MaterialDynamicColors.primary = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'primary',
    palette: (s)=>s.primaryPalette,
    tone: (s)=>{
        if ($ad39de81c51fbcac$var$isMonochrome(s)) return s.isDark ? 100 : 0;
        return s.isDark ? 80 : 40;
    },
    isBackground: true,
    background: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.highestSurface(s),
    contrastCurve: new $ad39de81c51fbcac$var$ContrastCurve(3, 4.5, 7, 7),
    toneDeltaPair: (s)=>new $ad39de81c51fbcac$var$ToneDeltaPair($ad39de81c51fbcac$var$MaterialDynamicColors.primaryContainer, $ad39de81c51fbcac$var$MaterialDynamicColors.primary, 10, 'nearer', false)
});
$ad39de81c51fbcac$var$MaterialDynamicColors.onPrimary = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'on_primary',
    palette: (s)=>s.primaryPalette,
    tone: (s)=>{
        if ($ad39de81c51fbcac$var$isMonochrome(s)) return s.isDark ? 10 : 90;
        return s.isDark ? 20 : 100;
    },
    background: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.primary,
    contrastCurve: new $ad39de81c51fbcac$var$ContrastCurve(4.5, 7, 11, 21)
});
$ad39de81c51fbcac$var$MaterialDynamicColors.primaryContainer = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'primary_container',
    palette: (s)=>s.primaryPalette,
    tone: (s)=>{
        if ($ad39de81c51fbcac$var$isFidelity(s)) return s.sourceColorHct.tone;
        if ($ad39de81c51fbcac$var$isMonochrome(s)) return s.isDark ? 85 : 25;
        return s.isDark ? 30 : 90;
    },
    isBackground: true,
    background: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.highestSurface(s),
    contrastCurve: new $ad39de81c51fbcac$var$ContrastCurve(1, 1, 3, 4.5),
    toneDeltaPair: (s)=>new $ad39de81c51fbcac$var$ToneDeltaPair($ad39de81c51fbcac$var$MaterialDynamicColors.primaryContainer, $ad39de81c51fbcac$var$MaterialDynamicColors.primary, 10, 'nearer', false)
});
$ad39de81c51fbcac$var$MaterialDynamicColors.onPrimaryContainer = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'on_primary_container',
    palette: (s)=>s.primaryPalette,
    tone: (s)=>{
        if ($ad39de81c51fbcac$var$isFidelity(s)) return $ad39de81c51fbcac$var$DynamicColor.foregroundTone($ad39de81c51fbcac$var$MaterialDynamicColors.primaryContainer.tone(s), 4.5);
        if ($ad39de81c51fbcac$var$isMonochrome(s)) return s.isDark ? 0 : 100;
        return s.isDark ? 90 : 30;
    },
    background: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.primaryContainer,
    contrastCurve: new $ad39de81c51fbcac$var$ContrastCurve(3, 4.5, 7, 11)
});
$ad39de81c51fbcac$var$MaterialDynamicColors.inversePrimary = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'inverse_primary',
    palette: (s)=>s.primaryPalette,
    tone: (s)=>s.isDark ? 40 : 80,
    background: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.inverseSurface,
    contrastCurve: new $ad39de81c51fbcac$var$ContrastCurve(3, 4.5, 7, 7)
});
$ad39de81c51fbcac$var$MaterialDynamicColors.secondary = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'secondary',
    palette: (s)=>s.secondaryPalette,
    tone: (s)=>s.isDark ? 80 : 40,
    isBackground: true,
    background: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.highestSurface(s),
    contrastCurve: new $ad39de81c51fbcac$var$ContrastCurve(3, 4.5, 7, 7),
    toneDeltaPair: (s)=>new $ad39de81c51fbcac$var$ToneDeltaPair($ad39de81c51fbcac$var$MaterialDynamicColors.secondaryContainer, $ad39de81c51fbcac$var$MaterialDynamicColors.secondary, 10, 'nearer', false)
});
$ad39de81c51fbcac$var$MaterialDynamicColors.onSecondary = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'on_secondary',
    palette: (s)=>s.secondaryPalette,
    tone: (s)=>{
        if ($ad39de81c51fbcac$var$isMonochrome(s)) return s.isDark ? 10 : 100;
        else return s.isDark ? 20 : 100;
    },
    background: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.secondary,
    contrastCurve: new $ad39de81c51fbcac$var$ContrastCurve(4.5, 7, 11, 21)
});
$ad39de81c51fbcac$var$MaterialDynamicColors.secondaryContainer = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'secondary_container',
    palette: (s)=>s.secondaryPalette,
    tone: (s)=>{
        const initialTone = s.isDark ? 30 : 90;
        if ($ad39de81c51fbcac$var$isMonochrome(s)) return s.isDark ? 30 : 85;
        if (!$ad39de81c51fbcac$var$isFidelity(s)) return initialTone;
        return $ad39de81c51fbcac$var$findDesiredChromaByTone(s.secondaryPalette.hue, s.secondaryPalette.chroma, initialTone, s.isDark ? false : true);
    },
    isBackground: true,
    background: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.highestSurface(s),
    contrastCurve: new $ad39de81c51fbcac$var$ContrastCurve(1, 1, 3, 4.5),
    toneDeltaPair: (s)=>new $ad39de81c51fbcac$var$ToneDeltaPair($ad39de81c51fbcac$var$MaterialDynamicColors.secondaryContainer, $ad39de81c51fbcac$var$MaterialDynamicColors.secondary, 10, 'nearer', false)
});
$ad39de81c51fbcac$var$MaterialDynamicColors.onSecondaryContainer = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'on_secondary_container',
    palette: (s)=>s.secondaryPalette,
    tone: (s)=>{
        if ($ad39de81c51fbcac$var$isMonochrome(s)) return s.isDark ? 90 : 10;
        if (!$ad39de81c51fbcac$var$isFidelity(s)) return s.isDark ? 90 : 30;
        return $ad39de81c51fbcac$var$DynamicColor.foregroundTone($ad39de81c51fbcac$var$MaterialDynamicColors.secondaryContainer.tone(s), 4.5);
    },
    background: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.secondaryContainer,
    contrastCurve: new $ad39de81c51fbcac$var$ContrastCurve(3, 4.5, 7, 11)
});
$ad39de81c51fbcac$var$MaterialDynamicColors.tertiary = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'tertiary',
    palette: (s)=>s.tertiaryPalette,
    tone: (s)=>{
        if ($ad39de81c51fbcac$var$isMonochrome(s)) return s.isDark ? 90 : 25;
        return s.isDark ? 80 : 40;
    },
    isBackground: true,
    background: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.highestSurface(s),
    contrastCurve: new $ad39de81c51fbcac$var$ContrastCurve(3, 4.5, 7, 7),
    toneDeltaPair: (s)=>new $ad39de81c51fbcac$var$ToneDeltaPair($ad39de81c51fbcac$var$MaterialDynamicColors.tertiaryContainer, $ad39de81c51fbcac$var$MaterialDynamicColors.tertiary, 10, 'nearer', false)
});
$ad39de81c51fbcac$var$MaterialDynamicColors.onTertiary = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'on_tertiary',
    palette: (s)=>s.tertiaryPalette,
    tone: (s)=>{
        if ($ad39de81c51fbcac$var$isMonochrome(s)) return s.isDark ? 10 : 90;
        return s.isDark ? 20 : 100;
    },
    background: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.tertiary,
    contrastCurve: new $ad39de81c51fbcac$var$ContrastCurve(4.5, 7, 11, 21)
});
$ad39de81c51fbcac$var$MaterialDynamicColors.tertiaryContainer = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'tertiary_container',
    palette: (s)=>s.tertiaryPalette,
    tone: (s)=>{
        if ($ad39de81c51fbcac$var$isMonochrome(s)) return s.isDark ? 60 : 49;
        if (!$ad39de81c51fbcac$var$isFidelity(s)) return s.isDark ? 30 : 90;
        const proposedHct = s.tertiaryPalette.getHct(s.sourceColorHct.tone);
        return $ad39de81c51fbcac$var$DislikeAnalyzer.fixIfDisliked(proposedHct).tone;
    },
    isBackground: true,
    background: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.highestSurface(s),
    contrastCurve: new $ad39de81c51fbcac$var$ContrastCurve(1, 1, 3, 4.5),
    toneDeltaPair: (s)=>new $ad39de81c51fbcac$var$ToneDeltaPair($ad39de81c51fbcac$var$MaterialDynamicColors.tertiaryContainer, $ad39de81c51fbcac$var$MaterialDynamicColors.tertiary, 10, 'nearer', false)
});
$ad39de81c51fbcac$var$MaterialDynamicColors.onTertiaryContainer = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'on_tertiary_container',
    palette: (s)=>s.tertiaryPalette,
    tone: (s)=>{
        if ($ad39de81c51fbcac$var$isMonochrome(s)) return s.isDark ? 0 : 100;
        if (!$ad39de81c51fbcac$var$isFidelity(s)) return s.isDark ? 90 : 30;
        return $ad39de81c51fbcac$var$DynamicColor.foregroundTone($ad39de81c51fbcac$var$MaterialDynamicColors.tertiaryContainer.tone(s), 4.5);
    },
    background: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.tertiaryContainer,
    contrastCurve: new $ad39de81c51fbcac$var$ContrastCurve(3, 4.5, 7, 11)
});
$ad39de81c51fbcac$var$MaterialDynamicColors.error = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'error',
    palette: (s)=>s.errorPalette,
    tone: (s)=>s.isDark ? 80 : 40,
    isBackground: true,
    background: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.highestSurface(s),
    contrastCurve: new $ad39de81c51fbcac$var$ContrastCurve(3, 4.5, 7, 7),
    toneDeltaPair: (s)=>new $ad39de81c51fbcac$var$ToneDeltaPair($ad39de81c51fbcac$var$MaterialDynamicColors.errorContainer, $ad39de81c51fbcac$var$MaterialDynamicColors.error, 10, 'nearer', false)
});
$ad39de81c51fbcac$var$MaterialDynamicColors.onError = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'on_error',
    palette: (s)=>s.errorPalette,
    tone: (s)=>s.isDark ? 20 : 100,
    background: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.error,
    contrastCurve: new $ad39de81c51fbcac$var$ContrastCurve(4.5, 7, 11, 21)
});
$ad39de81c51fbcac$var$MaterialDynamicColors.errorContainer = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'error_container',
    palette: (s)=>s.errorPalette,
    tone: (s)=>s.isDark ? 30 : 90,
    isBackground: true,
    background: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.highestSurface(s),
    contrastCurve: new $ad39de81c51fbcac$var$ContrastCurve(1, 1, 3, 4.5),
    toneDeltaPair: (s)=>new $ad39de81c51fbcac$var$ToneDeltaPair($ad39de81c51fbcac$var$MaterialDynamicColors.errorContainer, $ad39de81c51fbcac$var$MaterialDynamicColors.error, 10, 'nearer', false)
});
$ad39de81c51fbcac$var$MaterialDynamicColors.onErrorContainer = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'on_error_container',
    palette: (s)=>s.errorPalette,
    tone: (s)=>{
        if ($ad39de81c51fbcac$var$isMonochrome(s)) return s.isDark ? 90 : 10;
        return s.isDark ? 90 : 30;
    },
    background: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.errorContainer,
    contrastCurve: new $ad39de81c51fbcac$var$ContrastCurve(3, 4.5, 7, 11)
});
$ad39de81c51fbcac$var$MaterialDynamicColors.primaryFixed = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'primary_fixed',
    palette: (s)=>s.primaryPalette,
    tone: (s)=>$ad39de81c51fbcac$var$isMonochrome(s) ? 40.0 : 90.0,
    isBackground: true,
    background: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.highestSurface(s),
    contrastCurve: new $ad39de81c51fbcac$var$ContrastCurve(1, 1, 3, 4.5),
    toneDeltaPair: (s)=>new $ad39de81c51fbcac$var$ToneDeltaPair($ad39de81c51fbcac$var$MaterialDynamicColors.primaryFixed, $ad39de81c51fbcac$var$MaterialDynamicColors.primaryFixedDim, 10, 'lighter', true)
});
$ad39de81c51fbcac$var$MaterialDynamicColors.primaryFixedDim = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'primary_fixed_dim',
    palette: (s)=>s.primaryPalette,
    tone: (s)=>$ad39de81c51fbcac$var$isMonochrome(s) ? 30.0 : 80.0,
    isBackground: true,
    background: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.highestSurface(s),
    contrastCurve: new $ad39de81c51fbcac$var$ContrastCurve(1, 1, 3, 4.5),
    toneDeltaPair: (s)=>new $ad39de81c51fbcac$var$ToneDeltaPair($ad39de81c51fbcac$var$MaterialDynamicColors.primaryFixed, $ad39de81c51fbcac$var$MaterialDynamicColors.primaryFixedDim, 10, 'lighter', true)
});
$ad39de81c51fbcac$var$MaterialDynamicColors.onPrimaryFixed = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'on_primary_fixed',
    palette: (s)=>s.primaryPalette,
    tone: (s)=>$ad39de81c51fbcac$var$isMonochrome(s) ? 100.0 : 10.0,
    background: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.primaryFixedDim,
    secondBackground: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.primaryFixed,
    contrastCurve: new $ad39de81c51fbcac$var$ContrastCurve(4.5, 7, 11, 21)
});
$ad39de81c51fbcac$var$MaterialDynamicColors.onPrimaryFixedVariant = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'on_primary_fixed_variant',
    palette: (s)=>s.primaryPalette,
    tone: (s)=>$ad39de81c51fbcac$var$isMonochrome(s) ? 90.0 : 30.0,
    background: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.primaryFixedDim,
    secondBackground: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.primaryFixed,
    contrastCurve: new $ad39de81c51fbcac$var$ContrastCurve(3, 4.5, 7, 11)
});
$ad39de81c51fbcac$var$MaterialDynamicColors.secondaryFixed = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'secondary_fixed',
    palette: (s)=>s.secondaryPalette,
    tone: (s)=>$ad39de81c51fbcac$var$isMonochrome(s) ? 80.0 : 90.0,
    isBackground: true,
    background: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.highestSurface(s),
    contrastCurve: new $ad39de81c51fbcac$var$ContrastCurve(1, 1, 3, 4.5),
    toneDeltaPair: (s)=>new $ad39de81c51fbcac$var$ToneDeltaPair($ad39de81c51fbcac$var$MaterialDynamicColors.secondaryFixed, $ad39de81c51fbcac$var$MaterialDynamicColors.secondaryFixedDim, 10, 'lighter', true)
});
$ad39de81c51fbcac$var$MaterialDynamicColors.secondaryFixedDim = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'secondary_fixed_dim',
    palette: (s)=>s.secondaryPalette,
    tone: (s)=>$ad39de81c51fbcac$var$isMonochrome(s) ? 70.0 : 80.0,
    isBackground: true,
    background: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.highestSurface(s),
    contrastCurve: new $ad39de81c51fbcac$var$ContrastCurve(1, 1, 3, 4.5),
    toneDeltaPair: (s)=>new $ad39de81c51fbcac$var$ToneDeltaPair($ad39de81c51fbcac$var$MaterialDynamicColors.secondaryFixed, $ad39de81c51fbcac$var$MaterialDynamicColors.secondaryFixedDim, 10, 'lighter', true)
});
$ad39de81c51fbcac$var$MaterialDynamicColors.onSecondaryFixed = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'on_secondary_fixed',
    palette: (s)=>s.secondaryPalette,
    tone: (s)=>10.0,
    background: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.secondaryFixedDim,
    secondBackground: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.secondaryFixed,
    contrastCurve: new $ad39de81c51fbcac$var$ContrastCurve(4.5, 7, 11, 21)
});
$ad39de81c51fbcac$var$MaterialDynamicColors.onSecondaryFixedVariant = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'on_secondary_fixed_variant',
    palette: (s)=>s.secondaryPalette,
    tone: (s)=>$ad39de81c51fbcac$var$isMonochrome(s) ? 25.0 : 30.0,
    background: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.secondaryFixedDim,
    secondBackground: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.secondaryFixed,
    contrastCurve: new $ad39de81c51fbcac$var$ContrastCurve(3, 4.5, 7, 11)
});
$ad39de81c51fbcac$var$MaterialDynamicColors.tertiaryFixed = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'tertiary_fixed',
    palette: (s)=>s.tertiaryPalette,
    tone: (s)=>$ad39de81c51fbcac$var$isMonochrome(s) ? 40.0 : 90.0,
    isBackground: true,
    background: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.highestSurface(s),
    contrastCurve: new $ad39de81c51fbcac$var$ContrastCurve(1, 1, 3, 4.5),
    toneDeltaPair: (s)=>new $ad39de81c51fbcac$var$ToneDeltaPair($ad39de81c51fbcac$var$MaterialDynamicColors.tertiaryFixed, $ad39de81c51fbcac$var$MaterialDynamicColors.tertiaryFixedDim, 10, 'lighter', true)
});
$ad39de81c51fbcac$var$MaterialDynamicColors.tertiaryFixedDim = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'tertiary_fixed_dim',
    palette: (s)=>s.tertiaryPalette,
    tone: (s)=>$ad39de81c51fbcac$var$isMonochrome(s) ? 30.0 : 80.0,
    isBackground: true,
    background: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.highestSurface(s),
    contrastCurve: new $ad39de81c51fbcac$var$ContrastCurve(1, 1, 3, 4.5),
    toneDeltaPair: (s)=>new $ad39de81c51fbcac$var$ToneDeltaPair($ad39de81c51fbcac$var$MaterialDynamicColors.tertiaryFixed, $ad39de81c51fbcac$var$MaterialDynamicColors.tertiaryFixedDim, 10, 'lighter', true)
});
$ad39de81c51fbcac$var$MaterialDynamicColors.onTertiaryFixed = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'on_tertiary_fixed',
    palette: (s)=>s.tertiaryPalette,
    tone: (s)=>$ad39de81c51fbcac$var$isMonochrome(s) ? 100.0 : 10.0,
    background: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.tertiaryFixedDim,
    secondBackground: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.tertiaryFixed,
    contrastCurve: new $ad39de81c51fbcac$var$ContrastCurve(4.5, 7, 11, 21)
});
$ad39de81c51fbcac$var$MaterialDynamicColors.onTertiaryFixedVariant = $ad39de81c51fbcac$var$DynamicColor.fromPalette({
    name: 'on_tertiary_fixed_variant',
    palette: (s)=>s.tertiaryPalette,
    tone: (s)=>$ad39de81c51fbcac$var$isMonochrome(s) ? 90.0 : 30.0,
    background: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.tertiaryFixedDim,
    secondBackground: (s)=>$ad39de81c51fbcac$var$MaterialDynamicColors.tertiaryFixed,
    contrastCurve: new $ad39de81c51fbcac$var$ContrastCurve(3, 4.5, 7, 11)
});
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Constructed by a set of values representing the current UI state (such as
 * whether or not its dark theme, what the theme style is, etc.), and
 * provides a set of TonalPalettes that can create colors that fit in
 * with the theme style. Used by DynamicColor to resolve into a color.
 */ class $ad39de81c51fbcac$var$DynamicScheme {
    constructor(args){
        this.sourceColorArgb = args.sourceColorArgb;
        this.variant = args.variant;
        this.contrastLevel = args.contrastLevel;
        this.isDark = args.isDark;
        this.sourceColorHct = $ad39de81c51fbcac$var$Hct.fromInt(args.sourceColorArgb);
        this.primaryPalette = args.primaryPalette;
        this.secondaryPalette = args.secondaryPalette;
        this.tertiaryPalette = args.tertiaryPalette;
        this.neutralPalette = args.neutralPalette;
        this.neutralVariantPalette = args.neutralVariantPalette;
        this.errorPalette = $ad39de81c51fbcac$var$TonalPalette.fromHueAndChroma(25.0, 84.0);
    }
    /**
   * Support design spec'ing Dynamic Color by schemes that specify hue
   * rotations that should be applied at certain breakpoints.
   * @param sourceColor the source color of the theme, in HCT.
   * @param hues The "breakpoints", i.e. the hues at which a rotation should
   * be apply.
   * @param rotations The rotation that should be applied when source color's
   * hue is >= the same index in hues array, and <= the hue at the next index
   * in hues array.
   */ static getRotatedHue(sourceColor, hues, rotations) {
        const sourceHue = sourceColor.hue;
        if (hues.length !== rotations.length) throw new Error(`mismatch between hue length ${hues.length} & rotations ${rotations.length}`);
        if (rotations.length === 1) return $ad39de81c51fbcac$var$sanitizeDegreesDouble(sourceColor.hue + rotations[0]);
        const size = hues.length;
        for(let i = 0; i <= size - 2; i++){
            const thisHue = hues[i];
            const nextHue = hues[i + 1];
            if (thisHue < sourceHue && sourceHue < nextHue) return $ad39de81c51fbcac$var$sanitizeDegreesDouble(sourceHue + rotations[i]);
        }
        // If this statement executes, something is wrong, there should have been a
        // rotation found using the arrays.
        return sourceHue;
    }
    getArgb(dynamicColor) {
        return dynamicColor.getArgb(this);
    }
    getHct(dynamicColor) {
        return dynamicColor.getHct(this);
    }
    get primaryPaletteKeyColor() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.primaryPaletteKeyColor);
    }
    get secondaryPaletteKeyColor() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.secondaryPaletteKeyColor);
    }
    get tertiaryPaletteKeyColor() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.tertiaryPaletteKeyColor);
    }
    get neutralPaletteKeyColor() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.neutralPaletteKeyColor);
    }
    get neutralVariantPaletteKeyColor() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.neutralVariantPaletteKeyColor);
    }
    get background() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.background);
    }
    get onBackground() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.onBackground);
    }
    get surface() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.surface);
    }
    get surfaceDim() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.surfaceDim);
    }
    get surfaceBright() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.surfaceBright);
    }
    get surfaceContainerLowest() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.surfaceContainerLowest);
    }
    get surfaceContainerLow() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.surfaceContainerLow);
    }
    get surfaceContainer() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.surfaceContainer);
    }
    get surfaceContainerHigh() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.surfaceContainerHigh);
    }
    get surfaceContainerHighest() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.surfaceContainerHighest);
    }
    get onSurface() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.onSurface);
    }
    get surfaceVariant() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.surfaceVariant);
    }
    get onSurfaceVariant() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.onSurfaceVariant);
    }
    get inverseSurface() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.inverseSurface);
    }
    get inverseOnSurface() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.inverseOnSurface);
    }
    get outline() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.outline);
    }
    get outlineVariant() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.outlineVariant);
    }
    get shadow() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.shadow);
    }
    get scrim() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.scrim);
    }
    get surfaceTint() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.surfaceTint);
    }
    get primary() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.primary);
    }
    get onPrimary() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.onPrimary);
    }
    get primaryContainer() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.primaryContainer);
    }
    get onPrimaryContainer() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.onPrimaryContainer);
    }
    get inversePrimary() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.inversePrimary);
    }
    get secondary() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.secondary);
    }
    get onSecondary() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.onSecondary);
    }
    get secondaryContainer() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.secondaryContainer);
    }
    get onSecondaryContainer() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.onSecondaryContainer);
    }
    get tertiary() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.tertiary);
    }
    get onTertiary() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.onTertiary);
    }
    get tertiaryContainer() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.tertiaryContainer);
    }
    get onTertiaryContainer() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.onTertiaryContainer);
    }
    get error() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.error);
    }
    get onError() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.onError);
    }
    get errorContainer() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.errorContainer);
    }
    get onErrorContainer() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.onErrorContainer);
    }
    get primaryFixed() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.primaryFixed);
    }
    get primaryFixedDim() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.primaryFixedDim);
    }
    get onPrimaryFixed() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.onPrimaryFixed);
    }
    get onPrimaryFixedVariant() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.onPrimaryFixedVariant);
    }
    get secondaryFixed() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.secondaryFixed);
    }
    get secondaryFixedDim() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.secondaryFixedDim);
    }
    get onSecondaryFixed() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.onSecondaryFixed);
    }
    get onSecondaryFixedVariant() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.onSecondaryFixedVariant);
    }
    get tertiaryFixed() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.tertiaryFixed);
    }
    get tertiaryFixedDim() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.tertiaryFixedDim);
    }
    get onTertiaryFixed() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.onTertiaryFixed);
    }
    get onTertiaryFixedVariant() {
        return this.getArgb($ad39de81c51fbcac$var$MaterialDynamicColors.onTertiaryFixedVariant);
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An intermediate concept between the key color for a UI theme, and a full
 * color scheme. 5 sets of tones are generated, all except one use the same hue
 * as the key color, and all vary in chroma.
 */ class $ad39de81c51fbcac$var$CorePalette {
    /**
   * @param argb ARGB representation of a color
   */ static of(argb) {
        return new $ad39de81c51fbcac$var$CorePalette(argb, false);
    }
    /**
   * @param argb ARGB representation of a color
   */ static contentOf(argb) {
        return new $ad39de81c51fbcac$var$CorePalette(argb, true);
    }
    /**
   * Create a [CorePalette] from a set of colors
   */ static fromColors(colors) {
        return $ad39de81c51fbcac$var$CorePalette.createPaletteFromColors(false, colors);
    }
    /**
   * Create a content [CorePalette] from a set of colors
   */ static contentFromColors(colors) {
        return $ad39de81c51fbcac$var$CorePalette.createPaletteFromColors(true, colors);
    }
    static createPaletteFromColors(content, colors) {
        const palette = new $ad39de81c51fbcac$var$CorePalette(colors.primary, content);
        if (colors.secondary) {
            const p = new $ad39de81c51fbcac$var$CorePalette(colors.secondary, content);
            palette.a2 = p.a1;
        }
        if (colors.tertiary) {
            const p = new $ad39de81c51fbcac$var$CorePalette(colors.tertiary, content);
            palette.a3 = p.a1;
        }
        if (colors.error) {
            const p = new $ad39de81c51fbcac$var$CorePalette(colors.error, content);
            palette.error = p.a1;
        }
        if (colors.neutral) {
            const p = new $ad39de81c51fbcac$var$CorePalette(colors.neutral, content);
            palette.n1 = p.n1;
        }
        if (colors.neutralVariant) {
            const p = new $ad39de81c51fbcac$var$CorePalette(colors.neutralVariant, content);
            palette.n2 = p.n2;
        }
        return palette;
    }
    constructor(argb, isContent){
        const hct = $ad39de81c51fbcac$var$Hct.fromInt(argb);
        const hue = hct.hue;
        const chroma = hct.chroma;
        if (isContent) {
            this.a1 = $ad39de81c51fbcac$var$TonalPalette.fromHueAndChroma(hue, chroma);
            this.a2 = $ad39de81c51fbcac$var$TonalPalette.fromHueAndChroma(hue, chroma / 3);
            this.a3 = $ad39de81c51fbcac$var$TonalPalette.fromHueAndChroma(hue + 60, chroma / 2);
            this.n1 = $ad39de81c51fbcac$var$TonalPalette.fromHueAndChroma(hue, Math.min(chroma / 12, 4));
            this.n2 = $ad39de81c51fbcac$var$TonalPalette.fromHueAndChroma(hue, Math.min(chroma / 6, 8));
        } else {
            this.a1 = $ad39de81c51fbcac$var$TonalPalette.fromHueAndChroma(hue, Math.max(48, chroma));
            this.a2 = $ad39de81c51fbcac$var$TonalPalette.fromHueAndChroma(hue, 16);
            this.a3 = $ad39de81c51fbcac$var$TonalPalette.fromHueAndChroma(hue + 60, 24);
            this.n1 = $ad39de81c51fbcac$var$TonalPalette.fromHueAndChroma(hue, 4);
            this.n2 = $ad39de81c51fbcac$var$TonalPalette.fromHueAndChroma(hue, 8);
        }
        this.error = $ad39de81c51fbcac$var$TonalPalette.fromHueAndChroma(25, 84);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A Dynamic Color theme that is intentionally detached from the source color.
 */ class $ad39de81c51fbcac$var$SchemeExpressive extends $ad39de81c51fbcac$var$DynamicScheme {
    constructor(sourceColorHct, isDark, contrastLevel){
        super({
            sourceColorArgb: sourceColorHct.toInt(),
            variant: $ad39de81c51fbcac$var$Variant.EXPRESSIVE,
            contrastLevel: contrastLevel,
            isDark: isDark,
            primaryPalette: $ad39de81c51fbcac$var$TonalPalette.fromHueAndChroma($ad39de81c51fbcac$var$sanitizeDegreesDouble(sourceColorHct.hue + 240.0), 40.0),
            secondaryPalette: $ad39de81c51fbcac$var$TonalPalette.fromHueAndChroma($ad39de81c51fbcac$var$DynamicScheme.getRotatedHue(sourceColorHct, $ad39de81c51fbcac$var$SchemeExpressive.hues, $ad39de81c51fbcac$var$SchemeExpressive.secondaryRotations), 24.0),
            tertiaryPalette: $ad39de81c51fbcac$var$TonalPalette.fromHueAndChroma($ad39de81c51fbcac$var$DynamicScheme.getRotatedHue(sourceColorHct, $ad39de81c51fbcac$var$SchemeExpressive.hues, $ad39de81c51fbcac$var$SchemeExpressive.tertiaryRotations), 32.0),
            neutralPalette: $ad39de81c51fbcac$var$TonalPalette.fromHueAndChroma(sourceColorHct.hue + 15, 8.0),
            neutralVariantPalette: $ad39de81c51fbcac$var$TonalPalette.fromHueAndChroma(sourceColorHct.hue + 15, 12.0)
        });
    }
}
/**
 * Hues (in degrees) used at breakpoints such that designers can specify a
 * hue rotation that occurs at a given break point.
 */ $ad39de81c51fbcac$var$SchemeExpressive.hues = [
    0.0,
    21.0,
    51.0,
    121.0,
    151.0,
    191.0,
    271.0,
    321.0,
    360.0
];
/**
 * Hue rotations (in degrees) of the Secondary [TonalPalette],
 * corresponding to the breakpoints in [hues].
 */ $ad39de81c51fbcac$var$SchemeExpressive.secondaryRotations = [
    45.0,
    95.0,
    45.0,
    20.0,
    45.0,
    90.0,
    45.0,
    45.0,
    45.0
];
/**
 * Hue rotations (in degrees) of the Tertiary [TonalPalette],
 * corresponding to the breakpoints in [hues].
 */ $ad39de81c51fbcac$var$SchemeExpressive.tertiaryRotations = [
    120.0,
    120.0,
    20.0,
    45.0,
    20.0,
    15.0,
    20.0,
    120.0,
    120.0
];
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A Dynamic Color theme that maxes out colorfulness at each position in the
 * Primary Tonal Palette.
 */ class $ad39de81c51fbcac$var$SchemeVibrant extends $ad39de81c51fbcac$var$DynamicScheme {
    constructor(sourceColorHct, isDark, contrastLevel){
        super({
            sourceColorArgb: sourceColorHct.toInt(),
            variant: $ad39de81c51fbcac$var$Variant.VIBRANT,
            contrastLevel: contrastLevel,
            isDark: isDark,
            primaryPalette: $ad39de81c51fbcac$var$TonalPalette.fromHueAndChroma(sourceColorHct.hue, 200.0),
            secondaryPalette: $ad39de81c51fbcac$var$TonalPalette.fromHueAndChroma($ad39de81c51fbcac$var$DynamicScheme.getRotatedHue(sourceColorHct, $ad39de81c51fbcac$var$SchemeVibrant.hues, $ad39de81c51fbcac$var$SchemeVibrant.secondaryRotations), 24.0),
            tertiaryPalette: $ad39de81c51fbcac$var$TonalPalette.fromHueAndChroma($ad39de81c51fbcac$var$DynamicScheme.getRotatedHue(sourceColorHct, $ad39de81c51fbcac$var$SchemeVibrant.hues, $ad39de81c51fbcac$var$SchemeVibrant.tertiaryRotations), 32.0),
            neutralPalette: $ad39de81c51fbcac$var$TonalPalette.fromHueAndChroma(sourceColorHct.hue, 10.0),
            neutralVariantPalette: $ad39de81c51fbcac$var$TonalPalette.fromHueAndChroma(sourceColorHct.hue, 12.0)
        });
    }
}
/**
 * Hues (in degrees) used at breakpoints such that designers can specify a
 * hue rotation that occurs at a given break point.
 */ $ad39de81c51fbcac$var$SchemeVibrant.hues = [
    0.0,
    41.0,
    61.0,
    101.0,
    131.0,
    181.0,
    251.0,
    301.0,
    360.0
];
/**
 * Hue rotations (in degrees) of the Secondary [TonalPalette],
 * corresponding to the breakpoints in [hues].
 */ $ad39de81c51fbcac$var$SchemeVibrant.secondaryRotations = [
    18.0,
    15.0,
    10.0,
    12.0,
    15.0,
    18.0,
    15.0,
    12.0,
    12.0
];
/**
 * Hue rotations (in degrees) of the Tertiary [TonalPalette],
 * corresponding to the breakpoints in [hues].
 */ $ad39de81c51fbcac$var$SchemeVibrant.tertiaryRotations = [
    35.0,
    30.0,
    20.0,
    25.0,
    30.0,
    35.0,
    30.0,
    25.0,
    25.0
];
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Utility methods for hexadecimal representations of colors.
 */ /**
 * @param argb ARGB representation of a color.
 * @return Hex string representing color, ex. #ff0000 for red.
 */ function $ad39de81c51fbcac$var$hexFromArgb(argb) {
    const r = $ad39de81c51fbcac$var$redFromArgb(argb);
    const g = $ad39de81c51fbcac$var$greenFromArgb(argb);
    const b = $ad39de81c51fbcac$var$blueFromArgb(argb);
    const outParts = [
        r.toString(16),
        g.toString(16),
        b.toString(16)
    ];
    // Pad single-digit output values
    for (const [i, part] of outParts.entries())if (part.length === 1) outParts[i] = '0' + part;
    return '#' + outParts.join('');
}
/**
 * @param hex String representing color as hex code. Accepts strings with or
 *     without leading #, and string representing the color using 3, 6, or 8
 *     hex characters.
 * @return ARGB representation of color.
 */ function $ad39de81c51fbcac$var$argbFromHex(hex) {
    hex = hex.replace('#', '');
    const isThree = hex.length === 3;
    const isSix = hex.length === 6;
    const isEight = hex.length === 8;
    if (!isThree && !isSix && !isEight) throw new Error('unexpected hex ' + hex);
    let r = 0;
    let g = 0;
    let b = 0;
    if (isThree) {
        r = $ad39de81c51fbcac$var$parseIntHex(hex.slice(0, 1).repeat(2));
        g = $ad39de81c51fbcac$var$parseIntHex(hex.slice(1, 2).repeat(2));
        b = $ad39de81c51fbcac$var$parseIntHex(hex.slice(2, 3).repeat(2));
    } else if (isSix) {
        r = $ad39de81c51fbcac$var$parseIntHex(hex.slice(0, 2));
        g = $ad39de81c51fbcac$var$parseIntHex(hex.slice(2, 4));
        b = $ad39de81c51fbcac$var$parseIntHex(hex.slice(4, 6));
    } else if (isEight) {
        r = $ad39de81c51fbcac$var$parseIntHex(hex.slice(2, 4));
        g = $ad39de81c51fbcac$var$parseIntHex(hex.slice(4, 6));
        b = $ad39de81c51fbcac$var$parseIntHex(hex.slice(6, 8));
    }
    return (-16777216 | (r & 0x0ff) << 16 | (g & 0x0ff) << 8 | b & 0x0ff) >>> 0;
}
function $ad39de81c51fbcac$var$parseIntHex(value) {
    // tslint:disable-next-line:ban
    return parseInt(value, 16);
}
var $ad39de81c51fbcac$var$_M3eThemeElement_instances, $ad39de81c51fbcac$var$_M3eThemeElement_styleSheet, $ad39de81c51fbcac$var$_M3eThemeElement_firstUpdated, $ad39de81c51fbcac$var$_M3eThemeElement_light, $ad39de81c51fbcac$var$_M3eThemeElement_dark, $ad39de81c51fbcac$var$_M3eThemeElement_forcedColor, $ad39de81c51fbcac$var$_M3eThemeElement_colorSchemeChangeHandler, $ad39de81c51fbcac$var$_M3eThemeElement_apply, $ad39de81c51fbcac$var$_M3eThemeElement_getContrastLevel;
/**
 * A non-visual element responsible for application-level theming.
 *
 * @description
 * The `m3e-theme` component is a non-visual element used to apply dynamic color, expressive motion, density, and strong focus indicators
 * to nested, theme-aware elements.
 *
 * When `m3e-theme` is nested directly beneath the `<body>` of a document, the `<body>`'s `background-color` is set to the computed
 * value of `--md-sys-color-background` and `color` is set to the computed value of `--md-sys-color-on-background`. In addition,
 * the document's `scrollbar-color` is set to the computed values of `--m3e-scrollbar-thumb-color` and `--m3e-scrollbar-track-color` which,
 * when supported, cascades to all viewport scrollbars.
 *
 * @example
 * The following example adds a top-level `m3e-theme` directly beneath a document's `<body>` element to
 * apply application-level theming.  In this example, `color` and `scheme` are used to create a dynamic color
 * palette which automatically adjusts to a user's light or dark color preference. In addition, expressive motion
 * and strong focus indicators are enabled.
 *
 * ```html
 * <body>
 *  <m3e-theme color="#6750A4" scheme="auto" motion="expressive" strong-focus>
 *      <!-- Normal body content here. -->
 *  </m3e-theme>
 * <body/>
 * ```
 * @tag m3e-theme
 *
 * @attr color - The hex color from which to derive dynamic color palettes.
 * @attr contrast - The contrast level of the theme.
 * @attr density - The density scale (0, -1, -2).
 * @attr scheme - The color scheme of the theme.
 * @attr strong-focus - Whether to enable strong focus indicators.
 *
 * @fires change - Dispatched when the theme changes.
 */ let $ad39de81c51fbcac$export$1bc448ebf7e4bbf1 = class M3eThemeElement extends (0, $fa29e5b5c67837a0$export$3f2f9f5909897157) {
    constructor(){
        super(...arguments);
        $ad39de81c51fbcac$var$_M3eThemeElement_instances.add(this);
        /** @private */ $ad39de81c51fbcac$var$_M3eThemeElement_styleSheet.set(this, new CSSStyleSheet());
        /** @private */ $ad39de81c51fbcac$var$_M3eThemeElement_firstUpdated.set(this, false);
        /** @private */ $ad39de81c51fbcac$var$_M3eThemeElement_light.set(this, void 0);
        /** @private */ $ad39de81c51fbcac$var$_M3eThemeElement_dark.set(this, void 0);
        /** @private */ $ad39de81c51fbcac$var$_M3eThemeElement_forcedColor.set(this, void 0);
        /** @private */ $ad39de81c51fbcac$var$_M3eThemeElement_colorSchemeChangeHandler.set(this, ()=>(0, $gkQP3.__classPrivateFieldGet)(this, $ad39de81c51fbcac$var$_M3eThemeElement_instances, "m", $ad39de81c51fbcac$var$_M3eThemeElement_apply).call(this, true));
        /**
     * The hex color from which to derive dynamic color palettes.
     * @default "#6750A4"
     */ this.color = "#6750A4";
        /**
     * The color scheme of the theme.
     * @default "auto"
     */ this.scheme = "auto";
        /**
     * The contrast level of the theme.
     * @default "standard"
     */ this.contrast = "standard";
        /**
     * Whether to enable strong focus indicators.
     * @default false
     */ this.strongFocus = false;
        /**
     * The density scale (0, -1, -2).
     * @default 0
     */ this.density = 0;
        /** The motion scheme.
     * @default "standard"
     */ this.motion = "standard";
    }
    /** Whether a dark theme is applied. */ get isDark() {
        switch(this.scheme){
            case "light":
                return false;
            case "dark":
                return true;
            default:
                // auto
                if (this.parentElement instanceof HTMLBodyElement) switch(document.documentElement.style.colorScheme){
                    case "light":
                        return false;
                    case "dark":
                        return true;
                }
                return (0, $gkQP3.__classPrivateFieldGet)(this, $ad39de81c51fbcac$var$_M3eThemeElement_dark, "f")?.matches ?? false;
        }
    }
    /** @inheritdoc */ connectedCallback() {
        super.connectedCallback();
        if (this.shadowRoot && !this.shadowRoot.adoptedStyleSheets.includes((0, $gkQP3.__classPrivateFieldGet)(this, $ad39de81c51fbcac$var$_M3eThemeElement_styleSheet, "f"))) this.shadowRoot.adoptedStyleSheets = [
            ...this.shadowRoot.adoptedStyleSheets,
            (0, $gkQP3.__classPrivateFieldGet)(this, $ad39de81c51fbcac$var$_M3eThemeElement_styleSheet, "f")
        ];
        (0, $gkQP3.__classPrivateFieldSet)(this, $ad39de81c51fbcac$var$_M3eThemeElement_light, matchMedia("(prefers-color-scheme: light)"), "f");
        (0, $gkQP3.__classPrivateFieldSet)(this, $ad39de81c51fbcac$var$_M3eThemeElement_dark, matchMedia("(prefers-color-scheme: dark)"), "f");
        (0, $gkQP3.__classPrivateFieldSet)(this, $ad39de81c51fbcac$var$_M3eThemeElement_forcedColor, matchMedia("(forced-colors: active)"), "f");
        [
            (0, $gkQP3.__classPrivateFieldGet)(this, $ad39de81c51fbcac$var$_M3eThemeElement_light, "f"),
            (0, $gkQP3.__classPrivateFieldGet)(this, $ad39de81c51fbcac$var$_M3eThemeElement_dark, "f"),
            (0, $gkQP3.__classPrivateFieldGet)(this, $ad39de81c51fbcac$var$_M3eThemeElement_forcedColor, "f")
        ].forEach((x)=>x.addEventListener("change", (0, $gkQP3.__classPrivateFieldGet)(this, $ad39de81c51fbcac$var$_M3eThemeElement_colorSchemeChangeHandler, "f")));
    }
    /** @inheritdoc */ disconnectedCallback() {
        super.disconnectedCallback();
        [
            (0, $gkQP3.__classPrivateFieldGet)(this, $ad39de81c51fbcac$var$_M3eThemeElement_light, "f"),
            (0, $gkQP3.__classPrivateFieldGet)(this, $ad39de81c51fbcac$var$_M3eThemeElement_dark, "f"),
            (0, $gkQP3.__classPrivateFieldGet)(this, $ad39de81c51fbcac$var$_M3eThemeElement_forcedColor, "f")
        ].forEach((x)=>x?.removeEventListener("change", (0, $gkQP3.__classPrivateFieldGet)(this, $ad39de81c51fbcac$var$_M3eThemeElement_colorSchemeChangeHandler, "f")));
        (0, $gkQP3.__classPrivateFieldSet)(this, $ad39de81c51fbcac$var$_M3eThemeElement_light, (0, $gkQP3.__classPrivateFieldSet)(this, $ad39de81c51fbcac$var$_M3eThemeElement_dark, (0, $gkQP3.__classPrivateFieldSet)(this, $ad39de81c51fbcac$var$_M3eThemeElement_forcedColor, undefined, "f"), "f"), "f");
    }
    /** @inheritdoc */ updated(_changedProperties) {
        super.updated(_changedProperties);
        (0, $gkQP3.__classPrivateFieldGet)(this, $ad39de81c51fbcac$var$_M3eThemeElement_instances, "m", $ad39de81c51fbcac$var$_M3eThemeElement_apply).call(this, (0, $gkQP3.__classPrivateFieldGet)(this, $ad39de81c51fbcac$var$_M3eThemeElement_firstUpdated, "f") && [
            "color",
            "scheme",
            "contrast"
        ].some((x)=>_changedProperties.has(x)));
    }
    /** @inheritdoc */ firstUpdated(_changedProperties) {
        super.firstUpdated(_changedProperties);
        (0, $gkQP3.__classPrivateFieldSet)(this, $ad39de81c51fbcac$var$_M3eThemeElement_firstUpdated, true, "f");
    }
    /** @inheritdoc */ render() {
        return (0, $00a10a29322bb2a1$export$c0bb0b647f701bb5)`<slot></slot>`;
    }
};
$ad39de81c51fbcac$var$_M3eThemeElement_styleSheet = new WeakMap();
$ad39de81c51fbcac$var$_M3eThemeElement_firstUpdated = new WeakMap();
$ad39de81c51fbcac$var$_M3eThemeElement_light = new WeakMap();
$ad39de81c51fbcac$var$_M3eThemeElement_dark = new WeakMap();
$ad39de81c51fbcac$var$_M3eThemeElement_forcedColor = new WeakMap();
$ad39de81c51fbcac$var$_M3eThemeElement_colorSchemeChangeHandler = new WeakMap();
$ad39de81c51fbcac$var$_M3eThemeElement_instances = new WeakSet();
$ad39de81c51fbcac$var$_M3eThemeElement_apply = function _M3eThemeElement_apply(forceReflow) {
    const color = $ad39de81c51fbcac$var$argbFromHex(this.color);
    const palette = $ad39de81c51fbcac$var$CorePalette.of(color);
    const scheme = new $ad39de81c51fbcac$var$DynamicScheme({
        sourceColorArgb: color,
        variant: 1,
        contrastLevel: (0, $gkQP3.__classPrivateFieldGet)(this, $ad39de81c51fbcac$var$_M3eThemeElement_instances, "m", $ad39de81c51fbcac$var$_M3eThemeElement_getContrastLevel).call(this),
        isDark: this.isDark,
        primaryPalette: palette.a1,
        secondaryPalette: palette.a2,
        tertiaryPalette: palette.a3,
        neutralPalette: palette.n1,
        neutralVariantPalette: palette.n2
    });
    let css = "";
    for(const key in $ad39de81c51fbcac$var$MaterialDynamicColors)if (!key.endsWith("PaletteKeyColor")) {
        const dynamicColor = $ad39de81c51fbcac$var$MaterialDynamicColors[key];
        if (dynamicColor instanceof $ad39de81c51fbcac$var$DynamicColor) css += `--md-sys-color-${key.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}: ${$ad39de81c51fbcac$var$hexFromArgb(dynamicColor.getArgb(scheme))};`;
    }
    if (this.motion === "expressive") {
        css += "--md-sys-motion-spring-fast-spatial: 350ms cubic-bezier(0.42, 1.67, 0.21, 0.90);";
        css += "--md-sys-motion-spring-default-spatial: 500ms cubic-bezier(0.38, 1.21, 0.22, 1.00);";
        css += "--md-sys-motion-spring-slow-spatial: 650ms cubic-bezier(0.39, 1.29, 0.35, 0.98);";
        css += "--md-sys-motion-spring-fast-effects: 150ms cubic-bezier(0.31, 0.94, 0.34, 1.00);";
        css += "--md-sys-motion-spring-default-effects: 200ms cubic-bezier(0.34, 0.80, 0.34, 1.00);";
        css += "--md-sys-motion-spring-slow-effects: 300ms cubic-bezier(0.34, 0.88, 0.34, 1.00);";
    }
    css += `--md-sys-density-scale: ${this.density};`;
    css += `--m3e-scrollbar-thumb-color: ${$ad39de81c51fbcac$var$hexFromArgb(scheme.neutralPalette.tone(60))};`;
    css += `--m3e-focus-ring-visibility: ${this.strongFocus ? "visible" : "hidden"};`;
    (0, $gkQP3.__classPrivateFieldGet)(this, $ad39de81c51fbcac$var$_M3eThemeElement_styleSheet, "f").replaceSync(`:host { ${css} }`);
    if (this.parentElement instanceof HTMLBodyElement) {
        const computedStyle = getComputedStyle(this);
        switch(this.scheme){
            case "light":
                document.documentElement.style.colorScheme = "light";
                break;
            case "dark":
                document.documentElement.style.colorScheme = "dark";
                break;
            default:
                switch(document.documentElement.style.colorScheme){
                    case "light":
                    case "dark":
                        document.documentElement.style.colorScheme = "light dark";
                        break;
                }
        }
        if ((0, $gkQP3.__classPrivateFieldGet)(this, $ad39de81c51fbcac$var$_M3eThemeElement_forcedColor, "f")?.matches) this.parentElement.style.backgroundColor = this.parentElement.style.color = this.parentElement.ownerDocument.documentElement.style.scrollbarColor = this.parentElement.style.scrollbarColor = "";
        else {
            this.parentElement.style.backgroundColor = computedStyle.getPropertyValue("--md-sys-color-background");
            this.parentElement.style.color = computedStyle.getPropertyValue("--md-sys-color-on-background");
            this.parentElement.ownerDocument.documentElement.style.scrollbarColor = this.parentElement.style.scrollbarColor = `${computedStyle.getPropertyValue("--m3e-scrollbar-thumb-color")} ${computedStyle.getPropertyValue("--m3e-scrollbar-track-color")}`;
        }
    }
    if ((0, $gkQP3.__classPrivateFieldGet)(this, $ad39de81c51fbcac$var$_M3eThemeElement_firstUpdated, "f")) this.dispatchEvent(new Event("change", {
        bubbles: true
    }));
    if (forceReflow) document.body.offsetHeight;
};
$ad39de81c51fbcac$var$_M3eThemeElement_getContrastLevel = function _M3eThemeElement_getContrastLevel() {
    switch(this.contrast){
        case "high":
            return 1;
        case "medium":
            return 0.5;
        default:
            // standard
            return 0;
    }
};
/** The styles of the element. */ $ad39de81c51fbcac$export$1bc448ebf7e4bbf1.styles = (0, $fbf856437f99196f$export$dbf350e5966cf602)`:host { display: contents; font-size: ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.body.large.fontSize}; font-weight: ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.body.large.fontWeight}; line-height: ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.body.large.lineHeight}; letter-spacing: ${(0, $ca7aa15aa0ba1e7b$export$b6ce77d07cd22443).typescale.standard.body.large.tracking}; }`;
(0, $gkQP3.__decorate)([
    (0, $21eb6a58ce309899$export$d541bacb2bda4494)()
], $ad39de81c51fbcac$export$1bc448ebf7e4bbf1.prototype, "color", void 0);
(0, $gkQP3.__decorate)([
    (0, $21eb6a58ce309899$export$d541bacb2bda4494)()
], $ad39de81c51fbcac$export$1bc448ebf7e4bbf1.prototype, "scheme", void 0);
(0, $gkQP3.__decorate)([
    (0, $21eb6a58ce309899$export$d541bacb2bda4494)()
], $ad39de81c51fbcac$export$1bc448ebf7e4bbf1.prototype, "contrast", void 0);
(0, $gkQP3.__decorate)([
    (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
        attribute: "strong-focus",
        type: Boolean
    })
], $ad39de81c51fbcac$export$1bc448ebf7e4bbf1.prototype, "strongFocus", void 0);
(0, $gkQP3.__decorate)([
    (0, $21eb6a58ce309899$export$d541bacb2bda4494)({
        type: Number
    })
], $ad39de81c51fbcac$export$1bc448ebf7e4bbf1.prototype, "density", void 0);
(0, $gkQP3.__decorate)([
    (0, $21eb6a58ce309899$export$d541bacb2bda4494)()
], $ad39de81c51fbcac$export$1bc448ebf7e4bbf1.prototype, "motion", void 0);
$ad39de81c51fbcac$export$1bc448ebf7e4bbf1 = (0, $gkQP3.__decorate)([
    (0, $ca7aa15aa0ba1e7b$export$da64fc29f17f9d0e)("m3e-theme")
], $ad39de81c51fbcac$export$1bc448ebf7e4bbf1);


var $5ec47347fc6130b4$var$OriginalPromise = Promise;
/**
 * ES5 subclassing is used per:
 * https://github.com/rtsao/browser-unhandled-rejection/issues/1
 * https://kangax.github.io/compat-table/es6/#test-Promise_is_subclassable
 *
 * Adapted from: https://gist.github.com/domenic/8ed6048b187ee8f2ec75
 */ var $5ec47347fc6130b4$var$InstrumentedPromise$1 = function Promise1(resolver) {
    if (!(this instanceof $5ec47347fc6130b4$var$InstrumentedPromise$1)) throw new TypeError('Cannot call a class as a function');
    var promise = new $5ec47347fc6130b4$var$OriginalPromise(function(resolve, reject) {
        return resolver(resolve, function(arg) {
            $5ec47347fc6130b4$var$OriginalPromise.resolve().then(function() {
                if (promise._hasDownstreams === undefined) $5ec47347fc6130b4$var$dispatchUnhandledRejectionEvent(promise, arg);
            });
            return reject(arg);
        });
    });
    promise.__proto__ = $5ec47347fc6130b4$var$InstrumentedPromise$1.prototype;
    return promise;
};
$5ec47347fc6130b4$var$InstrumentedPromise$1.__proto__ = $5ec47347fc6130b4$var$OriginalPromise;
$5ec47347fc6130b4$var$InstrumentedPromise$1.prototype.__proto__ = $5ec47347fc6130b4$var$OriginalPromise.prototype;
$5ec47347fc6130b4$var$InstrumentedPromise$1.prototype.then = function then(onFulfilled, onRejected) {
    var next = $5ec47347fc6130b4$var$OriginalPromise.prototype.then.call(this, onFulfilled, onRejected);
    this._hasDownstreams = true;
    return next;
};
function $5ec47347fc6130b4$var$dispatchUnhandledRejectionEvent(promise, reason) {
    var event = document.createEvent('Event');
    /**
   * Note: these properties should not be enumerable, which is the default setting
   */ Object.defineProperties(event, {
        promise: {
            value: promise,
            writable: false
        },
        reason: {
            value: reason,
            writable: false
        }
    });
    event.initEvent('unhandledrejection', false, true // PromiseRejectionEvent is cancelable
    );
    window.dispatchEvent(event);
}
function $5ec47347fc6130b4$export$baf72085f5fb4df() {
    return typeof PromiseRejectionEvent === 'undefined';
}
function $5ec47347fc6130b4$export$cea1c58a6db52bca() {
    Promise = $5ec47347fc6130b4$var$InstrumentedPromise$1;
}
function $5ec47347fc6130b4$export$dfb5619354ba860() {
    if ($5ec47347fc6130b4$export$baf72085f5fb4df()) $5ec47347fc6130b4$export$cea1c58a6db52bca();
}
var $5ec47347fc6130b4$export$2e2bcd8739ae039 = $5ec47347fc6130b4$var$InstrumentedPromise$1;



var $dtjlP = parcelRequire("dtjlP");

var $8T2E9 = parcelRequire("8T2E9");

var $kdqQ0 = parcelRequire("kdqQ0");

var $1jJwX = parcelRequire("1jJwX");

var $9zAQJ = parcelRequire("9zAQJ");

var $1jJwX = parcelRequire("1jJwX");

var $9zAQJ = parcelRequire("9zAQJ");

var $dXDj3 = parcelRequire("dXDj3");
var $50f2945f3ed314da$var$__runInitializers = undefined && undefined.__runInitializers || function(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
};
var $50f2945f3ed314da$var$__esDecorate = undefined && undefined.__esDecorate || function(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
let $50f2945f3ed314da$export$ef8da11641c635de = (()=>{
    let _classDecorators = [
        (0, $9zAQJ.component)({
            tagName: 'nav-bar'
        }),
        (0, $9zAQJ.observer)
    ];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = HTMLElement;
    let _instanceExtraInitializers = [];
    let _handleSearch_decorators;
    var NavBar = class extends _classSuper {
        static{
            _classThis = this;
        }
        static{
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(_classSuper[Symbol.metadata] ?? null) : void 0;
            _handleSearch_decorators = [
                (0, $9zAQJ.on)('submit', 'form')
            ];
            $50f2945f3ed314da$var$__esDecorate(this, null, _handleSearch_decorators, {
                kind: "method",
                name: "handleSearch",
                static: false,
                private: false,
                access: {
                    has: (obj)=>"handleSearch" in obj,
                    get: (obj)=>obj.handleSearch
                },
                metadata: _metadata
            }, null, _instanceExtraInitializers);
            $50f2945f3ed314da$var$__esDecorate(null, _classDescriptor = {
                value: _classThis
            }, _classDecorators, {
                kind: "class",
                name: _classThis.name,
                metadata: _metadata
            }, null, _classExtraInitializers);
            NavBar = _classThis = _classDescriptor.value;
            if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, {
                enumerable: true,
                configurable: true,
                writable: true,
                value: _metadata
            });
            $50f2945f3ed314da$var$__runInitializers(_classThis, _classExtraInitializers);
        }
        title = ($50f2945f3ed314da$var$__runInitializers(this, _instanceExtraInitializers), "GitHub \u4E2D\u6587\u7248");
        channels = [
            {
                title: "G \u6D41",
                name: "\u4E8B\u4EF6\u6D41",
                URL: '#/events'
            },
            {
                title: "G \u4ED3",
                name: "\u5F00\u6E90\u4ED3\u5E93",
                URL: '#/repos'
            },
            {
                title: "G \u9526",
                name: "\u4EE3\u7801\u9526\u56CA",
                URL: '#/gists'
            },
            {
                title: "G \u53CB",
                name: "\u7A0B\u5E8F\u5458",
                URL: '#/users'
            },
            {
                title: "G \u56E2",
                name: "\u5F00\u53D1\u56E2\u961F",
                URL: '#/users'
            },
            {
                title: "\u5173\u4E8E\u672C\u7AD9",
                URL: '#/ReadMe.md'
            },
            {
                title: "\u5173\u4E8E\u4F5C\u8005",
                URL: '#/users/TechQuery'
            }
        ];
        handleSearch(event) {
            event.preventDefault();
            const form = event.target;
            const keyword = form.elements.namedItem('keyword').value;
            window.location.hash = !keyword.includes('/') ? `#/users/${keyword}` : `#/repos/${keyword}`;
        }
        render() {
            return (0, $1jJwX.jsxs)("m3e-app-bar", {
                className: "sticky-top",
                children: [
                    (0, $1jJwX.jsx)((0, $dXDj3.Link), {
                        slot: "title",
                        to: "",
                        className: "text-decoration-none text-reset",
                        children: this.title
                    }),
                    (0, $1jJwX.jsxs)("div", {
                        slot: "trailing",
                        className: "d-flex align-items-center gap-1 flex-wrap",
                        children: [
                            this.channels.map(({ title: title, name: name, URL: URL, target: target })=>(0, $1jJwX.jsx)("m3e-button", {
                                    variant: "text",
                                    href: URL,
                                    target: target || '',
                                    title: name || title,
                                    children: title
                                }, URL + title)),
                            (0, $1jJwX.jsx)("form", {
                                className: "d-flex align-items-center gap-2 ms-2",
                                children: (0, $1jJwX.jsx)("input", {
                                    type: "search",
                                    className: "form-control form-control-sm",
                                    name: "keyword",
                                    required: true,
                                    placeholder: "\u5B9A\u4F4D\uFF1A\u7528\u6237 ID\u3001\u4ED3\u5E93\u5168\u540D"
                                })
                            })
                        ]
                    })
                ]
            });
        }
    };
    return NavBar = _classThis;
})();



var $1jJwX = parcelRequire("1jJwX");
function $4b6741e6925a057b$export$36d69433c4f81145() {
    return (0, $1jJwX.jsxs)("div", {
        className: "d-flex flex-column align-items-center py-5 px-3 text-center gap-3",
        children: [
            (0, $1jJwX.jsx)("h1", {
                className: "display-5 mb-0",
                children: "GitHub \u4E2D\u6587\u7248"
            }),
            (0, $1jJwX.jsx)("p", {
                className: "fs-5 mb-0 text-muted",
                children: "\u57FA\u4E8E WebCell v3 \u91CD\u5199\u7684\u73B0\u4EE3\u5316 GitHub \u6D4F\u89C8\u5668"
            }),
            (0, $1jJwX.jsxs)("div", {
                className: "d-flex gap-2 flex-wrap justify-content-center mt-2",
                children: [
                    (0, $1jJwX.jsx)("m3e-button", {
                        variant: "filled",
                        href: "#/events",
                        children: "\u67E5\u770B G \u6D41"
                    }),
                    (0, $1jJwX.jsx)("m3e-button", {
                        variant: "tonal",
                        href: "#/repos",
                        children: "\u6D4F\u89C8 G \u4ED3"
                    }),
                    (0, $1jJwX.jsx)("m3e-button", {
                        variant: "outlined",
                        href: "#/users",
                        children: "\u53D1\u73B0 G \u53CB"
                    })
                ]
            })
        ]
    });
}



var $dXDj3 = parcelRequire("dXDj3");









const $efe1595b30578567$export$9cec2e60c72475ca = ()=>(0, $1jJwX.jsxs)("m3e-theme", {
        color: "#1565C0",
        scheme: "auto",
        motion: "expressive",
        children: [
            (0, $1jJwX.jsx)((0, $50f2945f3ed314da$export$ef8da11641c635de), {}),
            (0, $1jJwX.jsx)("main", {
                id: "PageBox",
                className: "container py-3",
                children: (0, $1jJwX.jsxs)((0, $dXDj3.Router), {
                    children: [
                        (0, $1jJwX.jsx)((0, $dXDj3.Route), {
                            path: "",
                            component: (0, $4b6741e6925a057b$export$36d69433c4f81145)
                        }),
                        (0, $1jJwX.jsx)((0, $dXDj3.Route), {
                            path: "/users",
                            component: (0, $9zAQJ.lazy)(()=>(parcelRequire("yjxvR")))
                        }),
                        (0, $1jJwX.jsx)((0, $dXDj3.Route), {
                            path: "/users/:username",
                            component: (0, $9zAQJ.lazy)(()=>(parcelRequire("akIEM")))
                        }),
                        (0, $1jJwX.jsx)((0, $dXDj3.Route), {
                            path: "/repos",
                            component: (0, $9zAQJ.lazy)(()=>(parcelRequire("leE2r")))
                        }),
                        (0, $1jJwX.jsx)((0, $dXDj3.Route), {
                            path: "/repos/:owner/:repo",
                            component: (0, $9zAQJ.lazy)(()=>(parcelRequire("6cXKj")))
                        }),
                        (0, $1jJwX.jsx)((0, $dXDj3.Route), {
                            path: "/repos/:owner/:repo/issues/:issueNumber",
                            component: (0, $9zAQJ.lazy)(()=>(parcelRequire("9wX5b")))
                        }),
                        (0, $1jJwX.jsx)((0, $dXDj3.Route), {
                            path: "/repos/:owner/:repo/milestones/:milestoneNumber",
                            component: (0, $9zAQJ.lazy)(()=>(parcelRequire("7C1fz")))
                        }),
                        (0, $1jJwX.jsx)((0, $dXDj3.Route), {
                            path: "/events",
                            component: (0, $9zAQJ.lazy)(()=>(parcelRequire("dnKQI")))
                        }),
                        (0, $1jJwX.jsx)((0, $dXDj3.Route), {
                            path: "/gists",
                            component: (0, $9zAQJ.lazy)(()=>(parcelRequire("geDru")))
                        }),
                        (0, $1jJwX.jsx)((0, $dXDj3.Route), {
                            path: "/gists/:gistId",
                            component: (0, $9zAQJ.lazy)(()=>(parcelRequire("96Jpt")))
                        })
                    ]
                })
            })
        ]
    });



var $kdqQ0 = parcelRequire("kdqQ0");
const { renderMode: $9b401f7840dd935f$export$bf347e2913cc7267 = 'sync' } = (0, $kdqQ0.parseURLData)();


(0, $5ec47347fc6130b4$export$dfb5619354ba860)();
(0, $8T2E9.configure)({
    enforceActions: 'never'
});
self.addEventListener('unhandledrejection', ({ reason: reason })=>{
    const { message: message } = reason;
    if (message) self.alert(message);
});
const { serviceWorker: $ce967277cb0dfddc$var$serviceWorker } = window.navigator;
$ce967277cb0dfddc$var$serviceWorker?.register('sw.js').then((0, $kdqQ0.serviceWorkerUpdate)).then((worker)=>{
    if (window.confirm('New version of this Web App detected, update now?')) worker.postMessage({
        type: 'SKIP_WAITING'
    });
});
$ce967277cb0dfddc$var$serviceWorker?.addEventListener('controllerchange', ()=>window.location.reload());
(0, $kdqQ0.documentReady).then(()=>new (0, $dtjlP.DOMRenderer)().render((0, $1jJwX.jsx)((0, $efe1595b30578567$export$9cec2e60c72475ca), {}), document.body, (0, $9b401f7840dd935f$export$bf347e2913cc7267)));


//# sourceMappingURL=repo.ec9e3c36.js.map
